// Generated by Avo VERSION 123.2.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function(exports) {
  var __AVO_DEV__ = false;
  var __AVO_NOOP__ = false;
  var __AVO_LOGGER__ = null;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;

  var __WEB_DEBUGGER__ = true;
  const avoInspectorApiKey = "ncKE8oVxtcaE4Hdy9XP1";
  var __INSPECTOR__ = null;

  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function() {
      'use strict';
      var hasOwnProperty = Object.prototype.hasOwnProperty,
          hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
          dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
          ],
          dontEnumsLength = dontEnums.length;

      return function(obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)  Array.prototype.indexOf = (function(Object, max, min){
    "use strict";
    return function indexOf(member, fromIndex) {
      if(this===null||this===undefined)throw TypeError("Array.prototype.indexOf called on null or undefined");

      var that = Object(this), Len = that.length >>> 0, i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len+i); else if (i >= Len) return -1;

      if(member===void 0){ for(; i !== Len; ++i) if(that[i]===void 0 && i in that) return i; // undefined
      }else if(member !== member){   for(; i !== Len; ++i) if(that[i] !== that[i]) return i; // NaN
      }else                           for(; i !== Len; ++i) if(that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);

  var array_difference, AvoAssert, InternalAvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }

  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== 'object') {
        var message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
        return [{tag: 'expectedObjectType', propertyId: propertyId, message: message, actualType: typeof obj}];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== 'string') {
        var message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
        return [{tag: 'expectedStringType', propertyId: propertyId, message: message, actualType: typeof str}];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === 'number' && int !== Math.round(int)) {
        var message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof int !== 'number') {
        var message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, message: message, actualType: typeof int}];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === 'number' && long !== Math.round(long)) {
        var message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof long !== 'number') {
        var message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, message: message, actualType: typeof long}];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== 'number') {
        var message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
        return [{tag: 'expectedFloatType', propertyId: propertyId, message: message, actualType: typeof float}];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== 'boolean') {
        var message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
        return [{tag: 'expectedBoolType', propertyId: propertyId, message: message, actualType: typeof bool}];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message = propName +
          ' has a maximum value of ' +
          max +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMax', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message = propName +
          ' has a minimum value of ' +
          min +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMin', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message = propName + ' should be of type list but you provided type ' + typeof value;
        return [{tag: 'expectedList', propertyId: propertyId, message: message, actualType: typeof value}];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    }
  };

    const WebDebuggerAssertions = {
      hasKey(obj, key) {
        return obj && obj[key] != null;
      },
      assertKey(obj, key, assert) {
        if (this.hasKey(obj, key) && assert(obj[key])) {
          return true;
        } else {
          throw new Error('WebDebugger: Object key: "' + key + '" failed assertion.')
        }
      },
      assertKeys(obj, arrayOfAssertions) {
        return arrayOfAssertions.every(assertionForKey => {
          if (this.hasKey(assertionForKey, "key") && this.hasKey(assertionForKey, "assert")) {
            return this.assertKey(obj, assertionForKey.key, assertionForKey.assert);
          } else {
            throw new Error('WebDebugger: Object form for assertion invalid.');
          }
        });
      },
      assertInt(int) {
        return Number.isInteger(int);
      },
    };

    var WebDebuggerPosition = {
      position: {
        BOTTOM_RIGHT: 'BottomRight',
        BOTTOM_LEFT: 'BottomLeft',
        TOP_RIGHT: 'TopRight',
        TOP_LEFT: 'TopLeft',
      },
      BottomRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_RIGHT,
          bottom: parameters.bottom,
          right: parameters.right,
        };
      },
      BottomLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_LEFT,
          bottom: parameters.bottom,
          left: parameters.left,
        };
      },
      TopRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_RIGHT,
          top: parameters.top,
          right: parameters.right,
        };
      },
      TopLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_LEFT,
          top: parameters.top,
          left: parameters.left,
        };
      },
    }


  InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties, groupProperties) {
      const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties) + "Group Props:" + JSON.stringify(groupProperties);

      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties, "Group Props:", groupProperties);
    },

    log: function log(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] " + message);
    },

    warn: function warn(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.warn("[avo] " + message);
    },

    error: function error(message, error) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
        return
      }
      typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
  };

  var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      }).then(function(res) { return res.json(); }).then(function(data) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    "ac": "y1ErLw6w4F5FQfP3cHyx",
    "br": "master",
    "en": env,
    "ev": eventId,
    "ha": hash,
    "sc": "6drybyLTwHSLSiD6Yicr",
    "se": (new Date()).toISOString(),
    "so": "EhraNYm6f",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    "ac": "y1ErLw6w4F5FQfP3cHyx",
    "br": "master",
    "en": env,
    "ty": type,
    "sc": "6drybyLTwHSLSiD6Yicr",
    "se": (new Date()).toISOString(),
    "so": "EhraNYm6f",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}


  var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    var iframe = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      var message = {
        type_: "avo-debugger-boot-events",
        schemaId: "6drybyLTwHSLSiD6Yicr",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
  if (typeof window === 'undefined') { return; }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties,
    groupProperties: groupProperties
  };

  if (_avo_debugger_ready) {
    var message = {type_: "avo-debugger-events", events: [event]};
    document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


  var DiscountPitch = {
    URGENCY_DISCOUNT: "Urgency Discount",
  };

  var Difficulty = {
    EASY: "Easy",
    MEDIUM: "Medium",
    HARD: "Hard",
  };

  var State = {
    VALID: "Valid",
    EXPIRED: "Expired",
    FREE: "Free",
    LOCKED: "Locked",
  };

  var UserPersonaType = {
    CLASS_ONLY: "class only",
    PTL: "ptl",
  };

  var Source = {
    LEFT_NAV: "Left Nav",
    TAB: "Tab",
  };

  var QuestionType = {
    SINGLE_SELECT: "Single Select",
    MULTI_SELECT: "Multi Select",
    MULTIMINUSSELECT_WITH_CAPPED_SELECTIONS: "Multi-Select with capped selections",
    FREE_TEXT: "Free Text",
    DROPDOWN: "Dropdown",
  };

  var Grade = {
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
    PK: "pk",
    K: "k",
    NA: "NA",
  };

  var Mode = {
    SCHOOL: "school",
    HOME: "home",
    B2CHOME: "b2chome",
  };

  var MFAssignedTo = {
    WHOLE_CLASS: "Whole Class",
    SELECTED_STUDENTS: "Selected Students",
  };

  var WorksheetFilterAppliedOn = {
    L1: "L1",
    L2: "L2",
    L3: "L3",
    L4: "L4",
    L5: "L5",
    L6: "L6",
  };

  var EndPoint = {
    PORTAL: "Portal",
    JUNGLE: "Jungle",
    CITY: "City",
    CAFE: "Cafe",
    NIGHT_TIME_LOBBY: "Night Time Lobby",
  };

  var Status = {
    SUCCESS: "Success",
    FAILED: "Failed",
  };

  var ClickedOnCustomReportPage = {
    VIEW_RESPONSE: "View Response",
    MARK_AS_COMPLETE: "Mark as Complete",
    EDIT_TEST: "Edit Test",
    SORT_STUDENTS: "Sort Students",
  };

  var MathGrade = {
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
    PK: "pk",
    K: "k",
  };

  var GradeSelected = {
    PK: "pk",
    K: "k",
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
  };

  var WorksheetGrade = {
    K: "k",
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
  };

  var ReportType = {
    GRID: "Grid",
    GROUP: "Group",
  };

  var ClickedOnTrackCustomPage = {
    VIEW_REPORT: "View Report",
    PRINT_WORKSHEET: "Print Worksheet",
    EDIT_TEST: "Edit Test",
    MARK_AS_COMPLETE: "Mark as Complete",
    COPY_PRACTICE_LINK: "Copy Practice Link",
    DELETE_TEST: "Delete Test",
  };

  var InteractionType = {
    CLICKED: "Clicked",
    SCROLLED: "Scrolled",
    HOVERED: "Hovered",
    HEARD: "Heard",
  };

  var Subject = {
    MATH: "Math",
    READING: "Reading",
    EXTRA_CURRICULUM: "Extra Curriculum",
    ELA: "ELA",
    ELA: "ela",
    MATH: "math",
    EXTRA_CURRICULUM: "extra curriculum",
    READING: "reading",
  };

  var GameMode = {
    PWC: "pwc",
    SOLO: "solo",
    _1_V_1: "1_v_1",
  };

  var InteractedWith = {
    TAKE_A_TOUR: "Take a Tour",
    ILL_TAKE_IT_LATER: "I'll take it later",
  };

  var ScrolledThrough = {
    MULTIPLAYER_GAMES: "Multiplayer Games",
    ACTIVITIES: "Activities",
    REWARDS: "Rewards",
    FOUNDATIONAL_GAMES: "Foundational Games",
    ADVANCED_GAMES: "Advanced Games",
    LOGIC_THINKING: "Logic & Thinking",
    ART_CREATIVITY: "Art & Creativity",
    GENERAL_KNOWLEDGE: "General Knowledge",
  };

  var OpponentType = {
    BOT: "Bot",
    STUDENT: "Student",
  };

  var MFMode = {
    ADAPTIVE: "Adaptive",
    CUSTOM: "Custom",
  };

  var CardType = {
    CARD_TYPE_NOT_AVAILABLE: "Card Type not available",
    DEBIT: "debit",
    CREDIT: "credit",
    PREPAID: "prepaid",
  };

  var CustomMFOperatorSelected = {
    ADD: "Add",
    SUBTRACT: "Subtract",
    MULTIPLY: "Multiply",
    DIVIDE: "Divide",
  };

  var MFOperatorSelected = {
    ADDITION_SUBTRACTION: "Addition & Subtraction",
    MULTIPLICATION_DIVISION: "Multiplication & Division",
  };

  var ClickedOnNewMFPractice = {
    ASSIGN_ADAPTIVE_PRACTICE: "Assign Adaptive Practice",
    CREATE_CUSTOM_TEST: "Create Custom Test",
  };

  var PlayAgainState = {
    USER_INITIATED: "User initiated",
    OPPONENT_INITIATED: "Opponent Initiated",
    FRIENDS_JOINED: "Friends joined",
  };

  var ClassType = {
    GOOGLE_CLASSROOM: "Google Classroom",
    CLEVER: "Clever",
    MANUAL: "Manual",
  };

  var MFCustomSettingsClickedOn = {
    PRINT_WORKSHEET: "Print Worksheet",
    SELECT_STUDENTS: "Select Students",
  };

  var ReachedVia = {
    NEW_FACT_PRACTICE: "New Fact Practice",
    TRACK_FACT_PRACTICE: "Track Fact Practice",
  };

  var Winner = {
    BOT: "Bot",
    STUDENT: "Student",
  };

  var FromPage = {
    CURRICULUM: "Curriculum",
    FACT_PRACTICE: "Fact Practice",
    DASHBOARD: "Dashboard",
    SUMMER_LEARNING: "Summer Learning",
    MATH_LIVE_CLASS: "Math Live Class",
    READING_LIVE_CLASS: "Reading Live Class",
  };

  var InteractionDetails = {
    STARTED_TYPING_CREDIT_CARD_DETAILS: "Started Typing Credit Card Details",
    STARTED_TYPING_CITY: "Started Typing City",
    STARTED_TYPING_SCHOOL: "Started Typing School",
    STOPPED_TYPING_CITY: "Stopped Typing City",
    STOPPED_TYPING_SCHOOL: "Stopped Typing School",
  };

  var ValidSavedCardExists = {
    YES: "Yes",
    NO: "No",
  };

  var View = {
    WITHCROSS: "withcross",
    WITHOUTCROSS: "withoutcross",
  };

  var GooglePayButtonAvailable = {
    YES: "Yes",
    NO: "No",
  };

  var ElaGrade = {
    _1: "1",
    _2: "2",
    _3: "3",
    _4: "4",
    _5: "5",
    PK: "pk",
    K: "k",
    NA: "NA",
  };

  var MFPracticeQuestionsCount = {
    _20: "20",
    _30: "30",
    _40: "40",
  };

  var MFTimePerQuestion = {
    OFF: "Off",
    _5_SECS: "5 Secs",
    _10_SECS: "10 Secs",
    _15_SECS: "15 Secs",
    _20_SECS: "20 Secs",
  };

  var UserType = {
    TEACHER: "Teacher",
    PARENT: "Parent",
    GUEST_PARENT: "Guest Parent",
    STUDENT: "Student",
    GUEST_TEACHER: "Guest Teacher",
  };

  var SignupFlow = {
    TRIAL_CLASS_25: "trial_class_25",
    CLASSROOM_LINKED: "classroom_linked",
    STUDENT_EXPERIENCE: "student_experience",
    CLASSCODE: "classcode",
  };

  var ClickedOnStudentSelectionPopup = {
    ASSIGN: "Assign",
  };

  function assertOnlineClassmates(onlineClassmates, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("-6EWaVnSU8", label_ ? "Online Classmates" + ": " + label_ : "Online Classmates", onlineClassmates));
    return messages;
  }

  function assertOptionalMilestoneChanged(milestoneChanged, label_) {
    var messages = [];
    if (milestoneChanged !== undefined && milestoneChanged !== null) {
      messages = messages.concat(AvoAssert.assertString("-8NMIzT9n", label_ ? "Milestone Changed" + ": " + label_ : "Milestone Changed", milestoneChanged));
    }
    return messages;
  }

  function assertOptionalDiscountPitch(discountPitch, label_) {
    var messages = [];
    if (discountPitch !== undefined && discountPitch !== null) {
      messages = messages.concat(AvoAssert.assertString("-tPNSAQK6", label_ ? "Discount Pitch" + ": " + label_ : "Discount Pitch", discountPitch));
      if ("Urgency Discount" !== discountPitch) {
        var message = (label_ ? "Discount Pitch" + ": " + label_ : "Discount Pitch") + " should match one of the following values [ Urgency Discount ] but you provided the value " + discountPitch
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "-tPNSAQK6", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalRecommendedPlayableCode(recommendedPlayableCode,
    label_) {
    var messages = [];
    if (recommendedPlayableCode !== undefined && recommendedPlayableCode !== null) {
      messages = messages.concat(AvoAssert.assertList("09LOni_Ki3", "Recommended Playable Code", recommendedPlayableCode));
      recommendedPlayableCode.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalDifficulty(difficulty, label_) {
    var messages = [];
    if (difficulty !== undefined && difficulty !== null) {
      messages = messages.concat(AvoAssert.assertString("12tG17N4vG", label_ ? "Difficulty" + ": " + label_ : "Difficulty", difficulty));
      if ("Easy" !== difficulty && "Medium" !== difficulty &&
            "Hard" !== difficulty) {
        var message = (label_ ? "Difficulty" + ": " + label_ : "Difficulty") + " should match one of the following values [ Easy | Medium | Hard ] but you provided the value " + difficulty
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "12tG17N4vG", message: message}]);
      }
    }
    return messages;
  }

  function assertState(state, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("19zWDg2Ccm", label_ ? "State" + ": " + label_ : "State", state));
    if ("Valid" !== state && "Expired" !== state && "Free" !== state &&
          "Locked" !== state) {
      var message = (label_ ? "State" + ": " + label_ : "State") + " should match one of the following values [ Valid | Expired | Free | Locked ] but you provided the value " + state
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "19zWDg2Ccm", message: message}]);
    }
    return messages;
  }

  function assertOptionalQuestionNo(questionNo, label_) {
    var messages = [];
    if (questionNo !== undefined && questionNo !== null) {
      messages = messages.concat(AvoAssert.assertString("1BxvMk6Nz6", label_ ? "Question No." + ": " + label_ : "Question No.", questionNo));
    }
    return messages;
  }

  function assertOptionalTopicName(topicName, label_) {
    var messages = [];
    if (topicName !== undefined && topicName !== null) {
      messages = messages.concat(AvoAssert.assertString("1Yc2cQ5iyN", label_ ? "Topic Name" + ": " + label_ : "Topic Name", topicName));
    }
    return messages;
  }

  function assertCountOfOnlineFriends(countOfOnlineFriends, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1hgGFRPeiA", label_ ? "Count of online friends" + ": " + label_ : "Count of online friends", countOfOnlineFriends));
    return messages;
  }

  function assertErrorMessage(errorMessage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1n3Bq4GKWy", label_ ? "Error Message" + ": " + label_ : "Error Message", errorMessage));
    return messages;
  }

  function assertOptionalErrorMessage(errorMessage, label_) {
    var messages = [];
    if (errorMessage !== undefined && errorMessage !== null) {
      messages = messages.concat(AvoAssert.assertString("1n3Bq4GKWy", label_ ? "Error Message" + ": " + label_ : "Error Message", errorMessage));
    }
    return messages;
  }

  function assertUserPersonaType(userPersonaType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("1z9szfE-j", label_ ? "User Persona Type" + ": " + label_ : "User Persona Type", userPersonaType));
    if ("class only" !== userPersonaType && "ptl" !== userPersonaType) {
      var message = (label_ ? "User Persona Type" + ": " + label_ : "User Persona Type") + " should match one of the following values [ class only | ptl ] but you provided the value " + userPersonaType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "1z9szfE-j", message: message}]);
    }
    return messages;
  }

  function assertSource(source, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("293juZE8KT", label_ ? "Source" + ": " + label_ : "Source", source));
    if ("Left Nav" !== source && "Tab" !== source) {
      var message = (label_ ? "Source" + ": " + label_ : "Source") + " should match one of the following values [ Left Nav | Tab ] but you provided the value " + source
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "293juZE8KT", message: message}]);
    }
    return messages;
  }

  function assertOptionalPercentClassInvited(percentClassInvited, label_) {
    var messages = [];
    if (percentClassInvited !== undefined && percentClassInvited !== null) {
      messages = messages.concat(AvoAssert.assertString("2Q7hpPm9y", label_ ? "Percent Class Invited" + ": " + label_ : "Percent Class Invited", percentClassInvited));
    }
    return messages;
  }

  function assertGameType(gameType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2da5NLAEc", label_ ? "Game Type" + ": " + label_ : "Game Type", gameType));
    return messages;
  }

  function assertOptionalGameType(gameType, label_) {
    var messages = [];
    if (gameType !== undefined && gameType !== null) {
      messages = messages.concat(AvoAssert.assertString("2da5NLAEc", label_ ? "Game Type" + ": " + label_ : "Game Type", gameType));
    }
    return messages;
  }

  function assertOptionalGameCode(gameCode, label_) {
    var messages = [];
    if (gameCode !== undefined && gameCode !== null) {
      messages = messages.concat(AvoAssert.assertString("2oZQdvXRu", label_ ? "Game Code" + ": " + label_ : "Game Code", gameCode));
    }
    return messages;
  }

  function assertGameCode(gameCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2oZQdvXRu", label_ ? "Game Code" + ": " + label_ : "Game Code", gameCode));
    return messages;
  }

  function assertQuestionType(questionType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2pLBcf4Iyi", label_ ? "Question Type" + ": " + label_ : "Question Type", questionType));
    if ("Single Select" !== questionType &&
          "Multi Select" !== questionType &&
          "Multi-Select with capped selections" !== questionType &&
          "Free Text" !== questionType && "Dropdown" !== questionType) {
      var message = (label_ ? "Question Type" + ": " + label_ : "Question Type") + " should match one of the following values [ Single Select | Multi Select | Multi-Select with capped selections | Free Text | Dropdown ] but you provided the value " + questionType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "2pLBcf4Iyi", message: message}]);
    }
    return messages;
  }

  function assertGrade(grade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("3LbQtKEdjc", label_ ? "Grade" + ": " + label_ : "Grade", grade));
    if ("1" !== grade && "2" !== grade && "3" !== grade && "4" !== grade &&
          "5" !== grade && "pk" !== grade && "k" !== grade && "NA" !== grade) {
      var message = (label_ ? "Grade" + ": " + label_ : "Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k | NA ] but you provided the value " + grade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "3LbQtKEdjc", message: message}]);
    }
    return messages;
  }

  function assertOptionalGrade(grade, label_) {
    var messages = [];
    if (grade !== undefined && grade !== null) {
      messages = messages.concat(AvoAssert.assertString("3LbQtKEdjc", label_ ? "Grade" + ": " + label_ : "Grade", grade));
      if ("1" !== grade && "2" !== grade && "3" !== grade && "4" !== grade &&
            "5" !== grade && "pk" !== grade && "k" !== grade &&
            "NA" !== grade) {
        var message = (label_ ? "Grade" + ": " + label_ : "Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k | NA ] but you provided the value " + grade
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "3LbQtKEdjc", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalStripePaymentMethodInfo(stripePaymentMethodInfo,
    label_) {
    var messages = [];
    if (stripePaymentMethodInfo !== undefined && stripePaymentMethodInfo !== null) {
      messages = messages.concat(AvoAssert.assertString("3kx20gfYw", label_ ? "Stripe Payment Method Info" + ": " + label_ : "Stripe Payment Method Info", stripePaymentMethodInfo));
    }
    return messages;
  }

  function assertMode(mode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("3pg8bY1LfC", label_ ? "Mode" + ": " + label_ : "Mode", mode));
    if ("school" !== mode && "home" !== mode && "b2chome" !== mode) {
      var message = (label_ ? "Mode" + ": " + label_ : "Mode") + " should match one of the following values [ school | home | b2chome ] but you provided the value " + mode
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "3pg8bY1LfC", message: message}]);
    }
    return messages;
  }

  function assertNudgeShownOnPage(nudgeShownOnPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("3ysDI0za_", label_ ? "Nudge Shown on Page" + ": " + label_ : "Nudge Shown on Page", nudgeShownOnPage));
    return messages;
  }

  function assertMFAssignedTo(mfAssignedTo, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4BthSPAer", label_ ? "MF Assigned To" + ": " + label_ : "MF Assigned To", mfAssignedTo));
    if ("Whole Class" !== mfAssignedTo &&
          "Selected Students" !== mfAssignedTo) {
      var message = (label_ ? "MF Assigned To" + ": " + label_ : "MF Assigned To") + " should match one of the following values [ Whole Class | Selected Students ] but you provided the value " + mfAssignedTo
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "4BthSPAer", message: message}]);
    }
    return messages;
  }

  function assertCertificatesEarned(certificatesEarned, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4DPFLSCCa", label_ ? "Certificates Earned" + ": " + label_ : "Certificates Earned", certificatesEarned));
    return messages;
  }

  function assertOptionalOrdering(ordering, label_) {
    var messages = [];
    if (ordering !== undefined && ordering !== null) {
      messages = messages.concat(AvoAssert.assertInt("4YcQJt7EU", label_ ? "Ordering" + ": " + label_ : "Ordering", ordering));
    }
    return messages;
  }

  function assertOrdering(ordering, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("4YcQJt7EU", label_ ? "Ordering" + ": " + label_ : "Ordering", ordering));
    return messages;
  }

  function assertWorksheetFilterAppliedOn(worksheetFilterAppliedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4bmBhSOqz4", label_ ? "Worksheet Filter Applied On" + ": " + label_ : "Worksheet Filter Applied On", worksheetFilterAppliedOn));
    if ("L1" !== worksheetFilterAppliedOn &&
          "L2" !== worksheetFilterAppliedOn &&
          "L3" !== worksheetFilterAppliedOn &&
          "L4" !== worksheetFilterAppliedOn &&
          "L5" !== worksheetFilterAppliedOn &&
          "L6" !== worksheetFilterAppliedOn) {
      var message = (label_ ? "Worksheet Filter Applied On" + ": " + label_ : "Worksheet Filter Applied On") + " should match one of the following values [ L1 | L2 | L3 | L4 | L5 | L6 ] but you provided the value " + worksheetFilterAppliedOn
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "4bmBhSOqz4", message: message}]);
    }
    return messages;
  }

  function assertFiredFrom(firedFrom, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4e2iM_rBA", label_ ? "Fired From" + ": " + label_ : "Fired From", firedFrom));
    return messages;
  }

  function assertOptionalStudentID(studentId, label_) {
    var messages = [];
    if (studentId !== undefined && studentId !== null) {
      messages = messages.concat(AvoAssert.assertList("5IEpaITD9", "Student ID", studentId));
      studentId.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertCountOfSearchResults(countOfSearchResults, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("5OAHrQIZt", label_ ? "Count of Search Results" + ": " + label_ : "Count of Search Results", countOfSearchResults));
    return messages;
  }

  function assertOptionalDashboardVersion(dashboardVersion, label_) {
    var messages = [];
    if (dashboardVersion !== undefined && dashboardVersion !== null) {
      messages = messages.concat(AvoAssert.assertString("6QT3mtqEUD", label_ ? "Dashboard Version" + ": " + label_ : "Dashboard Version", dashboardVersion));
    }
    return messages;
  }

  function assertEndPoint(endPoint, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("6R8Dsubm7", label_ ? "End Point" + ": " + label_ : "End Point", endPoint));
    if ("Portal" !== endPoint && "Jungle" !== endPoint &&
          "City" !== endPoint && "Cafe" !== endPoint &&
          "Night Time Lobby" !== endPoint) {
      var message = (label_ ? "End Point" + ": " + label_ : "End Point") + " should match one of the following values [ Portal | Jungle | City | Cafe | Night Time Lobby ] but you provided the value " + endPoint
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "6R8Dsubm7", message: message}]);
    }
    return messages;
  }

  function assertOptionalRecommendedRailName(recommendedRailName, label_) {
    var messages = [];
    if (recommendedRailName !== undefined && recommendedRailName !== null) {
      messages = messages.concat(AvoAssert.assertString("6lrsWYY5Y", label_ ? "Recommended Rail Name" + ": " + label_ : "Recommended Rail Name", recommendedRailName));
    }
    return messages;
  }

  function assertRecommendedRailName(recommendedRailName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("6lrsWYY5Y", label_ ? "Recommended Rail Name" + ": " + label_ : "Recommended Rail Name", recommendedRailName));
    return messages;
  }

  function assertHoveredOver(hoveredOver, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7wbK1QRC0", label_ ? "Hovered Over" + ": " + label_ : "Hovered Over", hoveredOver));
    return messages;
  }

  function assertOptionalNextPlayableCode(nextPlayableCode, label_) {
    var messages = [];
    if (nextPlayableCode !== undefined && nextPlayableCode !== null) {
      messages = messages.concat(AvoAssert.assertString("88sHuVDRp", label_ ? "Next Playable Code" + ": " + label_ : "Next Playable Code", nextPlayableCode));
    }
    return messages;
  }

  function assertOptionalPlanAmount(planAmount, label_) {
    var messages = [];
    if (planAmount !== undefined && planAmount !== null) {
      messages = messages.concat(AvoAssert.assertInt("8ATWzSmrM", label_ ? "Plan Amount" + ": " + label_ : "Plan Amount", planAmount));
    }
    return messages;
  }

  function assertMFPracticeDaysCount(mfPracticeDaysCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("8mj3Kb8zsO", "MF Practice Days Count", mfPracticeDaysCount));
    if (mfPracticeDaysCount !== null && mfPracticeDaysCount !== undefined && mfPracticeDaysCount.forEach) {
      mfPracticeDaysCount.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertInt("8mj3Kb8zsO", "item at index " + index + " in MF Practice Days Count", value));
        messages = messages.concat(AvoAssert.assertMin("8mj3Kb8zsO", label_ ? "item at index " + index + " in MF Practice Days Count" + ": " + label_ : "item at index " + index + " in MF Practice Days Count", 1, value));
        messages = messages.concat(AvoAssert.assertInt("8mj3Kb8zsO", "item at index " + index + " in MF Practice Days Count", value));
        messages = messages.concat(AvoAssert.assertMax("8mj3Kb8zsO", label_ ? "item at index " + index + " in MF Practice Days Count" + ": " + label_ : "item at index " + index + " in MF Practice Days Count", 7, value));
      });
    }
    return messages;
  }

  function assertStatus(status, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9_Al8_kuam", label_ ? "Status" + ": " + label_ : "Status", status));
    if ("Success" !== status && "Failed" !== status) {
      var message = (label_ ? "Status" + ": " + label_ : "Status") + " should match one of the following values [ Success | Failed ] but you provided the value " + status
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "9_Al8_kuam", message: message}]);
    }
    return messages;
  }

  function assertClassName(className, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9dTrjsxjG", label_ ? "Class Name" + ": " + label_ : "Class Name", className));
    return messages;
  }

  function assertClickedOnCustomReportPage(clickedOnCustomReportPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9xTjWsrhLS", label_ ? "Clicked on- Custom Report Page" + ": " + label_ : "Clicked on- Custom Report Page", clickedOnCustomReportPage));
    if ("View Response" !== clickedOnCustomReportPage &&
          "Mark as Complete" !== clickedOnCustomReportPage &&
          "Edit Test" !== clickedOnCustomReportPage &&
          "Sort Students" !== clickedOnCustomReportPage) {
      var message = (label_ ? "Clicked on- Custom Report Page" + ": " + label_ : "Clicked on- Custom Report Page") + " should match one of the following values [ View Response | Mark as Complete | Edit Test | Sort Students ] but you provided the value " + clickedOnCustomReportPage
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "9xTjWsrhLS", message: message}]);
    }
    return messages;
  }

  function assertJoinEnabled(joinEnabled, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("A-lFlAcNj", label_ ? "Join Enabled" + ": " + label_ : "Join Enabled", joinEnabled));
    return messages;
  }

  function assertOptionalRecommendedMilestone(recommendedMilestone, label_) {
    var messages = [];
    if (recommendedMilestone !== undefined && recommendedMilestone !== null) {
      messages = messages.concat(AvoAssert.assertInt("ACsEf3MYO", label_ ? "Recommended Milestone" + ": " + label_ : "Recommended Milestone", recommendedMilestone));
    }
    return messages;
  }

  function assertSearchResultType(searchResultType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("AeBTQBXi0", label_ ? "Search Result Type" + ": " + label_ : "Search Result Type", searchResultType));
    return messages;
  }

  function assertOptionalStripePaymentElementRendered(
    stripePaymentElementRendered, label_) {
    var messages = [];
    if (stripePaymentElementRendered !== undefined && stripePaymentElementRendered !== null) {
      messages = messages.concat(AvoAssert.assertString("AjgnWgaBe", label_ ? "Stripe Payment Element Rendered" + ": " + label_ : "Stripe Payment Element Rendered", stripePaymentElementRendered));
    }
    return messages;
  }

  function assertMathGrade(mathGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BaOSrmfa3A", label_ ? "Math Grade" + ": " + label_ : "Math Grade", mathGrade));
    if ("1" !== mathGrade && "2" !== mathGrade && "3" !== mathGrade &&
          "4" !== mathGrade && "5" !== mathGrade && "pk" !== mathGrade &&
          "k" !== mathGrade) {
      var message = (label_ ? "Math Grade" + ": " + label_ : "Math Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k ] but you provided the value " + mathGrade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "BaOSrmfa3A", message: message}]);
    }
    return messages;
  }

  function assertTapType(tapType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CG846K8Ql", label_ ? "Tap Type" + ": " + label_ : "Tap Type", tapType));
    return messages;
  }

  function assertOptionalSetupIntentStatus(setupIntentStatus, label_) {
    var messages = [];
    if (setupIntentStatus !== undefined && setupIntentStatus !== null) {
      messages = messages.concat(AvoAssert.assertString("CGZP6dYmm", label_ ? "Setup Intent Status" + ": " + label_ : "Setup Intent Status", setupIntentStatus));
    }
    return messages;
  }

  function assertNudgeTitleMessage(nudgeTitleMessage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("CLVHX-1DH", label_ ? "Nudge Title Message" + ": " + label_ : "Nudge Title Message", nudgeTitleMessage));
    return messages;
  }

  function assertStateMachineTid(stateMachineTid, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("D325IngkY", label_ ? "State Machine Tid" + ": " + label_ : "State Machine Tid", stateMachineTid));
    return messages;
  }

  function assertEventName(eventName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("DmZydOAXd", "Event Name", eventName));
    if (eventName !== null && eventName !== undefined && eventName.forEach) {
      eventName.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertFrom(from, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ENjG288F1l", label_ ? "From" + ": " + label_ : "From", from));
    return messages;
  }

  function assertOptionalFrom(from, label_) {
    var messages = [];
    if (from !== undefined && from !== null) {
      messages = messages.concat(AvoAssert.assertString("ENjG288F1l", label_ ? "From" + ": " + label_ : "From", from));
    }
    return messages;
  }

  function assertQuizSubject(quizSubject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("El8KEuVMR", label_ ? "Quiz Subject" + ": " + label_ : "Quiz Subject", quizSubject));
    return messages;
  }

  function assertQuestion(question, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("EsalTilTi7", label_ ? "Question" + ": " + label_ : "Question", question));
    return messages;
  }

  function assertOptionalRecommendedTileRank(recommendedTileRank, label_) {
    var messages = [];
    if (recommendedTileRank !== undefined && recommendedTileRank !== null) {
      messages = messages.concat(AvoAssert.assertInt("FLDtSJNKL", label_ ? "Recommended Tile Rank" + ": " + label_ : "Recommended Tile Rank", recommendedTileRank));
    }
    return messages;
  }

  function assertTimerValue(timerValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FQr65Ct5y", label_ ? "Timer Value" + ": " + label_ : "Timer Value", timerValue));
    return messages;
  }

  function assertOptionalOptionsSelected(optionsSelected, label_) {
    var messages = [];
    if (optionsSelected !== undefined && optionsSelected !== null) {
      messages = messages.concat(AvoAssert.assertList("FZg42lPcF", "Options Selected", optionsSelected));
      optionsSelected.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalLiveClassName(liveClassName, label_) {
    var messages = [];
    if (liveClassName !== undefined && liveClassName !== null) {
      messages = messages.concat(AvoAssert.assertString("F__odFSVZ", label_ ? "Live Class Name" + ": " + label_ : "Live Class Name", liveClassName));
    }
    return messages;
  }

  function assertLiveClassName(liveClassName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("F__odFSVZ", label_ ? "Live Class Name" + ": " + label_ : "Live Class Name", liveClassName));
    return messages;
  }

  function assertOptionalGradeSelected(gradeSelected, label_) {
    var messages = [];
    if (gradeSelected !== undefined && gradeSelected !== null) {
      messages = messages.concat(AvoAssert.assertString("Fcl7PSdr4", label_ ? "Grade Selected" + ": " + label_ : "Grade Selected", gradeSelected));
      if ("pk" !== gradeSelected && "k" !== gradeSelected &&
            "1" !== gradeSelected && "2" !== gradeSelected &&
            "3" !== gradeSelected && "4" !== gradeSelected &&
            "5" !== gradeSelected) {
        var message = (label_ ? "Grade Selected" + ": " + label_ : "Grade Selected") + " should match one of the following values [ pk | k | 1 | 2 | 3 | 4 | 5 ] but you provided the value " + gradeSelected
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Fcl7PSdr4", message: message}]);
      }
    }
    return messages;
  }

  function assertOnboardingWidgetStepName(onboardingWidgetStepName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FyfKKmNk3", label_ ? "Onboarding Widget Step Name" + ": " + label_ : "Onboarding Widget Step Name", onboardingWidgetStepName));
    return messages;
  }

  function assertOptionalWallet(wallet, label_) {
    var messages = [];
    if (wallet !== undefined && wallet !== null) {
      messages = messages.concat(AvoAssert.assertString("G8FSLVPgG", label_ ? "Wallet" + ": " + label_ : "Wallet", wallet));
    }
    return messages;
  }

  function assertUserCity(userCity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Gh85Hi8uN0", label_ ? "User City" + ": " + label_ : "User City", userCity));
    return messages;
  }

  function assertFreeWorksheetsLeftCount(freeWorksheetsLeftCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("H4pP9av1w", label_ ? "Free Worksheets Left Count" + ": " + label_ : "Free Worksheets Left Count", freeWorksheetsLeftCount));
    return messages;
  }

  function assertOptionalFreeWorksheetsLeftCount(freeWorksheetsLeftCount,
    label_) {
    var messages = [];
    if (freeWorksheetsLeftCount !== undefined && freeWorksheetsLeftCount !== null) {
      messages = messages.concat(AvoAssert.assertString("H4pP9av1w", label_ ? "Free Worksheets Left Count" + ": " + label_ : "Free Worksheets Left Count", freeWorksheetsLeftCount));
    }
    return messages;
  }

  function assertActiveAssignment(activeAssignment, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("HMu5eJkRj5", label_ ? "Active Assignment" + ": " + label_ : "Active Assignment", activeAssignment));
    return messages;
  }

  function assertNewTopicSelected(newTopicSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HkxSt1enX", label_ ? "New Topic Selected" + ": " + label_ : "New Topic Selected", newTopicSelected));
    return messages;
  }

  function assertWorksheetGrade(worksheetGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HqigT1cZJV", label_ ? "Worksheet Grade" + ": " + label_ : "Worksheet Grade", worksheetGrade));
    if ("k" !== worksheetGrade && "1" !== worksheetGrade &&
          "2" !== worksheetGrade && "3" !== worksheetGrade &&
          "4" !== worksheetGrade && "5" !== worksheetGrade) {
      var message = (label_ ? "Worksheet Grade" + ": " + label_ : "Worksheet Grade") + " should match one of the following values [ k | 1 | 2 | 3 | 4 | 5 ] but you provided the value " + worksheetGrade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "HqigT1cZJV", message: message}]);
    }
    return messages;
  }

  function assertReportType(reportType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Iye0o_TlZ0", label_ ? "Report Type" + ": " + label_ : "Report Type", reportType));
    if ("Grid" !== reportType && "Group" !== reportType) {
      var message = (label_ ? "Report Type" + ": " + label_ : "Report Type") + " should match one of the following values [ Grid | Group ] but you provided the value " + reportType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Iye0o_TlZ0", message: message}]);
    }
    return messages;
  }

  function assertOptionalSelectedMilestone(selectedMilestone, label_) {
    var messages = [];
    if (selectedMilestone !== undefined && selectedMilestone !== null) {
      messages = messages.concat(AvoAssert.assertInt("J8GQmfwD7", label_ ? "Selected Milestone" + ": " + label_ : "Selected Milestone", selectedMilestone));
    }
    return messages;
  }

  function assertOptionalErrorCode(errorCode, label_) {
    var messages = [];
    if (errorCode !== undefined && errorCode !== null) {
      messages = messages.concat(AvoAssert.assertString("JSl62lgk3", label_ ? "Error Code" + ": " + label_ : "Error Code", errorCode));
    }
    return messages;
  }

  function assertGameEngine(gameEngine, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("JVkBdMN1_", label_ ? "Game Engine" + ": " + label_ : "Game Engine", gameEngine));
    return messages;
  }

  function assertGameNamePosition(gameNamePosition, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("JnQC7Gu0QJ", label_ ? "Game Name Position" + ": " + label_ : "Game Name Position", gameNamePosition));
    return messages;
  }

  function assertVoText(voText, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("KEGhoZGvu", label_ ? "Vo Text" + ": " + label_ : "Vo Text", voText));
    return messages;
  }

  function assertOptionalOTPEntered(otpEntered, label_) {
    var messages = [];
    if (otpEntered !== undefined && otpEntered !== null) {
      messages = messages.concat(AvoAssert.assertBool("KQDoDel93", label_ ? "OTP Entered" + ": " + label_ : "OTP Entered", otpEntered));
    }
    return messages;
  }

  function assertClickedOnTrackCustomPage(clickedOnTrackCustomPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("LqyojH3QzY", label_ ? "Clicked on - Track Custom Page" + ": " + label_ : "Clicked on - Track Custom Page", clickedOnTrackCustomPage));
    if ("View Report" !== clickedOnTrackCustomPage &&
          "Print Worksheet" !== clickedOnTrackCustomPage &&
          "Edit Test" !== clickedOnTrackCustomPage &&
          "Mark as Complete" !== clickedOnTrackCustomPage &&
          "Copy Practice Link" !== clickedOnTrackCustomPage &&
          "Delete Test" !== clickedOnTrackCustomPage) {
      var message = (label_ ? "Clicked on - Track Custom Page" + ": " + label_ : "Clicked on - Track Custom Page") + " should match one of the following values [ View Report | Print Worksheet | Edit Test | Mark as Complete | Copy Practice Link | Delete Test ] but you provided the value " + clickedOnTrackCustomPage
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "LqyojH3QzY", message: message}]);
    }
    return messages;
  }

  function assertCompanionState(companionState, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MBcj_KFnG", label_ ? "Companion State" + ": " + label_ : "Companion State", companionState));
    return messages;
  }

  function assertPageName(pageName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MJKSzmqfHu", label_ ? "Page Name" + ": " + label_ : "Page Name", pageName));
    return messages;
  }

  function assertCertificateName(certificateName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("MfWi2aBDZ", label_ ? "Certificate Name" + ": " + label_ : "Certificate Name", certificateName));
    return messages;
  }

  function assertOptionalSubscriptionPlan(subscriptionPlan, label_) {
    var messages = [];
    if (subscriptionPlan !== undefined && subscriptionPlan !== null) {
      messages = messages.concat(AvoAssert.assertString("N8pv_Xjhj", label_ ? "Subscription Plan" + ": " + label_ : "Subscription Plan", subscriptionPlan));
    }
    return messages;
  }

  function assertDaysSinceSY23Onboarding(daysSinceSy23Onboarding, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("NF129Gymtv", label_ ? "Days Since SY23 Onboarding" + ": " + label_ : "Days Since SY23 Onboarding", daysSinceSy23Onboarding));
    messages = messages.concat(AvoAssert.assertMin("NF129Gymtv", label_ ? "Days Since SY23 Onboarding" + ": " + label_ : "Days Since SY23 Onboarding", 0, daysSinceSy23Onboarding));
    return messages;
  }

  function assertUserIntervention(userIntervention, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("NPXDMFP1_", label_ ? "User Intervention" + ": " + label_ : "User Intervention", userIntervention));
    return messages;
  }

  function assertOptionalWorksheetCode(worksheetCode, label_) {
    var messages = [];
    if (worksheetCode !== undefined && worksheetCode !== null) {
      messages = messages.concat(AvoAssert.assertString("NRFYZYLxy", label_ ? "Worksheet Code" + ": " + label_ : "Worksheet Code", worksheetCode));
    }
    return messages;
  }

  function assertWorksheetCode(worksheetCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("NRFYZYLxy", label_ ? "Worksheet Code" + ": " + label_ : "Worksheet Code", worksheetCode));
    return messages;
  }

  function assertTutorName(tutorName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("NS3VU6-SM", label_ ? "Tutor Name" + ": " + label_ : "Tutor Name", tutorName));
    return messages;
  }

  function assertContentType(contentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Nfs9QLl8W7", label_ ? "Content Type" + ": " + label_ : "Content Type", contentType));
    return messages;
  }

  function assertOptionalContentType(contentType, label_) {
    var messages = [];
    if (contentType !== undefined && contentType !== null) {
      messages = messages.concat(AvoAssert.assertString("Nfs9QLl8W7", label_ ? "Content Type" + ": " + label_ : "Content Type", contentType));
    }
    return messages;
  }

  function assertEnabledCTA(enabledCta, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Nspz0JPS5", label_ ? "Enabled CTA" + ": " + label_ : "Enabled CTA", enabledCta));
    return messages;
  }

  function assertOptionalClickedOn(clickedOn, label_) {
    var messages = [];
    if (clickedOn !== undefined && clickedOn !== null) {
      messages = messages.concat(AvoAssert.assertString("O0dEFLrgl", label_ ? "Clicked On" + ": " + label_ : "Clicked On", clickedOn));
    }
    return messages;
  }

  function assertClickedOn(clickedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("O0dEFLrgl", label_ ? "Clicked On" + ": " + label_ : "Clicked On", clickedOn));
    return messages;
  }

  function assertQuizGrade(quizGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("OdOreTGEK", label_ ? "Quiz Grade" + ": " + label_ : "Quiz Grade", quizGrade));
    return messages;
  }

  function assertOptionalContentGroup(contentGroup, label_) {
    var messages = [];
    if (contentGroup !== undefined && contentGroup !== null) {
      messages = messages.concat(AvoAssert.assertString("Otu1r2JQW", label_ ? "Content Group" + ": " + label_ : "Content Group", contentGroup));
    }
    return messages;
  }

  function assertContentGroup(contentGroup, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Otu1r2JQW", label_ ? "Content Group" + ": " + label_ : "Content Group", contentGroup));
    return messages;
  }

  function assertOpponentCity(opponentCity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("P9dar0xMXW", label_ ? "Opponent City" + ": " + label_ : "Opponent City", opponentCity));
    return messages;
  }

  function assertOptionalSetupIntentId(setupIntentId, label_) {
    var messages = [];
    if (setupIntentId !== undefined && setupIntentId !== null) {
      messages = messages.concat(AvoAssert.assertString("PFXfXOuvy", label_ ? "Setup Intent Id" + ": " + label_ : "Setup Intent Id", setupIntentId));
    }
    return messages;
  }

  function assertOptionalInteractionType(interactionType, label_) {
    var messages = [];
    if (interactionType !== undefined && interactionType !== null) {
      messages = messages.concat(AvoAssert.assertString("PokUqOLpg8", label_ ? "Interaction Type" + ": " + label_ : "Interaction Type", interactionType));
      if ("Clicked" !== interactionType && "Scrolled" !== interactionType &&
            "Hovered" !== interactionType && "Heard" !== interactionType) {
        var message = (label_ ? "Interaction Type" + ": " + label_ : "Interaction Type") + " should match one of the following values [ Clicked | Scrolled | Hovered | Heard ] but you provided the value " + interactionType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "PokUqOLpg8", message: message}]);
      }
    }
    return messages;
  }

  function assertInteractionType(interactionType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PokUqOLpg8", label_ ? "Interaction Type" + ": " + label_ : "Interaction Type", interactionType));
    if ("Clicked" !== interactionType && "Scrolled" !== interactionType &&
          "Hovered" !== interactionType && "Heard" !== interactionType) {
      var message = (label_ ? "Interaction Type" + ": " + label_ : "Interaction Type") + " should match one of the following values [ Clicked | Scrolled | Hovered | Heard ] but you provided the value " + interactionType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "PokUqOLpg8", message: message}]);
    }
    return messages;
  }

  function assertSpringboardRank(springboardRank, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PpLUQoMje", label_ ? "Springboard Rank" + ": " + label_ : "Springboard Rank", springboardRank));
    return messages;
  }

  function assertClass(class_, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PxWDGuxq95", label_ ? "Class" + ": " + label_ : "Class", class_));
    return messages;
  }

  function assertSubject(subject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QE2CTvenDi", label_ ? "Subject" + ": " + label_ : "Subject", subject));
    if ("Math" !== subject && "Reading" !== subject &&
          "Extra Curriculum" !== subject && "ELA" !== subject &&
          "ela" !== subject && "math" !== subject &&
          "extra curriculum" !== subject && "reading" !== subject) {
      var message = (label_ ? "Subject" + ": " + label_ : "Subject") + " should match one of the following values [ Math | Reading | Extra Curriculum | ELA | ela | math | extra curriculum | reading ] but you provided the value " + subject
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "QE2CTvenDi", message: message}]);
    }
    return messages;
  }

  function assertOptionalSubject(subject, label_) {
    var messages = [];
    if (subject !== undefined && subject !== null) {
      messages = messages.concat(AvoAssert.assertString("QE2CTvenDi", label_ ? "Subject" + ": " + label_ : "Subject", subject));
      if ("Math" !== subject && "Reading" !== subject &&
            "Extra Curriculum" !== subject && "ELA" !== subject &&
            "ela" !== subject && "math" !== subject &&
            "extra curriculum" !== subject && "reading" !== subject) {
        var message = (label_ ? "Subject" + ": " + label_ : "Subject") + " should match one of the following values [ Math | Reading | Extra Curriculum | ELA | ela | math | extra curriculum | reading ] but you provided the value " + subject
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "QE2CTvenDi", message: message}]);
      }
    }
    return messages;
  }

  function assertPlayableCode(playableCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QjCwFasvW0", label_ ? "Playable Code" + ": " + label_ : "Playable Code", playableCode));
    return messages;
  }

  function assertOptionalPlayableCode(playableCode, label_) {
    var messages = [];
    if (playableCode !== undefined && playableCode !== null) {
      messages = messages.concat(AvoAssert.assertString("QjCwFasvW0", label_ ? "Playable Code" + ": " + label_ : "Playable Code", playableCode));
    }
    return messages;
  }

  function assertSlide(slide, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("Qo8RFu5jt2", label_ ? "Slide" + ": " + label_ : "Slide", slide));
    messages = messages.concat(AvoAssert.assertMin("Qo8RFu5jt2", label_ ? "Slide" + ": " + label_ : "Slide", 1, slide));
    messages = messages.concat(AvoAssert.assertMax("Qo8RFu5jt2", label_ ? "Slide" + ": " + label_ : "Slide", 3, slide));
    return messages;
  }

  function assertFlowName(flowName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QvqHzz_24", label_ ? "Flow Name" + ": " + label_ : "Flow Name", flowName));
    return messages;
  }

  function assertQuizMeetingSlug(quizMeetingSlug, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QwEJtFNQB", label_ ? "Quiz Meeting Slug" + ": " + label_ : "Quiz Meeting Slug", quizMeetingSlug));
    return messages;
  }

  function assertGameMode(gameMode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SCiKCU5kRo", label_ ? "Game Mode" + ": " + label_ : "Game Mode", gameMode));
    if ("pwc" !== gameMode && "solo" !== gameMode && "1_v_1" !== gameMode) {
      var message = (label_ ? "Game Mode" + ": " + label_ : "Game Mode") + " should match one of the following values [ pwc | solo | 1_v_1 ] but you provided the value " + gameMode
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "SCiKCU5kRo", message: message}]);
    }
    return messages;
  }

  function assertTid(tid, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SYGmTqa9e", label_ ? "Tid" + ": " + label_ : "Tid", tid));
    return messages;
  }

  function assertOptionalColumnPosition(columnPosition, label_) {
    var messages = [];
    if (columnPosition !== undefined && columnPosition !== null) {
      messages = messages.concat(AvoAssert.assertInt("Sq_wyVgw4s", label_ ? "Column Position" + ": " + label_ : "Column Position", columnPosition));
    }
    return messages;
  }

  function assertInteractedWith(interactedWith, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ssr_b4cA9A", label_ ? "Interacted With" + ": " + label_ : "Interacted With", interactedWith));
    if ("Take a Tour" !== interactedWith &&
          "I'll take it later" !== interactedWith) {
      var message = (label_ ? "Interacted With" + ": " + label_ : "Interacted With") + " should match one of the following values [ Take a Tour | I'll take it later ] but you provided the value " + interactedWith
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Ssr_b4cA9A", message: message}]);
    }
    return messages;
  }

  function assertCertificateType(certificateType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("T1COE_Of2", label_ ? "Certificate Type" + ": " + label_ : "Certificate Type", certificateType));
    return messages;
  }

  function assertStateMachineCode(stateMachineCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("T9gjnp76o", label_ ? "State Machine Code" + ": " + label_ : "State Machine Code", stateMachineCode));
    return messages;
  }

  function assertOptionalScrolledThrough(scrolledThrough, label_) {
    var messages = [];
    if (scrolledThrough !== undefined && scrolledThrough !== null) {
      messages = messages.concat(AvoAssert.assertString("TLBtHE5cOx", label_ ? "Scrolled Through" + ": " + label_ : "Scrolled Through", scrolledThrough));
      if ("Multiplayer Games" !== scrolledThrough &&
            "Activities" !== scrolledThrough &&
            "Rewards" !== scrolledThrough &&
            "Foundational Games" !== scrolledThrough &&
            "Advanced Games" !== scrolledThrough &&
            "Logic & Thinking" !== scrolledThrough &&
            "Art & Creativity" !== scrolledThrough &&
            "General Knowledge" !== scrolledThrough) {
        var message = (label_ ? "Scrolled Through" + ": " + label_ : "Scrolled Through") + " should match one of the following values [ Multiplayer Games | Activities | Rewards | Foundational Games | Advanced Games | Logic & Thinking | Art & Creativity | General Knowledge ] but you provided the value " + scrolledThrough
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "TLBtHE5cOx", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalRecommendedTileName(recommendedTileName, label_) {
    var messages = [];
    if (recommendedTileName !== undefined && recommendedTileName !== null) {
      messages = messages.concat(AvoAssert.assertString("TYbmk5DQn", label_ ? "Recommended Tile Name" + ": " + label_ : "Recommended Tile Name", recommendedTileName));
    }
    return messages;
  }

  function assertOptionalUrl(url, label_) {
    var messages = [];
    if (url !== undefined && url !== null) {
      messages = messages.concat(AvoAssert.assertString("ToCgaA4KN", label_ ? "Url" + ": " + label_ : "Url", url));
    }
    return messages;
  }

  function assertUrl(url, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ToCgaA4KN", label_ ? "Url" + ": " + label_ : "Url", url));
    return messages;
  }

  function assertOptionalNewGradeSelected(newGradeSelected, label_) {
    var messages = [];
    if (newGradeSelected !== undefined && newGradeSelected !== null) {
      messages = messages.concat(AvoAssert.assertString("Tps4I1ukM", label_ ? "New Grade Selected" + ": " + label_ : "New Grade Selected", newGradeSelected));
    }
    return messages;
  }

  function assertNewGradeSelected(newGradeSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Tps4I1ukM", label_ ? "New Grade Selected" + ": " + label_ : "New Grade Selected", newGradeSelected));
    return messages;
  }

  function assertModifiedOperator(modifiedOperator, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("Tz8yoJEXaS", label_ ? "Modified Operator" + ": " + label_ : "Modified Operator", modifiedOperator));
    return messages;
  }

  function assertOpponentType(opponentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("U2QSiMZrpE", label_ ? "Opponent Type" + ": " + label_ : "Opponent Type", opponentType));
    if ("Bot" !== opponentType && "Student" !== opponentType) {
      var message = (label_ ? "Opponent Type" + ": " + label_ : "Opponent Type") + " should match one of the following values [ Bot | Student ] but you provided the value " + opponentType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "U2QSiMZrpE", message: message}]);
    }
    return messages;
  }

  function assertWorksheetFilterValue(worksheetFilterValue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("UGULV7SI7o", label_ ? "Worksheet Filter Value" + ": " + label_ : "Worksheet Filter Value", worksheetFilterValue));
    return messages;
  }

  function assertAssignmentType(assignmentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ueowl7sRb", label_ ? "Assignment Type" + ": " + label_ : "Assignment Type", assignmentType));
    return messages;
  }

  function assertModifiedFor(modifiedFor, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("UrJ4r6Tv4Q", label_ ? "Modified For" + ": " + label_ : "Modified For", modifiedFor));
    messages = messages.concat(AvoAssert.assertMin("UrJ4r6Tv4Q", label_ ? "Modified For" + ": " + label_ : "Modified For", 0, modifiedFor));
    return messages;
  }

  function assertOptionalTeacherType(teacherType, label_) {
    var messages = [];
    if (teacherType !== undefined && teacherType !== null) {
      messages = messages.concat(AvoAssert.assertString("UsQGEDnYDs", label_ ? "Teacher Type" + ": " + label_ : "Teacher Type", teacherType));
    }
    return messages;
  }

  function assertNumberOfResults(numberOfResults, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("UtPMQu4JE", label_ ? "Number of Results" + ": " + label_ : "Number of Results", numberOfResults));
    return messages;
  }

  function assertPlayablePlayed(playablePlayed, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("V16Tay7p5", label_ ? "Playable Played" + ": " + label_ : "Playable Played", playablePlayed));
    return messages;
  }

  function assertOptionalDiscountOfferingCodeApplied(
    discountOfferingCodeApplied, label_) {
    var messages = [];
    if (discountOfferingCodeApplied !== undefined && discountOfferingCodeApplied !== null) {
      messages = messages.concat(AvoAssert.assertString("VUkpaROVL", label_ ? "Discount Offering Code Applied" + ": " + label_ : "Discount Offering Code Applied", discountOfferingCodeApplied));
    }
    return messages;
  }

  function assertTotalProblemsAnswered(totalProblemsAnswered, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("V_eCbteEGc", label_ ? "Total Problems Answered" + ": " + label_ : "Total Problems Answered", totalProblemsAnswered));
    return messages;
  }

  function assertOptionalRecommendedCategory(recommendedCategory, label_) {
    var messages = [];
    if (recommendedCategory !== undefined && recommendedCategory !== null) {
      messages = messages.concat(AvoAssert.assertList("VdJhEU0H6s", "Recommended Category", recommendedCategory));
      recommendedCategory.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalDiscountType(discountType, label_) {
    var messages = [];
    if (discountType !== undefined && discountType !== null) {
      messages = messages.concat(AvoAssert.assertString("VdxNoqe4b", label_ ? "Discount Type" + ": " + label_ : "Discount Type", discountType));
    }
    return messages;
  }

  function assertMFMode(mfMode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("W2HLoVKJnA", label_ ? "MF Mode" + ": " + label_ : "MF Mode", mfMode));
    if ("Adaptive" !== mfMode && "Custom" !== mfMode) {
      var message = (label_ ? "MF Mode" + ": " + label_ : "MF Mode") + " should match one of the following values [ Adaptive | Custom ] but you provided the value " + mfMode
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "W2HLoVKJnA", message: message}]);
    }
    return messages;
  }

  function assertOptionalCardType(cardType, label_) {
    var messages = [];
    if (cardType !== undefined && cardType !== null) {
      messages = messages.concat(AvoAssert.assertString("WZ4UUsQFg", label_ ? "Card Type" + ": " + label_ : "Card Type", cardType));
      if ("Card Type not available" !== cardType && "debit" !== cardType &&
            "credit" !== cardType && "prepaid" !== cardType) {
        var message = (label_ ? "Card Type" + ": " + label_ : "Card Type") + " should match one of the following values [ Card Type not available | debit | credit | prepaid ] but you provided the value " + cardType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "WZ4UUsQFg", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalSubscriptionPlanStartsFromAmount(
    subscriptionPlanStartsFromAmount, label_) {
    var messages = [];
    if (subscriptionPlanStartsFromAmount !== undefined && subscriptionPlanStartsFromAmount !== null) {
      messages = messages.concat(AvoAssert.assertList("XIwdg9nE7", "Subscription Plan Starts From Amount", subscriptionPlanStartsFromAmount));
      subscriptionPlanStartsFromAmount.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertCustomMFOperatorSelected(customMfOperatorSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("XJ6AZrYTI-", "Custom MF Operator Selected", customMfOperatorSelected));
    if (customMfOperatorSelected !== null && customMfOperatorSelected !== undefined && customMfOperatorSelected.forEach) {
      customMfOperatorSelected.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertString("XJ6AZrYTI-", "item at index " + index + " in Custom MF Operator Selected", value));
        if ("Add" !== value && "Subtract" !== value &&
              "Multiply" !== value && "Divide" !== value) {
          var message = (label_ ? "item at index " + index + " in Custom MF Operator Selected" + ": " + label_ : "item at index " + index + " in Custom MF Operator Selected") + " should match one of the following values [ Add | Subtract | Multiply | Divide ] but you provided the value " + value
          messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "XJ6AZrYTI-", message: message}]);
        }
      });
    }
    return messages;
  }

  function assertMFOperatorSelected(mfOperatorSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("XkzC7k3g8c", label_ ? "MF Operator Selected" + ": " + label_ : "MF Operator Selected", mfOperatorSelected));
    if ("Addition & Subtraction" !== mfOperatorSelected &&
          "Multiplication & Division" !== mfOperatorSelected) {
      var message = (label_ ? "MF Operator Selected" + ": " + label_ : "MF Operator Selected") + " should match one of the following values [ Addition & Subtraction | Multiplication & Division ] but you provided the value " + mfOperatorSelected
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "XkzC7k3g8c", message: message}]);
    }
    return messages;
  }

  function assertOptionalLiveClassSubject(liveClassSubject, label_) {
    var messages = [];
    if (liveClassSubject !== undefined && liveClassSubject !== null) {
      messages = messages.concat(AvoAssert.assertString("Ys_LWCV8p", label_ ? "Live Class Subject" + ": " + label_ : "Live Class Subject", liveClassSubject));
    }
    return messages;
  }

  function assertLiveClassSubject(liveClassSubject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Ys_LWCV8p", label_ ? "Live Class Subject" + ": " + label_ : "Live Class Subject", liveClassSubject));
    return messages;
  }

  function assertOptionalIsRecommendedContent(isRecommendedContent, label_) {
    var messages = [];
    if (isRecommendedContent !== undefined && isRecommendedContent !== null) {
      messages = messages.concat(AvoAssert.assertString("YzXAIbKaI", label_ ? "Is Recommended Content" + ": " + label_ : "Is Recommended Content", isRecommendedContent));
    }
    return messages;
  }

  function assertOptionalGameName(gameName, label_) {
    var messages = [];
    if (gameName !== undefined && gameName !== null) {
      messages = messages.concat(AvoAssert.assertString("_L1z86KIYb", label_ ? "Game Name" + ": " + label_ : "Game Name", gameName));
    }
    return messages;
  }

  function assertGameName(gameName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_L1z86KIYb", label_ ? "Game Name" + ": " + label_ : "Game Name", gameName));
    return messages;
  }

  function assertCACompletedSuccessfully(caCompletedSuccessfully, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("_YDbEIGLh", label_ ? "CA Completed Successfully" + ": " + label_ : "CA Completed Successfully", caCompletedSuccessfully));
    return messages;
  }

  function assertQuestionNumber(questionNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_cuCZnBI_", label_ ? "Question Number" + ": " + label_ : "Question Number", questionNumber));
    return messages;
  }

  function assertClickedOnNewMFPractice(clickedOnNewMfPractice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_fUyjKBzmx", label_ ? "Clicked on - New MF Practice" + ": " + label_ : "Clicked on - New MF Practice", clickedOnNewMfPractice));
    if ("Assign Adaptive Practice" !== clickedOnNewMfPractice &&
          "Create Custom Test" !== clickedOnNewMfPractice) {
      var message = (label_ ? "Clicked on - New MF Practice" + ": " + label_ : "Clicked on - New MF Practice") + " should match one of the following values [ Assign Adaptive Practice | Create Custom Test ] but you provided the value " + clickedOnNewMfPractice
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "_fUyjKBzmx", message: message}]);
    }
    return messages;
  }

  function assertQuizCode(quizCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_gr4kO5vEN", label_ ? "Quiz Code" + ": " + label_ : "Quiz Code", quizCode));
    return messages;
  }

  function assertNumberOfLearnCards(numberOfLearnCards, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_rbYN5Au4", label_ ? "Number of 'Learn' Cards" + ": " + label_ : "Number of 'Learn' Cards", numberOfLearnCards));
    return messages;
  }

  function assertOptionalRowNumber(rowNumber, label_) {
    var messages = [];
    if (rowNumber !== undefined && rowNumber !== null) {
      messages = messages.concat(AvoAssert.assertInt("a9l_OugqB", label_ ? "Row Number" + ": " + label_ : "Row Number", rowNumber));
    }
    return messages;
  }

  function assertRowNumber(rowNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("a9l_OugqB", label_ ? "Row Number" + ": " + label_ : "Row Number", rowNumber));
    return messages;
  }

  function assertLessonPlanName(lessonPlanName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("aESgK6MlY", label_ ? "Lesson Plan Name" + ": " + label_ : "Lesson Plan Name", lessonPlanName));
    return messages;
  }

  function assertWorksheetCategory(worksheetCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ahxpYE3lQW", label_ ? "Worksheet Category" + ": " + label_ : "Worksheet Category", worksheetCategory));
    return messages;
  }

  function assertQuestionCode(questionCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bZZvnMF1m", label_ ? "Question Code" + ": " + label_ : "Question Code", questionCode));
    return messages;
  }

  function assertPlayAgainState(playAgainState, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bZsbP1uDvn", label_ ? "Play Again State" + ": " + label_ : "Play Again State", playAgainState));
    if ("User initiated" !== playAgainState &&
          "Opponent Initiated" !== playAgainState &&
          "Friends joined" !== playAgainState) {
      var message = (label_ ? "Play Again State" + ": " + label_ : "Play Again State") + " should match one of the following values [ User initiated | Opponent Initiated | Friends joined ] but you provided the value " + playAgainState
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "bZsbP1uDvn", message: message}]);
    }
    return messages;
  }

  function assertMFAssignedStudentCount(mfAssignedStudentCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ba_sAWHkZP", label_ ? "MF Assigned Student Count" + ": " + label_ : "MF Assigned Student Count", mfAssignedStudentCount));
    messages = messages.concat(AvoAssert.assertMin("ba_sAWHkZP", label_ ? "MF Assigned Student Count" + ": " + label_ : "MF Assigned Student Count", 1, mfAssignedStudentCount));
    return messages;
  }

  function assertPlayableName(playableName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("c2W4X05Jy", label_ ? "Playable Name" + ": " + label_ : "Playable Name", playableName));
    return messages;
  }

  function assertOptionalPlayableName(playableName, label_) {
    var messages = [];
    if (playableName !== undefined && playableName !== null) {
      messages = messages.concat(AvoAssert.assertString("c2W4X05Jy", label_ ? "Playable Name" + ": " + label_ : "Playable Name", playableName));
    }
    return messages;
  }

  function assertOptionalReferrerPage(referrerPage, label_) {
    var messages = [];
    if (referrerPage !== undefined && referrerPage !== null) {
      messages = messages.concat(AvoAssert.assertString("cYVv-jM3n6", label_ ? "Referrer Page" + ": " + label_ : "Referrer Page", referrerPage));
    }
    return messages;
  }

  function assertTappedOn(tappedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("cfvmMqWft", label_ ? "Tapped On" + ": " + label_ : "Tapped On", tappedOn));
    return messages;
  }

  function assertAnswer(answer, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("coqPCyLyxy", label_ ? "Answer" + ": " + label_ : "Answer", answer));
    return messages;
  }

  function assertTeacherName(teacherName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("d4VuJfq-Y", label_ ? "Teacher Name" + ": " + label_ : "Teacher Name", teacherName));
    return messages;
  }

  function assertOptionalPaymentMethodClicked(paymentMethodClicked, label_) {
    var messages = [];
    if (paymentMethodClicked !== undefined && paymentMethodClicked !== null) {
      messages = messages.concat(AvoAssert.assertString("dVRLZ1nWs", label_ ? "Payment Method Clicked" + ": " + label_ : "Payment Method Clicked", paymentMethodClicked));
    }
    return messages;
  }

  function assertClassType(classType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("dk2bhnFne", label_ ? "Class Type" + ": " + label_ : "Class Type", classType));
    if ("Google Classroom" !== classType && "Clever" !== classType &&
          "Manual" !== classType) {
      var message = (label_ ? "Class Type" + ": " + label_ : "Class Type") + " should match one of the following values [ Google Classroom | Clever | Manual ] but you provided the value " + classType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "dk2bhnFne", message: message}]);
    }
    return messages;
  }

  function assertOptionalELAAssignmentCount(elaAssignmentCount, label_) {
    var messages = [];
    if (elaAssignmentCount !== undefined && elaAssignmentCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("dqG7mb_H0j", label_ ? "ELA Assignment Count" + ": " + label_ : "ELA Assignment Count", elaAssignmentCount));
      messages = messages.concat(AvoAssert.assertMin("dqG7mb_H0j", label_ ? "ELA Assignment Count" + ": " + label_ : "ELA Assignment Count", 0, elaAssignmentCount));
    }
    return messages;
  }

  function assertOptionalRecommendedRail(recommendedRail, label_) {
    var messages = [];
    if (recommendedRail !== undefined && recommendedRail !== null) {
      messages = messages.concat(AvoAssert.assertList("drNgwJn5Xg", "Recommended Rail", recommendedRail));
      recommendedRail.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertRecommendedRail(recommendedRail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("drNgwJn5Xg", "Recommended Rail", recommendedRail));
    if (recommendedRail !== null && recommendedRail !== undefined && recommendedRail.forEach) {
      recommendedRail.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertAnimationURL(animationUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("dt9ueOw7v", label_ ? "Animation URL" + ": " + label_ : "Animation URL", animationUrl));
    return messages;
  }

  function assertOptionalColumnNumber(columnNumber, label_) {
    var messages = [];
    if (columnNumber !== undefined && columnNumber !== null) {
      messages = messages.concat(AvoAssert.assertInt("eGs90Bi3pM", label_ ? "Column Number" + ": " + label_ : "Column Number", columnNumber));
    }
    return messages;
  }

  function assertColumnNumber(columnNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("eGs90Bi3pM", label_ ? "Column Number" + ": " + label_ : "Column Number", columnNumber));
    return messages;
  }

  function assertOptionalSubscriptionPlanName(subscriptionPlanName, label_) {
    var messages = [];
    if (subscriptionPlanName !== undefined && subscriptionPlanName !== null) {
      messages = messages.concat(AvoAssert.assertString("eOj3JBu_S", label_ ? "Subscription Plan Name" + ": " + label_ : "Subscription Plan Name", subscriptionPlanName));
    }
    return messages;
  }

  function assertClassSize(classSize, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("erbI-IRpim", label_ ? "Class Size" + ": " + label_ : "Class Size", classSize));
    messages = messages.concat(AvoAssert.assertMin("erbI-IRpim", label_ ? "Class Size" + ": " + label_ : "Class Size", 0, classSize));
    return messages;
  }

  function assertModifiedDays(modifiedDays, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("fvYVVEdCul", label_ ? "Modified Days" + ": " + label_ : "Modified Days", modifiedDays));
    return messages;
  }

  function assertNumberOfMasterCards(numberOfMasterCards, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("fwzqzcIZ4", label_ ? "Number of 'Master' Cards" + ": " + label_ : "Number of 'Master' Cards", numberOfMasterCards));
    return messages;
  }

  function assertWorksheetName(worksheetName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("g8uPZdwOmF", label_ ? "Worksheet Name" + ": " + label_ : "Worksheet Name", worksheetName));
    return messages;
  }

  function assertCountOfGamesToJoin(countOfGamesToJoin, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gTDYzkiHPP", label_ ? "Count of games to join" + ": " + label_ : "Count of games to join", countOfGamesToJoin));
    return messages;
  }

  function assertTotalTimeTaken(totalTimeTaken, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gTep6toPK0", label_ ? "Total Time Taken" + ": " + label_ : "Total Time Taken", totalTimeTaken));
    return messages;
  }

  function assertSearchTerm(searchTerm, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("guJOTwi5T", label_ ? "Search Term" + ": " + label_ : "Search Term", searchTerm));
    return messages;
  }

  function assertContentCode(contentCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gwbjSWtxS", label_ ? "Content Code" + ": " + label_ : "Content Code", contentCode));
    return messages;
  }

  function assertMFCustomSettingsClickedOn(mfCustomSettingsClickedOn, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("h2KwMOlZr5", label_ ? "MF Custom Settings - Clicked On" + ": " + label_ : "MF Custom Settings - Clicked On", mfCustomSettingsClickedOn));
    if ("Print Worksheet" !== mfCustomSettingsClickedOn &&
          "Select Students" !== mfCustomSettingsClickedOn) {
      var message = (label_ ? "MF Custom Settings - Clicked On" + ": " + label_ : "MF Custom Settings - Clicked On") + " should match one of the following values [ Print Worksheet | Select Students ] but you provided the value " + mfCustomSettingsClickedOn
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "h2KwMOlZr5", message: message}]);
    }
    return messages;
  }

  function assertTotalAssignmentCount(totalAssignmentCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", totalAssignmentCount));
    messages = messages.concat(AvoAssert.assertMin("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", 0, totalAssignmentCount));
    return messages;
  }

  function assertOptionalTotalAssignmentCount(totalAssignmentCount, label_) {
    var messages = [];
    if (totalAssignmentCount !== undefined && totalAssignmentCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", totalAssignmentCount));
      messages = messages.concat(AvoAssert.assertMin("hBgoB0mPff", label_ ? "Total Assignment Count" + ": " + label_ : "Total Assignment Count", 0, totalAssignmentCount));
    }
    return messages;
  }

  function assertOptionalCategory(category, label_) {
    var messages = [];
    if (category !== undefined && category !== null) {
      messages = messages.concat(AvoAssert.assertString("hVOa_xHVR", label_ ? "Category" + ": " + label_ : "Category", category));
    }
    return messages;
  }

  function assertCategory(category, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hVOa_xHVR", label_ ? "Category" + ": " + label_ : "Category", category));
    return messages;
  }

  function assertCoachmarkText(coachmarkText, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("htmKRbaew", label_ ? "Coachmark Text" + ": " + label_ : "Coachmark Text", coachmarkText));
    return messages;
  }

  function assertMilestoneSelected(milestoneSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("iMRbxEjXB", label_ ? "Milestone Selected" + ": " + label_ : "Milestone Selected", milestoneSelected));
    return messages;
  }

  function assertReachedVia(reachedVia, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("iRAn4RfO3I", label_ ? "Reached Via" + ": " + label_ : "Reached Via", reachedVia));
    if ("New Fact Practice" !== reachedVia &&
          "Track Fact Practice" !== reachedVia) {
      var message = (label_ ? "Reached Via" + ": " + label_ : "Reached Via") + " should match one of the following values [ New Fact Practice | Track Fact Practice ] but you provided the value " + reachedVia
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "iRAn4RfO3I", message: message}]);
    }
    return messages;
  }

  function assertWinner(winner, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("j-WLQ2tjI", label_ ? "Winner" + ": " + label_ : "Winner", winner));
    if ("Bot" !== winner && "Student" !== winner) {
      var message = (label_ ? "Winner" + ": " + label_ : "Winner") + " should match one of the following values [ Bot | Student ] but you provided the value " + winner
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "j-WLQ2tjI", message: message}]);
    }
    return messages;
  }

  function assertOptionalLevel1Topic(level1Topic, label_) {
    var messages = [];
    if (level1Topic !== undefined && level1Topic !== null) {
      messages = messages.concat(AvoAssert.assertString("jHXiFNYU2", label_ ? "Level 1 Topic" + ": " + label_ : "Level 1 Topic", level1Topic));
    }
    return messages;
  }

  function assertQuestionIndex(questionIndex, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("jJNP65jPw7", label_ ? "Question Index" + ": " + label_ : "Question Index", questionIndex));
    messages = messages.concat(AvoAssert.assertMin("jJNP65jPw7", label_ ? "Question Index" + ": " + label_ : "Question Index", 1, questionIndex));
    return messages;
  }

  function assertOptionalClickId(clickId, label_) {
    var messages = [];
    if (clickId !== undefined && clickId !== null) {
      messages = messages.concat(AvoAssert.assertString("jVQaLzj_1", label_ ? "Click Id" + ": " + label_ : "Click Id", clickId));
    }
    return messages;
  }

  function assertCurriculumAssignmentAvailable(curriculumAssignmentAvailable,
    label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("jiop2Ii29S", label_ ? "Curriculum Assignment Available" + ": " + label_ : "Curriculum Assignment Available", curriculumAssignmentAvailable));
    return messages;
  }

  function assertOptionalRoundNumber(roundNumber, label_) {
    var messages = [];
    if (roundNumber !== undefined && roundNumber !== null) {
      messages = messages.concat(AvoAssert.assertInt("jw_xpal_L1", label_ ? "Round Number" + ": " + label_ : "Round Number", roundNumber));
    }
    return messages;
  }

  function assertRoundNumber(roundNumber, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("jw_xpal_L1", label_ ? "Round Number" + ": " + label_ : "Round Number", roundNumber));
    return messages;
  }

  function assertQuizLiveClassId(quizLiveClassId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("kjjqNSO2f", label_ ? "Quiz Live Class Id" + ": " + label_ : "Quiz Live Class Id", quizLiveClassId));
    return messages;
  }

  function assertInteraction(interaction, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("kwwJ5LAMqN", label_ ? "Interaction" + ": " + label_ : "Interaction", interaction));
    return messages;
  }

  function assertValueName(valueName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("l-8JNUE0q", label_ ? "Value Name" + ": " + label_ : "Value Name", valueName));
    return messages;
  }

  function assertTabCode(tabCode, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("l9PbANZBu", label_ ? "Tab Code" + ": " + label_ : "Tab Code", tabCode));
    return messages;
  }

  function assertModifiedTime(modifiedTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("m-vmQiLuIl", label_ ? "Modified Time" + ": " + label_ : "Modified Time", modifiedTime));
    return messages;
  }

  function assertEmail(email, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("mGe3lMWlNY", label_ ? "Email" + ": " + label_ : "Email", email));
    return messages;
  }

  function assertOptionalRowPosition(rowPosition, label_) {
    var messages = [];
    if (rowPosition !== undefined && rowPosition !== null) {
      messages = messages.concat(AvoAssert.assertInt("mOXSzLg0Im", label_ ? "Row Position" + ": " + label_ : "Row Position", rowPosition));
    }
    return messages;
  }

  function assertContentName(contentName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("mWOBwcMoZ", label_ ? "Content Name" + ": " + label_ : "Content Name", contentName));
    return messages;
  }

  function assertOptionalMathAssignmentCount(mathAssignmentCount, label_) {
    var messages = [];
    if (mathAssignmentCount !== undefined && mathAssignmentCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("mdeQgK543Z", label_ ? "Math Assignment Count" + ": " + label_ : "Math Assignment Count", mathAssignmentCount));
      messages = messages.concat(AvoAssert.assertMin("mdeQgK543Z", label_ ? "Math Assignment Count" + ": " + label_ : "Math Assignment Count", 0, mathAssignmentCount));
    }
    return messages;
  }

  function assertOptionalSection(section, label_) {
    var messages = [];
    if (section !== undefined && section !== null) {
      messages = messages.concat(AvoAssert.assertString("my9qL7M8w6", label_ ? "Section" + ": " + label_ : "Section", section));
    }
    return messages;
  }

  function assertSection(section, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("my9qL7M8w6", label_ ? "Section" + ": " + label_ : "Section", section));
    return messages;
  }

  function assertLessonPlanSubject(lessonPlanSubject, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("n3rBqFq3X", label_ ? "Lesson Plan Subject" + ": " + label_ : "Lesson Plan Subject", lessonPlanSubject));
    return messages;
  }

  function assertOptionalClickedOnSection(clickedOnSection, label_) {
    var messages = [];
    if (clickedOnSection !== undefined && clickedOnSection !== null) {
      messages = messages.concat(AvoAssert.assertString("n4HbuwgZ_E", label_ ? "Clicked on Section" + ": " + label_ : "Clicked on Section", clickedOnSection));
    }
    return messages;
  }

  function assertOptionalDaysGoal(daysGoal, label_) {
    var messages = [];
    if (daysGoal !== undefined && daysGoal !== null) {
      messages = messages.concat(AvoAssert.assertList("nAyyn2Mnw", "Days Goal", daysGoal));
      daysGoal.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalSubscriberId(subscriberId, label_) {
    var messages = [];
    if (subscriberId !== undefined && subscriberId !== null) {
      messages = messages.concat(AvoAssert.assertString("nSwyEoLcJ", label_ ? "Subscriber Id" + ": " + label_ : "Subscriber Id", subscriberId));
    }
    return messages;
  }

  function assertFromPage(fromPage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("nbgkWrkHkN", label_ ? "From Page" + ": " + label_ : "From Page", fromPage));
    if ("Curriculum" !== fromPage && "Fact Practice" !== fromPage &&
          "Dashboard" !== fromPage && "Summer Learning" !== fromPage &&
          "Math Live Class" !== fromPage &&
          "Reading Live Class" !== fromPage) {
      var message = (label_ ? "From Page" + ": " + label_ : "From Page") + " should match one of the following values [ Curriculum | Fact Practice | Dashboard | Summer Learning | Math Live Class | Reading Live Class ] but you provided the value " + fromPage
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "nbgkWrkHkN", message: message}]);
    }
    return messages;
  }

  function assertOptionalInteractionDetails(interactionDetails, label_) {
    var messages = [];
    if (interactionDetails !== undefined && interactionDetails !== null) {
      messages = messages.concat(AvoAssert.assertString("ncdYto9gZ", label_ ? "Interaction Details" + ": " + label_ : "Interaction Details", interactionDetails));
      if ("Started Typing Credit Card Details" !== interactionDetails &&
            "Started Typing City" !== interactionDetails &&
            "Started Typing School" !== interactionDetails &&
            "Stopped Typing City" !== interactionDetails &&
            "Stopped Typing School" !== interactionDetails) {
        var message = (label_ ? "Interaction Details" + ": " + label_ : "Interaction Details") + " should match one of the following values [ Started Typing Credit Card Details | Started Typing City | Started Typing School | Stopped Typing City | Stopped Typing School ] but you provided the value " + interactionDetails
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "ncdYto9gZ", message: message}]);
      }
    }
    return messages;
  }

  function assertOptionalValidSavedCardExists(validSavedCardExists, label_) {
    var messages = [];
    if (validSavedCardExists !== undefined && validSavedCardExists !== null) {
      messages = messages.concat(AvoAssert.assertString("o_O7Lq7wz", label_ ? "Valid Saved Card Exists" + ": " + label_ : "Valid Saved Card Exists", validSavedCardExists));
      if ("Yes" !== validSavedCardExists && "No" !== validSavedCardExists) {
        var message = (label_ ? "Valid Saved Card Exists" + ": " + label_ : "Valid Saved Card Exists") + " should match one of the following values [ Yes | No ] but you provided the value " + validSavedCardExists
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "o_O7Lq7wz", message: message}]);
      }
    }
    return messages;
  }

  function assertSearchResultSelected(searchResultSelected, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("of6hlcB4H", label_ ? "Search Result Selected" + ": " + label_ : "Search Result Selected", searchResultSelected));
    return messages;
  }

  function assertScreenHeight(screenHeight, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ofwq9A74yc", label_ ? "Screen Height" + ": " + label_ : "Screen Height", screenHeight));
    return messages;
  }

  function assertView(view, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("p6UnsWI0U", label_ ? "View" + ": " + label_ : "View", view));
    if ("withcross" !== view && "withoutcross" !== view) {
      var message = (label_ ? "View" + ": " + label_ : "View") + " should match one of the following values [ withcross | withoutcross ] but you provided the value " + view
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "p6UnsWI0U", message: message}]);
    }
    return messages;
  }

  function assertInvitesAvailable(invitesAvailable, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("pFfp-zamld", label_ ? "Invites Available" + ": " + label_ : "Invites Available", invitesAvailable));
    return messages;
  }

  function assertOptionalSubscriptionPlansShown(subscriptionPlansShown,
    label_) {
    var messages = [];
    if (subscriptionPlansShown !== undefined && subscriptionPlansShown !== null) {
      messages = messages.concat(AvoAssert.assertList("pJEe4G1yr", "Subscription Plans Shown", subscriptionPlansShown));
      subscriptionPlansShown.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalGooglePayButtonAvailable(googlePayButtonAvailable,
    label_) {
    var messages = [];
    if (googlePayButtonAvailable !== undefined && googlePayButtonAvailable !== null) {
      messages = messages.concat(AvoAssert.assertString("pMtnCZl-R", label_ ? "Google Pay Button Available" + ": " + label_ : "Google Pay Button Available", googlePayButtonAvailable));
      if ("Yes" !== googlePayButtonAvailable &&
            "No" !== googlePayButtonAvailable) {
        var message = (label_ ? "Google Pay Button Available" + ": " + label_ : "Google Pay Button Available") + " should match one of the following values [ Yes | No ] but you provided the value " + googlePayButtonAvailable
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "pMtnCZl-R", message: message}]);
      }
    }
    return messages;
  }

  function assertStudentName(studentName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ptvPVC2md", label_ ? "Student Name" + ": " + label_ : "Student Name", studentName));
    return messages;
  }

  function assertElaGrade(elaGrade, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("qvkkIrTx4s", label_ ? "Ela Grade" + ": " + label_ : "Ela Grade", elaGrade));
    if ("1" !== elaGrade && "2" !== elaGrade && "3" !== elaGrade &&
          "4" !== elaGrade && "5" !== elaGrade && "pk" !== elaGrade &&
          "k" !== elaGrade && "NA" !== elaGrade) {
      var message = (label_ ? "Ela Grade" + ": " + label_ : "Ela Grade") + " should match one of the following values [ 1 | 2 | 3 | 4 | 5 | pk | k | NA ] but you provided the value " + elaGrade
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "qvkkIrTx4s", message: message}]);
    }
    return messages;
  }

  function assertIsGradeDifferent(isGradeDifferent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("qwCZiUS_99", label_ ? "Is Grade Different" + ": " + label_ : "Is Grade Different", isGradeDifferent));
    return messages;
  }

  function assertPlayerBand(playerBand, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rQb5nwMS5I", label_ ? "Player Band" + ": " + label_ : "Player Band", playerBand));
    return messages;
  }

  function assertOptionalErrorMessageFromApi(errorMessageFromApi, label_) {
    var messages = [];
    if (errorMessageFromApi !== undefined && errorMessageFromApi !== null) {
      messages = messages.concat(AvoAssert.assertString("rbMXuJsBw", label_ ? "Error Message From Api" + ": " + label_ : "Error Message From Api", errorMessageFromApi));
    }
    return messages;
  }

  function assertOptionalPosition(position, label_) {
    var messages = [];
    if (position !== undefined && position !== null) {
      messages = messages.concat(AvoAssert.assertInt("rlSRn44vYq", label_ ? "Position" + ": " + label_ : "Position", position));
    }
    return messages;
  }

  function assertMFPracticeQuestionsCount(mfPracticeQuestionsCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("rpd15EbJEO", label_ ? "MF Practice Questions Count" + ": " + label_ : "MF Practice Questions Count", mfPracticeQuestionsCount));
    if ("20" !== mfPracticeQuestionsCount &&
          "30" !== mfPracticeQuestionsCount &&
          "40" !== mfPracticeQuestionsCount) {
      var message = (label_ ? "MF Practice Questions Count" + ": " + label_ : "MF Practice Questions Count") + " should match one of the following values [ 20 | 30 | 40 ] but you provided the value " + mfPracticeQuestionsCount
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "rpd15EbJEO", message: message}]);
    }
    return messages;
  }

  function assertMaxWorksheetViewed(maxWorksheetViewed, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("s4DOhHgK_6", label_ ? "Max Worksheet Viewed" + ": " + label_ : "Max Worksheet Viewed", maxWorksheetViewed));
    return messages;
  }

  function assertOptionalClickedOnCategory(clickedOnCategory, label_) {
    var messages = [];
    if (clickedOnCategory !== undefined && clickedOnCategory !== null) {
      messages = messages.concat(AvoAssert.assertString("s4K0XLoiQ", label_ ? "Clicked on Category" + ": " + label_ : "Clicked on Category", clickedOnCategory));
    }
    return messages;
  }

  function assertOptionalPracticeTime(practiceTime, label_) {
    var messages = [];
    if (practiceTime !== undefined && practiceTime !== null) {
      messages = messages.concat(AvoAssert.assertString("sGjYFiQA4", label_ ? "Practice Time" + ": " + label_ : "Practice Time", practiceTime));
    }
    return messages;
  }

  function assertOptionalLiveClassWeek(liveClassWeek, label_) {
    var messages = [];
    if (liveClassWeek !== undefined && liveClassWeek !== null) {
      messages = messages.concat(AvoAssert.assertString("spiyY6nfy", label_ ? "Live Class Week" + ": " + label_ : "Live Class Week", liveClassWeek));
    }
    return messages;
  }

  function assertMFAssignmentAvailable(mfAssignmentAvailable, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("t3iU5mo89Y", label_ ? "MF Assignment Available" + ": " + label_ : "MF Assignment Available", mfAssignmentAvailable));
    return messages;
  }

  function assertPlayableType(playableType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("tHAI3DRE4", label_ ? "Playable Type" + ": " + label_ : "Playable Type", playableType));
    return messages;
  }

  function assertOptionalPlayableType(playableType, label_) {
    var messages = [];
    if (playableType !== undefined && playableType !== null) {
      messages = messages.concat(AvoAssert.assertString("tHAI3DRE4", label_ ? "Playable Type" + ": " + label_ : "Playable Type", playableType));
    }
    return messages;
  }

  function assertMFTimePerQuestion(mfTimePerQuestion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ti40sCZ5Kg", label_ ? "MF Time Per Question" + ": " + label_ : "MF Time Per Question", mfTimePerQuestion));
    if ("Off" !== mfTimePerQuestion && "5 Secs" !== mfTimePerQuestion &&
          "10 Secs" !== mfTimePerQuestion &&
          "15 Secs" !== mfTimePerQuestion && "20 Secs" !== mfTimePerQuestion) {
      var message = (label_ ? "MF Time Per Question" + ": " + label_ : "MF Time Per Question") + " should match one of the following values [ Off | 5 Secs | 10 Secs | 15 Secs | 20 Secs ] but you provided the value " + mfTimePerQuestion
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "ti40sCZ5Kg", message: message}]);
    }
    return messages;
  }

  function assertClassID(classId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("tmoviENyM", label_ ? "Class ID" + ": " + label_ : "Class ID", classId));
    return messages;
  }

  function assertOptionalRecommendedRailRank(recommendedRailRank, label_) {
    var messages = [];
    if (recommendedRailRank !== undefined && recommendedRailRank !== null) {
      messages = messages.concat(AvoAssert.assertInt("uyLgqxbg7", label_ ? "Recommended Rail Rank" + ": " + label_ : "Recommended Rail Rank", recommendedRailRank));
    }
    return messages;
  }

  function assertRecommendedRailRank(recommendedRailRank, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("uyLgqxbg7", label_ ? "Recommended Rail Rank" + ": " + label_ : "Recommended Rail Rank", recommendedRailRank));
    return messages;
  }

  function assertSearchResultPosition(searchResultPosition, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("vCfnwTQU8", label_ ? "Search Result Position" + ": " + label_ : "Search Result Position", searchResultPosition));
    return messages;
  }

  function assertUserCountry(userCountry, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("vHdXCmyiec", label_ ? "User Country" + ": " + label_ : "User Country", userCountry));
    return messages;
  }

  function assertOptionalGradeChanged(gradeChanged, label_) {
    var messages = [];
    if (gradeChanged !== undefined && gradeChanged !== null) {
      messages = messages.concat(AvoAssert.assertString("vbOzDO_fd", label_ ? "Grade Changed" + ": " + label_ : "Grade Changed", gradeChanged));
    }
    return messages;
  }

  function assertPlatform(platform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("vjELcWf4BG", label_ ? "Platform" + ": " + label_ : "Platform", platform));
    return messages;
  }

  function assertQuizName(quizName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("w5nsMhHyb", label_ ? "Quiz Name" + ": " + label_ : "Quiz Name", quizName));
    return messages;
  }

  function assertOpponentCountry(opponentCountry, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("wT_TBNcHj2", label_ ? "Opponent Country" + ": " + label_ : "Opponent Country", opponentCountry));
    return messages;
  }

  function assertSpringboardWeek(springboardWeek, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("wZVJV2Yc5", label_ ? "Springboard Week" + ": " + label_ : "Springboard Week", springboardWeek));
    return messages;
  }

  function assertOptionsViewed(optionsViewed, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("xHPp8yOuv", "Options Viewed", optionsViewed));
    if (optionsViewed !== null && optionsViewed !== undefined && optionsViewed.forEach) {
      optionsViewed.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertUserType(userType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("xZ9GCD71LN", label_ ? "User Type" + ": " + label_ : "User Type", userType));
    if ("Teacher" !== userType && "Parent" !== userType &&
          "Guest Parent" !== userType && "Student" !== userType &&
          "Guest Teacher" !== userType) {
      var message = (label_ ? "User Type" + ": " + label_ : "User Type") + " should match one of the following values [ Teacher | Parent | Guest Parent | Student | Guest Teacher ] but you provided the value " + userType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "xZ9GCD71LN", message: message}]);
    }
    return messages;
  }

  function assertSignupFlow(signupFlow, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("y8YSspTxeO", label_ ? "Signup Flow" + ": " + label_ : "Signup Flow", signupFlow));
    if ("trial_class_25" !== signupFlow &&
          "classroom_linked" !== signupFlow &&
          "student_experience" !== signupFlow && "classcode" !== signupFlow) {
      var message = (label_ ? "Signup Flow" + ": " + label_ : "Signup Flow") + " should match one of the following values [ trial_class_25 | classroom_linked | student_experience | classcode ] but you provided the value " + signupFlow
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "y8YSspTxeO", message: message}]);
    }
    return messages;
  }

  function assertVoURL(voUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("yeiCDbEMb", "Vo URL", voUrl));
    if (voUrl !== null && voUrl !== undefined && voUrl.forEach) {
      voUrl.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalVoURL(voUrl, label_) {
    var messages = [];
    if (voUrl !== undefined && voUrl !== null) {
      messages = messages.concat(AvoAssert.assertList("yeiCDbEMb", "Vo URL", voUrl));
      voUrl.forEach(function (value, index) {
      });
    }
    return messages;
  }

  function assertOptionalTimeGoal(timeGoal, label_) {
    var messages = [];
    if (timeGoal !== undefined && timeGoal !== null) {
      messages = messages.concat(AvoAssert.assertString("ypVRFOT1Z", label_ ? "Time Goal" + ": " + label_ : "Time Goal", timeGoal));
    }
    return messages;
  }

  function assertWorksheetSubcategory(worksheetSubcategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("z0AEnWmrqD", label_ ? "Worksheet Subcategory" + ": " + label_ : "Worksheet Subcategory", worksheetSubcategory));
    return messages;
  }

  function assertClickedOnStudentSelectionPopup(
    clickedOnStudentSelectionPopup, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zDpSmq5T0V", label_ ? "Clicked on - Student Selection Popup" + ": " + label_ : "Clicked on - Student Selection Popup", clickedOnStudentSelectionPopup));
    if ("Assign" !== clickedOnStudentSelectionPopup) {
      var message = (label_ ? "Clicked on - Student Selection Popup" + ": " + label_ : "Clicked on - Student Selection Popup") + " should match one of the following values [ Assign ] but you provided the value " + clickedOnStudentSelectionPopup
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "zDpSmq5T0V", message: message}]);
    }
    return messages;
  }

  function assertOptionalFreeActivitiesLeftCount(freeActivitiesLeftCount,
    label_) {
    var messages = [];
    if (freeActivitiesLeftCount !== undefined && freeActivitiesLeftCount !== null) {
      messages = messages.concat(AvoAssert.assertInt("zY_qKY7KjA", label_ ? "Free Activities Left Count" + ": " + label_ : "Free Activities Left Count", freeActivitiesLeftCount));
    }
    return messages;
  }

  function assertFreeActivitiesLeftCount(freeActivitiesLeftCount, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("zY_qKY7KjA", label_ ? "Free Activities Left Count" + ": " + label_ : "Free Activities Left Count", freeActivitiesLeftCount));
    return messages;
  }

  function assertOptionalErrorStep(errorStep, label_) {
    var messages = [];
    if (errorStep !== undefined && errorStep !== null) {
      messages = messages.concat(AvoAssert.assertString("zagTegBN_", label_ ? "Error Step" + ": " + label_ : "Error Step", errorStep));
    }
    return messages;
  }

  function setAvoLogger(avoLogger) {
    __AVO_LOGGER__ = avoLogger;
  }

  var sysScreenHeight;

  function setSystemProperties(properties) {
    if (properties.screenHeight !== null && properties.screenHeight !== undefined) {
      sysScreenHeight = properties.screenHeight;
      assertScreenHeight(sysScreenHeight);
    }
  }

  function setSystemProperties_(properties) {
    if (properties.screenHeight !== null && properties.screenHeight !== undefined) {
      sysScreenHeight = properties.screenHeight;
      assertScreenHeight(sysScreenHeight);
    }
  }


  var CustomDestination;
  function setup_(options, systemProperties, CustomDestinationDestination,
    destinationOptions) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }

    setSystemProperties_(systemProperties);

    destinationOptions = destinationOptions || {};

    if (!__AVO_NOOP__) {
      if (options.useProductionKey) {
      } else {
      }

      CustomDestination = CustomDestinationDestination;
      CustomDestination.make(options.useProductionKey);
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
      }
    }
  }

  function initAvo(options, systemProperties, destinationOptions,
    CustomDestinationDestination) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.avoLogger !== undefined) {
      __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
      __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == 'prod') {
      InternalAvoLogger.warn("****************************************************");
      InternalAvoLogger.warn("WARNING Avo cannot be initialized in noop mode in production:");
      InternalAvoLogger.warn("- Overwriting configuration with noop=false.");
      InternalAvoLogger.warn("- Please reach out if you want to be able to run Avo in production mode with noop=true");
      InternalAvoLogger.warn("****************************************************");
      __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
      InternalAvoLogger.log("****************************************************");
      InternalAvoLogger.log("Avo is now initialized in noop mode. This means:");
      InternalAvoLogger.log("- No events will be sent");
      InternalAvoLogger.log("- No network requests are made");
      InternalAvoLogger.log("****************************************************");
    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== 'prod'));
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
      __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
      InternalAvoLogger.warn("Avo Inspector not provided in initAvo() call");
    }
    if (__AVO_ENV__ !== 'prod') {
      __AVO_DEV__ = true;
    }

    setSystemProperties(systemProperties);

    destinationOptions = destinationOptions || {};

    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
      const {
        BOTTOM_RIGHT,
        BOTTOM_LEFT,
        TOP_RIGHT,
        TOP_LEFT,
        } =
        WebDebuggerPosition.position;

      try {
        WebDebuggerAssertions.assertKey(
          options.webDebuggerOptions.position,
          "position",
          position => {
            return position === BOTTOM_RIGHT ||
            position === BOTTOM_LEFT ||
            position === TOP_RIGHT ||
            position === TOP_LEFT;
          }
        )
      } catch (e) {
        throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      const top = options.webDebuggerOptions.position.top || 0;
      const right = options.webDebuggerOptions.position.right || 0;
      const bottom = options.webDebuggerOptions.position.bottom || 0;
      const left = options.webDebuggerOptions.position.left || 0;

      let positionParams;

      switch (options.webDebuggerOptions.position.position) {
        case BOTTOM_RIGHT:
          positionParams = {
            position: BOTTOM_RIGHT,
            bottom,
            right,
          };
          break;
        case BOTTOM_LEFT:
          positionParams = {
            position: BOTTOM_LEFT,
            bottom,
            left,
          };
          break;
        case TOP_RIGHT:
          positionParams = {
            position: TOP_RIGHT,
            top,
            right,
          };
          break;
        case TOP_LEFT:
          positionParams = {
            position: TOP_LEFT,
            top,
            left,
          };
          break;
        default: throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      _avo_debugger_send_position(positionParams);
    }

(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();

    }
    if (!__AVO_NOOP__) {
      if (__AVO_ENV__ === 'prod') {
      }
      if (__AVO_ENV__ === 'dev') {
      }

      CustomDestination = CustomDestinationDestination;
      if (__AVO_ENV__ === 'prod') {
        CustomDestination.make && CustomDestination.make(__AVO_ENV__, "skPUDmCt3kW3bttlaOrVZ96m9uEuoIl0");
      } else if (__AVO_ENV__ === 'dev') {
        CustomDestination.make && CustomDestination.make(__AVO_ENV__, "skPUDmCt3kW3bttlaOrVZ96m9uEuoIl0");
      } else {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Custom Destination. Head to destination settings in Avo to set a staging key.");
        CustomDestination.make && CustomDestination.make(__AVO_ENV__, null);
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
      }
    }
  }

  /**
   * Viewed Take-Tour Popup: This will be triggered when the user is shown the Take a Tour Pop-up during the onboarding journey.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MSkdFC-Z0Z}
   */
  function viewedTakeTourPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Take-Tour Popup", Object.keys(properties), [
        "subject",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MSkdFC-Z0Z", "dce1c30f1451b124f1eff3942d2428b8934c7c9253a2f890d0469cddfb049889", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Take-Tour Popup", {
        "Subject": properties.subject,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MSkdFC-Z0Z", "Viewed Take-Tour Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Take-Tour Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Take-Tour Popup", {
          "Subject": properties.subject,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "MSkdFC-Z0Z", "dce1c30f1451b124f1eff3942d2428b8934c7c9253a2f890d0469cddfb049889");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Take-Tour Popup", {
      "Subject": properties.subject,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted on Take-Tour Popup: This will be triggered when the user clicks on Take a Tour Pop-up.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.interactedWith - This property will help us know where the user has clicked/interacted on the Pop-up.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eIF8UWSAVZ}
   */
  function interactedOnTakeTourPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInteractedWith(properties.interactedWith));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted on Take-Tour Popup", Object.keys(properties), [
        "interactedWith",
        "subject",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eIF8UWSAVZ", "cacc353de063378de3ae102f65e3b5e26017cbb45e2a8d558cf2c9c517902118", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted on Take-Tour Popup", {
        "Interacted With": properties.interactedWith,
        "Subject": properties.subject,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eIF8UWSAVZ", "Interacted on Take-Tour Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Ssr_b4cA9A", name: "Interacted With", value: properties.interactedWith},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted on Take-Tour Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted on Take-Tour Popup", {
          "Interacted With": properties.interactedWith,
          "Subject": properties.subject,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "eIF8UWSAVZ", "cacc353de063378de3ae102f65e3b5e26017cbb45e2a8d558cf2c9c517902118");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted on Take-Tour Popup", {
      "Interacted With": properties.interactedWith,
      "Subject": properties.subject,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP game tab: When the user clicks on a mini game, 'game invites' or 'classmates'
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UBNqWf5cXD}
   */
  function interactedMpGameTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP game tab", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UBNqWf5cXD", "e0f1005e207d8a16ea94e59308d7844cbbb9e7b78cbeeea96942f24a2f653cc6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP game tab", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UBNqWf5cXD", "Interacted MP game tab", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP game tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP game tab", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "UBNqWf5cXD", "e0f1005e207d8a16ea94e59308d7844cbbb9e7b78cbeeea96942f24a2f653cc6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP game tab", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Classmates Drawer: When the classmates drawer is shown after clicking on the 'Classmates' button
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.onlineClassmates - Count of online classmates when Classmates Drawer is opened
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JNPQbCl3U9}
   */
  function viewedMpClassmatesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOnlineClassmates(properties.onlineClassmates));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Classmates Drawer", Object.keys(properties), [
        "onlineClassmates"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JNPQbCl3U9", "916ffb0d408f6dddd355cd5a144278cd6491b31a6286df9eca1e6cc16aeb07bf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Classmates Drawer", {
        "Online Classmates": properties.onlineClassmates,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JNPQbCl3U9", "Viewed MP Classmates Drawer", messages, [
        {id: "-6EWaVnSU8", name: "Online Classmates", value: properties.onlineClassmates},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Classmates Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Classmates Drawer", {
          "Online Classmates": properties.onlineClassmates,
          "Screen Height": sysScreenHeight,
          }, "JNPQbCl3U9", "916ffb0d408f6dddd355cd5a144278cd6491b31a6286df9eca1e6cc16aeb07bf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Classmates Drawer", {
      "Online Classmates": properties.onlineClassmates,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP game tab: Upon clicking on the MP tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.countOfGamesToJoin - no description
   * @param {string} properties.countOfOnlineFriends - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NkI3XGDy5W}
   */
  function viewedMpGameTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCountOfGamesToJoin(properties.countOfGamesToJoin));
      messages = messages.concat(assertCountOfOnlineFriends(properties.countOfOnlineFriends));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP game tab", Object.keys(properties), [
        "countOfGamesToJoin",
        "countOfOnlineFriends"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NkI3XGDy5W", "23b198ad42f04fae4c82d499a814657db59ee8e66a21f3444243591152c770a5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP game tab", {
        "Count of games to join": properties.countOfGamesToJoin,
        "Count of online friends": properties.countOfOnlineFriends,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NkI3XGDy5W", "Viewed MP game tab", messages, [
        {id: "1hgGFRPeiA", name: "Count of online friends", value: properties.countOfOnlineFriends},
        {id: "gTDYzkiHPP", name: "Count of games to join", value: properties.countOfGamesToJoin},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP game tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP game tab", {
          "Count of games to join": properties.countOfGamesToJoin,
          "Count of online friends": properties.countOfOnlineFriends,
          "Screen Height": sysScreenHeight,
          }, "NkI3XGDy5W", "23b198ad42f04fae4c82d499a814657db59ee8e66a21f3444243591152c770a5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP game tab", {
      "Count of games to join": properties.countOfGamesToJoin,
      "Count of online friends": properties.countOfOnlineFriends,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP Classmates Drawer: When the user interacts with classmates drawer
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.onlineClassmates - Count of online classmates when Classmates Drawer is opened
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-KzxvEzOvM}
   */
  function interactedMpClassmatesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOnlineClassmates(properties.onlineClassmates));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Classmates Drawer", Object.keys(properties), [
        "onlineClassmates",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-KzxvEzOvM", "8c8ed56c4e6cd06ae4c7953c83b5a6852a387005dc193551a358ef943786155f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP Classmates Drawer", {
        "Online Classmates": properties.onlineClassmates,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-KzxvEzOvM", "Interacted MP Classmates Drawer", messages, [
        {id: "-6EWaVnSU8", name: "Online Classmates", value: properties.onlineClassmates},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Classmates Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Classmates Drawer", {
          "Online Classmates": properties.onlineClassmates,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "-KzxvEzOvM", "8c8ed56c4e6cd06ae4c7953c83b5a6852a387005dc193551a358ef943786155f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Classmates Drawer", {
      "Online Classmates": properties.onlineClassmates,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Game Invites Drawer: When the game invites drawer is shown after clicking on the 'Game Invites' button
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.invitesAvailable - Count of invites available when the drawer is viewed
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SQiMt0jFUE}
   */
  function viewedMpGameInvitesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInvitesAvailable(properties.invitesAvailable));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Invites Drawer", Object.keys(properties), [
        "invitesAvailable"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SQiMt0jFUE", "a4cc9f03869b7065eaf6bba744675d6f084c156c58229bf2ea2bdf8d973431e6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Game Invites Drawer", {
        "Invites Available": properties.invitesAvailable,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SQiMt0jFUE", "Viewed MP Game Invites Drawer", messages, [
        {id: "pFfp-zamld", name: "Invites Available", value: properties.invitesAvailable},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Invites Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Invites Drawer", {
          "Invites Available": properties.invitesAvailable,
          "Screen Height": sysScreenHeight,
          }, "SQiMt0jFUE", "a4cc9f03869b7065eaf6bba744675d6f084c156c58229bf2ea2bdf8d973431e6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Invites Drawer", {
      "Invites Available": properties.invitesAvailable,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP Game Invites Drawer: When the user interacts with the game invites drawer
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.invitesAvailable - Count of invites available when the drawer is viewed
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/W7dU3uJ3ea}
   */
  function interactedMpGameInvitesDrawer(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInvitesAvailable(properties.invitesAvailable));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Game Invites Drawer", Object.keys(properties), [
        "invitesAvailable",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "W7dU3uJ3ea", "b1e754d81c414b269fd6845f94065d74d548878710d2721d4b2a9391aadfdb0d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP Game Invites Drawer", {
        "Invites Available": properties.invitesAvailable,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("W7dU3uJ3ea", "Interacted MP Game Invites Drawer", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "pFfp-zamld", name: "Invites Available", value: properties.invitesAvailable},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Game Invites Drawer': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Game Invites Drawer", {
          "Invites Available": properties.invitesAvailable,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "W7dU3uJ3ea", "b1e754d81c414b269fd6845f94065d74d548878710d2721d4b2a9391aadfdb0d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Game Invites Drawer", {
      "Invites Available": properties.invitesAvailable,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP invite notification: When the user sees the game invite notification
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.state - Multiplayer: Is the multiplayer invitation still valid or expired

Freemium: Whether the content was 'locked' or 'free' in Freemium while the user interacted with it
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7JdHxdW-BG}
   */
  function viewedMpInviteNotification(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertState(properties.state));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP invite notification", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "state",
        "gameName",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7JdHxdW-BG", "c1734fb9489c31f7bbea3ac2b8cfd6e06babb4394798fab77d906920d877baed", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP invite notification", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "State": properties.state,
        "Game Name": properties.gameName,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7JdHxdW-BG", "Viewed MP invite notification", messages, [
        {id: "19zWDg2Ccm", name: "State", value: properties.state},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP invite notification': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP invite notification", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "State": properties.state,
          "Game Name": properties.gameName,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "7JdHxdW-BG", "c1734fb9489c31f7bbea3ac2b8cfd6e06babb4394798fab77d906920d877baed");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP invite notification", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "State": properties.state,
      "Game Name": properties.gameName,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP invite notification: When the user clicks on the game invite notification
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.state - Multiplayer: Is the multiplayer invitation still valid or expired

Freemium: Whether the content was 'locked' or 'free' in Freemium while the user interacted with it
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wt_rx3iaqx}
   */
  function interactedMpInviteNotification(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertState(properties.state));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP invite notification", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "state",
        "gameName",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wt_rx3iaqx", "c4596027f09e37a2b4e6320919ecf46e73bc6ba839ab11d5d036d493264e8ecf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP invite notification", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "State": properties.state,
        "Game Name": properties.gameName,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wt_rx3iaqx", "Interacted MP invite notification", messages, [
        {id: "19zWDg2Ccm", name: "State", value: properties.state},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP invite notification': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP invite notification", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "State": properties.state,
          "Game Name": properties.gameName,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "wt_rx3iaqx", "c4596027f09e37a2b4e6320919ecf46e73bc6ba839ab11d5d036d493264e8ecf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP invite notification", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "State": properties.state,
      "Game Name": properties.gameName,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Mode Selection Screen: The Game Mode selection screen, which comes after clicking on a game tile in Playzone main page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6mtusYc6Bo}
   */
  function viewedMpModeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Mode Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "from",
        "elaGrade",
        "grade",
        "playableCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6mtusYc6Bo", "df6afedbc7977e47eb23f7996454965af1902083747d017362b2398669205db8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Mode Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "From": properties.from,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Playable Code": properties.playableCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6mtusYc6Bo", "Viewed MP Mode Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Mode Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Mode Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "From": properties.from,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Playable Code": properties.playableCode,
          "Screen Height": sysScreenHeight,
          }, "6mtusYc6Bo", "df6afedbc7977e47eb23f7996454965af1902083747d017362b2398669205db8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Mode Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "From": properties.from,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Playable Code": properties.playableCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP Mode Selection Screen: Interaction in the Game Mode selection screen, which comes after clicking on a game tile in Playzone main page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.playerBand - Band of the player
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9LFWQmHtqp}
   */
  function interactedMpModeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertPlayerBand(properties.playerBand));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Mode Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameMode",
        "gameName",
        "playerBand",
        "clickedOn",
        "elaGrade",
        "grade",
        "playableCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9LFWQmHtqp", "7ab2d0500db99d0c05e56c03eaadecc1f0461aa23a5681eef06be1a3de36601b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP Mode Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Mode": properties.gameMode,
        "Game Name": properties.gameName,
        "Player Band": properties.playerBand,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Playable Code": properties.playableCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9LFWQmHtqp", "Interacted MP Mode Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "rQb5nwMS5I", name: "Player Band", value: properties.playerBand},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Mode Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Mode Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Mode": properties.gameMode,
          "Game Name": properties.gameName,
          "Player Band": properties.playerBand,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Playable Code": properties.playableCode,
          "Screen Height": sysScreenHeight,
          }, "9LFWQmHtqp", "7ab2d0500db99d0c05e56c03eaadecc1f0461aa23a5681eef06be1a3de36601b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Mode Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Mode": properties.gameMode,
      "Game Name": properties.gameName,
      "Player Band": properties.playerBand,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Playable Code": properties.playableCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Options Selection Screen: When the user lands on the game options selection screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ghPmoCm7jQ}
   */
  function viewedMpOptionsSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Options Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ghPmoCm7jQ", "f411c8ef09a3241d7c0affecdc66c0687285bebcfdf24e450e0f8117bc2bbed2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Options Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ghPmoCm7jQ", "Viewed MP Options Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Options Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Options Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "ghPmoCm7jQ", "f411c8ef09a3241d7c0affecdc66c0687285bebcfdf24e450e0f8117bc2bbed2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Options Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP Options Selection Screen: When the user interacts with the game options selection screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.difficulty] - no description
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mU1fymKPK7}
   */
  function interactedMpOptionsSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalDifficulty(properties.difficulty));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Options Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameMode",
        "gameName",
        "topicName",
        "difficulty",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mU1fymKPK7", "8533cf36f1efe2b366f915f3e3b14ce0c0b3a994866d539d135892cf3191e14e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP Options Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Mode": properties.gameMode,
        "Game Name": properties.gameName,
        "Topic Name": properties.topicName,
        "Difficulty": properties.difficulty,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mU1fymKPK7", "Interacted MP Options Selection Screen", messages, [
        {id: "12tG17N4vG", name: "Difficulty", value: properties.difficulty},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Options Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Options Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Mode": properties.gameMode,
          "Game Name": properties.gameName,
          "Topic Name": properties.topicName,
          "Difficulty": properties.difficulty,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "mU1fymKPK7", "8533cf36f1efe2b366f915f3e3b14ce0c0b3a994866d539d135892cf3191e14e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Options Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Mode": properties.gameMode,
      "Game Name": properties.gameName,
      "Topic Name": properties.topicName,
      "Difficulty": properties.difficulty,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Invite Friends Screen: When the user lands on the invite friends screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.difficulty] - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AmnCjxWpXG}
   */
  function viewedMpInviteFriendsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalDifficulty(properties.difficulty));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Invite Friends Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "topicName",
        "difficulty",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AmnCjxWpXG", "7e2e9a60859231cbb45a03ef4aaf2e9271d87071b3b4f4c412f83195a9536996", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Invite Friends Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Topic Name": properties.topicName,
        "Difficulty": properties.difficulty,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AmnCjxWpXG", "Viewed MP Invite Friends Screen", messages, [
        {id: "12tG17N4vG", name: "Difficulty", value: properties.difficulty},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Invite Friends Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Invite Friends Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Topic Name": properties.topicName,
          "Difficulty": properties.difficulty,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "AmnCjxWpXG", "7e2e9a60859231cbb45a03ef4aaf2e9271d87071b3b4f4c412f83195a9536996");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Invite Friends Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Topic Name": properties.topicName,
      "Difficulty": properties.difficulty,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP Invite Friends Screen: When the user interacts with the invite friends screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.difficulty] - no description
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Q19-PF_ZDV}
   */
  function interactedMpInviteFriendsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalDifficulty(properties.difficulty));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Invite Friends Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "topicName",
        "difficulty",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Q19-PF_ZDV", "b196405194c527e2e442408872c2391faa04efdfa4d470c988a3874c194c5fdf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP Invite Friends Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Topic Name": properties.topicName,
        "Difficulty": properties.difficulty,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Q19-PF_ZDV", "Interacted MP Invite Friends Screen", messages, [
        {id: "12tG17N4vG", name: "Difficulty", value: properties.difficulty},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Invite Friends Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Invite Friends Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Topic Name": properties.topicName,
          "Difficulty": properties.difficulty,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "Q19-PF_ZDV", "b196405194c527e2e442408872c2391faa04efdfa4d470c988a3874c194c5fdf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Invite Friends Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Topic Name": properties.topicName,
      "Difficulty": properties.difficulty,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Game Loader Screen: When the game loader screen comes after selecting all options
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2dfVM_yh-2}
   */
  function viewedMpGameLoaderScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Loader Screen", Object.keys(properties), [
        "gameName",
        "gameMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2dfVM_yh-2", "a0954138cc00f17501802a2e3b115912cfc01134653dcdb8c21411f7155e5314", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Game Loader Screen", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2dfVM_yh-2", "Viewed MP Game Loader Screen", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Loader Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Loader Screen", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Screen Height": sysScreenHeight,
          }, "2dfVM_yh-2", "a0954138cc00f17501802a2e3b115912cfc01134653dcdb8c21411f7155e5314");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Loader Screen", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Game play screen: When the game actually starts (at student level)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_ewD-1nCoc}
   */
  function viewedMpGamePlayScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game play screen", Object.keys(properties), [
        "gameMode",
        "gameName",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_ewD-1nCoc", "4c40dfdcad61d771d054e80745cc0248aedb51c3e0c38538af3c6efd064f96a7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Game play screen", {
        "Game Mode": properties.gameMode,
        "Game Name": properties.gameName,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_ewD-1nCoc", "Viewed MP Game play screen", messages, [
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game play screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game play screen", {
          "Game Mode": properties.gameMode,
          "Game Name": properties.gameName,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "_ewD-1nCoc", "4c40dfdcad61d771d054e80745cc0248aedb51c3e0c38538af3c6efd064f96a7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game play screen", {
      "Game Mode": properties.gameMode,
      "Game Name": properties.gameName,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Opponent Search Started: When 1v1 opponent search is started
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.userCity - Name of the city the user is from
   * @param {string} properties.userCountry - Name of the country the user is from
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3MqfYYony}
   */
  function opponentSearchStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertUserCity(properties.userCity));
      messages = messages.concat(assertUserCountry(properties.userCountry));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Opponent Search Started", Object.keys(properties), [
        "gameName",
        "gameMode",
        "userCity",
        "userCountry"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3MqfYYony", "18ade68e07bf220ee102d59231532c3db00f6a90b90fa9d12e8a59afd02c2123", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Opponent Search Started", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "User City": properties.userCity,
        "User Country": properties.userCountry,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3MqfYYony", "Opponent Search Started", messages, [
        {id: "Gh85Hi8uN0", name: "User City", value: properties.userCity},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "vHdXCmyiec", name: "User Country", value: properties.userCountry},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Opponent Search Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Opponent Search Started", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "User City": properties.userCity,
          "User Country": properties.userCountry,
          "Screen Height": sysScreenHeight,
          }, "3MqfYYony", "18ade68e07bf220ee102d59231532c3db00f6a90b90fa9d12e8a59afd02c2123");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Opponent Search Started", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "User City": properties.userCity,
      "User Country": properties.userCountry,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Opponent Found: When 1v1 opponent is found (either bot or human)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.opponentType - Type of opponent which got matched
   * @param {string} properties.opponentCity - no description
   * @param {string} properties.opponentCountry - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/i9BMwZIVVB}
   */
  function opponentFound(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOpponentType(properties.opponentType));
      messages = messages.concat(assertOpponentCity(properties.opponentCity));
      messages = messages.concat(assertOpponentCountry(properties.opponentCountry));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Opponent Found", Object.keys(properties), [
        "gameName",
        "gameMode",
        "opponentType",
        "opponentCity",
        "opponentCountry"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "i9BMwZIVVB", "c04719dcf8ccbd9e43a57db452e6365b9b0d51aacf78f581a45dcdcecb61e78c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Opponent Found", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Opponent Type": properties.opponentType,
        "Opponent City": properties.opponentCity,
        "Opponent Country": properties.opponentCountry,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("i9BMwZIVVB", "Opponent Found", messages, [
        {id: "P9dar0xMXW", name: "Opponent City", value: properties.opponentCity},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "U2QSiMZrpE", name: "Opponent Type", value: properties.opponentType},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "wT_TBNcHj2", name: "Opponent Country", value: properties.opponentCountry},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Opponent Found': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Opponent Found", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Opponent Type": properties.opponentType,
          "Opponent City": properties.opponentCity,
          "Opponent Country": properties.opponentCountry,
          "Screen Height": sysScreenHeight,
          }, "i9BMwZIVVB", "c04719dcf8ccbd9e43a57db452e6365b9b0d51aacf78f581a45dcdcecb61e78c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Opponent Found", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Opponent Type": properties.opponentType,
      "Opponent City": properties.opponentCity,
      "Opponent Country": properties.opponentCountry,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Countdown Animation Started: When the countdown animation starts
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/A3HU3gCLIr/trigger/DgAm8aw2E
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/A3HU3gCLIr}
   */
  function countdownAnimationStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Countdown Animation Started", Object.keys(properties), [
        "gameName",
        "gameMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "A3HU3gCLIr", "197b69db6f80463f092fc40a42855d539e2b1a09568fcbce5aae37b221a18ed2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Countdown Animation Started", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("A3HU3gCLIr", "Countdown Animation Started", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Countdown Animation Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Countdown Animation Started", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Screen Height": sysScreenHeight,
          }, "A3HU3gCLIr", "197b69db6f80463f092fc40a42855d539e2b1a09568fcbce5aae37b221a18ed2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Countdown Animation Started", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP questions exhausted screen: When the player has completed all questions and land on the 'waiting for other players to finish' screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.opponentType - Type of opponent which got matched
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HaJwK75SM}
   */
  function viewedMpQuestionsExhaustedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOpponentType(properties.opponentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP questions exhausted screen", Object.keys(properties), [
        "gameName",
        "gameMode",
        "opponentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HaJwK75SM", "c3e749143f5c6adfbb9c7f6857a12044908ac2bfb304b57ec840d785e6055906", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP questions exhausted screen", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Opponent Type": properties.opponentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HaJwK75SM", "Viewed MP questions exhausted screen", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "U2QSiMZrpE", name: "Opponent Type", value: properties.opponentType},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP questions exhausted screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP questions exhausted screen", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Opponent Type": properties.opponentType,
          "Screen Height": sysScreenHeight,
          }, "HaJwK75SM", "c3e749143f5c6adfbb9c7f6857a12044908ac2bfb304b57ec840d785e6055906");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP questions exhausted screen", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Opponent Type": properties.opponentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Game Lobby: When the user lands on the 1v1 game lobby screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} [properties.referrerPage] - Shows the description of the previous page name/URL
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jp7yphWiL-}
   */
  function viewedMpGameLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalReferrerPage(properties.referrerPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Lobby", Object.keys(properties), [
        "gameName",
        "gameMode",
        "from",
        "referrerPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jp7yphWiL-", "32c383cbc88a0981d4ba19e2c24ad4b7053bf3623f9249b1efb2896f7c89056b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Game Lobby", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "From": properties.from,
        "Referrer Page": properties.referrerPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jp7yphWiL-", "Viewed MP Game Lobby", messages, [
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "cYVv-jM3n6", name: "Referrer Page", value: properties.referrerPage},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Lobby", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "From": properties.from,
          "Referrer Page": properties.referrerPage,
          "Screen Height": sysScreenHeight,
          }, "jp7yphWiL-", "32c383cbc88a0981d4ba19e2c24ad4b7053bf3623f9249b1efb2896f7c89056b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Lobby", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "From": properties.from,
      "Referrer Page": properties.referrerPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP Game Lobby: When the user interacts with the 1v1 game lobby screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MWCTaK2cLc}
   */
  function interactedMpGameLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Game Lobby", Object.keys(properties), [
        "gameName",
        "gameMode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MWCTaK2cLc", "8fbdabfe48a88dbef8330b33b1c5abb74b2315e1a9711c8fe72d5f9530f5bfd1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP Game Lobby", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MWCTaK2cLc", "Interacted MP Game Lobby", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Game Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Game Lobby", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "MWCTaK2cLc", "8fbdabfe48a88dbef8330b33b1c5abb74b2315e1a9711c8fe72d5f9530f5bfd1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Game Lobby", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP game rewards screen: When user views the rewards screen after gameplay
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.winner - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zjROke5TKW}
   */
  function viewedMpGameRewardsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertWinner(properties.winner));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP game rewards screen", Object.keys(properties), [
        "gameName",
        "gameMode",
        "winner"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zjROke5TKW", "97221c32f14ffd2de8ea6386be71d7880f9bf14edddf2e769b86e555c2080bcc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP game rewards screen", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Winner": properties.winner,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zjROke5TKW", "Viewed MP game rewards screen", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "j-WLQ2tjI", name: "Winner", value: properties.winner},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP game rewards screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP game rewards screen", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Winner": properties.winner,
          "Screen Height": sysScreenHeight,
          }, "zjROke5TKW", "97221c32f14ffd2de8ea6386be71d7880f9bf14edddf2e769b86e555c2080bcc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP game rewards screen", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Winner": properties.winner,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Rematch Popup: When opponent sees the rematch popup after rewards screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.winner - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gZZTa4cJeO}
   */
  function viewedMpRematchPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertWinner(properties.winner));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Rematch Popup", Object.keys(properties), [
        "gameName",
        "gameMode",
        "winner"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gZZTa4cJeO", "eb1fc06beb2fb2d2ce9c15e3864a127d798240503064d32ffe214302f2f5c2dd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Rematch Popup", {
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "Winner": properties.winner,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gZZTa4cJeO", "Viewed MP Rematch Popup", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "j-WLQ2tjI", name: "Winner", value: properties.winner},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Rematch Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Rematch Popup", {
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "Winner": properties.winner,
          "Screen Height": sysScreenHeight,
          }, "gZZTa4cJeO", "eb1fc06beb2fb2d2ce9c15e3864a127d798240503064d32ffe214302f2f5c2dd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Rematch Popup", {
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "Winner": properties.winner,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MP Rematch Popup: When user interacts with rematch popup
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tappedOn - UI element that user tapped on - used in conjunction with the event name which identifies the screen name
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.winner - no description
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} properties.playAgainState - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V5bm2a68De}
   */
  function interactedMpRematchPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTappedOn(properties.tappedOn));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertWinner(properties.winner));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertPlayAgainState(properties.playAgainState));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MP Rematch Popup", Object.keys(properties), [
        "tappedOn",
        "gameMode",
        "winner",
        "gameName",
        "playAgainState"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V5bm2a68De", "a545de36f290fd29f9c3561701615b1c2eafb60b1179e49bd66d8caa5269d0f7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MP Rematch Popup", {
        "Tapped On": properties.tappedOn,
        "Game Mode": properties.gameMode,
        "Winner": properties.winner,
        "Game Name": properties.gameName,
        "Play Again State": properties.playAgainState,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V5bm2a68De", "Interacted MP Rematch Popup", messages, [
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "bZsbP1uDvn", name: "Play Again State", value: properties.playAgainState},
        {id: "cfvmMqWft", name: "Tapped On", value: properties.tappedOn},
        {id: "j-WLQ2tjI", name: "Winner", value: properties.winner},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MP Rematch Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MP Rematch Popup", {
          "Tapped On": properties.tappedOn,
          "Game Mode": properties.gameMode,
          "Winner": properties.winner,
          "Game Name": properties.gameName,
          "Play Again State": properties.playAgainState,
          "Screen Height": sysScreenHeight,
          }, "V5bm2a68De", "a545de36f290fd29f9c3561701615b1c2eafb60b1179e49bd66d8caa5269d0f7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MP Rematch Popup", {
      "Tapped On": properties.tappedOn,
      "Game Mode": properties.gameMode,
      "Winner": properties.winner,
      "Game Name": properties.gameName,
      "Play Again State": properties.playAgainState,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Post 3PM Pop-Up: This event should be triggered when we show the Post 3PM Pop-up/Blocker to the student.
   *
   * When to trigger this event:
   * 1. This event should be triggered when we show the Post 3PM Pop-up/Blocker to the student
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cAqkdiuXFJ/trigger/HYuOFvfQU
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.view - View will represent weather the pop-up view has a cross or not; The default value of the event property will be "withoutcross" as the default pop-up is without cross.
The other value of this event property will be "withcross" when we are showing the pop-up with cross.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cAqkdiuXFJ}
   */
  function viewedPost3pmPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertView(properties.view));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Post 3PM Pop-Up", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "view",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cAqkdiuXFJ", "1a3dbf3884f348584a60a3ea8841a606c4e95919f2d37c3e4e406f9597213316", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Post 3PM Pop-Up", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "View": properties.view,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cAqkdiuXFJ", "Viewed Post 3PM Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "p6UnsWI0U", name: "View", value: properties.view},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Post 3PM Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Post 3PM Pop-Up", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "View": properties.view,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "cAqkdiuXFJ", "1a3dbf3884f348584a60a3ea8841a606c4e95919f2d37c3e4e406f9597213316");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Post 3PM Pop-Up", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "View": properties.view,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Post 3PM Pop-Up: When the user clicks on anywhere on this Pop-up, this event is fired. When the user clicks on the cross of the Post 3PM Pop-up sent Clicked on event property as cross.
   *
   * When to trigger this event:
   * 1. When the user clicks on anywhere on this Pop-up, this event is fired.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kdTIcfSyik/trigger/Y3WylVQmj
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kdTIcfSyik}
   */
  function interactedPost3pmPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Post 3PM Pop-Up", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "clickedOn",
        "userType",
        "grade",
        "elaGrade",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kdTIcfSyik", "9d08a54d52e89305c6ec99de0780ab2ab6c62b2e110a203af41dd2636d404dc9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Post 3PM Pop-Up", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "Clicked On": properties.clickedOn,
        "User Type": properties.userType,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kdTIcfSyik", "Interacted Post 3PM Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Post 3PM Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Post 3PM Pop-Up", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "Clicked On": properties.clickedOn,
          "User Type": properties.userType,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "kdTIcfSyik", "9d08a54d52e89305c6ec99de0780ab2ab6c62b2e110a203af41dd2636d404dc9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Post 3PM Pop-Up", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "Clicked On": properties.clickedOn,
      "User Type": properties.userType,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Error on Post 3PM Pop-Up: This event is shown when we show an error message on the Post 3PM Pop-up.
   *
   * When to trigger this event:
   * 1. This event is shown when we show an error message on the Post 3PM Pop-up.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hbj3YgMUEy/trigger/b8kfi6tP2
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.errorMessage - Error message shown to the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hbj3YgMUEy}
   */
  function viewedErrorOnPost3pmPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Error on Post 3PM Pop-Up", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "errorMessage",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hbj3YgMUEy", "de05e6c1a279019cb74ce5b3d31a5dfccc070e472449c54ca76aceaeeb6e4b7a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Error on Post 3PM Pop-Up", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Error Message": properties.errorMessage,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hbj3YgMUEy", "Viewed Error on Post 3PM Pop-Up", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Error on Post 3PM Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Error on Post 3PM Pop-Up", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Error Message": properties.errorMessage,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "hbj3YgMUEy", "de05e6c1a279019cb74ce5b3d31a5dfccc070e472449c54ca76aceaeeb6e4b7a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Error on Post 3PM Pop-Up", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Error Message": properties.errorMessage,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Suspected Email Nudge: This event will get triggered when nudge to suspected domain user is shown
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8k0kUqm42K}
   */
  function viewedSuspectedEmailNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Suspected Email Nudge", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8k0kUqm42K", "310d8d1714270a11a0bb5da478d75432f2de615300661e05b431617b5341e35a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Suspected Email Nudge", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8k0kUqm42K", "Viewed Suspected Email Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Suspected Email Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Suspected Email Nudge", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "8k0kUqm42K", "310d8d1714270a11a0bb5da478d75432f2de615300661e05b431617b5341e35a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Suspected Email Nudge", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Suspected Email Nudge: This event will be triggered when user interacts on nudge for suspected domain users
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KAC_5fChIR}
   */
  function interactedSuspectedEmailNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Suspected Email Nudge", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KAC_5fChIR", "3ba56b1452f0e39406a3482cd0fea2175cdeb9897b4c22e1b8e1e73b88e88c2f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Suspected Email Nudge", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KAC_5fChIR", "Interacted Suspected Email Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Suspected Email Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Suspected Email Nudge", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "KAC_5fChIR", "3ba56b1452f0e39406a3482cd0fea2175cdeb9897b4c22e1b8e1e73b88e88c2f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Suspected Email Nudge", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Game Tab Coachmark: When the user sees the nudge on the 'Splash Arena' tab
   *
   * When to trigger this event:
   * 1. When the user sees the nudge on the Splash Arena tab
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ni3ys2ia8d/trigger/oMYi9KVse
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ni3ys2ia8d}
   */
  function viewedMpGameTabCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Tab Coachmark", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ni3ys2ia8d", "856075b5ed69a8009e0ea566a68fa54419cdab65f99398bd09fd0f8e4a5f56a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Game Tab Coachmark", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ni3ys2ia8d", "Viewed MP Game Tab Coachmark", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Tab Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Tab Coachmark", {
          "Screen Height": sysScreenHeight,
          }, "ni3ys2ia8d", "856075b5ed69a8009e0ea566a68fa54419cdab65f99398bd09fd0f8e4a5f56a3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Tab Coachmark", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Game Tile Coachmark: When the user sees the nudge on the Game tile on the Game listing page of the Splash Arena tab
   *
   * When to trigger this event:
   * 1. When the user sees the nudge on the Game tile on the Game listing page of the Splash Arena tab
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ChALjdcHk/trigger/IwHVbOY0d
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ChALjdcHk}
   */
  function viewedMpGameTileCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Tile Coachmark", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ChALjdcHk", "007b06e218e31ef208803b95787f77c3102ca11bf9d11405978f44a795095c0a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Game Tile Coachmark", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ChALjdcHk", "Viewed MP Game Tile Coachmark", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Tile Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Tile Coachmark", {
          "Screen Height": sysScreenHeight,
          }, "ChALjdcHk", "007b06e218e31ef208803b95787f77c3102ca11bf9d11405978f44a795095c0a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Tile Coachmark", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Visited Dashboard Tab: Just after Login and landing on teacher dashboard OR clicking dashboard tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KFGFZqsRoC}
   */
  function visitedDashboardTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Dashboard Tab", Object.keys(properties), [
        "class_",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KFGFZqsRoC", "1567ea2383375c00adc020a7d352a6cb6cc60d548fae0dca6469ee0c4dd8fc86", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Visited Dashboard Tab", {
        "Class": properties.class_,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KFGFZqsRoC", "Visited Dashboard Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Dashboard Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Dashboard Tab", {
          "Class": properties.class_,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "KFGFZqsRoC", "1567ea2383375c00adc020a7d352a6cb6cc60d548fae0dca6469ee0c4dd8fc86");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Dashboard Tab", {
      "Class": properties.class_,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Walkthrough Popup: When the walkthrough is shown to the teacher.
   *
   * When to trigger this event:
   * 1. When the walkthrough is shown to the teacher.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xHOoo91p8l/trigger/3eSZ1IKN1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.daysSinceSy23Onboarding - Day since teacher lands on the dashboard for the first time in current school year.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xHOoo91p8l}
   */
  function viewedMfWalkthroughPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertDaysSinceSY23Onboarding(properties.daysSinceSy23Onboarding));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Walkthrough Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "daysSinceSy23Onboarding"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xHOoo91p8l", "2607f75bbb6b7fd27c71ea9df65cf05c5dce2c0978ea6a581b9f2f294d7afce8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Walkthrough Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Days Since SY23 Onboarding": properties.daysSinceSy23Onboarding,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xHOoo91p8l", "Viewed MF Walkthrough Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "NF129Gymtv", name: "Days Since SY23 Onboarding", value: properties.daysSinceSy23Onboarding},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Walkthrough Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Walkthrough Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Days Since SY23 Onboarding": properties.daysSinceSy23Onboarding,
          "Screen Height": sysScreenHeight,
          }, "xHOoo91p8l", "2607f75bbb6b7fd27c71ea9df65cf05c5dce2c0978ea6a581b9f2f294d7afce8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Walkthrough Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Days Since SY23 Onboarding": properties.daysSinceSy23Onboarding,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Walkthrough Popup: When a teacher clicks on the CTAs of the Math Fact Walkthrough
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.slide - On which slide of the walkthrough action happened
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ENwKfE5l7l}
   */
  function interactedMfWalkthroughPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSlide(properties.slide));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Walkthrough Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "slide",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ENwKfE5l7l", "9c0c4a4dcc39d513074b58a6f06863f97d145fd9809db741fec9acee3485f3b0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Walkthrough Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Slide": properties.slide,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ENwKfE5l7l", "Interacted MF Walkthrough Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Qo8RFu5jt2", name: "Slide", value: properties.slide},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Walkthrough Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Walkthrough Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Slide": properties.slide,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ENwKfE5l7l", "9c0c4a4dcc39d513074b58a6f06863f97d145fd9809db741fec9acee3485f3b0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Walkthrough Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Slide": properties.slide,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Nav Clicked MF New Practice: On Clicking "New Fact Practice" from left Nav or top horizontal tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hGAJNwWTDT}
   */
  function navClickedMfNewPractice(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked MF New Practice", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hGAJNwWTDT", "eb38e3427881207b484bf8ce9825313868f0824c39e998dcd86d2c1bdbc69d35", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Nav Clicked MF New Practice", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hGAJNwWTDT", "Nav Clicked MF New Practice", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked MF New Practice': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked MF New Practice", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "Screen Height": sysScreenHeight,
          }, "hGAJNwWTDT", "eb38e3427881207b484bf8ce9825313868f0824c39e998dcd86d2c1bdbc69d35");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked MF New Practice", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Settings Popup: When Math Fact assign settings popup is loaded
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3ZgKYQ_qGM}
   */
  function viewedMfSettingsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Settings Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "mfMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3ZgKYQ_qGM", "0dd311e60777559af1dc1dec523a78d6d62968122bba6728f89d44b9cac76b38", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Settings Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Mode": properties.mfMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3ZgKYQ_qGM", "Viewed MF Settings Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Settings Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Settings Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Mode": properties.mfMode,
          "Screen Height": sysScreenHeight,
          }, "3ZgKYQ_qGM", "0dd311e60777559af1dc1dec523a78d6d62968122bba6728f89d44b9cac76b38");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Settings Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Mode": properties.mfMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Settings Popup: Event to collect all the settings chosen by the teacher to assign an Adaptive mode. Triggered on clicking assign to whole class OR assign to selected students.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mfOperatorSelected - Which operator was selected while assigning Math Facts.
   * @param {Array<int>} properties.mfPracticeDaysCount - Total practice days selected by the teacher for Adaptive mode.
   * @param {string} properties.mfPracticeQuestionsCount - Count of selected questions for Adaptive mode. Range is 20, 30 , 40
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oMQiynYg2}
   */
  function interactedMfSettingsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFOperatorSelected(properties.mfOperatorSelected));
      messages = messages.concat(assertMFPracticeDaysCount(properties.mfPracticeDaysCount));
      messages = messages.concat(assertMFPracticeQuestionsCount(properties.mfPracticeQuestionsCount));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Settings Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "mfOperatorSelected",
        "mfPracticeDaysCount",
        "mfPracticeQuestionsCount",
        "mfMode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oMQiynYg2", "f54d0d2bdee1097ea99d35b07293e0c5f9571786a8ef54963da120cef8113da9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Settings Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Operator Selected": properties.mfOperatorSelected,
        "MF Practice Days Count": properties.mfPracticeDaysCount,
        "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
        "MF Mode": properties.mfMode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oMQiynYg2", "Interacted MF Settings Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "8mj3Kb8zsO", name: "MF Practice Days Count", value: properties.mfPracticeDaysCount},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "XkzC7k3g8c", name: "MF Operator Selected", value: properties.mfOperatorSelected},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "rpd15EbJEO", name: "MF Practice Questions Count", value: properties.mfPracticeQuestionsCount},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Settings Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Settings Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Operator Selected": properties.mfOperatorSelected,
          "MF Practice Days Count": properties.mfPracticeDaysCount,
          "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
          "MF Mode": properties.mfMode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "oMQiynYg2", "f54d0d2bdee1097ea99d35b07293e0c5f9571786a8ef54963da120cef8113da9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Settings Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Operator Selected": properties.mfOperatorSelected,
      "MF Practice Days Count": properties.mfPracticeDaysCount,
      "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
      "MF Mode": properties.mfMode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Successfully Assigned: Triggered when teacher selects students and clicks "Assign".
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.mfAssignedStudentCount - Count of students selected
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E-gfm7YPDX}
   */
  function successfullyAssigned(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFAssignedStudentCount(properties.mfAssignedStudentCount));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Successfully Assigned", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "mfAssignedStudentCount",
        "mfMode",
        "classSize"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E-gfm7YPDX", "05e5d9289f265407eed4a290e14730489758bbf20e901957d9b0461354e20350", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Successfully Assigned", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Assigned Student Count": properties.mfAssignedStudentCount,
        "MF Mode": properties.mfMode,
        "Class Size": properties.classSize,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E-gfm7YPDX", "Successfully Assigned", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "ba_sAWHkZP", name: "MF Assigned Student Count", value: properties.mfAssignedStudentCount},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Successfully Assigned': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Successfully Assigned", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Assigned Student Count": properties.mfAssignedStudentCount,
          "MF Mode": properties.mfMode,
          "Class Size": properties.classSize,
          "Screen Height": sysScreenHeight,
          }, "E-gfm7YPDX", "05e5d9289f265407eed4a290e14730489758bbf20e901957d9b0461354e20350");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Successfully Assigned", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Assigned Student Count": properties.mfAssignedStudentCount,
      "MF Mode": properties.mfMode,
      "Class Size": properties.classSize,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Nav Clicked MF Track Fluency: On clicking "Track Fact Fluency" tab either from left nav or horizontal tab.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/t2wrxSd9aW}
   */
  function navClickedMfTrackFluency(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked MF Track Fluency", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source",
        "mfMode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "t2wrxSd9aW", "2f2dd9973e1d2b4a9ce5fb73424e0f413c991144e3649aecfc2804beed1e4707", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Nav Clicked MF Track Fluency", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "MF Mode": properties.mfMode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("t2wrxSd9aW", "Nav Clicked MF Track Fluency", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked MF Track Fluency': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked MF Track Fluency", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "MF Mode": properties.mfMode,
          "Screen Height": sysScreenHeight,
          }, "t2wrxSd9aW", "2f2dd9973e1d2b4a9ce5fb73424e0f413c991144e3649aecfc2804beed1e4707");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked MF Track Fluency", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "MF Mode": properties.mfMode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Track Adaptive Page: Triggered when the "Track adaptive practice" tab is rendered.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {bool} properties.activeAssignment - Was there any active assignment when teacher visited this page.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1uz5oUrT2u}
   */
  function viewedMfTrackAdaptivePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertActiveAssignment(properties.activeAssignment));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Track Adaptive Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "activeAssignment"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1uz5oUrT2u", "96225e2e179a5ae9da4637854e8fb0a3d32a42779b70c2d51ce66afd4da9d4cb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Track Adaptive Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Active Assignment": properties.activeAssignment,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1uz5oUrT2u", "Viewed MF Track Adaptive Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HMu5eJkRj5", name: "Active Assignment", value: properties.activeAssignment},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Track Adaptive Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Track Adaptive Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Active Assignment": properties.activeAssignment,
          "Screen Height": sysScreenHeight,
          }, "1uz5oUrT2u", "96225e2e179a5ae9da4637854e8fb0a3d32a42779b70c2d51ce66afd4da9d4cb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Track Adaptive Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Active Assignment": properties.activeAssignment,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Track Custom Page: Triggered when the "Track custom test" tab is rendered.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {bool} properties.activeAssignment - Was there any active assignment when teacher visited this page.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZUgsBQSpEG}
   */
  function viewedMfTrackCustomPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertActiveAssignment(properties.activeAssignment));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Track Custom Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "activeAssignment"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZUgsBQSpEG", "312ebea6ba5788af82d2e13cf5d4be38d012ebd3ce9e10b591a792e6e12066b4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Track Custom Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Active Assignment": properties.activeAssignment,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZUgsBQSpEG", "Viewed MF Track Custom Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HMu5eJkRj5", name: "Active Assignment", value: properties.activeAssignment},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Track Custom Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Track Custom Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Active Assignment": properties.activeAssignment,
          "Screen Height": sysScreenHeight,
          }, "ZUgsBQSpEG", "312ebea6ba5788af82d2e13cf5d4be38d012ebd3ce9e10b591a792e6e12066b4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Track Custom Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Active Assignment": properties.activeAssignment,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Track Adaptive Page: Clicked on key CTAs in the Track Adaptive practice page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sBSbnqgKlq}
   */
  function interactedMfTrackAdaptivePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Track Adaptive Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sBSbnqgKlq", "29b73d3d6786e25bbe48492ebe544004b2f9ccd15e8b031b51dfc48cfe1dd60b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Track Adaptive Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sBSbnqgKlq", "Interacted MF Track Adaptive Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Track Adaptive Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Track Adaptive Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "sBSbnqgKlq", "29b73d3d6786e25bbe48492ebe544004b2f9ccd15e8b031b51dfc48cfe1dd60b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Track Adaptive Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Nav Clicked Student Report: Clicking the Student Progress tab on the left nav/Top horizontal tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fLFcae43mS}
   */
  function navClickedStudentReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked Student Report", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fLFcae43mS", "dbf82a3077f2daa75a4e53621e0537e677fbcb5ef2a8a0529c1d89e1c2f2cc51", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Nav Clicked Student Report", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fLFcae43mS", "Nav Clicked Student Report", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked Student Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked Student Report", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "Screen Height": sysScreenHeight,
          }, "fLFcae43mS", "dbf82a3077f2daa75a4e53621e0537e677fbcb5ef2a8a0529c1d89e1c2f2cc51");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked Student Report", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Student Progress Page: When Math Fact student progress report page is rendered.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mZBu_P3Wz_}
   */
  function viewedMfStudentProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Student Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mZBu_P3Wz_", "fa1ec4843df7e7eeee08e94198cbf17b9863fc8435e6546420f130c402c70b48", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Student Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mZBu_P3Wz_", "Viewed MF Student Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Student Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Student Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "mZBu_P3Wz_", "fa1ec4843df7e7eeee08e94198cbf17b9863fc8435e6546420f130c402c70b48");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Student Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Student Progress Page: Clicked on the key CTAs on Math Fact student report page.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZhhC2ruUxR}
   */
  function interactedMfStudentProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Student Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZhhC2ruUxR", "3c304dcdac4426feb2bb9903205e853e563cf59747a07f241598e18cc4747e3a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Student Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZhhC2ruUxR", "Interacted MF Student Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Student Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Student Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ZhhC2ruUxR", "3c304dcdac4426feb2bb9903205e853e563cf59747a07f241598e18cc4747e3a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Student Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Nav Clicked Class Report: On clicking Class Progress Tab on the left nav/top horizontal tab.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.source - Click source
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qcbY_UukS}
   */
  function navClickedClassReport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSource(properties.source));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Nav Clicked Class Report", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "source"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qcbY_UukS", "77d5483619f1751fa29a3c3ec996bead9c1de5640139cd0ea71cfc3bf207656c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Nav Clicked Class Report", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Source": properties.source,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qcbY_UukS", "Nav Clicked Class Report", messages, [
        {id: "293juZE8KT", name: "Source", value: properties.source},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Nav Clicked Class Report': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Nav Clicked Class Report", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Source": properties.source,
          "Screen Height": sysScreenHeight,
          }, "qcbY_UukS", "77d5483619f1751fa29a3c3ec996bead9c1de5640139cd0ea71cfc3bf207656c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Nav Clicked Class Report", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Click Source": properties.source,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Class Curriculum Report Page: Event thrown when Class curriculum Grid report OR Group report is rendered.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.reportType - Type of report
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/vOTO87mhnR}
   */
  function viewedClassCurriculumReportPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertReportType(properties.reportType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Curriculum Report Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "reportType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "vOTO87mhnR", "88685eb2d0d22fb70b5802e61a91bfea0e0a20210b7f0eb17bb497f24bac729d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Class Curriculum Report Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Report Type": properties.reportType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("vOTO87mhnR", "Viewed Class Curriculum Report Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "Iye0o_TlZ0", name: "Report Type", value: properties.reportType},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Curriculum Report Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Curriculum Report Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Report Type": properties.reportType,
          "Screen Height": sysScreenHeight,
          }, "vOTO87mhnR", "88685eb2d0d22fb70b5802e61a91bfea0e0a20210b7f0eb17bb497f24bac729d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Curriculum Report Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Report Type": properties.reportType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Class Progress Page: When Math fact class report is rendered.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Tz6ZvP9MQu}
   */
  function viewedMfClassProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Class Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Tz6ZvP9MQu", "943f590acdde6bd2753b57eba2f2ce241e1279f3a94ca09dfe6cbbafdeda8634", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Class Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Tz6ZvP9MQu", "Viewed MF Class Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Class Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Class Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "Tz6ZvP9MQu", "943f590acdde6bd2753b57eba2f2ce241e1279f3a94ca09dfe6cbbafdeda8634");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Class Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Class Progress Page: On clicking on the grid cell or Operator
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/S_We7spjZ}
   */
  function interactedMfClassProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Class Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "S_We7spjZ", "498c3de384fb6bd068bdcc93d644f041987c63b24b8b1fa50acf4f377be2759d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Class Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("S_We7spjZ", "Interacted MF Class Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Class Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Class Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "S_We7spjZ", "498c3de384fb6bd068bdcc93d644f041987c63b24b8b1fa50acf4f377be2759d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Class Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Modify Practice Page: When modify practice page of the math facts is rendered
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.reachedVia - Reached this page from this page.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mwvLOCxMqn}
   */
  function viewedMfModifyPracticePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertReachedVia(properties.reachedVia));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Modify Practice Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "reachedVia"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mwvLOCxMqn", "0586cfe105743565a03de43d33844ec6b95561b1b3f14b7369c02b6927482b16", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Modify Practice Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Reached Via": properties.reachedVia,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mwvLOCxMqn", "Viewed MF Modify Practice Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "iRAn4RfO3I", name: "Reached Via", value: properties.reachedVia},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Modify Practice Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Modify Practice Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Reached Via": properties.reachedVia,
          "Screen Height": sysScreenHeight,
          }, "mwvLOCxMqn", "0586cfe105743565a03de43d33844ec6b95561b1b3f14b7369c02b6927482b16");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Modify Practice Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Reached Via": properties.reachedVia,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Modify Practice Page: Teacher pressed the "Save" button after doing the modifications in Math Facts modify practice screen OR Unassign
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.modifiedFor - Student count for which modification was done
   * @param {bool} properties.modifiedTime - Has teacher changed time from modify screen?
   * @param {bool} properties.modifiedOperator - Has teacher modified the operator from modify practice screen?
   * @param {bool} properties.modifiedDays - Has teacher modified practice days from modify practice screen?
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Iceg173HtQ}
   */
  function interactedMfModifyPracticePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertModifiedFor(properties.modifiedFor));
      messages = messages.concat(assertModifiedTime(properties.modifiedTime));
      messages = messages.concat(assertModifiedOperator(properties.modifiedOperator));
      messages = messages.concat(assertModifiedDays(properties.modifiedDays));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Modify Practice Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "modifiedFor",
        "modifiedTime",
        "modifiedOperator",
        "modifiedDays",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Iceg173HtQ", "0777bfd0c285693e1c22c169a0476b9bd2ac0f801ecdfdb932afb020f5e7cdd8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Modify Practice Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Modified For": properties.modifiedFor,
        "Modified Time": properties.modifiedTime,
        "Modified Operator": properties.modifiedOperator,
        "Modified Days": properties.modifiedDays,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Iceg173HtQ", "Interacted MF Modify Practice Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Tz8yoJEXaS", name: "Modified Operator", value: properties.modifiedOperator},
        {id: "UrJ4r6Tv4Q", name: "Modified For", value: properties.modifiedFor},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "fvYVVEdCul", name: "Modified Days", value: properties.modifiedDays},
        {id: "m-vmQiLuIl", name: "Modified Time", value: properties.modifiedTime},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Modify Practice Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Modify Practice Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Modified For": properties.modifiedFor,
          "Modified Time": properties.modifiedTime,
          "Modified Operator": properties.modifiedOperator,
          "Modified Days": properties.modifiedDays,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Iceg173HtQ", "0777bfd0c285693e1c22c169a0476b9bd2ac0f801ecdfdb932afb020f5e7cdd8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Modify Practice Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Modified For": properties.modifiedFor,
      "Modified Time": properties.modifiedTime,
      "Modified Operator": properties.modifiedOperator,
      "Modified Days": properties.modifiedDays,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MyToDo Page: When MyToDo page is opened on the Student Dashboard
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {bool} properties.mfAssignmentAvailable - Is active MF assignment (adaptive or custom)  available in MyToDo section?
   * @param {bool} properties.curriculumAssignmentAvailable - Is assignment from core curriculum available? Includes Learning Path and LOs but not assessment.
   * @param {int} properties.totalAssignmentCount - Assignment count shown on the myToDo card on student dashboard.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-JCqGnIn92}
   */
  function viewedMytodoPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFAssignmentAvailable(properties.mfAssignmentAvailable));
      messages = messages.concat(assertCurriculumAssignmentAvailable(properties.curriculumAssignmentAvailable));
      messages = messages.concat(assertTotalAssignmentCount(properties.totalAssignmentCount));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MyToDo Page", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "mfAssignmentAvailable",
        "curriculumAssignmentAvailable",
        "totalAssignmentCount",
        "subject",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-JCqGnIn92", "51182e131175d4ca88e31394018006569187067c85e4104c991faec23859f24d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MyToDo Page", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Assignment Available": properties.mfAssignmentAvailable,
        "Curriculum Assignment Available": properties.curriculumAssignmentAvailable,
        "Total Assignment Count": properties.totalAssignmentCount,
        "Subject": properties.subject,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-JCqGnIn92", "Viewed MyToDo Page", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "hBgoB0mPff", name: "Total Assignment Count", value: properties.totalAssignmentCount},
        {id: "jiop2Ii29S", name: "Curriculum Assignment Available", value: properties.curriculumAssignmentAvailable},
        {id: "t3iU5mo89Y", name: "MF Assignment Available", value: properties.mfAssignmentAvailable},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MyToDo Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MyToDo Page", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Assignment Available": properties.mfAssignmentAvailable,
          "Curriculum Assignment Available": properties.curriculumAssignmentAvailable,
          "Total Assignment Count": properties.totalAssignmentCount,
          "Subject": properties.subject,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "-JCqGnIn92", "51182e131175d4ca88e31394018006569187067c85e4104c991faec23859f24d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MyToDo Page", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Assignment Available": properties.mfAssignmentAvailable,
      "Curriculum Assignment Available": properties.curriculumAssignmentAvailable,
      "Total Assignment Count": properties.totalAssignmentCount,
      "Subject": properties.subject,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Math Fact Started: Existing event: When Math facts adaptive or custom mode is started and rendered in the iFrame.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/F11zQeD1tk}
   */
  function mathFactStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Math Fact Started", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "mfMode",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "F11zQeD1tk", "577fcda14fb253bcdac001abc81c520b49061802c70a805854150ed4d7ba0403", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Math Fact Started", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "MF Mode": properties.mfMode,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("F11zQeD1tk", "Math Fact Started", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Math Fact Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Math Fact Started", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "MF Mode": properties.mfMode,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "F11zQeD1tk", "577fcda14fb253bcdac001abc81c520b49061802c70a805854150ed4d7ba0403");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Math Fact Started", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Mode": properties.mfMode,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Completed Math Fact Assignment: Triggered when completed the custom mode test or daily adaptive practice.
   *
   * When to trigger this event:
   * 1. Triggered when completed the custom mode test or daily adaptive practice. 
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ho-URePgar/trigger/qHMy80JHl
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} properties.totalTimeTaken - Total time spent in completing the assignment
   * @param {int} properties.totalProblemsAnswered - Total problems answered to complete the assignment.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ho-URePgar}
   */
  function completedMathFactAssignment(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertTotalTimeTaken(properties.totalTimeTaken));
      messages = messages.concat(assertTotalProblemsAnswered(properties.totalProblemsAnswered));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Math Fact Assignment", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "mfMode",
        "totalTimeTaken",
        "totalProblemsAnswered"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ho-URePgar", "ccf53de9f2390433bcb7ee8d3b2ae4c21213da2ee012fc511396dc43102b31e6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Completed Math Fact Assignment", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "MF Mode": properties.mfMode,
        "Total Time Taken": properties.totalTimeTaken,
        "Total Problems Answered": properties.totalProblemsAnswered,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ho-URePgar", "Completed Math Fact Assignment", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "V_eCbteEGc", name: "Total Problems Answered", value: properties.totalProblemsAnswered},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "gTep6toPK0", name: "Total Time Taken", value: properties.totalTimeTaken},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Math Fact Assignment': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Math Fact Assignment", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "MF Mode": properties.mfMode,
          "Total Time Taken": properties.totalTimeTaken,
          "Total Problems Answered": properties.totalProblemsAnswered,
          "Screen Height": sysScreenHeight,
          }, "Ho-URePgar", "ccf53de9f2390433bcb7ee8d3b2ae4c21213da2ee012fc511396dc43102b31e6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Math Fact Assignment", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "MF Mode": properties.mfMode,
      "Total Time Taken": properties.totalTimeTaken,
      "Total Problems Answered": properties.totalProblemsAnswered,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Delete Account Alert: This event is fired when user clicks on delete account option & alert is presented
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kel_sQL_IK}
   */
  function viewedDeleteAccountAlert(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Delete Account Alert", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kel_sQL_IK", "cb9521bf170a9bd88ada236a7a415c04de9bacf7c2e3c655926f88a0632fa1d1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Delete Account Alert", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kel_sQL_IK", "Viewed Delete Account Alert", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Delete Account Alert': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Delete Account Alert", {
          "Screen Height": sysScreenHeight,
          }, "kel_sQL_IK", "cb9521bf170a9bd88ada236a7a415c04de9bacf7c2e3c655926f88a0632fa1d1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Delete Account Alert", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Delete Account Alert: Fired when user selects either option on delete account alert
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tappedOn - UI element that user tapped on - used in conjunction with the event name which identifies the screen name
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QWnXgL0unn}
   */
  function interactedDeleteAccountAlert(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTappedOn(properties.tappedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Delete Account Alert", Object.keys(properties), [
        "tappedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QWnXgL0unn", "c8607e876c73086e9a72472093a5df59ed8ee670307e79e1dc472c3f23588b87", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Delete Account Alert", {
        "Tapped On": properties.tappedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QWnXgL0unn", "Interacted Delete Account Alert", messages, [
        {id: "cfvmMqWft", name: "Tapped On", value: properties.tappedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Delete Account Alert': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Delete Account Alert", {
          "Tapped On": properties.tappedOn,
          "Screen Height": sysScreenHeight,
          }, "QWnXgL0unn", "c8607e876c73086e9a72472093a5df59ed8ee670307e79e1dc472c3f23588b87");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Delete Account Alert", {
      "Tapped On": properties.tappedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Started Game: Whenever a new games or activity is started
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Mmp3DnDn5T}
   */
  function startedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Game", Object.keys(properties), [
        "gameName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Mmp3DnDn5T", "be3c7c9680f4f73df4d170fe90a5c5bd23fffeac3a9d4c5c201ee5eaad39aa6e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Started Game", {
        "Game Name": properties.gameName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Mmp3DnDn5T", "Started Game", messages, [
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Game", {
          "Game Name": properties.gameName,
          "Screen Height": sysScreenHeight,
          }, "Mmp3DnDn5T", "be3c7c9680f4f73df4d170fe90a5c5bd23fffeac3a9d4c5c201ee5eaad39aa6e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Game", {
      "Game Name": properties.gameName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Games: The first time whenever a new game is viewed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} [properties.position] - 1. The position of the game group from left to right on the Pre-K dashboard
2. In the Activities section, position on Iphone is from left to right but on Ipad having dual row layout, the first column has position 1,2, second column has positions 3,4 and so on
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {int} [properties.columnNumber] - The column in which the game is appearing
   * @param {int} [properties.rowNumber] - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I_BknrYsE}
   */
  function viewedGames(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalPosition(properties.position));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalColumnNumber(properties.columnNumber));
      messages = messages.concat(assertOptionalRowNumber(properties.rowNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Games", Object.keys(properties), [
        "position",
        "gameName",
        "columnNumber",
        "rowNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "I_BknrYsE", "e7e5d33111cda779719075b27cb75e49b3855b74d32058e7c04e8e675ba94721", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Games", {
        "Position": properties.position,
        "Game Name": properties.gameName,
        "Column Number": properties.columnNumber,
        "Row Number": properties.rowNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("I_BknrYsE", "Viewed Games", messages, [
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "a9l_OugqB", name: "Row Number", value: properties.rowNumber},
        {id: "eGs90Bi3pM", name: "Column Number", value: properties.columnNumber},
        {id: "rlSRn44vYq", name: "Position", value: properties.position},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Games': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Games", {
          "Position": properties.position,
          "Game Name": properties.gameName,
          "Column Number": properties.columnNumber,
          "Row Number": properties.rowNumber,
          "Screen Height": sysScreenHeight,
          }, "I_BknrYsE", "e7e5d33111cda779719075b27cb75e49b3855b74d32058e7c04e8e675ba94721");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Games", {
      "Position": properties.position,
      "Game Name": properties.gameName,
      "Column Number": properties.columnNumber,
      "Row Number": properties.rowNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Tapped Game: Whenever a new game or activity is tapped/clicked
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {int} [properties.position] - 1. The position of the game group from left to right on the Pre-K dashboard
2. In the Activities section, position on Iphone is from left to right but on Ipad having dual row layout, the first column has position 1,2, second column has positions 3,4 and so on
   * @param {int} [properties.columnNumber] - The column in which the game is appearing
   * @param {int} [properties.rowNumber] - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SGkQR8dCqg}
   */
  function tappedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalPosition(properties.position));
      messages = messages.concat(assertOptionalColumnNumber(properties.columnNumber));
      messages = messages.concat(assertOptionalRowNumber(properties.rowNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Tapped Game", Object.keys(properties), [
        "gameName",
        "position",
        "columnNumber",
        "rowNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SGkQR8dCqg", "ee1c140a56817874aadd6f7bd636eaf10c1ac7a7fc1b1ae3e62e5473b08bfb7d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Tapped Game", {
        "Game Name": properties.gameName,
        "Position": properties.position,
        "Column Number": properties.columnNumber,
        "Row Number": properties.rowNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SGkQR8dCqg", "Tapped Game", messages, [
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "a9l_OugqB", name: "Row Number", value: properties.rowNumber},
        {id: "eGs90Bi3pM", name: "Column Number", value: properties.columnNumber},
        {id: "rlSRn44vYq", name: "Position", value: properties.position},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Tapped Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Tapped Game", {
          "Game Name": properties.gameName,
          "Position": properties.position,
          "Column Number": properties.columnNumber,
          "Row Number": properties.rowNumber,
          "Screen Height": sysScreenHeight,
          }, "SGkQR8dCqg", "ee1c140a56817874aadd6f7bd636eaf10c1ac7a7fc1b1ae3e62e5473b08bfb7d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Tapped Game", {
      "Game Name": properties.gameName,
      "Position": properties.position,
      "Column Number": properties.columnNumber,
      "Row Number": properties.rowNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF New Practice Page: When the teacher clicks on the CTAs on New fact practice page
   *
   * When to trigger this event:
   * 1. When the teacher clicks on the CTAs on New fact practice page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M7mAq9QvRA/trigger/eTL_psnH0
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnNewMfPractice - Alias event property for clicked on. List of key links on "New Fact Practice" page key
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M7mAq9QvRA}
   */
  function interactedMfNewPracticePage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnNewMFPractice(properties.clickedOnNewMfPractice));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF New Practice Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnNewMfPractice"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "M7mAq9QvRA", "70ec0517c649b86b9eb085772145f3038cfae93d76e96985b5e553f74a182fda", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF New Practice Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on - New MF Practice": properties.clickedOnNewMfPractice,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("M7mAq9QvRA", "Interacted MF New Practice Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "_fUyjKBzmx", name: "Clicked on - New MF Practice", value: properties.clickedOnNewMfPractice},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF New Practice Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF New Practice Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on - New MF Practice": properties.clickedOnNewMfPractice,
          "Screen Height": sysScreenHeight,
          }, "M7mAq9QvRA", "70ec0517c649b86b9eb085772145f3038cfae93d76e96985b5e553f74a182fda");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF New Practice Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnNewMfPractice,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Custom Mode Settings Popup: Event to collect all the settings chosen by the teacher to assign custom mode. Triggered on clicking Print Worksheet or Select Students
   *
   * When to trigger this event:
   * 1. Triggered on clicking Print Worksheet or Select Students
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/brWXxCW-RK/trigger/xtDQIT3Vw
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {Array<string>} properties.customMfOperatorSelected - Math Fact operators that are selected by the teacher to assign custom test.
   * @param {string} properties.mfPracticeQuestionsCount - Count of selected questions for Adaptive mode. Range is 20, 30 , 40
   * @param {string} properties.mfMode - Adaptive or Custom mode of the math facts.
   * @param {string} properties.mfCustomSettingsClickedOn - Alias event property for clicked on. When teacher clicks on key CTA's of settings popup.
   * @param {string} properties.mfTimePerQuestion - Time per question setting selected by the teacher for custom test.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/brWXxCW-RK}
   */
  function interactedMfCustomModeSettingsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertCustomMFOperatorSelected(properties.customMfOperatorSelected));
      messages = messages.concat(assertMFPracticeQuestionsCount(properties.mfPracticeQuestionsCount));
      messages = messages.concat(assertMFMode(properties.mfMode));
      messages = messages.concat(assertMFCustomSettingsClickedOn(properties.mfCustomSettingsClickedOn));
      messages = messages.concat(assertMFTimePerQuestion(properties.mfTimePerQuestion));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Custom Mode Settings Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "customMfOperatorSelected",
        "mfPracticeQuestionsCount",
        "mfMode",
        "mfCustomSettingsClickedOn",
        "mfTimePerQuestion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "brWXxCW-RK", "7daa85284ae17ad66f50bf65deff9338a963046a671e88249ffc7eae5e1178af", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Custom Mode Settings Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Custom MF Operator Selected": properties.customMfOperatorSelected,
        "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
        "MF Mode": properties.mfMode,
        "MF Custom Settings - Clicked On": properties.mfCustomSettingsClickedOn,
        "MF Time Per Question": properties.mfTimePerQuestion,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("brWXxCW-RK", "Interacted MF Custom Mode Settings Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "W2HLoVKJnA", name: "MF Mode", value: properties.mfMode},
        {id: "XJ6AZrYTI-", name: "Custom MF Operator Selected", value: properties.customMfOperatorSelected},
        {id: "h2KwMOlZr5", name: "MF Custom Settings - Clicked On", value: properties.mfCustomSettingsClickedOn},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "rpd15EbJEO", name: "MF Practice Questions Count", value: properties.mfPracticeQuestionsCount},
        {id: "ti40sCZ5Kg", name: "MF Time Per Question", value: properties.mfTimePerQuestion},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Custom Mode Settings Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Custom Mode Settings Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Custom MF Operator Selected": properties.customMfOperatorSelected,
          "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
          "MF Mode": properties.mfMode,
          "MF Custom Settings - Clicked On": properties.mfCustomSettingsClickedOn,
          "MF Time Per Question": properties.mfTimePerQuestion,
          "Screen Height": sysScreenHeight,
          }, "brWXxCW-RK", "7daa85284ae17ad66f50bf65deff9338a963046a671e88249ffc7eae5e1178af");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Settings Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "MF Operator Selected": properties.customMfOperatorSelected,
      "MF Practice Questions Count": properties.mfPracticeQuestionsCount,
      "MF Mode": properties.mfMode,
      "Clicked On": properties.mfCustomSettingsClickedOn,
      "MF Time Per Question": properties.mfTimePerQuestion,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Student Selection Popup: When the teacher clicks on "Assign" on student selection popup.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnStudentSelectionPopup - When teacher clicks on "Assign"
   * @param {string} properties.mfAssignedTo - Whether assigned to whole class or selected students.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xXSLdh88n_}
   */
  function interactedMfStudentSelectionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnStudentSelectionPopup(properties.clickedOnStudentSelectionPopup));
      messages = messages.concat(assertMFAssignedTo(properties.mfAssignedTo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Student Selection Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnStudentSelectionPopup",
        "mfAssignedTo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xXSLdh88n_", "316ab992a64f6a52a2b9886d8f571db526d3fbea3bf5ff85e573ff807dca9f95", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Student Selection Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on - Student Selection Popup": properties.clickedOnStudentSelectionPopup,
        "MF Assigned To": properties.mfAssignedTo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xXSLdh88n_", "Interacted MF Student Selection Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4BthSPAer", name: "MF Assigned To", value: properties.mfAssignedTo},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zDpSmq5T0V", name: "Clicked on - Student Selection Popup", value: properties.clickedOnStudentSelectionPopup},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Student Selection Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Student Selection Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on - Student Selection Popup": properties.clickedOnStudentSelectionPopup,
          "MF Assigned To": properties.mfAssignedTo,
          "Screen Height": sysScreenHeight,
          }, "xXSLdh88n_", "316ab992a64f6a52a2b9886d8f571db526d3fbea3bf5ff85e573ff807dca9f95");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Student Selection Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnStudentSelectionPopup,
      "MF Assigned To": properties.mfAssignedTo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Track Custom Page: When teacher clicks on "View report" or "Print worksheet" or links in the kebab menu
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnTrackCustomPage - Alias event property for clicked on. List of key links on the track custom test page.

   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pvVgCRq8iF}
   */
  function interactedMfTrackCustomPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnTrackCustomPage(properties.clickedOnTrackCustomPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Track Custom Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnTrackCustomPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pvVgCRq8iF", "552ca2e621817cfdc0b4e8b8ad98782f1302437d7d5a3c4e06599681187965a6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Track Custom Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on - Track Custom Page": properties.clickedOnTrackCustomPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pvVgCRq8iF", "Interacted MF Track Custom Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "LqyojH3QzY", name: "Clicked on - Track Custom Page", value: properties.clickedOnTrackCustomPage},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Track Custom Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Track Custom Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on - Track Custom Page": properties.clickedOnTrackCustomPage,
          "Screen Height": sysScreenHeight,
          }, "pvVgCRq8iF", "552ca2e621817cfdc0b4e8b8ad98782f1302437d7d5a3c4e06599681187965a6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Track Custom Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnTrackCustomPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Custom Report Page: When teacher clicks on the key CTAs on individual online custom test report.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOnCustomReportPage - List of links on Individual custom test page.  For Sort Students, click on any of the option will be considered.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GdMHcuHiJD}
   */
  function interactedMfCustomReportPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOnCustomReportPage(properties.clickedOnCustomReportPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Custom Report Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOnCustomReportPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GdMHcuHiJD", "9175a59b36298b4872fde3ed8cad4f1b8488734b25eaf861b624ef96d08d30a9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Custom Report Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked on- Custom Report Page": properties.clickedOnCustomReportPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GdMHcuHiJD", "Interacted MF Custom Report Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9xTjWsrhLS", name: "Clicked on- Custom Report Page", value: properties.clickedOnCustomReportPage},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Custom Report Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Custom Report Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked on- Custom Report Page": properties.clickedOnCustomReportPage,
          "Screen Height": sysScreenHeight,
          }, "GdMHcuHiJD", "9175a59b36298b4872fde3ed8cad4f1b8488734b25eaf861b624ef96d08d30a9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Custom Report Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOnCustomReportPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Weekly Goal Interacted: Interacted with the weekly goal screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I1V6823U-w/trigger/xZ5_XapPj
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/I1V6823U-w}
   */
  function weeklyGoalInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Weekly Goal Interacted", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "I1V6823U-w", "37e9cd7230056ea41eb3e2fe00334ed7dde7f217b39ea3d1d08627b71a3e10df", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Weekly Goal Interacted", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("I1V6823U-w", "Weekly Goal Interacted", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Weekly Goal Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Weekly Goal Interacted", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "I1V6823U-w", "37e9cd7230056ea41eb3e2fe00334ed7dde7f217b39ea3d1d08627b71a3e10df");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Weekly Goal Interacted", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Tiled Dashboard: Fired when the user lands on the student Dashboard
   *
   * When to trigger this event:
   * 1. The event will get fired when the user lands on the student dashboard on any of the 2 tabs
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ea2mFo-LsZ/trigger/Lqhlc1iG1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.dashboardVersion] - What kind of Dashboard is visible to the child
   * @param {int} [properties.totalAssignmentCount] - Assignment count shown on the myToDo card on student dashboard.
   * @param {int} [properties.mathAssignmentCount] - Total number of assignment (including assessment, Learning Plan, Math Facts) pending for a student in their My To Dos section
   * @param {int} [properties.elaAssignmentCount] - Total number of ELA assignment (including assessment, Learning Plan) pending for a student in their My To Dos section
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {Array<string>} [properties.recommendedCategory] - This property will be used to store what recommendations were shown to the user in the HOME tab.
We'll be saving them in this format:

<Rail Name>|<Category Name>

where possible values are:
Rail Name = Curriculum, Game Zone
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games, Math_LO, ELA_LO
   * @param {Array<string>} [properties.recommendedPlayableCode] - This will be used to store the recommended playable code to the user in the HOME tab , with the daily recommendation system. We'll be saving it in this format:

 <Category Name>|<Playable Code>

where <Category Name> will be same as the values passed in the 'recommended category' property.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {Array<string>} [properties.recommendedRail] - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
   * @param {string} [properties.grade] - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} [properties.worksheetCode] - Worksheet code of selected worksheet
   * @param {string} [properties.discountPitch] - This property highlights if we are offering any discount at the time of user doing that event - Eg: 'Viewed Tiled Dashboard' , 'clicking the CTA - Unlock Content'
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ea2mFo-LsZ}
   */
  function viewedTiledDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalDashboardVersion(properties.dashboardVersion));
      messages = messages.concat(assertOptionalTotalAssignmentCount(properties.totalAssignmentCount));
      messages = messages.concat(assertOptionalMathAssignmentCount(properties.mathAssignmentCount));
      messages = messages.concat(assertOptionalELAAssignmentCount(properties.elaAssignmentCount));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertOptionalRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertOptionalRecommendedPlayableCode(properties.recommendedPlayableCode));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertOptionalRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertOptionalGrade(properties.grade));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertOptionalWorksheetCode(properties.worksheetCode));
      messages = messages.concat(assertOptionalDiscountPitch(properties.discountPitch));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tiled Dashboard", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "dashboardVersion",
        "totalAssignmentCount",
        "mathAssignmentCount",
        "elaAssignmentCount",
        "teacherType",
        "recommendedCategory",
        "recommendedPlayableCode",
        "tabCode",
        "recommendedRail",
        "grade",
        "from",
        "worksheetCode",
        "discountPitch",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ea2mFo-LsZ", "e2a31c4ecafcc1f9b60706ed6762354734feb53e468d7a7097481913db6ac684", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Tiled Dashboard", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Dashboard Version": properties.dashboardVersion,
        "Total Assignment Count": properties.totalAssignmentCount,
        "Math Assignment Count": properties.mathAssignmentCount,
        "ELA Assignment Count": properties.elaAssignmentCount,
        "Teacher Type": properties.teacherType,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Playable Code": properties.recommendedPlayableCode,
        "Tab Code": properties.tabCode,
        "Recommended Rail": properties.recommendedRail,
        "Grade": properties.grade,
        "From": properties.from,
        "Worksheet Code": properties.worksheetCode,
        "Discount Pitch": properties.discountPitch,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ea2mFo-LsZ", "Viewed Tiled Dashboard", messages, [
        {id: "-tPNSAQK6", name: "Discount Pitch", value: properties.discountPitch},
        {id: "09LOni_Ki3", name: "Recommended Playable Code", value: properties.recommendedPlayableCode},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6QT3mtqEUD", name: "Dashboard Version", value: properties.dashboardVersion},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "NRFYZYLxy", name: "Worksheet Code", value: properties.worksheetCode},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "dqG7mb_H0j", name: "ELA Assignment Count", value: properties.elaAssignmentCount},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hBgoB0mPff", name: "Total Assignment Count", value: properties.totalAssignmentCount},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "mdeQgK543Z", name: "Math Assignment Count", value: properties.mathAssignmentCount},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tiled Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tiled Dashboard", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Dashboard Version": properties.dashboardVersion,
          "Total Assignment Count": properties.totalAssignmentCount,
          "Math Assignment Count": properties.mathAssignmentCount,
          "ELA Assignment Count": properties.elaAssignmentCount,
          "Teacher Type": properties.teacherType,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Playable Code": properties.recommendedPlayableCode,
          "Tab Code": properties.tabCode,
          "Recommended Rail": properties.recommendedRail,
          "Grade": properties.grade,
          "From": properties.from,
          "Worksheet Code": properties.worksheetCode,
          "Discount Pitch": properties.discountPitch,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "Ea2mFo-LsZ", "e2a31c4ecafcc1f9b60706ed6762354734feb53e468d7a7097481913db6ac684");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tiled Dashboard", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Dashboard Version": properties.dashboardVersion,
      "Total Assignment Count": properties.totalAssignmentCount,
      "Math Assignment Count": properties.mathAssignmentCount,
      "ELA Assignment Count": properties.elaAssignmentCount,
      "Teacher Type": properties.teacherType,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Playable Code": properties.recommendedPlayableCode,
      "Tab Code": properties.tabCode,
      "Recommended Rail": properties.recommendedRail,
      "Grade": properties.grade,
      "From": properties.from,
      "Worksheet Code": properties.worksheetCode,
      "Discount Pitch": properties.discountPitch,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Tiled Dashboard: This event get fired when the user clicks on any element on the Student Dashboard
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {string} [properties.dashboardVersion] - What kind of Dashboard is visible to the child
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {int} [properties.freeActivitiesLeftCount] - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {int} [properties.rowPosition] - The row position where the user has clicked. Will start from 1.
   * @param {int} [properties.columnPosition] - The column position where the user has clicked. Will start from 1.
   * @param {string} [properties.clickedOnSection] - Name of the section header where a user clicked/tapped
   * @param {string} [properties.clickedOnCategory] - Describes the category on which the user has clicked .
the categories are the broad content types which can be recommended in the daily recommendation section. Eg:  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games
   * @param {string} [properties.isRecommendedContent] - This property will differentiate whether the user is clicking on a recommended content or some other content like headers, tabs etc.
Values can be 'Yes' or 'No'
   * @param {string} [properties.section] - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.category] - This represents the different types of content being recommended to the user through the DRS. Possible values = MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games, etc







   * @param {string} [properties.gameCode] - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {int} [properties.ordering] - This field defines the order of the recommendation. It will start from 0 and then progress by one count at a time.
Since the users' recommendation can change in a particular day for a particular category, this ordering will let us know how the recommended category has changed over a day for the user.
   * @param {Array<string>} [properties.recommendedCategory] - This property will be used to store what recommendations were shown to the user in the HOME tab.
We'll be saving them in this format:

<Rail Name>|<Category Name>

where possible values are:
Rail Name = Curriculum, Game Zone
Category name =  MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games, Math_LO, ELA_LO
   * @param {Array<string>} [properties.recommendedPlayableCode] - This will be used to store the recommended playable code to the user in the HOME tab , with the daily recommendation system. We'll be saving it in this format:

 <Category Name>|<Playable Code>

where <Category Name> will be same as the values passed in the 'recommended category' property.
   * @param {Array<string>} [properties.recommendedRail] - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
   * @param {string} [properties.contentGroup] - Name of content group user clicked/tapped on
   * @param {string} [properties.worksheetCode] - Worksheet code of selected worksheet
   * @param {string} [properties.topicName] - The academic name of the topic that user selected
   * @param {string} [properties.subject] - Subject Selected during onboarding

   * @param {string} [properties.level1Topic] - Name of Level 1 Topic for worksheets
   * @param {string} [properties.url] - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.gradeSelected] - Grade selected by user in curriculum tab
   * @param {string} [properties.recommendedRailName] - This is the name of the rail viewed by the user.
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {int} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user.
   * @param {string} [properties.recommendedTileName] - This property will store the name of the tile user has interacted with - CG name for curriculum rails and playable name for non curr. rails

   * @param {int} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.interactionType] - Defines the type of interaction (click, scroll, hover etc)
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QYCOZy8NPj}
   */
  function interactedTiledDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertOptionalDashboardVersion(properties.dashboardVersion));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalRowPosition(properties.rowPosition));
      messages = messages.concat(assertOptionalColumnPosition(properties.columnPosition));
      messages = messages.concat(assertOptionalClickedOnSection(properties.clickedOnSection));
      messages = messages.concat(assertOptionalClickedOnCategory(properties.clickedOnCategory));
      messages = messages.concat(assertOptionalIsRecommendedContent(properties.isRecommendedContent));
      messages = messages.concat(assertOptionalSection(properties.section));
      messages = messages.concat(assertOptionalCategory(properties.category));
      messages = messages.concat(assertOptionalGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalOrdering(properties.ordering));
      messages = messages.concat(assertOptionalRecommendedCategory(properties.recommendedCategory));
      messages = messages.concat(assertOptionalRecommendedPlayableCode(properties.recommendedPlayableCode));
      messages = messages.concat(assertOptionalRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalWorksheetCode(properties.worksheetCode));
      messages = messages.concat(assertOptionalTopicName(properties.topicName));
      messages = messages.concat(assertOptionalSubject(properties.subject));
      messages = messages.concat(assertOptionalLevel1Topic(properties.level1Topic));
      messages = messages.concat(assertOptionalUrl(properties.url));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalInteractionType(properties.interactionType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tiled Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "teacherType",
        "dashboardVersion",
        "from",
        "playableCode",
        "freeActivitiesLeftCount",
        "rowPosition",
        "columnPosition",
        "clickedOnSection",
        "clickedOnCategory",
        "isRecommendedContent",
        "section",
        "category",
        "gameCode",
        "ordering",
        "recommendedCategory",
        "recommendedPlayableCode",
        "recommendedRail",
        "contentGroup",
        "worksheetCode",
        "topicName",
        "subject",
        "level1Topic",
        "url",
        "clickedOn",
        "gradeSelected",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "elaGrade",
        "grade",
        "interactionType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QYCOZy8NPj", "728b00fe70b524dce77d4be562458ecba987cc2b7118974af38a8fd670c65163", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Tiled Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Teacher Type": properties.teacherType,
        "Dashboard Version": properties.dashboardVersion,
        "From": properties.from,
        "Playable Code": properties.playableCode,
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Row Position": properties.rowPosition,
        "Column Position": properties.columnPosition,
        "Clicked on Section": properties.clickedOnSection,
        "Clicked on Category": properties.clickedOnCategory,
        "Is Recommended Content": properties.isRecommendedContent,
        "Section": properties.section,
        "Category": properties.category,
        "Game Code": properties.gameCode,
        "Ordering": properties.ordering,
        "Recommended Category": properties.recommendedCategory,
        "Recommended Playable Code": properties.recommendedPlayableCode,
        "Recommended Rail": properties.recommendedRail,
        "Content Group": properties.contentGroup,
        "Worksheet Code": properties.worksheetCode,
        "Topic Name": properties.topicName,
        "Subject": properties.subject,
        "Level 1 Topic": properties.level1Topic,
        "Url": properties.url,
        "Clicked On": properties.clickedOn,
        "Grade Selected": properties.gradeSelected,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Interaction Type": properties.interactionType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QYCOZy8NPj", "Interacted Tiled Dashboard", messages, [
        {id: "09LOni_Ki3", name: "Recommended Playable Code", value: properties.recommendedPlayableCode},
        {id: "1Yc2cQ5iyN", name: "Topic Name", value: properties.topicName},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "4YcQJt7EU", name: "Ordering", value: properties.ordering},
        {id: "6QT3mtqEUD", name: "Dashboard Version", value: properties.dashboardVersion},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "NRFYZYLxy", name: "Worksheet Code", value: properties.worksheetCode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "PokUqOLpg8", name: "Interaction Type", value: properties.interactionType},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "Sq_wyVgw4s", name: "Column Position", value: properties.columnPosition},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "VdJhEU0H6s", name: "Recommended Category", value: properties.recommendedCategory},
        {id: "YzXAIbKaI", name: "Is Recommended Content", value: properties.isRecommendedContent},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "hVOa_xHVR", name: "Category", value: properties.category},
        {id: "jHXiFNYU2", name: "Level 1 Topic", value: properties.level1Topic},
        {id: "mOXSzLg0Im", name: "Row Position", value: properties.rowPosition},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "n4HbuwgZ_E", name: "Clicked on Section", value: properties.clickedOnSection},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "s4K0XLoiQ", name: "Clicked on Category", value: properties.clickedOnCategory},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tiled Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tiled Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Teacher Type": properties.teacherType,
          "Dashboard Version": properties.dashboardVersion,
          "From": properties.from,
          "Playable Code": properties.playableCode,
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Row Position": properties.rowPosition,
          "Column Position": properties.columnPosition,
          "Clicked on Section": properties.clickedOnSection,
          "Clicked on Category": properties.clickedOnCategory,
          "Is Recommended Content": properties.isRecommendedContent,
          "Section": properties.section,
          "Category": properties.category,
          "Game Code": properties.gameCode,
          "Ordering": properties.ordering,
          "Recommended Category": properties.recommendedCategory,
          "Recommended Playable Code": properties.recommendedPlayableCode,
          "Recommended Rail": properties.recommendedRail,
          "Content Group": properties.contentGroup,
          "Worksheet Code": properties.worksheetCode,
          "Topic Name": properties.topicName,
          "Subject": properties.subject,
          "Level 1 Topic": properties.level1Topic,
          "Url": properties.url,
          "Clicked On": properties.clickedOn,
          "Grade Selected": properties.gradeSelected,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Interaction Type": properties.interactionType,
          "Screen Height": sysScreenHeight,
          }, "QYCOZy8NPj", "728b00fe70b524dce77d4be562458ecba987cc2b7118974af38a8fd670c65163");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tiled Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Teacher Type": properties.teacherType,
      "Dashboard Version": properties.dashboardVersion,
      "From": properties.from,
      "Playable Code": properties.playableCode,
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Row Position": properties.rowPosition,
      "Column Position": properties.columnPosition,
      "Clicked on Section": properties.clickedOnSection,
      "Clicked on Category": properties.clickedOnCategory,
      "Is Recommended Content": properties.isRecommendedContent,
      "Section": properties.section,
      "Category": properties.category,
      "Game Code": properties.gameCode,
      "Ordering": properties.ordering,
      "Recommended Category": properties.recommendedCategory,
      "Recommended Playable Code": properties.recommendedPlayableCode,
      "Recommended Rail": properties.recommendedRail,
      "Content Group": properties.contentGroup,
      "Worksheet Code": properties.worksheetCode,
      "Topic Name": properties.topicName,
      "Subject": properties.subject,
      "Level 1 Topic": properties.level1Topic,
      "Url": properties.url,
      "Clicked On": properties.clickedOn,
      "Grade Selected": properties.gradeSelected,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Interaction Type": properties.interactionType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Completed Student Dashboard Scroll: When the user completed scrolling the full student dashboard page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qzgiqToXI_}
   */
  function completedStudentDashboardScroll(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Student Dashboard Scroll", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qzgiqToXI_", "a67e732ae27d3a6def35efe0db61531fdd75217dcb6c250d4319b9a2c9b8b082", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Completed Student Dashboard Scroll", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qzgiqToXI_", "Completed Student Dashboard Scroll", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Student Dashboard Scroll': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Student Dashboard Scroll", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "qzgiqToXI_", "a67e732ae27d3a6def35efe0db61531fdd75217dcb6c250d4319b9a2c9b8b082");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Student Dashboard Scroll", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Completed Page Rendering: Event gets fired when the page rendering is complete and the user can interact with the page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FW5Xw4S2_v}
   */
  function completedPageRendering(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Page Rendering", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FW5Xw4S2_v", "d80031869a54695a8e690baaff8fe769e7a2e99f0fb88a718cd60c520f4b593e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Completed Page Rendering", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FW5Xw4S2_v", "Completed Page Rendering", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Page Rendering': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Page Rendering", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "FW5Xw4S2_v", "d80031869a54695a8e690baaff8fe769e7a2e99f0fb88a718cd60c520f4b593e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Page Rendering", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Downloaded Worksheet: Triggers when the teacher downloads any worksheet
   *
   * When to trigger this event:
   * 1. when the teacher downloads any worksheet.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lGQI-2ZA69/trigger/jgj_zXiND
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetName - Name of the Worksheet that is downloaded, clicked or tapped.
   * @param {string} properties.worksheetCategory - L1 Category of the Worksheet that is download, clicked or viewed
   * @param {string} properties.worksheetSubcategory - Sub-Category of the Worksheet viewed, clicked or downloaded
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lGQI-2ZA69}
   */
  function downloadedWorksheet(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetName(properties.worksheetName));
      messages = messages.concat(assertWorksheetCategory(properties.worksheetCategory));
      messages = messages.concat(assertWorksheetSubcategory(properties.worksheetSubcategory));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Downloaded Worksheet", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetName",
        "worksheetCategory",
        "worksheetSubcategory",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lGQI-2ZA69", "385b5bb52c603b88451f76905dba7366030507f9f6fddc3658165b91181b5e32", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Downloaded Worksheet", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Name": properties.worksheetName,
        "Worksheet Category": properties.worksheetCategory,
        "Worksheet Subcategory": properties.worksheetSubcategory,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lGQI-2ZA69", "Downloaded Worksheet", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ahxpYE3lQW", name: "Worksheet Category", value: properties.worksheetCategory},
        {id: "g8uPZdwOmF", name: "Worksheet Name", value: properties.worksheetName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "z0AEnWmrqD", name: "Worksheet Subcategory", value: properties.worksheetSubcategory},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Downloaded Worksheet': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Downloaded Worksheet", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Name": properties.worksheetName,
          "Worksheet Category": properties.worksheetCategory,
          "Worksheet Subcategory": properties.worksheetSubcategory,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "lGQI-2ZA69", "385b5bb52c603b88451f76905dba7366030507f9f6fddc3658165b91181b5e32");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Downloaded Worksheet", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Name": properties.worksheetName,
      "Worksheet Category": properties.worksheetCategory,
      "Worksheet Subcategory": properties.worksheetSubcategory,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Clicked Worksheet Tab: When the teacher clicks the left navigation download worksheets CTA. This event should trigger. This highlights discovery of the download worksheets feature.
   *
   * When to trigger this event:
   * 1. When the teacher clicks the Worksheet tab within the left nav
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5p59KeeWV/trigger/eQVZ1S38b
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5p59KeeWV}
   */
  function clickedWorksheetTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Worksheet Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5p59KeeWV", "a72af9b344b72a6fb817b0ae12d89d893f320d068a6aaff7076c64a15e8804eb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Clicked Worksheet Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5p59KeeWV", "Clicked Worksheet Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Worksheet Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Worksheet Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "5p59KeeWV", "a72af9b344b72a6fb817b0ae12d89d893f320d068a6aaff7076c64a15e8804eb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Worksheet Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Applied Worksheet Filters: When the teacher applies the worksheet filters. This event is triggered every time a filter is applied.
   *
   * When to trigger this event:
   * 1. When the teacher applies the worksheet filters. This event is triggered every time a filter is applied.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kjj5usN5Kz/trigger/xYJLOhJ9R
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetFilterValue - Value of the applied filter It will be categories or subcategories names - L1, L2, L3, etc.
   * @param {string} properties.worksheetFilterAppliedOn - On which level, the filter got applied.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kjj5usN5Kz}
   */
  function appliedWorksheetFilters(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetFilterValue(properties.worksheetFilterValue));
      messages = messages.concat(assertWorksheetFilterAppliedOn(properties.worksheetFilterAppliedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Applied Worksheet Filters", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetFilterValue",
        "worksheetFilterAppliedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kjj5usN5Kz", "795b56e8182c457e2dbda7242c6b62b95292e14f67e572ad29b24c1e1e8feed4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Applied Worksheet Filters", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Filter Value": properties.worksheetFilterValue,
        "Worksheet Filter Applied On": properties.worksheetFilterAppliedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kjj5usN5Kz", "Applied Worksheet Filters", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4bmBhSOqz4", name: "Worksheet Filter Applied On", value: properties.worksheetFilterAppliedOn},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UGULV7SI7o", name: "Worksheet Filter Value", value: properties.worksheetFilterValue},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Applied Worksheet Filters': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Applied Worksheet Filters", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Filter Value": properties.worksheetFilterValue,
          "Worksheet Filter Applied On": properties.worksheetFilterAppliedOn,
          "Screen Height": sysScreenHeight,
          }, "kjj5usN5Kz", "795b56e8182c457e2dbda7242c6b62b95292e14f67e572ad29b24c1e1e8feed4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Applied Worksheet Filters", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Filter Value": properties.worksheetFilterValue,
      "Worksheet Filter Applied On": properties.worksheetFilterAppliedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Cleared Worksheet Filters: When the teacher clears the filters with the click to the filter
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/a-k3T3B34U}
   */
  function clearedWorksheetFilters(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Cleared Worksheet Filters", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "a-k3T3B34U", "2e24256392786c7f4c229e3ee192f0f9e207bbf75c1887cdb296b26a0ced1d3f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Cleared Worksheet Filters", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("a-k3T3B34U", "Cleared Worksheet Filters", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Cleared Worksheet Filters': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Cleared Worksheet Filters", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Screen Height": sysScreenHeight,
          }, "a-k3T3B34U", "2e24256392786c7f4c229e3ee192f0f9e207bbf75c1887cdb296b26a0ced1d3f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Cleared Worksheet Filters", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Worksheet Listing Page: When the user views the worksheets listing page. This event should get fired.
   *
   * When to trigger this event:
   * 1. When the user views the worksheet listing screen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/N8fH5uK5Ju/trigger/h6ihma18M
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.freeWorksheetsLeftCount - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/N8fH5uK5Ju}
   */
  function viewedWorksheetListingPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Listing Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "freeWorksheetsLeftCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "N8fH5uK5Ju", "6907059d979e2cd6e2a9096c04fdd71373a6fb6653d07bd34094fc677dac9ba7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Worksheet Listing Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("N8fH5uK5Ju", "Viewed Worksheet Listing Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Listing Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Listing Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Screen Height": sysScreenHeight,
          }, "N8fH5uK5Ju", "6907059d979e2cd6e2a9096c04fdd71373a6fb6653d07bd34094fc677dac9ba7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Listing Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Worksheet Listing Page: When the teacher interacts anywhere on the worksheet listing page.
   *
   * When to trigger this event:
   * 1. When the teacher interacts anywhere on the worksheet listing page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/amI4okNeBJ/trigger/ibbC3eEYY
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/amI4okNeBJ}
   */
  function interactedWorksheetListingPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Listing Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "amI4okNeBJ", "51dc6c137a1c5964a914e1cc543cb7bb62329c79d8bcbe258d20eb478d1f3311", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Worksheet Listing Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("amI4okNeBJ", "Interacted Worksheet Listing Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Listing Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Listing Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "amI4okNeBJ", "51dc6c137a1c5964a914e1cc543cb7bb62329c79d8bcbe258d20eb478d1f3311");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Listing Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Saved Worksheet: When the teacher saves a worksheet
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetCategory - L1 Category of the Worksheet that is download, clicked or viewed
   * @param {string} properties.worksheetSubcategory - Sub-Category of the Worksheet viewed, clicked or downloaded
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6UiDsewmiH}
   */
  function savedWorksheet(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetCategory(properties.worksheetCategory));
      messages = messages.concat(assertWorksheetSubcategory(properties.worksheetSubcategory));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Saved Worksheet", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetCategory",
        "worksheetSubcategory",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6UiDsewmiH", "adb41f9e242dda804d4c0be53782352637313cfaf72fc61781817733b95917cb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Saved Worksheet", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Category": properties.worksheetCategory,
        "Worksheet Subcategory": properties.worksheetSubcategory,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6UiDsewmiH", "Saved Worksheet", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ahxpYE3lQW", name: "Worksheet Category", value: properties.worksheetCategory},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "z0AEnWmrqD", name: "Worksheet Subcategory", value: properties.worksheetSubcategory},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Saved Worksheet': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Saved Worksheet", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Category": properties.worksheetCategory,
          "Worksheet Subcategory": properties.worksheetSubcategory,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "6UiDsewmiH", "adb41f9e242dda804d4c0be53782352637313cfaf72fc61781817733b95917cb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Saved Worksheet", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Category": properties.worksheetCategory,
      "Worksheet Subcategory": properties.worksheetSubcategory,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Saved Worksheet Page: When the teacher views the saved worksheet page
   *
   * When to trigger this event:
   * 1. When the teacher views the saved worksheet page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XfIbszF0Oq/trigger/Yz7gjYdNR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XfIbszF0Oq}
   */
  function viewedSavedWorksheetPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Saved Worksheet Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XfIbszF0Oq", "b2e0ecd8b9efdea88472a9603842a4d8941036bb3c3c0017aef2b2cc77acfaaa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Saved Worksheet Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XfIbszF0Oq", "Viewed Saved Worksheet Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Saved Worksheet Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Saved Worksheet Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Screen Height": sysScreenHeight,
          }, "XfIbszF0Oq", "b2e0ecd8b9efdea88472a9603842a4d8941036bb3c3c0017aef2b2cc77acfaaa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Saved Worksheet Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Download History Worksheet Page: When the teacher views the Download History Page
   *
   * When to trigger this event:
   * 1. when the teacher views the download history page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rFuxyWHgbL/trigger/XViGJQYMz
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rFuxyWHgbL}
   */
  function viewedDownloadHistoryWorksheetPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Download History Worksheet Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rFuxyWHgbL", "10a25d9054f3ddd39fa5fbb01d37c526390faf8c77a9c5a1894d9dc5bd772326", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Download History Worksheet Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rFuxyWHgbL", "Viewed Download History Worksheet Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Download History Worksheet Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Download History Worksheet Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Screen Height": sysScreenHeight,
          }, "rFuxyWHgbL", "10a25d9054f3ddd39fa5fbb01d37c526390faf8c77a9c5a1894d9dc5bd772326");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Download History Worksheet Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Previewed Worksheet: When the teacher previews a worksheet
   *
   * When to trigger this event:
   * 1. When the teacher previews a worksheet
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JjcYtc2ak/trigger/JCn6YF35A
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.worksheetGrade - The grade of the worksheets being viewed.
   * @param {string} properties.worksheetName - Name of the Worksheet that is downloaded, clicked or tapped.
   * @param {string} properties.worksheetCategory - L1 Category of the Worksheet that is download, clicked or viewed
   * @param {string} properties.worksheetSubcategory - Sub-Category of the Worksheet viewed, clicked or downloaded
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JjcYtc2ak}
   */
  function previewedWorksheet(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertWorksheetGrade(properties.worksheetGrade));
      messages = messages.concat(assertWorksheetName(properties.worksheetName));
      messages = messages.concat(assertWorksheetCategory(properties.worksheetCategory));
      messages = messages.concat(assertWorksheetSubcategory(properties.worksheetSubcategory));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Previewed Worksheet", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "worksheetGrade",
        "worksheetName",
        "worksheetCategory",
        "worksheetSubcategory"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JjcYtc2ak", "1a4c41d8aa54ade6f5aa640bb087f931817563ca9fb43388375b507c5977c480", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Previewed Worksheet", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Worksheet Grade": properties.worksheetGrade,
        "Worksheet Name": properties.worksheetName,
        "Worksheet Category": properties.worksheetCategory,
        "Worksheet Subcategory": properties.worksheetSubcategory,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JjcYtc2ak", "Previewed Worksheet", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HqigT1cZJV", name: "Worksheet Grade", value: properties.worksheetGrade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ahxpYE3lQW", name: "Worksheet Category", value: properties.worksheetCategory},
        {id: "g8uPZdwOmF", name: "Worksheet Name", value: properties.worksheetName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "z0AEnWmrqD", name: "Worksheet Subcategory", value: properties.worksheetSubcategory},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Previewed Worksheet': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Previewed Worksheet", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Worksheet Grade": properties.worksheetGrade,
          "Worksheet Name": properties.worksheetName,
          "Worksheet Category": properties.worksheetCategory,
          "Worksheet Subcategory": properties.worksheetSubcategory,
          "Screen Height": sysScreenHeight,
          }, "JjcYtc2ak", "1a4c41d8aa54ade6f5aa640bb087f931817563ca9fb43388375b507c5977c480");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Previewed Worksheet", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Worksheet Grade": properties.worksheetGrade,
      "Worksheet Name": properties.worksheetName,
      "Worksheet Category": properties.worksheetCategory,
      "Worksheet Subcategory": properties.worksheetSubcategory,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Closed Math Facts: When math facts is closed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.endPoint - This is the phase of math facts in which user closes the math facts game (e.g. portal, city, jungle, cafe etc)
   * @param {int} properties.totalProblemsAnswered - Total problems answered to complete the assignment.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SmHULzglN}
   */
  function closedMathFacts(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEndPoint(properties.endPoint));
      messages = messages.concat(assertTotalProblemsAnswered(properties.totalProblemsAnswered));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Closed Math Facts", Object.keys(properties), [
        "endPoint",
        "totalProblemsAnswered",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SmHULzglN", "eadd3db8efc3af77decc0e516bb80f2ba7b5c57f4779a49b88c488b2248f52dd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Closed Math Facts", {
        "End Point": properties.endPoint,
        "Total Problems Answered": properties.totalProblemsAnswered,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SmHULzglN", "Closed Math Facts", messages, [
        {id: "6R8Dsubm7", name: "End Point", value: properties.endPoint},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "V_eCbteEGc", name: "Total Problems Answered", value: properties.totalProblemsAnswered},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Closed Math Facts': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Closed Math Facts", {
          "End Point": properties.endPoint,
          "Total Problems Answered": properties.totalProblemsAnswered,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "SmHULzglN", "eadd3db8efc3af77decc0e516bb80f2ba7b5c57f4779a49b88c488b2248f52dd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Closed Math Facts", {
      "End Point": properties.endPoint,
      "Total Problems Answered": properties.totalProblemsAnswered,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Activity Page: When user scrolls down on activity page v1 on web
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.interaction - The type of interaction that occurs
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UigRfT3ifQ}
   */
  function interactedActivityPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertInteraction(properties.interaction));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Activity Page", Object.keys(properties), [
        "interaction"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UigRfT3ifQ", "e35ea04fcbff9bd60cdddbb6e23a9710539fbe3db2670394948ac6ae3eb8b057", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Activity Page", {
        "Interaction": properties.interaction,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UigRfT3ifQ", "Interacted Activity Page", messages, [
        {id: "kwwJ5LAMqN", name: "Interaction", value: properties.interaction},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Activity Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Activity Page", {
          "Interaction": properties.interaction,
          "Screen Height": sysScreenHeight,
          }, "UigRfT3ifQ", "e35ea04fcbff9bd60cdddbb6e23a9710539fbe3db2670394948ac6ae3eb8b057");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Activity Page", {
      "Interaction": properties.interaction,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Email Verified Frontend: This event will be fired from frontend when the email of the user is verified. Ideally, this event will be fired after OTP verification.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.email - Email Id of the user
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Fmn9HpX5I5}
   */
  function emailVerifiedFrontend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertEmail(properties.email));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Email Verified Frontend", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "email"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Fmn9HpX5I5", "e2f16de1881d262a1bbf595d94bd4bd031088b59e30dd0f41cf75aabae1ded70", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Email Verified Frontend", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Email": properties.email,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Fmn9HpX5I5", "Email Verified Frontend", messages, [
        {id: "mGe3lMWlNY", name: "Email", value: properties.email},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Email Verified Frontend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Email Verified Frontend", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Email": properties.email,
          "Screen Height": sysScreenHeight,
          }, "Fmn9HpX5I5", "e2f16de1881d262a1bbf595d94bd4bd031088b59e30dd0f41cf75aabae1ded70");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Email Verified Frontend", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Email": properties.email,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Selected Game: When the user selects a game from the game zone section
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.columnNumber - The column in which the game is appearing
   * @param {int} properties.gameNamePosition - Defines the position of the game among many games shown
   * @param {int} properties.rowNumber - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GUc49405aY}
   */
  function selectedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertColumnNumber(properties.columnNumber));
      messages = messages.concat(assertGameNamePosition(properties.gameNamePosition));
      messages = messages.concat(assertRowNumber(properties.rowNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Selected Game", Object.keys(properties), [
        "columnNumber",
        "gameNamePosition",
        "rowNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GUc49405aY", "1bcb39a2884e7b7a812b43a2a3ece6a4901cda26508809d61c51835e61acf190", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Selected Game", {
        "Column Number": properties.columnNumber,
        "Game Name Position": properties.gameNamePosition,
        "Row Number": properties.rowNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GUc49405aY", "Selected Game", messages, [
        {id: "JnQC7Gu0QJ", name: "Game Name Position", value: properties.gameNamePosition},
        {id: "a9l_OugqB", name: "Row Number", value: properties.rowNumber},
        {id: "eGs90Bi3pM", name: "Column Number", value: properties.columnNumber},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Selected Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Selected Game", {
          "Column Number": properties.columnNumber,
          "Game Name Position": properties.gameNamePosition,
          "Row Number": properties.rowNumber,
          "Screen Height": sysScreenHeight,
          }, "GUc49405aY", "1bcb39a2884e7b7a812b43a2a3ece6a4901cda26508809d61c51835e61acf190");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Selected Game", {
      "Column Number": properties.columnNumber,
      "Game Name Position": properties.gameNamePosition,
      "Row Number": properties.rowNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Visited Onboarding Welcome: Triggered as soon as the Onboarding Welcome Screen is displayed. This is the 'Let's Get Started' screen before Question 1.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/myZ13O-4HH/trigger/I9qJyBaCH
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/myZ13O-4HH}
   */
  function visitedOnboardingWelcome(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Onboarding Welcome", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "myZ13O-4HH", "41f8800020266ebad6540d8c5e75e851f6e4c2d2a839a2a000acb955e5cbde59", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Visited Onboarding Welcome", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("myZ13O-4HH", "Visited Onboarding Welcome", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Onboarding Welcome': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Onboarding Welcome", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "myZ13O-4HH", "41f8800020266ebad6540d8c5e75e851f6e4c2d2a839a2a000acb955e5cbde59");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Onboarding Welcome", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Teacher Onboarding: This will capture all user activities within the Onboarding Widget
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.question - This will capture the Question in full. For example, "How big is your class?"
   * @param {string} properties.answer - This will capture the option selected by the user to that question. For example, "1-5"
   * @param {string} properties.questionType - This will capture the type of question such as multi-select, single-select etc.
   * @param {string} [properties.questionNo] - This will capture the Question Serial no. as it appears in sequence
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Qt2dyR-p_T}
   */
  function interactedTeacherOnboarding(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertQuestion(properties.question));
      messages = messages.concat(assertAnswer(properties.answer));
      messages = messages.concat(assertQuestionType(properties.questionType));
      messages = messages.concat(assertOptionalQuestionNo(properties.questionNo));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Teacher Onboarding", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "question",
        "answer",
        "questionType",
        "questionNo",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Qt2dyR-p_T", "e99d41bf47214b56e6866ea2e0f0510350d379598d805770adbb63d08c5d6760", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Teacher Onboarding", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Question": properties.question,
        "Answer": properties.answer,
        "Question Type": properties.questionType,
        "Question No.": properties.questionNo,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Qt2dyR-p_T", "Interacted Teacher Onboarding", messages, [
        {id: "1BxvMk6Nz6", name: "Question No.", value: properties.questionNo},
        {id: "2pLBcf4Iyi", name: "Question Type", value: properties.questionType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "EsalTilTi7", name: "Question", value: properties.question},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "coqPCyLyxy", name: "Answer", value: properties.answer},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Teacher Onboarding': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Teacher Onboarding", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Question": properties.question,
          "Answer": properties.answer,
          "Question Type": properties.questionType,
          "Question No.": properties.questionNo,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Qt2dyR-p_T", "e99d41bf47214b56e6866ea2e0f0510350d379598d805770adbb63d08c5d6760");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Teacher Onboarding", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Question": properties.question,
      "Answer": properties.answer,
      "Question Type": properties.questionType,
      "Question No.": properties.questionNo,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Age Question Screen Viewed: The age screen viewed by the user.
   *
   * When to trigger this event:
   * 1. When the user sees the age question screen
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tcVyFoch9O/trigger/qDLA6RJpx
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/tcVyFoch9O}
   */
  function ageQuestionScreenViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Age Question Screen Viewed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "tcVyFoch9O", "c56d017402c06fe21373348160b303ae54fe9d05513952422fa610859dc8b4bb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Age Question Screen Viewed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("tcVyFoch9O", "Age Question Screen Viewed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Age Question Screen Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Age Question Screen Viewed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "tcVyFoch9O", "c56d017402c06fe21373348160b303ae54fe9d05513952422fa610859dc8b4bb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Age Question Screen Viewed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Age Question Screen Interacted: When the user interacted the age question screen.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/iccYpaT6xl}
   */
  function ageQuestionScreenInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Age Question Screen Interacted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "iccYpaT6xl", "99de2ef2ab435ea8917b98d7f7c708de2b1f30c40af779b17bb12029bac0ba76", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Age Question Screen Interacted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("iccYpaT6xl", "Age Question Screen Interacted", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Age Question Screen Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Age Question Screen Interacted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "iccYpaT6xl", "99de2ef2ab435ea8917b98d7f7c708de2b1f30c40af779b17bb12029bac0ba76");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Age Question Screen Interacted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Onboarding Question Screen Viewed: When the user views the POQ Screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.questionIndex - Index means order of the question
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/l_703E23G}
   */
  function onboardingQuestionScreenViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertQuestionIndex(properties.questionIndex));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Onboarding Question Screen Viewed", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "subject",
        "questionIndex"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "l_703E23G", "7b7c97f3a114e54e66d448cf5f9ca38d3e3800b32f532c4060695c41fb23d782", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Onboarding Question Screen Viewed", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Subject": properties.subject,
        "Question Index": properties.questionIndex,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("l_703E23G", "Onboarding Question Screen Viewed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "jJNP65jPw7", name: "Question Index", value: properties.questionIndex},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Onboarding Question Screen Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Question Screen Viewed", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Subject": properties.subject,
          "Question Index": properties.questionIndex,
          "Screen Height": sysScreenHeight,
          }, "l_703E23G", "7b7c97f3a114e54e66d448cf5f9ca38d3e3800b32f532c4060695c41fb23d782");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Onboarding Question Screen Viewed", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Subject": properties.subject,
      "Question Index": properties.questionIndex,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Onboarding Question Interacted: When the user interacts the onboarding question
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.questionIndex - Index means order of the question
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HAYu07U2i_}
   */
  function onboardingQuestionInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertQuestionIndex(properties.questionIndex));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Onboarding Question Interacted", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "subject",
        "questionIndex"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HAYu07U2i_", "9c0b52773334a869390c601804fbab0891a4ec88b8caf93f6e8bfc0d59f56a39", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Onboarding Question Interacted", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Subject": properties.subject,
        "Question Index": properties.questionIndex,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HAYu07U2i_", "Onboarding Question Interacted", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "jJNP65jPw7", name: "Question Index", value: properties.questionIndex},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Onboarding Question Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Onboarding Question Interacted", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Subject": properties.subject,
          "Question Index": properties.questionIndex,
          "Screen Height": sysScreenHeight,
          }, "HAYu07U2i_", "9c0b52773334a869390c601804fbab0891a4ec88b8caf93f6e8bfc0d59f56a39");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Onboarding Question Interacted", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Subject": properties.subject,
      "Question Index": properties.questionIndex,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Assignment Successfully Assigned Page: This event is triggered upon click of Download Invite/Copy Invite button after assigning assignments to whole class/selected students
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4MkkX6efTw}
   */
  function interactedAssignmentSuccessfullyAssignedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Assignment Successfully Assigned Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn",
        "assignmentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4MkkX6efTw", "ddec873a6fb24941715ad27c850822ebc4e0c2d49a0d159011123d1c6abc6111", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Assignment Successfully Assigned Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Assignment Type": properties.assignmentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4MkkX6efTw", "Interacted Assignment Successfully Assigned Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Assignment Successfully Assigned Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Assignment Successfully Assigned Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Assignment Type": properties.assignmentType,
          "Screen Height": sysScreenHeight,
          }, "4MkkX6efTw", "ddec873a6fb24941715ad27c850822ebc4e0c2d49a0d159011123d1c6abc6111");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Assignment Successfully Assigned Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Assignment Type": properties.assignmentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MF Successfully Assigned Page: This event is triggered upon viewing the math facts successfully assigned message.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bj93efYuQU}
   */
  function viewedMfSuccessfullyAssignedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MF Successfully Assigned Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bj93efYuQU", "0411ae2ce0285bfc5e838bdc2d0e98cdb2c62edc644f5187a1bc4ddd0c629175", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MF Successfully Assigned Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bj93efYuQU", "Viewed MF Successfully Assigned Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MF Successfully Assigned Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MF Successfully Assigned Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "bj93efYuQU", "0411ae2ce0285bfc5e838bdc2d0e98cdb2c62edc644f5187a1bc4ddd0c629175");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MF Successfully Assigned Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted MF Successfully Assigned Page: This event is triggered upon click of Download Invite/Copy Invite button after assigning Math Facts to whole class/selected students
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FmBMqEoizp}
   */
  function interactedMfSuccessfullyAssignedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted MF Successfully Assigned Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FmBMqEoizp", "1d77764ebf9c8442d0b55e1af7489eb61000c00f2f339f7716b0120830c2af99", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted MF Successfully Assigned Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FmBMqEoizp", "Interacted MF Successfully Assigned Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted MF Successfully Assigned Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted MF Successfully Assigned Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "FmBMqEoizp", "1d77764ebf9c8442d0b55e1af7489eb61000c00f2f339f7716b0120830c2af99");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted MF Successfully Assigned Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Game Zone: This triggers when user sees the combined game zone page (with games activities rewards etc)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IV3pR1u9m1}
   */
  function viewedGameZone(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Game Zone", Object.keys(properties), [
        "grade",
        "mathGrade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IV3pR1u9m1", "2003e17973cdf120f3becfb54e325cc3820a816a11c507a3e47e34f1b8c1361c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Game Zone", {
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IV3pR1u9m1", "Viewed Game Zone", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Game Zone': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Game Zone", {
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "IV3pR1u9m1", "2003e17973cdf120f3becfb54e325cc3820a816a11c507a3e47e34f1b8c1361c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Game Zone", {
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Game Zone: This triggers when user interacts with (click/tap or scroll) with any element of the game zone page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.interactionType - Defines the type of interaction (click, scroll, hover etc)
   * @param {string} [properties.clickedOnSection] - Name of the section header where a user clicked/tapped
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} [properties.scrolledThrough] - Name of the section header where a user scrolled through
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yJACkx1pin}
   */
  function interactedGameZone(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertInteractionType(properties.interactionType));
      messages = messages.concat(assertOptionalClickedOnSection(properties.clickedOnSection));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertOptionalScrolledThrough(properties.scrolledThrough));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Game Zone", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "interactionType",
        "clickedOnSection",
        "from",
        "grade",
        "elaGrade",
        "mathGrade",
        "scrolledThrough",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yJACkx1pin", "4f23801cb3023354e4329a069fbd5930c9c45e4f2ca16a16a7e69fea88bf8565", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Game Zone", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Interaction Type": properties.interactionType,
        "Clicked on Section": properties.clickedOnSection,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Scrolled Through": properties.scrolledThrough,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yJACkx1pin", "Interacted Game Zone", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PokUqOLpg8", name: "Interaction Type", value: properties.interactionType},
        {id: "TLBtHE5cOx", name: "Scrolled Through", value: properties.scrolledThrough},
        {id: "n4HbuwgZ_E", name: "Clicked on Section", value: properties.clickedOnSection},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Game Zone': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Game Zone", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Interaction Type": properties.interactionType,
          "Clicked on Section": properties.clickedOnSection,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Scrolled Through": properties.scrolledThrough,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "yJACkx1pin", "4f23801cb3023354e4329a069fbd5930c9c45e4f2ca16a16a7e69fea88bf8565");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Game Zone", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Interaction Type": properties.interactionType,
      "Clicked on Section": properties.clickedOnSection,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Scrolled Through": properties.scrolledThrough,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Playable Clicked: When the user clicks on a Playable to start it
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {string} [properties.recommendedRailName] - This is the name of the rail viewed by the user.
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {int} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user.
   * @param {string} [properties.recommendedTileName] - This property will store the name of the tile user has interacted with - CG name for curriculum rails and playable name for non curr. rails

   * @param {int} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} [properties.contentGroup] - Name of content group user clicked/tapped on
   * @param {string} [properties.clickId] - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.playableType - Type of playable selected
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.subject - Subject Selected during onboarding

   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ohtQbeM-fl}
   */
  function playableClicked(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalClickId(properties.clickId));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertPlayableType(properties.playableType));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Clicked", Object.keys(properties), [
        "from",
        "contentType",
        "playableCode",
        "playableName",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "contentGroup",
        "clickId",
        "gameType",
        "playableType",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "gameEngine",
        "gameCode",
        "gameName",
        "subject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ohtQbeM-fl", "dde92d792f37a327d903e5c4c61b5d37683c7cf51c1224450bc56349145ae142", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Playable Clicked", {
        "From": properties.from,
        "Content Type": properties.contentType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Content Group": properties.contentGroup,
        "Click Id": properties.clickId,
        "Game Type": properties.gameType,
        "Playable Type": properties.playableType,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Game Engine": properties.gameEngine,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Subject": properties.subject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ohtQbeM-fl", "Playable Clicked", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Clicked': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Clicked", {
          "From": properties.from,
          "Content Type": properties.contentType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Content Group": properties.contentGroup,
          "Click Id": properties.clickId,
          "Game Type": properties.gameType,
          "Playable Type": properties.playableType,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Game Engine": properties.gameEngine,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Subject": properties.subject,
          "Screen Height": sysScreenHeight,
          }, "ohtQbeM-fl", "dde92d792f37a327d903e5c4c61b5d37683c7cf51c1224450bc56349145ae142");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Clicked", {
      "From": properties.from,
      "Content Type": properties.contentType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Content Group": properties.contentGroup,
      "Click Id": properties.clickId,
      "Game Type": properties.gameType,
      "Playable Type": properties.playableType,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Game Engine": properties.gameEngine,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Subject": properties.subject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Playable Started: When the Playable actually starts
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.gameType] - Type of game/playable selected
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * @param {string} [properties.playableType] - Type of playable selected
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.recommendedRailName] - This is the name of the rail viewed by the user.
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {int} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user.
   * @param {string} [properties.recommendedTileName] - This property will store the name of the tile user has interacted with - CG name for curriculum rails and playable name for non curr. rails

   * @param {int} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} [properties.clickId] - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} [properties.contentGroup] - Name of content group user clicked/tapped on
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.subject - Subject Selected during onboarding

   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/71_prnfx7Y}
   */
  function playableStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalGameType(properties.gameType));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalPlayableType(properties.playableType));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertOptionalClickId(properties.clickId));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Started", Object.keys(properties), [
        "from",
        "contentType",
        "gameCode",
        "gameName",
        "gameType",
        "playableCode",
        "playableName",
        "playableType",
        "clickedOn",
        "recommendedRailName",
        "recommendedRailRank",
        "recommendedTileName",
        "recommendedTileRank",
        "clickId",
        "contentGroup",
        "gameEngine",
        "subject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "71_prnfx7Y", "0e34c05f52f102bad19c658b78fc85ee7b078ad52ec3fb655d1c9f7dd1194d50", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Playable Started", {
        "From": properties.from,
        "Content Type": properties.contentType,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Playable Type": properties.playableType,
        "Clicked On": properties.clickedOn,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Click Id": properties.clickId,
        "Content Group": properties.contentGroup,
        "Game Engine": properties.gameEngine,
        "Subject": properties.subject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("71_prnfx7Y", "Playable Started", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Started", {
          "From": properties.from,
          "Content Type": properties.contentType,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Playable Type": properties.playableType,
          "Clicked On": properties.clickedOn,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Click Id": properties.clickId,
          "Content Group": properties.contentGroup,
          "Game Engine": properties.gameEngine,
          "Subject": properties.subject,
          "Screen Height": sysScreenHeight,
          }, "71_prnfx7Y", "0e34c05f52f102bad19c658b78fc85ee7b078ad52ec3fb655d1c9f7dd1194d50");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Started", {
      "From": properties.from,
      "Content Type": properties.contentType,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Playable Type": properties.playableType,
      "Clicked On": properties.clickedOn,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Click Id": properties.clickId,
      "Content Group": properties.contentGroup,
      "Game Engine": properties.gameEngine,
      "Subject": properties.subject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Playable Completed: When a aplayable gets completed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.gameType] - Type of game/playable selected
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * @param {string} [properties.playableType] - Type of playable selected
   * @param {string} [properties.recommendedTileName] - This property will store the name of the tile user has interacted with - CG name for curriculum rails and playable name for non curr. rails

   * @param {int} [properties.recommendedTileRank] - This property will store the position of the tile on which user has clciked. Earlier this was sent as column position

   * @param {string} [properties.recommendedRailName] - This is the name of the rail viewed by the user.
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {int} [properties.recommendedRailRank] - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user.
   * @param {string} [properties.contentGroup] - Name of content group user clicked/tapped on
   * @param {string} [properties.clickId] - unique id associated with distinct clicks on the home dashboard on playables
   * @param {string} properties.gameEngine - This property will contain the name of the game engine - unity, phaser, cocos, creator or worksheet

   * @param {string} properties.subject - Subject Selected during onboarding

   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ax-GP4kM7u}
   */
  function playableCompleted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalGameType(properties.gameType));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalPlayableType(properties.playableType));
      messages = messages.concat(assertOptionalRecommendedTileName(properties.recommendedTileName));
      messages = messages.concat(assertOptionalRecommendedTileRank(properties.recommendedTileRank));
      messages = messages.concat(assertOptionalRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertOptionalRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalClickId(properties.clickId));
      messages = messages.concat(assertGameEngine(properties.gameEngine));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Completed", Object.keys(properties), [
        "from",
        "contentType",
        "gameCode",
        "gameName",
        "gameType",
        "playableCode",
        "playableName",
        "playableType",
        "recommendedTileName",
        "recommendedTileRank",
        "recommendedRailName",
        "recommendedRailRank",
        "contentGroup",
        "clickId",
        "gameEngine",
        "subject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ax-GP4kM7u", "8486ef3d35023c49dd2edb0330d90fc6abd31b68aa9b48284a7a3bd2156043e0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Playable Completed", {
        "From": properties.from,
        "Content Type": properties.contentType,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Playable Type": properties.playableType,
        "Recommended Tile Name": properties.recommendedTileName,
        "Recommended Tile Rank": properties.recommendedTileRank,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Content Group": properties.contentGroup,
        "Click Id": properties.clickId,
        "Game Engine": properties.gameEngine,
        "Subject": properties.subject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ax-GP4kM7u", "Playable Completed", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "FLDtSJNKL", name: "Recommended Tile Rank", value: properties.recommendedTileRank},
        {id: "JVkBdMN1_", name: "Game Engine", value: properties.gameEngine},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "TYbmk5DQn", name: "Recommended Tile Name", value: properties.recommendedTileName},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "jVQaLzj_1", name: "Click Id", value: properties.clickId},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Completed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Completed", {
          "From": properties.from,
          "Content Type": properties.contentType,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Playable Type": properties.playableType,
          "Recommended Tile Name": properties.recommendedTileName,
          "Recommended Tile Rank": properties.recommendedTileRank,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Content Group": properties.contentGroup,
          "Click Id": properties.clickId,
          "Game Engine": properties.gameEngine,
          "Subject": properties.subject,
          "Screen Height": sysScreenHeight,
          }, "ax-GP4kM7u", "8486ef3d35023c49dd2edb0330d90fc6abd31b68aa9b48284a7a3bd2156043e0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Completed", {
      "From": properties.from,
      "Content Type": properties.contentType,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Playable Type": properties.playableType,
      "Recommended Tile Name": properties.recommendedTileName,
      "Recommended Tile Rank": properties.recommendedTileRank,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Content Group": properties.contentGroup,
      "Click Id": properties.clickId,
      "Game Engine": properties.gameEngine,
      "Subject": properties.subject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Subscribe Popup: When the user sees the popup after hitting the daily limit
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cv9KkHgNj/trigger/N7LdPQmh8
   * 2.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cv9KkHgNj/trigger/aM8WGmjk3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {int} properties.freeActivitiesLeftCount - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {string} [properties.freeWorksheetsLeftCount] - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cv9KkHgNj}
   */
  function viewedSubscribePopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Subscribe Popup", Object.keys(properties), [
        "from",
        "freeActivitiesLeftCount",
        "freeWorksheetsLeftCount",
        "contentType",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Cv9KkHgNj", "e2c0c826bf93a48bdbaa3fce277c224030326e84bf7618516f6fe0a58381a5ed", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Subscribe Popup", {
        "From": properties.from,
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Content Type": properties.contentType,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Cv9KkHgNj", "Viewed Subscribe Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Subscribe Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Subscribe Popup", {
          "From": properties.from,
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Content Type": properties.contentType,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "Cv9KkHgNj", "e2c0c826bf93a48bdbaa3fce277c224030326e84bf7618516f6fe0a58381a5ed");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Subscribe Popup", {
      "From": properties.from,
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Content Type": properties.contentType,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Subscribe Popup: When the user interacts wih the subscribe or daily limit hit popup
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2oy8ZIYtB/trigger/B4bYHsd_W
   * 2.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2oy8ZIYtB/trigger/wGS6COqyg
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.freeActivitiesLeftCount - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.freeWorksheetsLeftCount] - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2oy8ZIYtB}
   */
  function interactedSubscribePopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Subscribe Popup", Object.keys(properties), [
        "freeActivitiesLeftCount",
        "clickedOn",
        "freeWorksheetsLeftCount",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2oy8ZIYtB", "539a9bdad4f03e9c6e50696c204f61dd3cb02e7e3f76c573c3a7b3bd458e6a03", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Subscribe Popup", {
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Clicked On": properties.clickedOn,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2oy8ZIYtB", "Interacted Subscribe Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Subscribe Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Subscribe Popup", {
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Clicked On": properties.clickedOn,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "2oy8ZIYtB", "539a9bdad4f03e9c6e50696c204f61dd3cb02e7e3f76c573c3a7b3bd458e6a03");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Subscribe Popup", {
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Clicked On": properties.clickedOn,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Worksheet Search Dropdown: This will be triggered upon clicking on Worksheet Search bar to see the search dropdown
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UgHjawTqaf}
   */
  function viewedWorksheetSearchDropdown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Search Dropdown", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UgHjawTqaf", "018395ed2ae393dea52b2422c99d1578599517dda7fa90ccea0d02aee84e640b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Worksheet Search Dropdown", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UgHjawTqaf", "Viewed Worksheet Search Dropdown", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Search Dropdown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Search Dropdown", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UgHjawTqaf", "018395ed2ae393dea52b2422c99d1578599517dda7fa90ccea0d02aee84e640b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Search Dropdown", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Worksheet Search Dropdown: This will be triggered when the user does any interaction with the Search dropdown such as clicking, pressing enter, entering search query etc.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E2AQ9GYXFY}
   */
  function interactedWorksheetSearchDropdown(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Search Dropdown", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E2AQ9GYXFY", "5367b8cc906459e28521cb0465df1b2bd04386c7d000d467854cec77f581ccae", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Worksheet Search Dropdown", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E2AQ9GYXFY", "Interacted Worksheet Search Dropdown", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Search Dropdown': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Search Dropdown", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "E2AQ9GYXFY", "5367b8cc906459e28521cb0465df1b2bd04386c7d000d467854cec77f581ccae");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Search Dropdown", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Worksheet Search Results Page: This event gets triggered if the user clicks on a worksheet from the search icon or hits enter after entering the search query in the search bar.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P6lgzeqvSt}
   */
  function viewedWorksheetSearchResultsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Search Results Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "P6lgzeqvSt", "b935f2d0fc3098a1eaf2f8e6bb80a1decaf7a95ad6abf49b3866c2d85fb5d1c2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Worksheet Search Results Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("P6lgzeqvSt", "Viewed Worksheet Search Results Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Search Results Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Search Results Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "P6lgzeqvSt", "b935f2d0fc3098a1eaf2f8e6bb80a1decaf7a95ad6abf49b3866c2d85fb5d1c2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Search Results Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Worksheet Search Results Page: This will be triggered when the user interacts with the Search Results Page.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.maxWorksheetViewed - This will capture maximum WS no. viewed by the user (scroll depth)
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DzXGchIbC_}
   */
  function interactedWorksheetSearchResultsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMaxWorksheetViewed(properties.maxWorksheetViewed));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Search Results Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "maxWorksheetViewed",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DzXGchIbC_", "0618b95b27bec9cf975e977f00b219eace7ff9d9b68663ad35512f6be0a25b90", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Worksheet Search Results Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Max Worksheet Viewed": properties.maxWorksheetViewed,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DzXGchIbC_", "Interacted Worksheet Search Results Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "s4DOhHgK_6", name: "Max Worksheet Viewed", value: properties.maxWorksheetViewed},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Search Results Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Search Results Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Max Worksheet Viewed": properties.maxWorksheetViewed,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "DzXGchIbC_", "0618b95b27bec9cf975e977f00b219eace7ff9d9b68663ad35512f6be0a25b90");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Search Results Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Max Worksheet Viewed": properties.maxWorksheetViewed,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Worksheet Search Results End Page: This is triggered when the user reaches the end of search results after scrolling down
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GfP64qveJj}
   */
  function viewedWorksheetSearchResultsEndPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Search Results End Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GfP64qveJj", "b046175ad9f1e3647c63727aefb63c65404399cc5d03b0b39e49985fcc611d2f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Worksheet Search Results End Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GfP64qveJj", "Viewed Worksheet Search Results End Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Search Results End Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Search Results End Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "GfP64qveJj", "b046175ad9f1e3647c63727aefb63c65404399cc5d03b0b39e49985fcc611d2f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Search Results End Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Theme Toggle: When the user toggles between seasonal theme and default theme
   *
   * When to trigger this event:
   * 1. Clicking/tapping on theme toggle in settings/parents menu
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CSdnqg_WW/trigger/0zbDMU6mZ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/CSdnqg_WW}
   */
  function interactedThemeToggle(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Theme Toggle", Object.keys(properties), [
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CSdnqg_WW", "be79be8a8ef07e06a63a148ef9f221be329adada9be433789e5701ba03a5e072", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Theme Toggle", {
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CSdnqg_WW", "Interacted Theme Toggle", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Theme Toggle': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Theme Toggle", {
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "CSdnqg_WW", "be79be8a8ef07e06a63a148ef9f221be329adada9be433789e5701ba03a5e072");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Theme Toggle", {
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Nudge: This will be triggered every time a teacher views a nudge on any screen of the teacher product
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.nudgeTitleMessage - This will capture the main message of the nudge.
   * @param {string} properties.nudgeShownOnPage - This will capture the page where the teacher sees the nudge such as 'Dashboard', 'Curriculum' etc.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1XVvTNo_hp}
   */
  function viewedNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNudgeTitleMessage(properties.nudgeTitleMessage));
      messages = messages.concat(assertNudgeShownOnPage(properties.nudgeShownOnPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Nudge", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "nudgeTitleMessage",
        "nudgeShownOnPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1XVvTNo_hp", "11ee225d5eb1e89116939976e76422922e099f4a536fdfd9c0a85b7e1be11382", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Nudge", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Nudge Title Message": properties.nudgeTitleMessage,
        "Nudge Shown on Page": properties.nudgeShownOnPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1XVvTNo_hp", "Viewed Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3ysDI0za_", name: "Nudge Shown on Page", value: properties.nudgeShownOnPage},
        {id: "CLVHX-1DH", name: "Nudge Title Message", value: properties.nudgeTitleMessage},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Nudge", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Nudge Title Message": properties.nudgeTitleMessage,
          "Nudge Shown on Page": properties.nudgeShownOnPage,
          "Screen Height": sysScreenHeight,
          }, "1XVvTNo_hp", "11ee225d5eb1e89116939976e76422922e099f4a536fdfd9c0a85b7e1be11382");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Nudge", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Nudge Title Message": properties.nudgeTitleMessage,
      "Nudge Shown on Page": properties.nudgeShownOnPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Nudge: This will capture user interactions with the nudge
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HUHH-X3BXc/trigger/lWCV8mx-p
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.nudgeTitleMessage - This will capture the main message of the nudge.
   * @param {string} properties.nudgeShownOnPage - This will capture the page where the teacher sees the nudge such as 'Dashboard', 'Curriculum' etc.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HUHH-X3BXc}
   */
  function interactedNudge(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNudgeTitleMessage(properties.nudgeTitleMessage));
      messages = messages.concat(assertNudgeShownOnPage(properties.nudgeShownOnPage));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Nudge", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "nudgeTitleMessage",
        "nudgeShownOnPage",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HUHH-X3BXc", "7515c341f9a98516ac656136369d707cd1960eab0adec892555cb74701914e10", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Nudge", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Nudge Title Message": properties.nudgeTitleMessage,
        "Nudge Shown on Page": properties.nudgeShownOnPage,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HUHH-X3BXc", "Interacted Nudge", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3ysDI0za_", name: "Nudge Shown on Page", value: properties.nudgeShownOnPage},
        {id: "CLVHX-1DH", name: "Nudge Title Message", value: properties.nudgeTitleMessage},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Nudge': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Nudge", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Nudge Title Message": properties.nudgeTitleMessage,
          "Nudge Shown on Page": properties.nudgeShownOnPage,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "HUHH-X3BXc", "7515c341f9a98516ac656136369d707cd1960eab0adec892555cb74701914e10");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Nudge", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Nudge Title Message": properties.nudgeTitleMessage,
      "Nudge Shown on Page": properties.nudgeShownOnPage,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Student Progress Page: This will be triggered when the user does any activity on the Student Progress page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QRcOoO5dfP}
   */
  function interactedStudentProgressPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Progress Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QRcOoO5dfP", "7180aaef062cadbc2dd7411a58acfa853eeb95a313a52ad7943c862ed90879cf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Student Progress Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QRcOoO5dfP", "Interacted Student Progress Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Progress Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Progress Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "QRcOoO5dfP", "7180aaef062cadbc2dd7411a58acfa853eeb95a313a52ad7943c862ed90879cf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Progress Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Recommended Item: This event captures the details of what is recommended to a user in the Daily Recommendation Section tab/section.
This will have details of what is recommended such as section, content type, game code, playable code
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.category - This represents the different types of content being recommended to the user through the DRS. Possible values = MyToDo, Math_LP, ELA_LP, Math Facts, Books, Spelling, Reading Comprehension, Playzone, Activities, Learning Games, etc







   * @param {string} [properties.gameCode] - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {int} properties.ordering - This field defines the order of the recommendation. It will start from 0 and then progress by one count at a time.
Since the users' recommendation can change in a particular day for a particular category, this ordering will let us know how the recommended category has changed over a day for the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/OgVHdBXh1_}
   */
  function recommendedItem(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertCategory(properties.category));
      messages = messages.concat(assertOptionalGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOrdering(properties.ordering));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Recommended Item", Object.keys(properties), [
        "section",
        "category",
        "gameCode",
        "playableCode",
        "ordering"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OgVHdBXh1_", "734728c2e897c16f11d9537d62908e5002fb3e6737b57ffac545e78d3ee5bee2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Recommended Item", {
        "Section": properties.section,
        "Category": properties.category,
        "Game Code": properties.gameCode,
        "Playable Code": properties.playableCode,
        "Ordering": properties.ordering,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OgVHdBXh1_", "Recommended Item", messages, [
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "4YcQJt7EU", name: "Ordering", value: properties.ordering},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "hVOa_xHVR", name: "Category", value: properties.category},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Recommended Item': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Recommended Item", {
          "Section": properties.section,
          "Category": properties.category,
          "Game Code": properties.gameCode,
          "Playable Code": properties.playableCode,
          "Ordering": properties.ordering,
          "Screen Height": sysScreenHeight,
          }, "OgVHdBXh1_", "734728c2e897c16f11d9537d62908e5002fb3e6737b57ffac545e78d3ee5bee2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Recommended Item", {
      "Section": properties.section,
      "Category": properties.category,
      "Game Code": properties.gameCode,
      "Playable Code": properties.playableCode,
      "Ordering": properties.ordering,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Print Report Popup: This will be triggered when the user clicks on 'Print Report' from the pop-up that appears after clicking on the Print icon.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/orUIPL0SZY/trigger/pNsueznoB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.tappedOn - UI element that user tapped on - used in conjunction with the event name which identifies the screen name
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/orUIPL0SZY}
   */
  function interactedPrintReportPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertTappedOn(properties.tappedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Print Report Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "tappedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "orUIPL0SZY", "3b01be5ea346f3680aa89c92036d92daddeb981410fb2db5ba9cbe0d012b7e2b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Print Report Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Tapped On": properties.tappedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("orUIPL0SZY", "Interacted Print Report Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "cfvmMqWft", name: "Tapped On", value: properties.tappedOn},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Print Report Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Print Report Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Tapped On": properties.tappedOn,
          "Screen Height": sysScreenHeight,
          }, "orUIPL0SZY", "3b01be5ea346f3680aa89c92036d92daddeb981410fb2db5ba9cbe0d012b7e2b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Print Report Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Tapped On": properties.tappedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Student Progress: This will be triggered when the user does any activity on the Student Progress page
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kE-qxL6hLl/trigger/LiB3_-Wln
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kE-qxL6hLl}
   */
  function interactedStudentProgress(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Progress", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kE-qxL6hLl", "a73454fa888f7114505bdf23621f2510bdc22749c27a1b4bb60654cee38b88ae", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Student Progress", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kE-qxL6hLl", "Interacted Student Progress", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Progress': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Progress", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "kE-qxL6hLl", "a73454fa888f7114505bdf23621f2510bdc22749c27a1b4bb60654cee38b88ae");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Progress", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Playable Tapped: When user taps a playable on iOS or android platform
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.gameCode - Game code of the playable selected, for example: Math learning games have multiple variations, all those variations will have one game code
   * @param {string} [properties.gameName] - Name of the Game being tapped (Optional)
   * @param {string} [properties.gameType] - Type of game/playable selected
   * @param {string} [properties.playableCode] - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.playableName] - Name of playable selected
   * @param {string} [properties.playableType] - Type of playable selected
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mdn2gl4z0}
   */
  function playableTapped(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertGameCode(properties.gameCode));
      messages = messages.concat(assertOptionalGameName(properties.gameName));
      messages = messages.concat(assertOptionalGameType(properties.gameType));
      messages = messages.concat(assertOptionalPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalPlayableType(properties.playableType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Playable Tapped", Object.keys(properties), [
        "contentType",
        "from",
        "gameCode",
        "gameName",
        "gameType",
        "playableCode",
        "playableName",
        "playableType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mdn2gl4z0", "b44d4cce303706ff06bcc26b7d8df54f0437b451a6c38c02a001ba2b4882108b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Playable Tapped", {
        "Content Type": properties.contentType,
        "From": properties.from,
        "Game Code": properties.gameCode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Playable Type": properties.playableType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mdn2gl4z0", "Playable Tapped", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "2oZQdvXRu", name: "Game Code", value: properties.gameCode},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "tHAI3DRE4", name: "Playable Type", value: properties.playableType},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Playable Tapped': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Playable Tapped", {
          "Content Type": properties.contentType,
          "From": properties.from,
          "Game Code": properties.gameCode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Playable Type": properties.playableType,
          "Screen Height": sysScreenHeight,
          }, "mdn2gl4z0", "b44d4cce303706ff06bcc26b7d8df54f0437b451a6c38c02a001ba2b4882108b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Playable Tapped", {
      "Content Type": properties.contentType,
      "From": properties.from,
      "Game Code": properties.gameCode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Playable Type": properties.playableType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Math Facts Closed: When user starts math facts game
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.endPoint - This is the phase of math facts in which user closes the math facts game (e.g. portal, city, jungle, cafe etc)
   * @param {int} properties.totalProblemsAnswered - Total problems answered to complete the assignment.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/r6HH9FWsuM}
   */
  function mathFactsClosed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEndPoint(properties.endPoint));
      messages = messages.concat(assertTotalProblemsAnswered(properties.totalProblemsAnswered));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Math Facts Closed", Object.keys(properties), [
        "endPoint",
        "totalProblemsAnswered"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "r6HH9FWsuM", "1a1d77ff4100c8d2942a3bf3d6298b8ab5cc89f6b55429c4ad8de6a7f5ffc7ad", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Math Facts Closed", {
        "End Point": properties.endPoint,
        "Total Problems Answered": properties.totalProblemsAnswered,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("r6HH9FWsuM", "Math Facts Closed", messages, [
        {id: "6R8Dsubm7", name: "End Point", value: properties.endPoint},
        {id: "V_eCbteEGc", name: "Total Problems Answered", value: properties.totalProblemsAnswered},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Math Facts Closed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Math Facts Closed", {
          "End Point": properties.endPoint,
          "Total Problems Answered": properties.totalProblemsAnswered,
          "Screen Height": sysScreenHeight,
          }, "r6HH9FWsuM", "1a1d77ff4100c8d2942a3bf3d6298b8ab5cc89f6b55429c4ad8de6a7f5ffc7ad");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Math Facts Closed", {
      "End Point": properties.endPoint,
      "Total Problems Answered": properties.totalProblemsAnswered,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Live Classes Tab: Clicked anywhere on the live classes tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.subscriberId] - Subscriber Id of user, registered in live class service
   * @param {Array<string>} [properties.studentId] - This will capture the Student analytics IDs in an array.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_1P0Y6vNcL}
   */
  function interactedLiveClassesTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalSubscriberId(properties.subscriberId));
      messages = messages.concat(assertOptionalStudentID(properties.studentId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Tab", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "from",
        "elaGrade",
        "grade",
        "subscriberId",
        "studentId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_1P0Y6vNcL", "cd8bc5de0ed6910604454d74499cdeb42d0fa318c3baa482df89e40c55042558", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Live Classes Tab", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "From": properties.from,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Subscriber Id": properties.subscriberId,
        "Student ID": properties.studentId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_1P0Y6vNcL", "Interacted Live Classes Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "5IEpaITD9", name: "Student ID", value: properties.studentId},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "nSwyEoLcJ", name: "Subscriber Id", value: properties.subscriberId},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Tab", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "From": properties.from,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Subscriber Id": properties.subscriberId,
          "Student ID": properties.studentId,
          "Screen Height": sysScreenHeight,
          }, "_1P0Y6vNcL", "cd8bc5de0ed6910604454d74499cdeb42d0fa318c3baa482df89e40c55042558");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Tab", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "From": properties.from,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Subscriber Id": properties.subscriberId,
      "Student ID": properties.studentId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Live Classes Subscription Popup: Triggered when user interacts with the subscription required popup which comes after clicking on the class cards
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MNYS-5whGk}
   */
  function interactedLiveClassesSubscriptionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Subscription Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MNYS-5whGk", "91d6983ec4ed0577842c903c7d3441a051c7955336be80aa1965e5ab2c82c0fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Live Classes Subscription Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MNYS-5whGk", "Interacted Live Classes Subscription Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Subscription Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Subscription Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "MNYS-5whGk", "91d6983ec4ed0577842c903c7d3441a051c7955336be80aa1965e5ab2c82c0fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Subscription Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Trial Pitch Screen: When a user sees the trial pitch screen during onboarding on the web
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DV2sGHW6RB}
   */
  function viewedTrialPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Trial Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DV2sGHW6RB", "82e509210721bff0545b4b62eff9d14f701da1bc999c07e12b617b43b493b69b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Trial Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DV2sGHW6RB", "Viewed Trial Pitch Screen", messages, [
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Trial Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Trial Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "DV2sGHW6RB", "82e509210721bff0545b4b62eff9d14f701da1bc999c07e12b617b43b493b69b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Trial Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Trial Pitch Screen: Interacted anywhere on the trial pitch screen on web
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ivs9xyQ7uz}
   */
  function interactedTrialPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Trial Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ivs9xyQ7uz", "815db791dd4cd16ee75ae324b56c1b408afb2ccc2855e785cee2b4abfb267da1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Trial Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ivs9xyQ7uz", "Interacted Trial Pitch Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Trial Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Trial Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ivs9xyQ7uz", "815db791dd4cd16ee75ae324b56c1b408afb2ccc2855e785cee2b4abfb267da1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Trial Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Left Navigation Menu: This event will get fired as soon as a user clicks anywhere in the left navigation menu.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cq4OazKyjs}
   */
  function interactedLeftNavigationMenu(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Left Navigation Menu", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Cq4OazKyjs", "061c4c93588bdf535eb381dddc12b1cccc3cb06ab09e69d49a663cf82a74b572", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Left Navigation Menu", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Cq4OazKyjs", "Interacted Left Navigation Menu", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Left Navigation Menu': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Left Navigation Menu", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Cq4OazKyjs", "061c4c93588bdf535eb381dddc12b1cccc3cb06ab09e69d49a663cf82a74b572");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Left Navigation Menu", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted SplashCommunity Discoverability Pop-Up: This event will get fired when the user interacts with the SplashCommunity Discoverability Pop-Up. These are the ways of interaction - 'Cross Button', 'Check Terms & Conditions', 'Terms & Conditions Details', 'Join SplashCommunity button', 'Uncheck Terms & Conditions'
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BuymQ_t3Sj}
   */
  function interactedSplashcommunityDiscoverabilityPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted SplashCommunity Discoverability Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BuymQ_t3Sj", "ffc97249e03d142915365d4cc9b68f9eda9b771cd8a8a62ff6cf7b8b40e98567", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted SplashCommunity Discoverability Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BuymQ_t3Sj", "Interacted SplashCommunity Discoverability Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted SplashCommunity Discoverability Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted SplashCommunity Discoverability Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "BuymQ_t3Sj", "ffc97249e03d142915365d4cc9b68f9eda9b771cd8a8a62ff6cf7b8b40e98567");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted SplashCommunity Discoverability Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed SplashCommunity Discoverability Pop-Up: This event will be fired when a user views the SplashCommunity Discoverability Pop-Up from the left navigation menu.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E4gkIDQS6a}
   */
  function viewedSplashcommunityDiscoverabilityPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed SplashCommunity Discoverability Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E4gkIDQS6a", "e2ac670a2904ffcbdb100e273a23db4f40d2623334cba8102b0279aade284c17", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed SplashCommunity Discoverability Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E4gkIDQS6a", "Viewed SplashCommunity Discoverability Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed SplashCommunity Discoverability Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed SplashCommunity Discoverability Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "E4gkIDQS6a", "e2ac670a2904ffcbdb100e273a23db4f40d2623334cba8102b0279aade284c17");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed SplashCommunity Discoverability Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted New Class Addition Page: This event will be fired when the user clicks with the new class addition screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IqZuaGKSGX/trigger/2lT2jnG2q
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IqZuaGKSGX}
   */
  function interactedNewClassAdditionPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted New Class Addition Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IqZuaGKSGX", "7a549b0ef81a3076241e0dba3cfd77d62b90d6d170f9cd60e1f296428a91c5ef", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted New Class Addition Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IqZuaGKSGX", "Interacted New Class Addition Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted New Class Addition Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted New Class Addition Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "IqZuaGKSGX", "7a549b0ef81a3076241e0dba3cfd77d62b90d6d170f9cd60e1f296428a91c5ef");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted New Class Addition Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Freemium Timer Expired: This event is triggered from the backend when the free timer for the user expires. The user may or may not see any change in the frontend. But as per the backend, the timer is expired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.playablePlayed - The number of playable started by the user within the Freemium Timer Started and Expired. The value can be 1, 2, 3, 4, etc.. This will keep increasing as the number of playable started.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1si8LocV8e}
   */
  function freemiumTimerExpired(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlayablePlayed(properties.playablePlayed));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Freemium Timer Expired", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "playablePlayed"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1si8LocV8e", "bb6f1d517d20573346b010846e2ba9e2dcd4a7fc9f730c010d78aed02bfe05ed", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Freemium Timer Expired", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Playable Played": properties.playablePlayed,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1si8LocV8e", "Freemium Timer Expired", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "V16Tay7p5", name: "Playable Played", value: properties.playablePlayed},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Freemium Timer Expired': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Freemium Timer Expired", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Playable Played": properties.playablePlayed,
          "Screen Height": sysScreenHeight,
          }, "1si8LocV8e", "bb6f1d517d20573346b010846e2ba9e2dcd4a7fc9f730c010d78aed02bfe05ed");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Freemium Timer Expired", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Playable Played": properties.playablePlayed,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Freemium Timer Started: The freemium timer started when the user starts the first playable. This event should get triggered immediately.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.timerValue - The value of the timer in minutes. As the same will be configurable from the backend. The value should be whatever we are showing the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fdQGkGEW9F}
   */
  function freemiumTimerStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertTimerValue(properties.timerValue));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Freemium Timer Started", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "timerValue"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fdQGkGEW9F", "858e430d7bdcb95b08130a8fe19c36e368dc0d074a70f1b45fa4b45e6c3957ad", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Freemium Timer Started", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Timer Value": properties.timerValue,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fdQGkGEW9F", "Freemium Timer Started", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FQr65Ct5y", name: "Timer Value", value: properties.timerValue},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Freemium Timer Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Freemium Timer Started", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Timer Value": properties.timerValue,
          "Screen Height": sysScreenHeight,
          }, "fdQGkGEW9F", "858e430d7bdcb95b08130a8fe19c36e368dc0d074a70f1b45fa4b45e6c3957ad");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Freemium Timer Started", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Timer Value": properties.timerValue,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Reached Daily Limit: This event needs to be fired when the user reaches the daily limit irrespective of the experiment segment. This should happen for 2 free cards or freemium of 10 minutes.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.subject] - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} [properties.contentType] - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QrQdavLJdx}
   */
  function reachedDailyLimit(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalContentType(properties.contentType));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Reached Daily Limit", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "subject",
        "grade",
        "from",
        "contentType",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QrQdavLJdx", "6563f771e3bdf7f5c510652fe628d0664fa22536e006300291c1bc2bf95080c8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Reached Daily Limit", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Subject": properties.subject,
        "Grade": properties.grade,
        "From": properties.from,
        "Content Type": properties.contentType,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QrQdavLJdx", "Reached Daily Limit", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Reached Daily Limit': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reached Daily Limit", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Subject": properties.subject,
          "Grade": properties.grade,
          "From": properties.from,
          "Content Type": properties.contentType,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "QrQdavLJdx", "6563f771e3bdf7f5c510652fe628d0664fa22536e006300291c1bc2bf95080c8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Reached Daily Limit", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Subject": properties.subject,
      "Grade": properties.grade,
      "From": properties.from,
      "Content Type": properties.contentType,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Student Auto Logged in Successfully: Whenever there is a Login via the Student - Fire Student Auto Logged in Successfully event with the event property platform as ipad. Also, event property mode as school or home as per the post 3 pm check. Also, event property user type as student whenever there is a student login and user persona as per logic.
   *
   * When to trigger this event:
   * 1. Login via the Student
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/KmKOPQ6FT
   * 2. PTL Sign Up
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/jCc04AgVb
   * 3. PTL Parent Login Successful
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/3g9myEkWv
   * 4. Parent Signup from the Teacher Invite and Post 3 PM Signup
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc/trigger/sI_b58Y8x
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userPersonaType - User persona type at an event level is the property that highlights whether the user persona is class only or after the parent signup - it is ptl. In the school, class the persona is class only and at home the persona is ptl. If the parent is not signed up, it is class only.
   * @param {string} properties.firedFrom - Fired from web-frontent, web-backend, ipad-frontend, ipad-backend.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RdSCAdwoxc}
   */
  function studentAutoLoggedInSuccessfully(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserPersonaType(properties.userPersonaType));
      messages = messages.concat(assertFiredFrom(properties.firedFrom));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Student Auto Logged in Successfully", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "userPersonaType",
        "firedFrom"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RdSCAdwoxc", "ac05a86d48394f31e234db044c105154e81c4eafeed55ea4f5622b485c425d23", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Student Auto Logged in Successfully", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Persona Type": properties.userPersonaType,
        "Fired From": properties.firedFrom,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RdSCAdwoxc", "Student Auto Logged in Successfully", messages, [
        {id: "1z9szfE-j", name: "User Persona Type", value: properties.userPersonaType},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "4e2iM_rBA", name: "Fired From", value: properties.firedFrom},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Student Auto Logged in Successfully': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Student Auto Logged in Successfully", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Persona Type": properties.userPersonaType,
          "Fired From": properties.firedFrom,
          "Screen Height": sysScreenHeight,
          }, "RdSCAdwoxc", "ac05a86d48394f31e234db044c105154e81c4eafeed55ea4f5622b485c425d23");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Student Auto Logged in Successfully", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Persona Type": properties.userPersonaType,
      "Fired From": properties.firedFrom,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Subscribe Pop-Up on Ptl: Viewed Subscribe Pop-Up on Ptl - When the user sees the pop-up where we show CTA as view plans post the free limit is reached. This will be fired only on the PTL post 3 PM flow.
   *
   * When to trigger this event:
   * 1. When the user sees the pop-up post limit is reached.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XnyMsOLC7A/trigger/JIuigb06v
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XnyMsOLC7A}
   */
  function viewedSubscribePopUpOnPtl(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Subscribe Pop-Up on Ptl", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XnyMsOLC7A", "5597ec99c958be0fcc1b72d438e785301e93abfff4b5c5d909be779368858155", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Subscribe Pop-Up on Ptl", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XnyMsOLC7A", "Viewed Subscribe Pop-Up on Ptl", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Subscribe Pop-Up on Ptl': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Subscribe Pop-Up on Ptl", {
          "Screen Height": sysScreenHeight,
          }, "XnyMsOLC7A", "5597ec99c958be0fcc1b72d438e785301e93abfff4b5c5d909be779368858155");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Subscribe Pop-Up on Ptl", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Onboarding Step Completion Animation: This event will be fired when the step completion animation will play within the onboarding widget.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.onboardingWidgetStepName - This will capture the corresponding step name for which the animation gets completed. FOr example, 'Add Students', 'Explore Splashlearn Content'
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zZLiNhOaS5}
   */
  function viewedOnboardingStepCompletionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOnboardingWidgetStepName(properties.onboardingWidgetStepName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Onboarding Step Completion Animation", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "onboardingWidgetStepName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zZLiNhOaS5", "fc9b3f1086cb2de1c631113501a73a99dd122296a8070f66cbd927e2aeda431e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Onboarding Step Completion Animation", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Onboarding Widget Step Name": properties.onboardingWidgetStepName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zZLiNhOaS5", "Viewed Onboarding Step Completion Animation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "FyfKKmNk3", name: "Onboarding Widget Step Name", value: properties.onboardingWidgetStepName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Onboarding Step Completion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Onboarding Step Completion Animation", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Onboarding Widget Step Name": properties.onboardingWidgetStepName,
          "Screen Height": sysScreenHeight,
          }, "zZLiNhOaS5", "fc9b3f1086cb2de1c631113501a73a99dd122296a8070f66cbd927e2aeda431e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Onboarding Step Completion Animation", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Onboarding Widget Step Name": properties.onboardingWidgetStepName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Teacher Dashboard: This event will be fired when the user visits the Teacher Dashboard
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5IeHSXbuvb}
   */
  function viewedTeacherDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Teacher Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5IeHSXbuvb", "6fb0280d1f25f981be51100d87f2bfb2fc0bad7aac28cc00d2982859631b6a33", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Teacher Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5IeHSXbuvb", "Viewed Teacher Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Teacher Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Teacher Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "5IeHSXbuvb", "6fb0280d1f25f981be51100d87f2bfb2fc0bad7aac28cc00d2982859631b6a33");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Teacher Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Teacher Dashboard: This event will be fired when the user clicks anywhere within any section on the Teacher's Dashboard
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.hoveredOver - This will fire as soon as the user hovers over the status numbers in the assignment cards.
The values captured will be 'Yet to Start', 'In Progress', 'Completed'
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/T6OimMcyg_}
   */
  function interactedTeacherDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertHoveredOver(properties.hoveredOver));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Teacher Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "hoveredOver",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "T6OimMcyg_", "0d595df4088a76af4263478f6a3aa64ce07e0370dde5b4acb75447e8f5e50375", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Teacher Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Hovered Over": properties.hoveredOver,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("T6OimMcyg_", "Interacted Teacher Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "7wbK1QRC0", name: "Hovered Over", value: properties.hoveredOver},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Teacher Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Teacher Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Hovered Over": properties.hoveredOver,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "T6OimMcyg_", "0d595df4088a76af4263478f6a3aa64ce07e0370dde5b4acb75447e8f5e50375");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Teacher Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Hovered Over": properties.hoveredOver,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Auto-Enrolled for SpringBoard: This event is fired when the class is auto-enrolled for the springboard.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} properties.className - The name of the class that is kept by the teacher.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ck7guxdUU9}
   */
  function autoEnrolledForSpringboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Auto-Enrolled for SpringBoard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "classSize",
        "className"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ck7guxdUU9", "541ae8c706e8b274ec8ad9b169d5ffdda10bb360c6e375442049c2c06a388d2d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Auto-Enrolled for SpringBoard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Size": properties.classSize,
        "Class Name": properties.className,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ck7guxdUU9", "Auto-Enrolled for SpringBoard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Auto-Enrolled for SpringBoard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Auto-Enrolled for SpringBoard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Size": properties.classSize,
          "Class Name": properties.className,
          "Screen Height": sysScreenHeight,
          }, "Ck7guxdUU9", "541ae8c706e8b274ec8ad9b169d5ffdda10bb360c6e375442049c2c06a388d2d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Auto-Enrolled for SpringBoard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Size": properties.classSize,
      "Class Name": properties.className,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Springboard New Intro: Viewed the springboard new introduction pop-up that we are making similar to the Math Facts.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} properties.className - The name of the class that is kept by the teacher.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qdV3BirFh0}
   */
  function viewedSpringboardNewIntro(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Springboard New Intro", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "classSize",
        "className"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qdV3BirFh0", "1428c5656ca87ef83acaadc8a4543d53f6cccc871ea5820fe3a5f37cba3e2203", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Springboard New Intro", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Size": properties.classSize,
        "Class Name": properties.className,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qdV3BirFh0", "Viewed Springboard New Intro", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Springboard New Intro': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Springboard New Intro", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Size": properties.classSize,
          "Class Name": properties.className,
          "Screen Height": sysScreenHeight,
          }, "qdV3BirFh0", "1428c5656ca87ef83acaadc8a4543d53f6cccc871ea5820fe3a5f37cba3e2203");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Springboard New Intro", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Size": properties.classSize,
      "Class Name": properties.className,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Springboard New Intro: When the user interacts with the new Springboard intro , this events needs to be fired for every interaction.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/V87v2nKqbJ}
   */
  function interactedSpringboardNewIntro(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Springboard New Intro", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "V87v2nKqbJ", "afb087aea199afffad89d2244acce5a292cb0591237fce01425586124a8dbcb0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Springboard New Intro", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("V87v2nKqbJ", "Interacted Springboard New Intro", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Springboard New Intro': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Springboard New Intro", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "V87v2nKqbJ", "afb087aea199afffad89d2244acce5a292cb0591237fce01425586124a8dbcb0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Springboard New Intro", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Springboard Tab: When the user views the springboard landing page, this event needs to be fired.
   *
   * When to trigger this event:
   * 1. When the user views the springboard landing page, this event needs to be fired.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aH0cJ47tMK/trigger/8kEzeH6QW
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aH0cJ47tMK}
   */
  function viewedSpringboardTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Springboard Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aH0cJ47tMK", "1baadf17f95834fc10974093119816502a72af3e785ed24f07a1321da2a0d314", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Springboard Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aH0cJ47tMK", "Viewed Springboard Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Springboard Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Springboard Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "aH0cJ47tMK", "1baadf17f95834fc10974093119816502a72af3e785ed24f07a1321da2a0d314");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Springboard Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Springboard Tab: When the user interacted the Springboard landing page and clicks on anything the same needs to be registered via sending this event.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} properties.className - The name of the class that is kept by the teacher.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2H79WEYOwO}
   */
  function interactedSpringboardTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Springboard Tab", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "classSize",
        "className",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2H79WEYOwO", "8d890a139487673a8e702a7ba5a06c2b72680201a0552a266210a4918f9758e1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Springboard Tab", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Size": properties.classSize,
        "Class Name": properties.className,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2H79WEYOwO", "Interacted Springboard Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Springboard Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Springboard Tab", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Size": properties.classSize,
          "Class Name": properties.className,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "2H79WEYOwO", "8d890a139487673a8e702a7ba5a06c2b72680201a0552a266210a4918f9758e1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Springboard Tab", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Size": properties.classSize,
      "Class Name": properties.className,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Classroom Settings Page: When the user clicks on to unenroll or enroll in the class settings page.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.className - The name of the class that is kept by the teacher.
   * @param {int} properties.classSize - Total students in the class at the time this event was triggered.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rH7996zpF}
   */
  function interactedClassroomSettingsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertClassSize(properties.classSize));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Classroom Settings Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "className",
        "classSize",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rH7996zpF", "9553ba8853cbb7ddcd6421af3c7d762ea373aff06834d7f48f22d146629775f4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Classroom Settings Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Class Name": properties.className,
        "Class Size": properties.classSize,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rH7996zpF", "Interacted Classroom Settings Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "erbI-IRpim", name: "Class Size", value: properties.classSize},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Classroom Settings Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Classroom Settings Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Class Name": properties.className,
          "Class Size": properties.classSize,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "rH7996zpF", "9553ba8853cbb7ddcd6421af3c7d762ea373aff06834d7f48f22d146629775f4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Classroom Settings Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Class Name": properties.className,
      "Class Size": properties.classSize,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Urgency Discount Popup: When the user views the Urgency Discount Popup, this event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/obEYOIabsO}
   */
  function viewedUrgencyDiscountPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Urgency Discount Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "obEYOIabsO", "be9b05e9277bcd11afe9d14e87c9d21e0cf2369233a115d509be75b44c1df958", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Urgency Discount Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("obEYOIabsO", "Viewed Urgency Discount Popup", messages, [
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Urgency Discount Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Urgency Discount Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "obEYOIabsO", "be9b05e9277bcd11afe9d14e87c9d21e0cf2369233a115d509be75b44c1df958");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Urgency Discount Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Urgency Discount Popup: When the user interacts the urgency discount pop-up, this event needs to  be fired.
   *
   * When to trigger this event:
   * 1. interacts the urgency discount pop-up
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lugSmSK6IV/trigger/4dtsxJAs1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lugSmSK6IV}
   */
  function interactedUrgencyDiscountPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Urgency Discount Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lugSmSK6IV", "0ed616c2cd83571583d752894e74fe687934d9adcd0f571a0cdcead25323a186", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Urgency Discount Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lugSmSK6IV", "Interacted Urgency Discount Popup", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Urgency Discount Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Urgency Discount Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "lugSmSK6IV", "0ed616c2cd83571583d752894e74fe687934d9adcd0f571a0cdcead25323a186");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Urgency Discount Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Unlock Content: When the user interacts the unlock content CTA, this event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.discountPitch] - This property highlights if we are offering any discount at the time of user doing that event - Eg: 'Viewed Tiled Dashboard' , 'clicking the CTA - Unlock Content'
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rjDd6qtve8}
   */
  function interactedUnlockContent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalDiscountPitch(properties.discountPitch));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Unlock Content", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "discountPitch"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rjDd6qtve8", "6040cde06cb0ffd88768f5fc002172cb28f7b1b31fce43238f3cb4c86edc11f6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Unlock Content", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Discount Pitch": properties.discountPitch,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rjDd6qtve8", "Interacted Unlock Content", messages, [
        {id: "-tPNSAQK6", name: "Discount Pitch", value: properties.discountPitch},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Unlock Content': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Unlock Content", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Discount Pitch": properties.discountPitch,
          "Screen Height": sysScreenHeight,
          }, "rjDd6qtve8", "6040cde06cb0ffd88768f5fc002172cb28f7b1b31fce43238f3cb4c86edc11f6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Unlock Content", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Discount Pitch": properties.discountPitch,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Visited Certificate Tab Springboard: This event is fired when the teacher visits the certificate tab of the springboard.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/c84jsTeM80}
   */
  function visitedCertificateTabSpringboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Certificate Tab Springboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "c84jsTeM80", "95631ab476fb9e7a8baa12ecaf4a3aabffb3fb3d053d8cb3e44323655a1b5628", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Visited Certificate Tab Springboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("c84jsTeM80", "Visited Certificate Tab Springboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Certificate Tab Springboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Certificate Tab Springboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "c84jsTeM80", "95631ab476fb9e7a8baa12ecaf4a3aabffb3fb3d053d8cb3e44323655a1b5628");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Certificate Tab Springboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Certificates Page Springboard: This event is fired when the user interacts within the Certificates page of the Springboard.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HOSLfZP43u}
   */
  function interactedCertificatesPageSpringboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Certificates Page Springboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HOSLfZP43u", "084a12659650364d593ec8d780d512b3c6bd0df544c10efbe52f30b6714e10f8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Certificates Page Springboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HOSLfZP43u", "Interacted Certificates Page Springboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Certificates Page Springboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Certificates Page Springboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "HOSLfZP43u", "084a12659650364d593ec8d780d512b3c6bd0df544c10efbe52f30b6714e10f8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Certificates Page Springboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Certificate: When the teacher views any certificate - this event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.certificateType - the type of the certificate that is viewed
- Springboard Class Certificate
- Springboard Teacher Certificate
- Springboard Student Cetificate
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hcXBOD9d15}
   */
  function viewedCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertCertificateType(properties.certificateType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Certificate", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "certificateName",
        "certificateType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hcXBOD9d15", "79eb1ef6438ecaa4c49726206751618e33713e29f7cb630c6cd5e0fcbb7a50a4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Certificate", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Certificate Name": properties.certificateName,
        "Certificate Type": properties.certificateType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hcXBOD9d15", "Viewed Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "T1COE_Of2", name: "Certificate Type", value: properties.certificateType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Certificate", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Certificate Name": properties.certificateName,
          "Certificate Type": properties.certificateType,
          "Screen Height": sysScreenHeight,
          }, "hcXBOD9d15", "79eb1ef6438ecaa4c49726206751618e33713e29f7cb630c6cd5e0fcbb7a50a4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Certificate", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Certificate Name": properties.certificateName,
      "Certificate Type": properties.certificateType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Downloaded Certificate: When the teacher downloads any certificate. This event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.certificateType - the type of the certificate that is viewed
- Springboard Class Certificate
- Springboard Teacher Certificate
- Springboard Student Cetificate
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UkW63JSZCX}
   */
  function downloadedCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertCertificateType(properties.certificateType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Downloaded Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "certificateName",
        "certificateType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UkW63JSZCX", "b2d4f866c90249e27d9ea29dc10d294f57b233b48572eb456a755c933516f699", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Downloaded Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Certificate Name": properties.certificateName,
        "Certificate Type": properties.certificateType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UkW63JSZCX", "Downloaded Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "T1COE_Of2", name: "Certificate Type", value: properties.certificateType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Downloaded Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Downloaded Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Certificate Name": properties.certificateName,
          "Certificate Type": properties.certificateType,
          "Screen Height": sysScreenHeight,
          }, "UkW63JSZCX", "b2d4f866c90249e27d9ea29dc10d294f57b233b48572eb456a755c933516f699");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Downloaded Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Certificate Name": properties.certificateName,
      "Certificate Type": properties.certificateType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Introducing Certificates Popup: This event is fired when the teacher views the introductory certificates popup.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lsKrD9qG5r}
   */
  function viewedIntroducingCertificatesPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Introducing Certificates Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lsKrD9qG5r", "ef84682d7f6ccc732cea03cd076be60f053b830d2863563ea2300c3c45541c18", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Introducing Certificates Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lsKrD9qG5r", "Viewed Introducing Certificates Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Introducing Certificates Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Introducing Certificates Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "lsKrD9qG5r", "ef84682d7f6ccc732cea03cd076be60f053b830d2863563ea2300c3c45541c18");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Introducing Certificates Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Introductory Certificates Popup: When the user clicks on the CTA of the Introductory Certificates Popup
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTMIYRvIwn}
   */
  function interactedIntroductoryCertificatesPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Introductory Certificates Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wTMIYRvIwn", "97c5af527750d20e2bf56af79319d718e12733097965678acb506579d7d48bcf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Introductory Certificates Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wTMIYRvIwn", "Interacted Introductory Certificates Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Introductory Certificates Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Introductory Certificates Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "wTMIYRvIwn", "97c5af527750d20e2bf56af79319d718e12733097965678acb506579d7d48bcf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Introductory Certificates Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Weekly Highlights Popup: When the teacher views the weekly highlights popup. This event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10.
   * @param {string} properties.certificatesEarned - This highlights the number of certificated earned. If no certificate is earned, the value is 0. Else the value is equivalent of the number of certificated earned.
   * @param {string} properties.springboardRank - This highlights whether the springboard rank increased, decreased or remained same when this event got fired compared to last week.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Y0b_FoYW5d}
   */
  function viewedWeeklyHighlightsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertCertificatesEarned(properties.certificatesEarned));
      messages = messages.concat(assertSpringboardRank(properties.springboardRank));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Weekly Highlights Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "springboardWeek",
        "certificatesEarned",
        "springboardRank"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Y0b_FoYW5d", "b8389810d3a7af4e18529b0ca6d8acee694538a27928e04d158d03fc2de0d37b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Weekly Highlights Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Springboard Week": properties.springboardWeek,
        "Certificates Earned": properties.certificatesEarned,
        "Springboard Rank": properties.springboardRank,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Y0b_FoYW5d", "Viewed Weekly Highlights Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "4DPFLSCCa", name: "Certificates Earned", value: properties.certificatesEarned},
        {id: "PpLUQoMje", name: "Springboard Rank", value: properties.springboardRank},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Weekly Highlights Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Weekly Highlights Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Springboard Week": properties.springboardWeek,
          "Certificates Earned": properties.certificatesEarned,
          "Springboard Rank": properties.springboardRank,
          "Screen Height": sysScreenHeight,
          }, "Y0b_FoYW5d", "b8389810d3a7af4e18529b0ca6d8acee694538a27928e04d158d03fc2de0d37b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Weekly Highlights Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Springboard Week": properties.springboardWeek,
      "Certificates Earned": properties.certificatesEarned,
      "Springboard Rank": properties.springboardRank,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Weekly Highlights Popup: When the user clicks on the weekly highlights popup, this event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ljG6Zgle_B}
   */
  function interactedWeeklyHighlightsPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Weekly Highlights Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ljG6Zgle_B", "f04b7c3f1f3784e131e3d957982f8a82426e84489b427b985bfc9b3f7b95f257", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Weekly Highlights Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ljG6Zgle_B", "Interacted Weekly Highlights Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Weekly Highlights Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Weekly Highlights Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "ljG6Zgle_B", "f04b7c3f1f3784e131e3d957982f8a82426e84489b427b985bfc9b3f7b95f257");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Weekly Highlights Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Tutor Lobby: Triggered when the teacher visits tutor lobby screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizName - no description
   * @param {string} properties.quizSubject - no description
   * @param {string} properties.tutorName - no description
   * @param {string} properties.quizGrade - no description
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EUyUckkAzl}
   */
  function viewedTutorLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizName(properties.quizName));
      messages = messages.concat(assertQuizSubject(properties.quizSubject));
      messages = messages.concat(assertTutorName(properties.tutorName));
      messages = messages.concat(assertQuizGrade(properties.quizGrade));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Lobby", Object.keys(properties), [
        "quizName",
        "quizSubject",
        "tutorName",
        "quizGrade",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EUyUckkAzl", "a31b0384de2f9cfef9389c95d7c6ec9ea8c5c9f557ab3f3e42624cb483779a0d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Tutor Lobby", {
        "Quiz Name": properties.quizName,
        "Quiz Subject": properties.quizSubject,
        "Tutor Name": properties.tutorName,
        "Quiz Grade": properties.quizGrade,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EUyUckkAzl", "Viewed Tutor Lobby", messages, [
        {id: "El8KEuVMR", name: "Quiz Subject", value: properties.quizSubject},
        {id: "NS3VU6-SM", name: "Tutor Name", value: properties.tutorName},
        {id: "OdOreTGEK", name: "Quiz Grade", value: properties.quizGrade},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "w5nsMhHyb", name: "Quiz Name", value: properties.quizName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Lobby", {
          "Quiz Name": properties.quizName,
          "Quiz Subject": properties.quizSubject,
          "Tutor Name": properties.tutorName,
          "Quiz Grade": properties.quizGrade,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "EUyUckkAzl", "a31b0384de2f9cfef9389c95d7c6ec9ea8c5c9f557ab3f3e42624cb483779a0d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Lobby", {
      "Quiz Name": properties.quizName,
      "Quiz Subject": properties.quizSubject,
      "Tutor Name": properties.tutorName,
      "Quiz Grade": properties.quizGrade,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Tutor Lobby: Triggered when the tutor lobby screen is interacted
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qKnjLecBEi}
   */
  function interactedTutorLobby(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Lobby", Object.keys(properties), [
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qKnjLecBEi", "3432ac06dd406c38bc2e9e7293725832eac9d2d53c9a5c2f52372bebc29e9ddf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Tutor Lobby", {
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qKnjLecBEi", "Interacted Tutor Lobby", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Lobby': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Lobby", {
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "qKnjLecBEi", "3432ac06dd406c38bc2e9e7293725832eac9d2d53c9a5c2f52372bebc29e9ddf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Lobby", {
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Class Quiz Started: Triggered when the quiz is started for everyone
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizName - no description
   * @param {string} properties.quizGrade - no description
   * @param {string} properties.quizSubject - no description
   * @param {string} properties.tutorName - no description
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Cm2wspxNTM}
   */
  function classQuizStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizName(properties.quizName));
      messages = messages.concat(assertQuizGrade(properties.quizGrade));
      messages = messages.concat(assertQuizSubject(properties.quizSubject));
      messages = messages.concat(assertTutorName(properties.tutorName));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Quiz Started", Object.keys(properties), [
        "quizName",
        "quizGrade",
        "quizSubject",
        "tutorName",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Cm2wspxNTM", "9615cfc60618a7a88d8f7e3f59322c42d303455002b6e16f2e540d00e3826ca8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Class Quiz Started", {
        "Quiz Name": properties.quizName,
        "Quiz Grade": properties.quizGrade,
        "Quiz Subject": properties.quizSubject,
        "Tutor Name": properties.tutorName,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Cm2wspxNTM", "Class Quiz Started", messages, [
        {id: "El8KEuVMR", name: "Quiz Subject", value: properties.quizSubject},
        {id: "NS3VU6-SM", name: "Tutor Name", value: properties.tutorName},
        {id: "OdOreTGEK", name: "Quiz Grade", value: properties.quizGrade},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "w5nsMhHyb", name: "Quiz Name", value: properties.quizName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Quiz Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Quiz Started", {
          "Quiz Name": properties.quizName,
          "Quiz Grade": properties.quizGrade,
          "Quiz Subject": properties.quizSubject,
          "Tutor Name": properties.tutorName,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "Cm2wspxNTM", "9615cfc60618a7a88d8f7e3f59322c42d303455002b6e16f2e540d00e3826ca8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Quiz Started", {
      "Quiz Name": properties.quizName,
      "Quiz Grade": properties.quizGrade,
      "Quiz Subject": properties.quizSubject,
      "Tutor Name": properties.tutorName,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Class Quiz Ended: Triggered when the class quiz is ended for everyone
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KCKh1qFsSM}
   */
  function classQuizEnded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Quiz Ended", Object.keys(properties), [
        "from",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KCKh1qFsSM", "645bb88c83616419be0620cef816d4cf2f8cdb7fddafce6be7650d3e1fbb0946", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Class Quiz Ended", {
        "From": properties.from,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KCKh1qFsSM", "Class Quiz Ended", messages, [
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Quiz Ended': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Quiz Ended", {
          "From": properties.from,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Screen Height": sysScreenHeight,
          }, "KCKh1qFsSM", "645bb88c83616419be0620cef816d4cf2f8cdb7fddafce6be7650d3e1fbb0946");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Quiz Ended", {
      "From": properties.from,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Tutor In Quiz Screen: Triggered when the tutor views in quiz screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/k180znTnrv}
   */
  function viewedTutorInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor In Quiz Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "k180znTnrv", "6cd01e962d76445bbbe2b6f8a36422b7c37d07a6ee1fe3a061030967805e3943", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Tutor In Quiz Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("k180znTnrv", "Viewed Tutor In Quiz Screen", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor In Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor In Quiz Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "k180znTnrv", "6cd01e962d76445bbbe2b6f8a36422b7c37d07a6ee1fe3a061030967805e3943");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor In Quiz Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Tutor in Quiz Screen: Interacted on the in quiz screens
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IvWGaK-szK}
   */
  function interactedTutorInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor in Quiz Screen", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionCode",
        "questionNumber",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IvWGaK-szK", "eb88f97ac149addab3590161b46d412f1e940065eea61ee3eb0bd6b4c59c7c18", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Tutor in Quiz Screen", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Code": properties.questionCode,
        "Question Number": properties.questionNumber,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IvWGaK-szK", "Interacted Tutor in Quiz Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor in Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor in Quiz Screen", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Code": properties.questionCode,
          "Question Number": properties.questionNumber,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "IvWGaK-szK", "eb88f97ac149addab3590161b46d412f1e940065eea61ee3eb0bd6b4c59c7c18");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor in Quiz Screen", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Code": properties.questionCode,
      "Question Number": properties.questionNumber,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Next Question Warning Viewed: Triggered when the next question warning screen is viewed
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UtLlcmbSTL}
   */
  function nextQuestionWarningViewed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Next Question Warning Viewed", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UtLlcmbSTL", "f4354533430fb4bd839fdebffa5eb36e67331b3389df861cbcc9c7d8cf2abebf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Next Question Warning Viewed", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UtLlcmbSTL", "Next Question Warning Viewed", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Next Question Warning Viewed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Next Question Warning Viewed", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "UtLlcmbSTL", "f4354533430fb4bd839fdebffa5eb36e67331b3389df861cbcc9c7d8cf2abebf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Next Question Warning Viewed", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Next Question Warning Interacted: Triggered when the next question warning is interacted
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Yfkny84ZGa}
   */
  function nextQuestionWarningInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Next Question Warning Interacted", Object.keys(properties), [
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Yfkny84ZGa", "cb7116689a68ac90bd1f64f91f5d7125c35a3fe1ca3efdc235db61c7b9d69e95", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Next Question Warning Interacted", {
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Yfkny84ZGa", "Next Question Warning Interacted", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Next Question Warning Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Next Question Warning Interacted", {
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "Yfkny84ZGa", "cb7116689a68ac90bd1f64f91f5d7125c35a3fe1ca3efdc235db61c7b9d69e95");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Next Question Warning Interacted", {
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Tutor Quiz Timer Run Out Popup: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/_GBaUOwTAh}
   */
  function viewedTutorQuizTimerRunOutPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Quiz Timer Run Out Popup", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_GBaUOwTAh", "ffaf7d10df62d0df4b6049912761c107e6ebed5ffde9004767fec8fff106555f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Tutor Quiz Timer Run Out Popup", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_GBaUOwTAh", "Viewed Tutor Quiz Timer Run Out Popup", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Quiz Timer Run Out Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Quiz Timer Run Out Popup", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "_GBaUOwTAh", "ffaf7d10df62d0df4b6049912761c107e6ebed5ffde9004767fec8fff106555f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Quiz Timer Run Out Popup", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Tutor Final Leaderboard: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cnkDqUAqod}
   */
  function viewedTutorFinalLeaderboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Final Leaderboard", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cnkDqUAqod", "3bc47b8794915d2a2a2e9813a5a97124214fc3989ae437f516b639194c1a4c2c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Tutor Final Leaderboard", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cnkDqUAqod", "Viewed Tutor Final Leaderboard", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Final Leaderboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Final Leaderboard", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "cnkDqUAqod", "3bc47b8794915d2a2a2e9813a5a97124214fc3989ae437f516b639194c1a4c2c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Final Leaderboard", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student Lobby Screen: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.quizName - no description
   * @param {string} properties.quizGrade - no description
   * @param {string} properties.quizSubject - no description
   * @param {string} properties.tutorName - no description
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9y5UviQI-P}
   */
  function viewedStudentLobbyScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertQuizName(properties.quizName));
      messages = messages.concat(assertQuizGrade(properties.quizGrade));
      messages = messages.concat(assertQuizSubject(properties.quizSubject));
      messages = messages.concat(assertTutorName(properties.tutorName));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Lobby Screen", Object.keys(properties), [
        "mathGrade",
        "mode",
        "quizName",
        "quizGrade",
        "quizSubject",
        "tutorName",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9y5UviQI-P", "758c6bb8aa884a4ec439f55a4b11a208424182cbed0470f95150360b1a4d5241", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student Lobby Screen", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Quiz Name": properties.quizName,
        "Quiz Grade": properties.quizGrade,
        "Quiz Subject": properties.quizSubject,
        "Tutor Name": properties.tutorName,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9y5UviQI-P", "Viewed Student Lobby Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "El8KEuVMR", name: "Quiz Subject", value: properties.quizSubject},
        {id: "NS3VU6-SM", name: "Tutor Name", value: properties.tutorName},
        {id: "OdOreTGEK", name: "Quiz Grade", value: properties.quizGrade},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "w5nsMhHyb", name: "Quiz Name", value: properties.quizName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Lobby Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Lobby Screen", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Quiz Name": properties.quizName,
          "Quiz Grade": properties.quizGrade,
          "Quiz Subject": properties.quizSubject,
          "Tutor Name": properties.tutorName,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "9y5UviQI-P", "758c6bb8aa884a4ec439f55a4b11a208424182cbed0470f95150360b1a4d5241");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Lobby Screen", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Quiz Name": properties.quizName,
      "Quiz Grade": properties.quizGrade,
      "Quiz Subject": properties.quizSubject,
      "Tutor Name": properties.tutorName,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student In Quiz Screen: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TiDRQb_Bdf}
   */
  function viewedStudentInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student In Quiz Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TiDRQb_Bdf", "adcc36b116cfeb3903a33bdf6c5fbc222966492810b8bccd5a5407689292d9d4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student In Quiz Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TiDRQb_Bdf", "Viewed Student In Quiz Screen", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student In Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student In Quiz Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "TiDRQb_Bdf", "adcc36b116cfeb3903a33bdf6c5fbc222966492810b8bccd5a5407689292d9d4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student In Quiz Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Student In Quiz Screen: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wwJlbRYOSh}
   */
  function interactedStudentInQuizScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student In Quiz Screen", Object.keys(properties), [
        "clickedOn",
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wwJlbRYOSh", "44910f62dc049388e68066c91e766ddf4e13199959fd07dee0b6a7b6fbffb89e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Student In Quiz Screen", {
        "Clicked On": properties.clickedOn,
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wwJlbRYOSh", "Interacted Student In Quiz Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student In Quiz Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student In Quiz Screen", {
          "Clicked On": properties.clickedOn,
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "wwJlbRYOSh", "44910f62dc049388e68066c91e766ddf4e13199959fd07dee0b6a7b6fbffb89e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student In Quiz Screen", {
      "Clicked On": properties.clickedOn,
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student Pitstop Screen: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ht-mV3vmhN}
   */
  function viewedStudentPitstopScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Pitstop Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionCode",
        "questionNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ht-mV3vmhN", "b52eb29d0a3cc5c4ed0c9388a98e2e0c312c43fad2ec749dfe52aef1e4096c54", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student Pitstop Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Code": properties.questionCode,
        "Question Number": properties.questionNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ht-mV3vmhN", "Viewed Student Pitstop Screen", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Pitstop Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Pitstop Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Code": properties.questionCode,
          "Question Number": properties.questionNumber,
          "Screen Height": sysScreenHeight,
          }, "Ht-mV3vmhN", "b52eb29d0a3cc5c4ed0c9388a98e2e0c312c43fad2ec749dfe52aef1e4096c54");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Pitstop Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Code": properties.questionCode,
      "Question Number": properties.questionNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Problems Answered: No description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hEcO_Dz4dt}
   */
  function problemsAnswered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Problems Answered", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hEcO_Dz4dt", "0233341ec7b9fc57b2e6ca0e9ea36e07eca1a2335e7033808317f6f4654f9ccc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Problems Answered", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hEcO_Dz4dt", "Problems Answered", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Problems Answered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Problems Answered", {
          "Screen Height": sysScreenHeight,
          }, "hEcO_Dz4dt", "0233341ec7b9fc57b2e6ca0e9ea36e07eca1a2335e7033808317f6f4654f9ccc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Problems Answered", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student Quiz Timer Run Out: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Mf9C357VoY}
   */
  function viewedStudentQuizTimerRunOut(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Quiz Timer Run Out", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Mf9C357VoY", "ab4739eec7948b59fdbe697e68cab8b0298c50d75a42e4bdec6dad74d76a32cf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student Quiz Timer Run Out", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Mf9C357VoY", "Viewed Student Quiz Timer Run Out", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Quiz Timer Run Out': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Quiz Timer Run Out", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "Screen Height": sysScreenHeight,
          }, "Mf9C357VoY", "ab4739eec7948b59fdbe697e68cab8b0298c50d75a42e4bdec6dad74d76a32cf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Quiz Timer Run Out", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student Final Leaderboard: No description
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bjqqNI4ue6}
   */
  function viewedStudentFinalLeaderboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Final Leaderboard", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bjqqNI4ue6", "7ac130a0aa733317e7b485ccea25ba62ec6a6543610536125821c01261d6ad48", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student Final Leaderboard", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bjqqNI4ue6", "Viewed Student Final Leaderboard", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Final Leaderboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Final Leaderboard", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "bjqqNI4ue6", "7ac130a0aa733317e7b485ccea25ba62ec6a6543610536125821c01261d6ad48");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Final Leaderboard", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Subscribe Pop-Up on PTL: When the user interacts the Subscribe Pop-up on PTL, this event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userPersonaType - User persona type at an event level is the property that highlights whether the user persona is class only or after the parent signup - it is ptl. In the school, class the persona is class only and at home the persona is ptl. If the parent is not signed up, it is class only.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dWzCeArG29}
   */
  function interactedSubscribePopUpOnPtl(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserPersonaType(properties.userPersonaType));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Subscribe Pop-Up on PTL", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "userPersonaType",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dWzCeArG29", "34a3c629d3f88e57cb53e0c36348d31fdd52d308a9227f587b4285f8996c1446", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Subscribe Pop-Up on PTL", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Persona Type": properties.userPersonaType,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dWzCeArG29", "Interacted Subscribe Pop-Up on PTL", messages, [
        {id: "1z9szfE-j", name: "User Persona Type", value: properties.userPersonaType},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Subscribe Pop-Up on PTL': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Subscribe Pop-Up on PTL", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Persona Type": properties.userPersonaType,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "dWzCeArG29", "34a3c629d3f88e57cb53e0c36348d31fdd52d308a9227f587b4285f8996c1446");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Subscribe Pop-Up on PTL", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Persona Type": properties.userPersonaType,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Problems Answered in Neo Worksheets: Count of problems answered in neo worksheets
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TadJfng_8X}
   */
  function problemsAnsweredInNeoWorksheets(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Problems Answered in Neo Worksheets", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionCode",
        "questionNumber",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TadJfng_8X", "40a2045dd01710a4e2ad19bd15ea256f9d1fbda3333a061590d693521b997231", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Problems Answered in Neo Worksheets", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Code": properties.questionCode,
        "Question Number": properties.questionNumber,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TadJfng_8X", "Problems Answered in Neo Worksheets", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Problems Answered in Neo Worksheets': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Problems Answered in Neo Worksheets", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Code": properties.questionCode,
          "Question Number": properties.questionNumber,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "TadJfng_8X", "40a2045dd01710a4e2ad19bd15ea256f9d1fbda3333a061590d693521b997231");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Problems Answered in Neo Worksheets", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Code": properties.questionCode,
      "Question Number": properties.questionNumber,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Upcoming Class Tab: Triggered when a user sees the live classes upcoming class tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/njG3oQa5fg}
   */
  function viewedUpcomingClassTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Upcoming Class Tab", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "njG3oQa5fg", "cc9163871d09fa8ef1ddbb05f4958f47e862cda330b09fa49d5876c43c210a94", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Upcoming Class Tab", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("njG3oQa5fg", "Viewed Upcoming Class Tab", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Upcoming Class Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Upcoming Class Tab", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "njG3oQa5fg", "cc9163871d09fa8ef1ddbb05f4958f47e862cda330b09fa49d5876c43c210a94");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Upcoming Class Tab", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Upcoming Class Tab: Triggered when a user interacts with the upcoming classes section
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {bool} properties.joinEnabled - This property is used to find out if the join link was enabled or not at the time of tap on live class card!
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/G-pzm4zxF3}
   */
  function interactedUpcomingClassTab(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertJoinEnabled(properties.joinEnabled));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Upcoming Class Tab", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "joinEnabled",
        "elaGrade",
        "grade",
        "tabCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "G-pzm4zxF3", "dbdee92c492209272febcf1d4b5b762be96a5384a78583fdaf3c05b2739906fe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Upcoming Class Tab", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Join Enabled": properties.joinEnabled,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Tab Code": properties.tabCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("G-pzm4zxF3", "Interacted Upcoming Class Tab", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "A-lFlAcNj", name: "Join Enabled", value: properties.joinEnabled},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Upcoming Class Tab': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Upcoming Class Tab", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Join Enabled": properties.joinEnabled,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Tab Code": properties.tabCode,
          "Screen Height": sysScreenHeight,
          }, "G-pzm4zxF3", "dbdee92c492209272febcf1d4b5b762be96a5384a78583fdaf3c05b2739906fe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Upcoming Class Tab", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Join Enabled": properties.joinEnabled,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Tab Code": properties.tabCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Live Classes Introduction Popup: Triggered with the repeat user popup is shown to the users
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/X4M2jxCMCE}
   */
  function viewedLiveClassesIntroductionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Classes Introduction Popup", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "X4M2jxCMCE", "f647d0b820eb23f74cebdb16d4e794e48c615f1234014b6b289210bf7c8ae215", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Live Classes Introduction Popup", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("X4M2jxCMCE", "Viewed Live Classes Introduction Popup", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Classes Introduction Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Classes Introduction Popup", {
          "Screen Height": sysScreenHeight,
          }, "X4M2jxCMCE", "f647d0b820eb23f74cebdb16d4e794e48c615f1234014b6b289210bf7c8ae215");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Classes Introduction Popup", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Live Classes Introduction Popup: Triggered when a user interacts with the live classes repeat user popup
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8tuDH4EdMz}
   */
  function interactedLiveClassesIntroductionPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Introduction Popup", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8tuDH4EdMz", "39d4d68bd83b807d1978dbe1ceb70347e7af8126dcc81c9fc9fd633ac8a870dd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Live Classes Introduction Popup", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8tuDH4EdMz", "Interacted Live Classes Introduction Popup", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Introduction Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Introduction Popup", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "8tuDH4EdMz", "39d4d68bd83b807d1978dbe1ceb70347e7af8126dcc81c9fc9fd633ac8a870dd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Introduction Popup", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Add Parent Emails Page: This event will be fired when the user visits the page on which she needs to enter parent emails
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5Rf1uc4O0d}
   */
  function viewedAddParentEmailsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add Parent Emails Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5Rf1uc4O0d", "5d4de55c049585c39ce25d5f85aa8cd0eca34b5a3ab70a15809261f7a83edac2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Add Parent Emails Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5Rf1uc4O0d", "Viewed Add Parent Emails Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add Parent Emails Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add Parent Emails Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "5Rf1uc4O0d", "5d4de55c049585c39ce25d5f85aa8cd0eca34b5a3ab70a15809261f7a83edac2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add Parent Emails Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Add Parent Emails Page: This gets fired when the user does any kind of interaction with the 'Add Parent Emails' page. This should also capture if an email is entered in the textbox as Clicked on 'Email Enter' (this is similarly implemented on the Enable Home Access Page as well)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/9h0XuaNKkS}
   */
  function interactedAddParentEmailsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Parent Emails Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9h0XuaNKkS", "067ad6caa5b621165c7f40df833204d17f522b6da65d75a82927f53041ec7fe5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Add Parent Emails Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9h0XuaNKkS", "Interacted Add Parent Emails Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Parent Emails Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Parent Emails Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "9h0XuaNKkS", "067ad6caa5b621165c7f40df833204d17f522b6da65d75a82927f53041ec7fe5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Parent Emails Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Program Selection Screen: When the user lands on the ELP/ESP selection screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DGPTNxszAM/trigger/JaztsFJhV
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DGPTNxszAM}
   */
  function viewedProgramSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Program Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DGPTNxszAM", "a4320cfa60199fc7551b2324dad609f7d6d04d784ff68b3cb52d7ef64e354dbb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Program Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DGPTNxszAM", "Viewed Program Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Program Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Program Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "DGPTNxszAM", "a4320cfa60199fc7551b2324dad609f7d6d04d784ff68b3cb52d7ef64e354dbb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Program Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Program Selection Screen: When the user selects the program (ELP or ESP) or opts to go back
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gII0S2fzsu/trigger/At_Jo1Jnj
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gII0S2fzsu}
   */
  function interactedProgramSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Program Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gII0S2fzsu", "e14cb573f5744f9385c186f0bbdd5514e279345d1925ec826886b9125230cd69", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Program Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gII0S2fzsu", "Interacted Program Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Program Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Program Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "gII0S2fzsu", "e14cb573f5744f9385c186f0bbdd5514e279345d1925ec826886b9125230cd69");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Program Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Age Selection Screen: When the user lands on the new age selection screen for age 2-5
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UvTODv7l_z/trigger/1heUa10kE
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UvTODv7l_z}
   */
  function viewedAgeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Age Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UvTODv7l_z", "37a7d76e88839120345e875d8930f5e3da8a245b36cf725d28217ff3e5b423a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Age Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UvTODv7l_z", "Viewed Age Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Age Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Age Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "UvTODv7l_z", "37a7d76e88839120345e875d8930f5e3da8a245b36cf725d28217ff3e5b423a3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Age Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Age Selection Screen: When the user selects the age or goes back
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kRMuZ6pGRW/trigger/N-r5G3314
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kRMuZ6pGRW}
   */
  function interactedAgeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Age Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kRMuZ6pGRW", "a557a67fb70fe8a584c840a5c731a707b382deb8998e6be329bab2e39abeb431", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Age Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kRMuZ6pGRW", "Interacted Age Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Age Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Age Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "kRMuZ6pGRW", "a557a67fb70fe8a584c840a5c731a707b382deb8998e6be329bab2e39abeb431");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Age Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Program Details Screen: When the user views the screen with age-wise program details
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hZjHxMqShj/trigger/owEjlM0HJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hZjHxMqShj}
   */
  function viewedProgramDetailsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Program Details Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hZjHxMqShj", "779eac731ef6085c4caf402b503462dced937cc06689ce4dcf97f14aa53c153a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Program Details Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hZjHxMqShj", "Viewed Program Details Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Program Details Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Program Details Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "hZjHxMqShj", "779eac731ef6085c4caf402b503462dced937cc06689ce4dcf97f14aa53c153a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Program Details Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Program Details Screen: When the user clicks on the CTA or changes the age
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HLrKJYyFBB/trigger/QFHdD0xBF
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HLrKJYyFBB}
   */
  function interactedProgramDetailsScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Program Details Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HLrKJYyFBB", "11e31ff5436f6eb4289365121ee9e5e95fdb0e0f99bde41299cb98eb76783f0a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Program Details Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HLrKJYyFBB", "Interacted Program Details Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Program Details Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Program Details Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "HLrKJYyFBB", "11e31ff5436f6eb4289365121ee9e5e95fdb0e0f99bde41299cb98eb76783f0a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Program Details Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Add Parents Email Page: This event will be fired when the user visits the page on which she needs to enter parent emails
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LMHXVbSuX_}
   */
  function viewedAddParentsEmailPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add Parents Email Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LMHXVbSuX_", "e43cccbc12b20b33ea7460575753ea6e33ab7ba84fee46edbc4d4f6baedf4afc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Add Parents Email Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LMHXVbSuX_", "Viewed Add Parents Email Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add Parents Email Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add Parents Email Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "LMHXVbSuX_", "e43cccbc12b20b33ea7460575753ea6e33ab7ba84fee46edbc4d4f6baedf4afc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add Parents Email Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Add Parents Email Page: This gets fired when the user does any kind of interaction with the 'Add Parent Emails' page. This should also capture if an email is entered in the textbox as Clicked on 'Email Enter' (this is similarly implemented on the Enable Home Access Page as well)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2RmyWmerXN}
   */
  function interactedAddParentsEmailPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Parents Email Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2RmyWmerXN", "788211b0aecbcb7660899bf4c3027933e8369df395eb828f42d1150103d6d5fd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Add Parents Email Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2RmyWmerXN", "Interacted Add Parents Email Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Parents Email Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Parents Email Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "2RmyWmerXN", "788211b0aecbcb7660899bf4c3027933e8369df395eb828f42d1150103d6d5fd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Parents Email Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Locked Game: Interacted Locked Game during school hours
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.gameType - Type of game/playable selected
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hiBLfGwrcQ}
   */
  function interactedLockedGame(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Locked Game", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "gameName",
        "grade",
        "gameType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hiBLfGwrcQ", "398bbc9fcc9b6ec0d8346dcc317cca0f7f6e84e9f72136c964d23b4b8a8ef73b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Locked Game", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Game Name": properties.gameName,
        "Grade": properties.grade,
        "Game Type": properties.gameType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hiBLfGwrcQ", "Interacted Locked Game", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Locked Game': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Locked Game", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Game Name": properties.gameName,
          "Grade": properties.grade,
          "Game Type": properties.gameType,
          "Screen Height": sysScreenHeight,
          }, "hiBLfGwrcQ", "398bbc9fcc9b6ec0d8346dcc317cca0f7f6e84e9f72136c964d23b4b8a8ef73b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Locked Game", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Game Name": properties.gameName,
      "Grade": properties.grade,
      "Game Type": properties.gameType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Play at Home Screen: Viewed play at home screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hkfgIMdDBN}
   */
  function viewedPlayAtHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Play at Home Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameType",
        "from",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hkfgIMdDBN", "2e02025a468ba0f5733d56335ae173e8ac316906507599186630e57207c082e0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Play at Home Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Type": properties.gameType,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hkfgIMdDBN", "Viewed Play at Home Screen", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Play at Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Play at Home Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Type": properties.gameType,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "hkfgIMdDBN", "2e02025a468ba0f5733d56335ae173e8ac316906507599186630e57207c082e0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Play at Home Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Type": properties.gameType,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Play at Home Screen: Interacted Play at Home Screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.gameType - Type of game/playable selected
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/y8-IlQJMaF}
   */
  function interactedPlayAtHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGameType(properties.gameType));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Play at Home Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "grade",
        "clickedOn",
        "from",
        "gameType",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "y8-IlQJMaF", "08b634744f50fdcba3bc31235dc7749b9e0846513018d7cb514c848a58fbdf9d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Play at Home Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Grade": properties.grade,
        "Clicked On": properties.clickedOn,
        "From": properties.from,
        "Game Type": properties.gameType,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("y8-IlQJMaF", "Interacted Play at Home Screen", messages, [
        {id: "2da5NLAEc", name: "Game Type", value: properties.gameType},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Play at Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Play at Home Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Grade": properties.grade,
          "Clicked On": properties.clickedOn,
          "From": properties.from,
          "Game Type": properties.gameType,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "y8-IlQJMaF", "08b634744f50fdcba3bc31235dc7749b9e0846513018d7cb514c848a58fbdf9d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Play at Home Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Grade": properties.grade,
      "Clicked On": properties.clickedOn,
      "From": properties.from,
      "Game Type": properties.gameType,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Locked Games: When the user views the locked games, fire this event.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DtQdokH62D}
   */
  function viewedLockedGames(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Locked Games", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DtQdokH62D", "b365e5dd8dfbebe94780325d6ad723384322d83c9dd0d328033fe5d3a03624f9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Locked Games", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DtQdokH62D", "Viewed Locked Games", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Locked Games': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Locked Games", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "DtQdokH62D", "b365e5dd8dfbebe94780325d6ad723384322d83c9dd0d328033fe5d3a03624f9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Locked Games", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed COQ Opt-in Screen: When the user lands on the opt-in screen for child onboarding questions
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3IE94Ton2w/trigger/LUXVamtx0
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3IE94Ton2w}
   */
  function viewedCoqOptInScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed COQ Opt-in Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3IE94Ton2w", "683db18c46954e9e3a935a1914a038ab932bc554a925d1750eeb3dfcbbd52867", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed COQ Opt-in Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3IE94Ton2w", "Viewed COQ Opt-in Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed COQ Opt-in Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed COQ Opt-in Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "3IE94Ton2w", "683db18c46954e9e3a935a1914a038ab932bc554a925d1750eeb3dfcbbd52867");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed COQ Opt-in Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted COQ Opt-in Screen: When user clicks on either of the CTAs on the opt-in screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Pq3nODzOi_/trigger/qf8U-viRI
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Pq3nODzOi_}
   */
  function interactedCoqOptInScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted COQ Opt-in Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Pq3nODzOi_", "ff586704ee189cea677b9c25a012e4b372a8c051d7b6ea8ac103c8310f0e1961", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted COQ Opt-in Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Pq3nODzOi_", "Interacted COQ Opt-in Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted COQ Opt-in Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted COQ Opt-in Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "Pq3nODzOi_", "ff586704ee189cea677b9c25a012e4b372a8c051d7b6ea8ac103c8310f0e1961");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted COQ Opt-in Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Class Won SpringBoard Certificate: This event will be triggered for every certificate win by a class.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10.
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IBD4E9C15k}
   */
  function classWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Won SpringBoard Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classId",
        "certificateName",
        "springboardWeek",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IBD4E9C15k", "8c94c474249374a4cdd0f855d83b80c3add1a1b47e06fd169a735eff697c9b72", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Class Won SpringBoard Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class ID": properties.classId,
        "Certificate Name": properties.certificateName,
        "Springboard Week": properties.springboardWeek,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IBD4E9C15k", "Class Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Won SpringBoard Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class ID": properties.classId,
          "Certificate Name": properties.certificateName,
          "Springboard Week": properties.springboardWeek,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "IBD4E9C15k", "8c94c474249374a4cdd0f855d83b80c3add1a1b47e06fd169a735eff697c9b72");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Won SpringBoard Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class ID": properties.classId,
      "Certificate Name": properties.certificateName,
      "Springboard Week": properties.springboardWeek,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Student Won SpringBoard Certificate: Student’s class winning a certificate - This event will be triggered for every certificate win for the corresponding PTL parent.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.studentName - This will capture the name of the student in the corresponding certificate winning class.
The format will be <FirstName> <LastName>. Example, Tim Cook
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.className - The name of the class that is kept by the teacher.
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10.
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XygholF2Ev}
   */
  function studentWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertStudentName(properties.studentName));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Student Won SpringBoard Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "studentName",
        "classId",
        "className",
        "certificateName",
        "springboardWeek",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XygholF2Ev", "ce9b5ce843548ebd5b729a6b4752db15a4701b57872cacd84b866e67949d0fd1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Student Won SpringBoard Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Student Name": properties.studentName,
        "Class ID": properties.classId,
        "Class Name": properties.className,
        "Certificate Name": properties.certificateName,
        "Springboard Week": properties.springboardWeek,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XygholF2Ev", "Student Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ptvPVC2md", name: "Student Name", value: properties.studentName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Student Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Student Won SpringBoard Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Student Name": properties.studentName,
          "Class ID": properties.classId,
          "Class Name": properties.className,
          "Certificate Name": properties.certificateName,
          "Springboard Week": properties.springboardWeek,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "XygholF2Ev", "ce9b5ce843548ebd5b729a6b4752db15a4701b57872cacd84b866e67949d0fd1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Student Won SpringBoard Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Student Name": properties.studentName,
      "Class ID": properties.classId,
      "Class Name": properties.className,
      "Certificate Name": properties.certificateName,
      "Springboard Week": properties.springboardWeek,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Class Almost Won SpringBoard Certificate: Class almost winning a certificate - This event will be triggered for every almost certificate win.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.className - The name of the class that is kept by the teacher.
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10.
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EpbNem_fmV}
   */
  function classAlmostWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Class Almost Won SpringBoard Certificate", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classId",
        "className",
        "certificateName",
        "springboardWeek",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EpbNem_fmV", "429cd9729004bc1d838d10f30660526551df24452da4b0a3a6c7c8bd8f2f61de", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Class Almost Won SpringBoard Certificate", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class ID": properties.classId,
        "Class Name": properties.className,
        "Certificate Name": properties.certificateName,
        "Springboard Week": properties.springboardWeek,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EpbNem_fmV", "Class Almost Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Class Almost Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Class Almost Won SpringBoard Certificate", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class ID": properties.classId,
          "Class Name": properties.className,
          "Certificate Name": properties.certificateName,
          "Springboard Week": properties.springboardWeek,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "EpbNem_fmV", "429cd9729004bc1d838d10f30660526551df24452da4b0a3a6c7c8bd8f2f61de");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Class Almost Won SpringBoard Certificate", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class ID": properties.classId,
      "Class Name": properties.className,
      "Certificate Name": properties.certificateName,
      "Springboard Week": properties.springboardWeek,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Student Almost Won SpringBoard Certificate: Student’s class almost winning a certificate - This event will be triggered for every almost certificate winning for the corresponding PTL parent.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.springboardWeek - Springboard Week - Springboard is a 10 week big competition. This event property highlights which week of the Springboard. Values will be Week1, Week2, Week3, Week4 so on and so forth till Week10.
   * @param {string} properties.studentName - This will capture the name of the student in the corresponding certificate winning class.
The format will be <FirstName> <LastName>. Example, Tim Cook
   * @param {string} properties.classId - This captures the Analytics ID of the class for which this event is fired.
   * @param {string} properties.className - The name of the class that is kept by the teacher.
   * @param {string} properties.certificateName - This is the name of the certificate.
   * @param {string} properties.url - This will capture the URL of the certificates tab on the Springboard page for that particuar class
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dP2mhePeMZ}
   */
  function studentAlmostWonSpringboardCertificate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertSpringboardWeek(properties.springboardWeek));
      messages = messages.concat(assertStudentName(properties.studentName));
      messages = messages.concat(assertClassID(properties.classId));
      messages = messages.concat(assertClassName(properties.className));
      messages = messages.concat(assertCertificateName(properties.certificateName));
      messages = messages.concat(assertUrl(properties.url));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Student Almost Won SpringBoard Certificate", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "springboardWeek",
        "studentName",
        "classId",
        "className",
        "certificateName",
        "url"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dP2mhePeMZ", "276dd626825885b9c365d9383c6d20fc5b3865780f7c189d855148bd5a43bd94", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Student Almost Won SpringBoard Certificate", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Springboard Week": properties.springboardWeek,
        "Student Name": properties.studentName,
        "Class ID": properties.classId,
        "Class Name": properties.className,
        "Certificate Name": properties.certificateName,
        "Url": properties.url,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dP2mhePeMZ", "Student Almost Won SpringBoard Certificate", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "9dTrjsxjG", name: "Class Name", value: properties.className},
        {id: "MfWi2aBDZ", name: "Certificate Name", value: properties.certificateName},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "ToCgaA4KN", name: "Url", value: properties.url},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "ptvPVC2md", name: "Student Name", value: properties.studentName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "tmoviENyM", name: "Class ID", value: properties.classId},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "wZVJV2Yc5", name: "Springboard Week", value: properties.springboardWeek},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Student Almost Won SpringBoard Certificate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Student Almost Won SpringBoard Certificate", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Springboard Week": properties.springboardWeek,
          "Student Name": properties.studentName,
          "Class ID": properties.classId,
          "Class Name": properties.className,
          "Certificate Name": properties.certificateName,
          "Url": properties.url,
          "Screen Height": sysScreenHeight,
          }, "dP2mhePeMZ", "276dd626825885b9c365d9383c6d20fc5b3865780f7c189d855148bd5a43bd94");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Student Almost Won SpringBoard Certificate", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Springboard Week": properties.springboardWeek,
      "Student Name": properties.studentName,
      "Class ID": properties.classId,
      "Class Name": properties.className,
      "Certificate Name": properties.certificateName,
      "Url": properties.url,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed CG Summary: When user views CG summary popup
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fVdu6ukCiQ/trigger/pX1ug9ZeG
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Name of content group user clicked/tapped on
   * @param {int} properties.milestoneSelected - Milestone selected by the user
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fVdu6ukCiQ}
   */
  function viewedCgSummary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertMilestoneSelected(properties.milestoneSelected));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed CG Summary", Object.keys(properties), [
        "grade",
        "contentGroup",
        "milestoneSelected",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fVdu6ukCiQ", "f7c85de4d80fdac7642f3597561436be11784ea95e6b9c25ee7c9da9592af10b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed CG Summary", {
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "Milestone Selected": properties.milestoneSelected,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fVdu6ukCiQ", "Viewed CG Summary", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "iMRbxEjXB", name: "Milestone Selected", value: properties.milestoneSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed CG Summary': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed CG Summary", {
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "Milestone Selected": properties.milestoneSelected,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "fVdu6ukCiQ", "f7c85de4d80fdac7642f3597561436be11784ea95e6b9c25ee7c9da9592af10b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed CG Summary", {
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "Milestone Selected": properties.milestoneSelected,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted CG Summary: When user interacts with CG summary popup
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Name of content group user clicked/tapped on
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ecuxUAM8_l}
   */
  function interactedCgSummary(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted CG Summary", Object.keys(properties), [
        "grade",
        "contentGroup",
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ecuxUAM8_l", "76543c40fdb7f2503bd358d3cc7d509aa7913cb3ca068ab949c3827fc9a37b78", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted CG Summary", {
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ecuxUAM8_l", "Interacted CG Summary", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted CG Summary': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted CG Summary", {
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "ecuxUAM8_l", "76543c40fdb7f2503bd358d3cc7d509aa7913cb3ca068ab949c3827fc9a37b78");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted CG Summary", {
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed CG Milestones: When user sees CG with milestone view allowing them to change the milestone
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Name of content group user clicked/tapped on
   * @param {int} properties.milestoneSelected - Milestone selected by the user
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/EWDqf--wkG}
   */
  function viewedCgMilestones(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertMilestoneSelected(properties.milestoneSelected));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed CG Milestones", Object.keys(properties), [
        "grade",
        "contentGroup",
        "milestoneSelected",
        "from",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "EWDqf--wkG", "16480e50150f965d4eb51752578231fece5d880118171dc2d0dbcb7bb6f10f8e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed CG Milestones", {
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "Milestone Selected": properties.milestoneSelected,
        "From": properties.from,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("EWDqf--wkG", "Viewed CG Milestones", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "iMRbxEjXB", name: "Milestone Selected", value: properties.milestoneSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed CG Milestones': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed CG Milestones", {
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "Milestone Selected": properties.milestoneSelected,
          "From": properties.from,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "EWDqf--wkG", "16480e50150f965d4eb51752578231fece5d880118171dc2d0dbcb7bb6f10f8e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed CG Milestones", {
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "Milestone Selected": properties.milestoneSelected,
      "From": properties.from,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted CG Milestones: When user interacts with CG milestone page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} [properties.recommendedMilestone] - The recommended milestone inside a CG
   * @param {int} [properties.selectedMilestone] - Milestone selected by user inside a CG
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.contentGroup - Name of content group user clicked/tapped on
   * @param {string} [properties.newGradeSelected] - The grade selected when user changes grade
   * @param {string} [properties.milestoneChanged] - When user changes milestone in a CG
   * @param {string} [properties.gradeChanged] - Binary property if user has changed grade - Yes/No
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UUMDHSB3i7}
   */
  function interactedCgMilestones(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalRecommendedMilestone(properties.recommendedMilestone));
      messages = messages.concat(assertOptionalSelectedMilestone(properties.selectedMilestone));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertContentGroup(properties.contentGroup));
      messages = messages.concat(assertOptionalNewGradeSelected(properties.newGradeSelected));
      messages = messages.concat(assertOptionalMilestoneChanged(properties.milestoneChanged));
      messages = messages.concat(assertOptionalGradeChanged(properties.gradeChanged));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted CG Milestones", Object.keys(properties), [
        "recommendedMilestone",
        "selectedMilestone",
        "grade",
        "contentGroup",
        "newGradeSelected",
        "milestoneChanged",
        "gradeChanged",
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UUMDHSB3i7", "03a369a428d5a665863e285f2ba7ee0340edad32fe6adccca249b889234ece19", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted CG Milestones", {
        "Recommended Milestone": properties.recommendedMilestone,
        "Selected Milestone": properties.selectedMilestone,
        "Grade": properties.grade,
        "Content Group": properties.contentGroup,
        "New Grade Selected": properties.newGradeSelected,
        "Milestone Changed": properties.milestoneChanged,
        "Grade Changed": properties.gradeChanged,
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UUMDHSB3i7", "Interacted CG Milestones", messages, [
        {id: "-8NMIzT9n", name: "Milestone Changed", value: properties.milestoneChanged},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "ACsEf3MYO", name: "Recommended Milestone", value: properties.recommendedMilestone},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "J8GQmfwD7", name: "Selected Milestone", value: properties.selectedMilestone},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "Tps4I1ukM", name: "New Grade Selected", value: properties.newGradeSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vbOzDO_fd", name: "Grade Changed", value: properties.gradeChanged},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted CG Milestones': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted CG Milestones", {
          "Recommended Milestone": properties.recommendedMilestone,
          "Selected Milestone": properties.selectedMilestone,
          "Grade": properties.grade,
          "Content Group": properties.contentGroup,
          "New Grade Selected": properties.newGradeSelected,
          "Milestone Changed": properties.milestoneChanged,
          "Grade Changed": properties.gradeChanged,
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UUMDHSB3i7", "03a369a428d5a665863e285f2ba7ee0340edad32fe6adccca249b889234ece19");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted CG Milestones", {
      "Recommended Milestone": properties.recommendedMilestone,
      "Selected Milestone": properties.selectedMilestone,
      "Grade": properties.grade,
      "Content Group": properties.contentGroup,
      "New Grade Selected": properties.newGradeSelected,
      "Milestone Changed": properties.milestoneChanged,
      "Grade Changed": properties.gradeChanged,
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Scrolled Student Dashboard: When user scrolls past a specific rail on category expansion dashboard
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.recommendedRailName - This is the name of the rail viewed by the user.
Recommended rail property comes with rail name and rail rank, pipe separated - with the introduction of this property, we intend to separate rail name to calculate CTR on Mixpanel.
   * @param {int} properties.recommendedRailRank - Recommended Rail Rank will carry the rank of the rail in integer format viewed by the user.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6ZqAqPvMJn}
   */
  function scrolledStudentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertRecommendedRailName(properties.recommendedRailName));
      messages = messages.concat(assertRecommendedRailRank(properties.recommendedRailRank));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Scrolled Student Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "recommendedRail",
        "grade",
        "recommendedRailName",
        "recommendedRailRank",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6ZqAqPvMJn", "aa63a2664d07e5ad5daec8ee3b409768e657eae706fe56e7c1be5f36302f2c5f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Scrolled Student Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Recommended Rail": properties.recommendedRail,
        "Grade": properties.grade,
        "Recommended Rail Name": properties.recommendedRailName,
        "Recommended Rail Rank": properties.recommendedRailRank,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6ZqAqPvMJn", "Scrolled Student Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "6lrsWYY5Y", name: "Recommended Rail Name", value: properties.recommendedRailName},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "uyLgqxbg7", name: "Recommended Rail Rank", value: properties.recommendedRailRank},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Scrolled Student Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled Student Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Recommended Rail": properties.recommendedRail,
          "Grade": properties.grade,
          "Recommended Rail Name": properties.recommendedRailName,
          "Recommended Rail Rank": properties.recommendedRailRank,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "6ZqAqPvMJn", "aa63a2664d07e5ad5daec8ee3b409768e657eae706fe56e7c1be5f36302f2c5f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Scrolled Student Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Recommended Rail": properties.recommendedRail,
      "Grade": properties.grade,
      "Recommended Rail Name": properties.recommendedRailName,
      "Recommended Rail Rank": properties.recommendedRailRank,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Started Printables Search: When user clicks on search on worksheet tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.countOfSearchResults - Count of search results shown to user
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/eA30B_iObq}
   */
  function startedPrintablesSearch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertCountOfSearchResults(properties.countOfSearchResults));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Printables Search", Object.keys(properties), [
        "searchTerm",
        "countOfSearchResults",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eA30B_iObq", "09ecb937f2a2603086c23b1bea4b4cb7b20bbe359ab0c16b216537890b9df278", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Started Printables Search", {
        "Search Term": properties.searchTerm,
        "Count of Search Results": properties.countOfSearchResults,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eA30B_iObq", "Started Printables Search", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "5OAHrQIZt", name: "Count of Search Results", value: properties.countOfSearchResults},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Printables Search': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Printables Search", {
          "Search Term": properties.searchTerm,
          "Count of Search Results": properties.countOfSearchResults,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "eA30B_iObq", "09ecb937f2a2603086c23b1bea4b4cb7b20bbe359ab0c16b216537890b9df278");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Printables Search", {
      "Search Term": properties.searchTerm,
      "Count of Search Results": properties.countOfSearchResults,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Selected Printables Search: When user selects a search result from worksheet search opion
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.searchResultSelected - Among the search results shown, the one selected by the user
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/8RIk7EHN2G}
   */
  function selectedPrintablesSearch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertSearchResultSelected(properties.searchResultSelected));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Selected Printables Search", Object.keys(properties), [
        "searchTerm",
        "searchResultSelected",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8RIk7EHN2G", "0c53c980bfbbc72b547b81a78de5c322784afbdc4fab34e10a61e0d960e50fc1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Selected Printables Search", {
        "Search Term": properties.searchTerm,
        "Search Result Selected": properties.searchResultSelected,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8RIk7EHN2G", "Selected Printables Search", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "of6hlcB4H", name: "Search Result Selected", value: properties.searchResultSelected},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Selected Printables Search': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Selected Printables Search", {
          "Search Term": properties.searchTerm,
          "Search Result Selected": properties.searchResultSelected,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "8RIk7EHN2G", "0c53c980bfbbc72b547b81a78de5c322784afbdc4fab34e10a61e0d960e50fc1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Selected Printables Search", {
      "Search Term": properties.searchTerm,
      "Search Result Selected": properties.searchResultSelected,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Printables Filters: When user interacts with left hand side filter menu on worksheet tab
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.newTopicSelected - new topic selected by user
   * @param {string} properties.newGradeSelected - The grade selected when user changes grade
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/JW2wyw-UAW}
   */
  function interactedPrintablesFilters(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertNewTopicSelected(properties.newTopicSelected));
      messages = messages.concat(assertNewGradeSelected(properties.newGradeSelected));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Printables Filters", Object.keys(properties), [
        "grade",
        "newTopicSelected",
        "newGradeSelected",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "JW2wyw-UAW", "002d15729e39a8306ded7741c6adf8f48e2e1f2248f9a995b82f9ad73cf01a86", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Printables Filters", {
        "Grade": properties.grade,
        "New Topic Selected": properties.newTopicSelected,
        "New Grade Selected": properties.newGradeSelected,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("JW2wyw-UAW", "Interacted Printables Filters", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "HkxSt1enX", name: "New Topic Selected", value: properties.newTopicSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Tps4I1ukM", name: "New Grade Selected", value: properties.newGradeSelected},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Printables Filters': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Printables Filters", {
          "Grade": properties.grade,
          "New Topic Selected": properties.newTopicSelected,
          "New Grade Selected": properties.newGradeSelected,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "JW2wyw-UAW", "002d15729e39a8306ded7741c6adf8f48e2e1f2248f9a995b82f9ad73cf01a86");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Printables Filters", {
      "Grade": properties.grade,
      "New Topic Selected": properties.newTopicSelected,
      "New Grade Selected": properties.newGradeSelected,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Share Discount Banner: This event will be fired when the teacher views the 'Share Offer with Parents' discount banner on the Teacher Dashboard. This same event will be fired for both Old and New Dashboard.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AdHLLMFoEj/trigger/RIuLwkiPv
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AdHLLMFoEj}
   */
  function viewedShareDiscountBanner(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Share Discount Banner", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AdHLLMFoEj", "40ad9812723bfa01fb82c8c3b2a98dfabfc24fc09c53813a2f806340dc22dcf6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Share Discount Banner", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AdHLLMFoEj", "Viewed Share Discount Banner", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Share Discount Banner': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Share Discount Banner", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "AdHLLMFoEj", "40ad9812723bfa01fb82c8c3b2a98dfabfc24fc09c53813a2f806340dc22dcf6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Share Discount Banner", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Share Discount Banner: This event will be fired when the teacher clicks on the 'Share Offer with Parents' CTA within the discount banner on both old and new dashboard.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/mTxFf80c2L}
   */
  function interactedShareDiscountBanner(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Share Discount Banner", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mTxFf80c2L", "dd503a7d7c6438a8e3c3e0cf15fbf73b40d6d075ed79917c25fa4f43b3ddd182", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Share Discount Banner", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mTxFf80c2L", "Interacted Share Discount Banner", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Share Discount Banner': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Share Discount Banner", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "mTxFf80c2L", "dd503a7d7c6438a8e3c3e0cf15fbf73b40d6d075ed79917c25fa4f43b3ddd182");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Share Discount Banner", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Certificate Tab on Parent Dashboard: This event will be fired when the user views the certificate tab on the parent dashboard.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IbVXzhz8XC}
   */
  function viewedCertificateTabOnParentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Certificate Tab on Parent Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IbVXzhz8XC", "52123598f7cb68b44b7d32e747eedc79cc28f9a624562a76715c03cccccf5ab9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Certificate Tab on Parent Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IbVXzhz8XC", "Viewed Certificate Tab on Parent Dashboard", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Certificate Tab on Parent Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Certificate Tab on Parent Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "IbVXzhz8XC", "52123598f7cb68b44b7d32e747eedc79cc28f9a624562a76715c03cccccf5ab9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Certificate Tab on Parent Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Certificate Tab on Parent Dashboard: This event will be fired when the parent clicks anywhere within the certificate tab on parent dashboard.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ah7JV79-nd}
   */
  function interactedCertificateTabOnParentDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Certificate Tab on Parent Dashboard", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ah7JV79-nd", "c3a3483f5834060efb8039f1ef6816d9af48e6e848ea0e30042dc450d558b6e4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Certificate Tab on Parent Dashboard", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ah7JV79-nd", "Interacted Certificate Tab on Parent Dashboard", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Certificate Tab on Parent Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Certificate Tab on Parent Dashboard", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Ah7JV79-nd", "c3a3483f5834060efb8039f1ef6816d9af48e6e848ea0e30042dc450d558b6e4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Certificate Tab on Parent Dashboard", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed School Home Screen: Viewed School Home Screen when the new home school screen is shown to the student post class code login
   *
   * When to trigger this event:
   * 1. Class Code Login
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZdYSp6a9q_/trigger/YS_WL1usG
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.enabledCta - Enabled CTA - there will be only one enabled CTA among  "Play at School" or "Play at Home". Please send one of these two values as per the frontend visibility of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZdYSp6a9q_}
   */
  function viewedSchoolHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertEnabledCTA(properties.enabledCta));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed School Home Screen", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "enabledCta",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZdYSp6a9q_", "f2bf0465f08620d2f2d9653bda1928b6a02ec554c6b9e5bdea16da9648991a7e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed School Home Screen", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Enabled CTA": properties.enabledCta,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZdYSp6a9q_", "Viewed School Home Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Nspz0JPS5", name: "Enabled CTA", value: properties.enabledCta},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed School Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed School Home Screen", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Enabled CTA": properties.enabledCta,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "ZdYSp6a9q_", "f2bf0465f08620d2f2d9653bda1928b6a02ec554c6b9e5bdea16da9648991a7e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed School Home Screen", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Enabled CTA": properties.enabledCta,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted School Home Screen: When the user interacts the  School Home Screen. This event is fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HrzpJtS4Xl}
   */
  function interactedSchoolHomeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted School Home Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HrzpJtS4Xl", "e7d0aa577d7059801201983f70acabacab0a7b8139f17cc5ec709df82f4ddeb5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted School Home Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HrzpJtS4Xl", "Interacted School Home Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted School Home Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted School Home Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "HrzpJtS4Xl", "e7d0aa577d7059801201983f70acabacab0a7b8139f17cc5ec709df82f4ddeb5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted School Home Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Summer Learning Offer Page: When the user views the summer learning offer page, this event needs to be fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yYvNfVbULF}
   */
  function viewedSummerLearningOfferPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Summer Learning Offer Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yYvNfVbULF", "629d820e6b6333ea667f807470de317bc4475fef8a0a9d731995161e8b1d3b48", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Summer Learning Offer Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yYvNfVbULF", "Viewed Summer Learning Offer Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Summer Learning Offer Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Summer Learning Offer Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "yYvNfVbULF", "629d820e6b6333ea667f807470de317bc4475fef8a0a9d731995161e8b1d3b48");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Summer Learning Offer Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Summer Learning Offer Page: When the teacher interacts with the summer learning offer page. This event needs to be fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qORxYUaHGd}
   */
  function interactedSummerLearningOfferPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Summer Learning Offer Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qORxYUaHGd", "a3d8d3d0ef16254b1c6f82f701f9b80a80746f03e99a777762d18fbc80d2451b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Summer Learning Offer Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qORxYUaHGd", "Interacted Summer Learning Offer Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Summer Learning Offer Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Summer Learning Offer Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "qORxYUaHGd", "a3d8d3d0ef16254b1c6f82f701f9b80a80746f03e99a777762d18fbc80d2451b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Summer Learning Offer Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Summer Learning Pop-Up: When the user views the summer learning pop-up
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VZVDniOWMH}
   */
  function viewedSummerLearningPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Summer Learning Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VZVDniOWMH", "a9f91887a8e4c4c2fd6edd2434decb55077a553172e92e3b7193bb8cd21f8707", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Summer Learning Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VZVDniOWMH", "Viewed Summer Learning Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Summer Learning Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Summer Learning Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "VZVDniOWMH", "a9f91887a8e4c4c2fd6edd2434decb55077a553172e92e3b7193bb8cd21f8707");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Summer Learning Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Summer Learning Pop-Up: When the teacher interacts summer learning pop-up, this event should be fired.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hn6Qf1B9-I}
   */
  function interactedSummerLearningPopUp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Summer Learning Pop-Up", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hn6Qf1B9-I", "b6ba217299419de81cb4097aaf3d87da85d356453393478d0d5643594e36319f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Summer Learning Pop-Up", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hn6Qf1B9-I", "Interacted Summer Learning Pop-Up", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Summer Learning Pop-Up': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Summer Learning Pop-Up", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "hn6Qf1B9-I", "b6ba217299419de81cb4097aaf3d87da85d356453393478d0d5643594e36319f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Summer Learning Pop-Up", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Parental Gate Failed: When parental gate input is incorrect (most likely a child trying to cross parental gate)
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Qmv1CkV1L}
   */
  function parentalGateFailed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Parental Gate Failed", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Qmv1CkV1L", "88eb816471976c49a6af00866dda54e6337323b10d65430395401e55d7e5de91", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Parental Gate Failed", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Qmv1CkV1L", "Parental Gate Failed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Parental Gate Failed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Parental Gate Failed", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "Qmv1CkV1L", "88eb816471976c49a6af00866dda54e6337323b10d65430395401e55d7e5de91");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Parental Gate Failed", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Parental Gate Closed: When user closes the parental age gate
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/l2q7UIjjd5}
   */
  function parentalGateClosed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Parental Gate Closed", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "l2q7UIjjd5", "418357b5f281f60da3fd820874d3c70138ad03e9c911c423de8bf64e75c96c33", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Parental Gate Closed", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("l2q7UIjjd5", "Parental Gate Closed", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Parental Gate Closed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Parental Gate Closed", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "l2q7UIjjd5", "418357b5f281f60da3fd820874d3c70138ad03e9c911c423de8bf64e75c96c33");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Parental Gate Closed", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Login Screen: This will be triggered when the user interacts with the login screen. This is the common screen for both teachers and parents.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FKR7fPjHu/trigger/WrldwVl0Z
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FKR7fPjHu}
   */
  function interactedLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FKR7fPjHu", "eec096e94c67680d9b2517a4f652bfaa975f2b87f265a6526d14b02af3b4ae7f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FKR7fPjHu", "Interacted Login Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "FKR7fPjHu", "eec096e94c67680d9b2517a4f652bfaa975f2b87f265a6526d14b02af3b4ae7f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Classroom Linked Login Screen: This event will be triggered when the parent lands on the classroom linked login screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aHvXCBpU6O/trigger/7bcFj4gMW
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/aHvXCBpU6O}
   */
  function viewedClassroomLinkedLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Classroom Linked Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aHvXCBpU6O", "4b004970c09fab128d38aec71a1280c77478eda0839b6bf3f2bbac087c26078b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Classroom Linked Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aHvXCBpU6O", "Viewed Classroom Linked Login Screen", messages, [
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Classroom Linked Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Classroom Linked Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "aHvXCBpU6O", "4b004970c09fab128d38aec71a1280c77478eda0839b6bf3f2bbac087c26078b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Classroom Linked Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Classroom Linked Login Screen: This event will be triggered when the parent interacts anywhere with the classroom linked login screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RCKPe0105u/trigger/SIMjpPGiV
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RCKPe0105u}
   */
  function interactedClassroomLinkedLoginScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Classroom Linked Login Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RCKPe0105u", "5daf15a9f8ae04948ffd6d24d7515c2fc998595677cb1e147d262f9b9910a013", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Classroom Linked Login Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RCKPe0105u", "Interacted Classroom Linked Login Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Classroom Linked Login Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Classroom Linked Login Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "RCKPe0105u", "5daf15a9f8ae04948ffd6d24d7515c2fc998595677cb1e147d262f9b9910a013");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Classroom Linked Login Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Login via OTP by Classroom Linked Parent: This event will be triggered when the parent lands on the Login via OTP screen from classroom linked login screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rMZhC6EfL5/trigger/9NJGmaAI1
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/rMZhC6EfL5}
   */
  function viewedLoginViaOtpByClassroomLinkedParent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Login via OTP by Classroom Linked Parent", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "rMZhC6EfL5", "4cb1e89fdb5cc102069ed9c310c975425001953f4000f6da999709358365c69b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Login via OTP by Classroom Linked Parent", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("rMZhC6EfL5", "Viewed Login via OTP by Classroom Linked Parent", messages, [
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Login via OTP by Classroom Linked Parent': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Login via OTP by Classroom Linked Parent", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "rMZhC6EfL5", "4cb1e89fdb5cc102069ed9c310c975425001953f4000f6da999709358365c69b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Login via OTP by Classroom Linked Parent", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Login via OTP by Classroom Linked Parent: This event will be triggered when the parent interacts with the Login via OTP screen from classroom linked login screen.

   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ZKCbGW0PE/trigger/N2bPH_ftR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {bool} [properties.otpEntered] - This will capture if the user has entered the OTP or not.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ZKCbGW0PE}
   */
  function interactedLoginViaOtpByClassroomLinkedParent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalOTPEntered(properties.otpEntered));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Login via OTP by Classroom Linked Parent", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "otpEntered"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-ZKCbGW0PE", "ccfaae4b4980c311b919ea9c528fc6922a9a7ef06202132d97621ec164d5fbb9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Login via OTP by Classroom Linked Parent", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "OTP Entered": properties.otpEntered,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-ZKCbGW0PE", "Interacted Login via OTP by Classroom Linked Parent", messages, [
        {id: "KQDoDel93", name: "OTP Entered", value: properties.otpEntered},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Login via OTP by Classroom Linked Parent': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Login via OTP by Classroom Linked Parent", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "OTP Entered": properties.otpEntered,
          "Screen Height": sysScreenHeight,
          }, "-ZKCbGW0PE", "ccfaae4b4980c311b919ea9c528fc6922a9a7ef06202132d97621ec164d5fbb9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Login via OTP by Classroom Linked Parent", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "OTP Entered": properties.otpEntered,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Profile Icon: This should get fired as soon as the user clicks on any of the menu items within the Profile icon on teacher dashboard.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NVJNhPJMZ8/trigger/6D7XQqeWd
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NVJNhPJMZ8}
   */
  function interactedProfileIcon(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Profile Icon", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NVJNhPJMZ8", "7caadd3c661a8ad5fe122a35f4f76c565bb04d2e5727bf73eead9485a4557260", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Profile Icon", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NVJNhPJMZ8", "Interacted Profile Icon", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Profile Icon': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Profile Icon", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "NVJNhPJMZ8", "7caadd3c661a8ad5fe122a35f4f76c565bb04d2e5727bf73eead9485a4557260");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Profile Icon", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Co-Teacher Coachmark: This event will be fired when the user views the co-teacher coachmark (which will appear for the first time when the user logs into Splashlearn after this feature is launched)
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4_4PZq37WD/trigger/x_TWQs9U4
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4_4PZq37WD}
   */
  function viewedCoTeacherCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Co-Teacher Coachmark", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4_4PZq37WD", "c44b7d90a92fcf1f3c62e60059c87bc244b2fd09f920aa186ed5e14ba724bba3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Co-Teacher Coachmark", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4_4PZq37WD", "Viewed Co-Teacher Coachmark", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Co-Teacher Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Co-Teacher Coachmark", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "4_4PZq37WD", "c44b7d90a92fcf1f3c62e60059c87bc244b2fd09f920aa186ed5e14ba724bba3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Co-Teacher Coachmark", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Co-Teacher Coachmark: This event will be fired when the user interacts with the co-teacher coachmark. The user has only 1 action - clicked on 'OK'
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SIto3IxboY}
   */
  function interactedCoTeacherCoachmark(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Co-Teacher Coachmark", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SIto3IxboY", "2b8782e8099080acc45b787494865791bd32c18293e104d0af5b85277cd2ee61", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Co-Teacher Coachmark", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SIto3IxboY", "Interacted Co-Teacher Coachmark", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Co-Teacher Coachmark': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Co-Teacher Coachmark", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "SIto3IxboY", "2b8782e8099080acc45b787494865791bd32c18293e104d0af5b85277cd2ee61");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Co-Teacher Coachmark", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Manage All Classes Page: This event will be fired when the user lands on the 'Manage All Classes' page
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0pDlwx_5V_/trigger/wnEOT7UUp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0pDlwx_5V_}
   */
  function viewedManageAllClassesPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Manage All Classes Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0pDlwx_5V_", "91a02ec7357f3b9f0ef09e7f4d2e068c803e473fcb4cc0897d755c1870d6f810", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Manage All Classes Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0pDlwx_5V_", "Viewed Manage All Classes Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Manage All Classes Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Manage All Classes Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "0pDlwx_5V_", "91a02ec7357f3b9f0ef09e7f4d2e068c803e473fcb4cc0897d755c1870d6f810");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Manage All Classes Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Manage All Classes Page: This event will be fired when the user interacts with the 'Manage All Classes' page
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7g3VpL-frV}
   */
  function interactedManageAllClassesPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Manage All Classes Page", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7g3VpL-frV", "ecbc5812d2b2291b9dc7ad3960aa66c4cde89bb1fe2e87a6f5a3ba3d574a1e97", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Manage All Classes Page", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7g3VpL-frV", "Interacted Manage All Classes Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Manage All Classes Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Manage All Classes Page", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "7g3VpL-frV", "ecbc5812d2b2291b9dc7ad3960aa66c4cde89bb1fe2e87a6f5a3ba3d574a1e97");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Manage All Classes Page", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Add Co-Teacher Popup: This event will be fired when the user views the pop-up to enter the email of a co-teacher.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UWP-jzN1JJ/trigger/-54_CE00m
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UWP-jzN1JJ}
   */
  function viewedAddCoTeacherPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add Co-Teacher Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UWP-jzN1JJ", "e7277c1d88f4800031dbdf1e22743fe5b8085f22300be7b6c51b1710e19d1d8c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Add Co-Teacher Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UWP-jzN1JJ", "Viewed Add Co-Teacher Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add Co-Teacher Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add Co-Teacher Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UWP-jzN1JJ", "e7277c1d88f4800031dbdf1e22743fe5b8085f22300be7b6c51b1710e19d1d8c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add Co-Teacher Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Add Co-Teacher Popup: This event will be fired when the user interacts with the add co-teacher popup
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IpIdmr17gB/trigger/LdR9uQ0tY
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IpIdmr17gB}
   */
  function interactedAddCoTeacherPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add Co-Teacher Popup", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IpIdmr17gB", "6f292adc79430507a04142ba7195ee26e552e17e716699afb0c56a2cbc7108c9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Add Co-Teacher Popup", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IpIdmr17gB", "Interacted Add Co-Teacher Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add Co-Teacher Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add Co-Teacher Popup", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "IpIdmr17gB", "6f292adc79430507a04142ba7195ee26e552e17e716699afb0c56a2cbc7108c9");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add Co-Teacher Popup", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Co-Teaching Popup by Co-Teacher: This event will be fired when the co-teachers logs in to Splashlearn and views the popup that she has been added as a co-teacher
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yavrq7zl7r/trigger/2x4uHB0ya
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yavrq7zl7r}
   */
  function viewedCoTeachingPopupByCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Co-Teaching Popup by Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yavrq7zl7r", "e00dad7c8cc68dfdc1faa4346f88620c29400faa2ebe34f5f13ecef2cd41f9cf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Co-Teaching Popup by Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yavrq7zl7r", "Viewed Co-Teaching Popup by Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Co-Teaching Popup by Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Co-Teaching Popup by Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "yavrq7zl7r", "e00dad7c8cc68dfdc1faa4346f88620c29400faa2ebe34f5f13ecef2cd41f9cf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Co-Teaching Popup by Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Co-Teaching Popup by Co-Teacher: This event will be fired when the co-teacher interacts with the popup that tells them that they have been added as a co-teacher
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xWZaSFT-z3/trigger/vrGgCR0re
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/xWZaSFT-z3}
   */
  function interactedCoTeachingPopupByCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Co-Teaching Popup by Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xWZaSFT-z3", "b23a536951d7128b2a5a1c7483c57f8274c0c5956223a669d22212e95ddbf131", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Co-Teaching Popup by Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xWZaSFT-z3", "Interacted Co-Teaching Popup by Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Co-Teaching Popup by Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Co-Teaching Popup by Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "xWZaSFT-z3", "b23a536951d7128b2a5a1c7483c57f8274c0c5956223a669d22212e95ddbf131");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Co-Teaching Popup by Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Welcome Page by Newly Created Co-Teacher: This event will be triggered when a newly created teacher signs up on Splashlearn through the 'Add Co-Teacher' email and sees the welcome screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IVdUzYlpCa/trigger/Y7KJQjcZh
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IVdUzYlpCa}
   */
  function viewedWelcomePageByNewlyCreatedCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Welcome Page by Newly Created Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IVdUzYlpCa", "9269a3a88827d86ccb61c0b75a0bd7ac7ab451cf1cc380184b5d16937e01cd50", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Welcome Page by Newly Created Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IVdUzYlpCa", "Viewed Welcome Page by Newly Created Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Welcome Page by Newly Created Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Welcome Page by Newly Created Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "IVdUzYlpCa", "9269a3a88827d86ccb61c0b75a0bd7ac7ab451cf1cc380184b5d16937e01cd50");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Welcome Page by Newly Created Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Welcome Page by Newly Created Co-Teacher: This event will be triggered when a newly created teacher signs up on Splashlearn through the 'Add Co-Teacher' email and interacts with the welcome screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Apma_4NY8E/trigger/oMNnkRlz_
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Apma_4NY8E}
   */
  function interactedWelcomePageByNewlyCreatedCoTeacher(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Welcome Page by Newly Created Co-Teacher", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Apma_4NY8E", "c44a8ee11bf7c78cb4c17480b00d3806486f3ede7641081f3b96a8921a67bdb0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Welcome Page by Newly Created Co-Teacher", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Apma_4NY8E", "Interacted Welcome Page by Newly Created Co-Teacher", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Welcome Page by Newly Created Co-Teacher': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Welcome Page by Newly Created Co-Teacher", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Apma_4NY8E", "c44a8ee11bf7c78cb4c17480b00d3806486f3ede7641081f3b96a8921a67bdb0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Welcome Page by Newly Created Co-Teacher", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Summer Bundle Widget on Dashboard: This event will be fired when the teacher views the summer activity bundle from teacher dashboard or summer learning page.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZwMFD4pV/trigger/KTen6tgcw
   * 2.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZwMFD4pV/trigger/gIxGgeK0K
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZwMFD4pV}
   */
  function viewedSummerBundleWidgetOnDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Summer Bundle Widget on Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lZwMFD4pV", "80e3af4ab5691278d410dc606884cb6d5fa103306d83a5b7bea6e0b4f8cee538", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Summer Bundle Widget on Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lZwMFD4pV", "Viewed Summer Bundle Widget on Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Summer Bundle Widget on Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Summer Bundle Widget on Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "lZwMFD4pV", "80e3af4ab5691278d410dc606884cb6d5fa103306d83a5b7bea6e0b4f8cee538");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Summer Bundle Widget on Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Summer Bundle Widget on Dashboard: This event will be fired when the user clicks anywhere on the summer bundle from the Dashboard or Summer Learning Page
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/asUSLvDngp/trigger/UGKMiQTf6
   * 2.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/asUSLvDngp/trigger/uyemAmxbf
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/asUSLvDngp}
   */
  function interactedSummerBundleWidgetOnDashboard(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Summer Bundle Widget on Dashboard", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "asUSLvDngp", "633060d5c701597ef866407f49171b0a80c67360939d67685268ce4716ef2747", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Summer Bundle Widget on Dashboard", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("asUSLvDngp", "Interacted Summer Bundle Widget on Dashboard", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Summer Bundle Widget on Dashboard': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Summer Bundle Widget on Dashboard", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "asUSLvDngp", "633060d5c701597ef866407f49171b0a80c67360939d67685268ce4716ef2747");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Summer Bundle Widget on Dashboard", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Clicked Support: Adding support options in the drawer after user interacts with parent button on web and menu on iphone/ipad
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b7Fowsgevb}
   */
  function clickedSupport(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked Support", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "b7Fowsgevb", "a3ddbf4e43b5be5f766b7acf3a5eaf65cc603668abd583a940328d7f825a8d64", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Clicked Support", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("b7Fowsgevb", "Clicked Support", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked Support': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked Support", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "b7Fowsgevb", "a3ddbf4e43b5be5f766b7acf3a5eaf65cc603668abd583a940328d7f825a8d64");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked Support", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Visited All Plans Page: When the user views all the plans
   *
   * When to trigger this event:
   * 1. When the user lands on the plans page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b7-QDNo3YF/trigger/u_9cq7KU4
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.freeActivitiesLeftCount - Stores the number of free activities left for the user to play on a particular day, at that moment

   * @param {Array<string>} [properties.subscriptionPlansShown] - Stores which plans were shown on the plan page.
Possible values are (Premium, Premium Live)
   * @param {Array<string>} [properties.subscriptionPlanStartsFromAmount] - Stores the 'Start from $ amount' shown to the user on each plan, on the Plan page.
   * @param {string} [properties.freeWorksheetsLeftCount] - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   * @param {string} [properties.discountOfferingCodeApplied] - For users opening the plan page after clicking on a CRM campaign email link, this property stores the coupon-code which was applied for the user.
   * @param {string} [properties.discountType] - Can take the value "First-time" or "Perpetual" to indicate the number of cycles for which the discount is applied.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/b7-QDNo3YF}
   */
  function visitedAllPlansPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFreeActivitiesLeftCount(properties.freeActivitiesLeftCount));
      messages = messages.concat(assertOptionalSubscriptionPlansShown(properties.subscriptionPlansShown));
      messages = messages.concat(assertOptionalSubscriptionPlanStartsFromAmount(properties.subscriptionPlanStartsFromAmount));
      messages = messages.concat(assertOptionalFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertOptionalDiscountOfferingCodeApplied(properties.discountOfferingCodeApplied));
      messages = messages.concat(assertOptionalDiscountType(properties.discountType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited All Plans Page", Object.keys(properties), [
        "freeActivitiesLeftCount",
        "subscriptionPlansShown",
        "subscriptionPlanStartsFromAmount",
        "freeWorksheetsLeftCount",
        "discountOfferingCodeApplied",
        "discountType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "b7-QDNo3YF", "16c0c64f377022007d23999143bc6e6d4d8dc1915154ffd7aa8f2506d13d37fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Visited All Plans Page", {
        "Free Activities Left Count": properties.freeActivitiesLeftCount,
        "Subscription Plans Shown": properties.subscriptionPlansShown,
        "Subscription Plan Starts From Amount": properties.subscriptionPlanStartsFromAmount,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Discount Offering Code Applied": properties.discountOfferingCodeApplied,
        "Discount Type": properties.discountType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("b7-QDNo3YF", "Visited All Plans Page", messages, [
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "VUkpaROVL", name: "Discount Offering Code Applied", value: properties.discountOfferingCodeApplied},
        {id: "VdxNoqe4b", name: "Discount Type", value: properties.discountType},
        {id: "XIwdg9nE7", name: "Subscription Plan Starts From Amount", value: properties.subscriptionPlanStartsFromAmount},
        {id: "pJEe4G1yr", name: "Subscription Plans Shown", value: properties.subscriptionPlansShown},
        {id: "zY_qKY7KjA", name: "Free Activities Left Count", value: properties.freeActivitiesLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited All Plans Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited All Plans Page", {
          "Free Activities Left Count": properties.freeActivitiesLeftCount,
          "Subscription Plans Shown": properties.subscriptionPlansShown,
          "Subscription Plan Starts From Amount": properties.subscriptionPlanStartsFromAmount,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Discount Offering Code Applied": properties.discountOfferingCodeApplied,
          "Discount Type": properties.discountType,
          "Screen Height": sysScreenHeight,
          }, "b7-QDNo3YF", "16c0c64f377022007d23999143bc6e6d4d8dc1915154ffd7aa8f2506d13d37fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited All Plans Page", {
      "Free Activities Left Count": properties.freeActivitiesLeftCount,
      "Subscription Plans Shown": properties.subscriptionPlansShown,
      "Subscription Plan Starts From Amount": properties.subscriptionPlanStartsFromAmount,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Discount Offering Code Applied": properties.discountOfferingCodeApplied,
      "Discount Type": properties.discountType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted All Plans Page: When the user clicks on any elements on the plan page
   *
   * When to trigger this event:
   * 1. When the user clicks on these elements on the plan page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NG8X0Q79Sz/trigger/zf6jvrKds
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.subscriptionPlanName] - Stores the plan names i.e. Premium, Premium Live
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NG8X0Q79Sz}
   */
  function interactedAllPlansPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalSubscriptionPlanName(properties.subscriptionPlanName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted All Plans Page", Object.keys(properties), [
        "clickedOn",
        "subscriptionPlanName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NG8X0Q79Sz", "b2dd34997b08231a42538cc44b1283d405c5cc3644f2d89ae5742c1531887964", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted All Plans Page", {
        "Clicked On": properties.clickedOn,
        "Subscription Plan Name": properties.subscriptionPlanName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NG8X0Q79Sz", "Interacted All Plans Page", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "eOj3JBu_S", name: "Subscription Plan Name", value: properties.subscriptionPlanName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted All Plans Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted All Plans Page", {
          "Clicked On": properties.clickedOn,
          "Subscription Plan Name": properties.subscriptionPlanName,
          "Screen Height": sysScreenHeight,
          }, "NG8X0Q79Sz", "b2dd34997b08231a42538cc44b1283d405c5cc3644f2d89ae5742c1531887964");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted All Plans Page", {
      "Clicked On": properties.clickedOn,
      "Subscription Plan Name": properties.subscriptionPlanName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Visited Plan Purchase Combined Page: Triggers when user lands on the Plan duration selection & Purchase Summary page
   *
   * When to trigger this event:
   * 1. Triggers when user lands on the Plan duration selection & Purchase Summary page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2npJbVzs2F/trigger/QR3Ijuxsy
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.googlePayButtonAvailable] - Stores whether the Google Pay button was visible to the user or not
   * @param {string} [properties.validSavedCardExists] - Stores whether there is a valid (non-expired) card (debit/credit) that is already saved in user's SplashLearn account.
When this is available, the user can just use the saved card to make the payment OR can add another payment method if she wants.
   * @param {int} [properties.planAmount] - Stores the amount/price of the plan
   * @param {string} [properties.subscriptionPlanName] - Stores the plan names i.e. Premium, Premium Live
   * @param {string} [properties.subscriptionPlan] - Stores the cycle/duration of the plan that the user is buying.
Possible values are (Yearly, Monthly, Family, Quarterly)
   * @param {string} [properties.stripePaymentElementRendered] - We have 2 ways of rendering the payment methods form Stripe. This property distinguishes between those two.

Values:
- Old Credit Card Element
- New Payment Element

Refer this document for details of the implementation: https://www.notion.so/splashlearn/PRD-Payment-Element-Integration-Phase-1-8b4288f73eab4eadb4f0a1da62d9c20d?pvs=4#ef2a2ac2897b4b179c297192d3eeb95c
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/2npJbVzs2F}
   */
  function visitedPlanPurchaseCombinedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalGooglePayButtonAvailable(properties.googlePayButtonAvailable));
      messages = messages.concat(assertOptionalValidSavedCardExists(properties.validSavedCardExists));
      messages = messages.concat(assertOptionalPlanAmount(properties.planAmount));
      messages = messages.concat(assertOptionalSubscriptionPlanName(properties.subscriptionPlanName));
      messages = messages.concat(assertOptionalSubscriptionPlan(properties.subscriptionPlan));
      messages = messages.concat(assertOptionalStripePaymentElementRendered(properties.stripePaymentElementRendered));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Visited Plan Purchase Combined Page", Object.keys(properties), [
        "googlePayButtonAvailable",
        "validSavedCardExists",
        "planAmount",
        "subscriptionPlanName",
        "subscriptionPlan",
        "stripePaymentElementRendered",
        "cardType",
        "wallet",
        "stripePaymentMethodInfo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "2npJbVzs2F", "451da5d9e0235053a38146da9286da4f7fc1b452e1da2bcd9042e9743b22abb8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Visited Plan Purchase Combined Page", {
        "Google Pay Button Available": properties.googlePayButtonAvailable,
        "Valid Saved Card Exists": properties.validSavedCardExists,
        "Plan Amount": properties.planAmount,
        "Subscription Plan Name": properties.subscriptionPlanName,
        "Subscription Plan": properties.subscriptionPlan,
        "Stripe Payment Element Rendered": properties.stripePaymentElementRendered,
        "Card Type": properties.cardType,
        "Wallet": properties.wallet,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("2npJbVzs2F", "Visited Plan Purchase Combined Page", messages, [
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "8ATWzSmrM", name: "Plan Amount", value: properties.planAmount},
        {id: "AjgnWgaBe", name: "Stripe Payment Element Rendered", value: properties.stripePaymentElementRendered},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "N8pv_Xjhj", name: "Subscription Plan", value: properties.subscriptionPlan},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "eOj3JBu_S", name: "Subscription Plan Name", value: properties.subscriptionPlanName},
        {id: "o_O7Lq7wz", name: "Valid Saved Card Exists", value: properties.validSavedCardExists},
        {id: "pMtnCZl-R", name: "Google Pay Button Available", value: properties.googlePayButtonAvailable},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Visited Plan Purchase Combined Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Visited Plan Purchase Combined Page", {
          "Google Pay Button Available": properties.googlePayButtonAvailable,
          "Valid Saved Card Exists": properties.validSavedCardExists,
          "Plan Amount": properties.planAmount,
          "Subscription Plan Name": properties.subscriptionPlanName,
          "Subscription Plan": properties.subscriptionPlan,
          "Stripe Payment Element Rendered": properties.stripePaymentElementRendered,
          "Card Type": properties.cardType,
          "Wallet": properties.wallet,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Screen Height": sysScreenHeight,
          }, "2npJbVzs2F", "451da5d9e0235053a38146da9286da4f7fc1b452e1da2bcd9042e9743b22abb8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Visited Plan Purchase Combined Page", {
      "Google Pay Button Available": properties.googlePayButtonAvailable,
      "Valid Saved Card Exists": properties.validSavedCardExists,
      "Plan Amount": properties.planAmount,
      "Subscription Plan Name": properties.subscriptionPlanName,
      "Subscription Plan": properties.subscriptionPlan,
      "Stripe Payment Element Rendered": properties.stripePaymentElementRendered,
      "Card Type": properties.cardType,
      "Wallet": properties.wallet,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Plan Purchase Combined Page: When the user clicks on Elements on th Plan Duration Selection or Purchase Summary Page
   *
   * When to trigger this event:
   * 1. When the user clicks on Elements on th Plan Duration Selection or Purchase Summary Page
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DDAYoIhJd0/trigger/x9tZN_auX
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.subscriptionPlanName] - Stores the plan names i.e. Premium, Premium Live
   * @param {string} [properties.subscriptionPlan] - Stores the cycle/duration of the plan that the user is buying.
Possible values are (Yearly, Monthly, Family, Quarterly)
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {int} [properties.planAmount] - Stores the amount/price of the plan
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} [properties.paymentMethodClicked] - This property captures the Payment method tab selected by the user
Possible value are: cards, googlePay, applePay
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/DDAYoIhJd0}
   */
  function interactedPlanPurchaseCombinedPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalSubscriptionPlanName(properties.subscriptionPlanName));
      messages = messages.concat(assertOptionalSubscriptionPlan(properties.subscriptionPlan));
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalPlanAmount(properties.planAmount));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertOptionalPaymentMethodClicked(properties.paymentMethodClicked));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Plan Purchase Combined Page", Object.keys(properties), [
        "clickedOn",
        "subscriptionPlanName",
        "subscriptionPlan",
        "wallet",
        "planAmount",
        "cardType",
        "interactionDetails",
        "paymentMethodClicked",
        "stripePaymentMethodInfo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DDAYoIhJd0", "d34bde24be8099bdd0b1bc3f6a1d17e51df064f8dd382b54b5089eda8dd047cd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Plan Purchase Combined Page", {
        "Clicked On": properties.clickedOn,
        "Subscription Plan Name": properties.subscriptionPlanName,
        "Subscription Plan": properties.subscriptionPlan,
        "Wallet": properties.wallet,
        "Plan Amount": properties.planAmount,
        "Card Type": properties.cardType,
        "Interaction Details": properties.interactionDetails,
        "Payment Method Clicked": properties.paymentMethodClicked,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DDAYoIhJd0", "Interacted Plan Purchase Combined Page", messages, [
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "8ATWzSmrM", name: "Plan Amount", value: properties.planAmount},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "N8pv_Xjhj", name: "Subscription Plan", value: properties.subscriptionPlan},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "dVRLZ1nWs", name: "Payment Method Clicked", value: properties.paymentMethodClicked},
        {id: "eOj3JBu_S", name: "Subscription Plan Name", value: properties.subscriptionPlanName},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Plan Purchase Combined Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Plan Purchase Combined Page", {
          "Clicked On": properties.clickedOn,
          "Subscription Plan Name": properties.subscriptionPlanName,
          "Subscription Plan": properties.subscriptionPlan,
          "Wallet": properties.wallet,
          "Plan Amount": properties.planAmount,
          "Card Type": properties.cardType,
          "Interaction Details": properties.interactionDetails,
          "Payment Method Clicked": properties.paymentMethodClicked,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Screen Height": sysScreenHeight,
          }, "DDAYoIhJd0", "d34bde24be8099bdd0b1bc3f6a1d17e51df064f8dd382b54b5089eda8dd047cd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Plan Purchase Combined Page", {
      "Clicked On": properties.clickedOn,
      "Subscription Plan Name": properties.subscriptionPlanName,
      "Subscription Plan": properties.subscriptionPlan,
      "Wallet": properties.wallet,
      "Plan Amount": properties.planAmount,
      "Card Type": properties.cardType,
      "Interaction Details": properties.interactionDetails,
      "Payment Method Clicked": properties.paymentMethodClicked,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Payment Form Error: Stores the errors that Stripe shares with us when the user is inputting the payment method details and clicks on CTA (Start Trial or Buy) after which the payment starts processing by Stripe.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZSm-4GGLV8/trigger/R0yTLYkJ7
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.errorCode] - Captures the error on the Payment form
   * @param {string} [properties.stripePaymentElementRendered] - We have 2 ways of rendering the payment methods form Stripe. This property distinguishes between those two.

Values:
- Old Credit Card Element
- New Payment Element

Refer this document for details of the implementation: https://www.notion.so/splashlearn/PRD-Payment-Element-Integration-Phase-1-8b4288f73eab4eadb4f0a1da62d9c20d?pvs=4#ef2a2ac2897b4b179c297192d3eeb95c
   * @param {string} [properties.errorMessage] - Error message shown to the user.
   * @param {string} [properties.errorStep] - Defines at which step did the payment journey fail. Possible values are:

1. confirm_setup_failed : there was some issue in adding payment method
2. parent_creation_failed : only PTL flow
3. set_default_payment_method_failed
4. subscribe_product_failed
   * @param {string} [properties.errorMessageFromApi] - In case of Payment Failures during the user starting a trial or paying for the subscriptions, this will capture the failure message received from APIs.
   * @param {string} [properties.setupIntentStatus] - This property will capture the status of the Payment Method Setup Intent.
Possible values are  {succeeded, requires_payment_method, canceled }
   * @param {string} [properties.setupIntentId] - This will store the unique Payment Setup Intent ID when the user adds a Payment Method to start a trial or purchase.
This will be a alphanumeric ID like 'Distinct_ID' and will mainly be used for tech debugging.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZSm-4GGLV8}
   */
  function paymentFormError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalErrorCode(properties.errorCode));
      messages = messages.concat(assertOptionalStripePaymentElementRendered(properties.stripePaymentElementRendered));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertOptionalErrorStep(properties.errorStep));
      messages = messages.concat(assertOptionalErrorMessageFromApi(properties.errorMessageFromApi));
      messages = messages.concat(assertOptionalSetupIntentStatus(properties.setupIntentStatus));
      messages = messages.concat(assertOptionalSetupIntentId(properties.setupIntentId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Payment Form Error", Object.keys(properties), [
        "errorCode",
        "stripePaymentElementRendered",
        "errorMessage",
        "errorStep",
        "errorMessageFromApi",
        "setupIntentStatus",
        "setupIntentId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZSm-4GGLV8", "4ccbae5dfd5204202f9a62377a095bf124dcd51dc2ecd2196271587c86c008e1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Payment Form Error", {
        "Error Code": properties.errorCode,
        "Stripe Payment Element Rendered": properties.stripePaymentElementRendered,
        "Error Message": properties.errorMessage,
        "Error Step": properties.errorStep,
        "Error Message From Api": properties.errorMessageFromApi,
        "Setup Intent Status": properties.setupIntentStatus,
        "Setup Intent Id": properties.setupIntentId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZSm-4GGLV8", "Payment Form Error", messages, [
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "AjgnWgaBe", name: "Stripe Payment Element Rendered", value: properties.stripePaymentElementRendered},
        {id: "CGZP6dYmm", name: "Setup Intent Status", value: properties.setupIntentStatus},
        {id: "JSl62lgk3", name: "Error Code", value: properties.errorCode},
        {id: "PFXfXOuvy", name: "Setup Intent Id", value: properties.setupIntentId},
        {id: "rbMXuJsBw", name: "Error Message From Api", value: properties.errorMessageFromApi},
        {id: "zagTegBN_", name: "Error Step", value: properties.errorStep},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Payment Form Error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Payment Form Error", {
          "Error Code": properties.errorCode,
          "Stripe Payment Element Rendered": properties.stripePaymentElementRendered,
          "Error Message": properties.errorMessage,
          "Error Step": properties.errorStep,
          "Error Message From Api": properties.errorMessageFromApi,
          "Setup Intent Status": properties.setupIntentStatus,
          "Setup Intent Id": properties.setupIntentId,
          "Screen Height": sysScreenHeight,
          }, "ZSm-4GGLV8", "4ccbae5dfd5204202f9a62377a095bf124dcd51dc2ecd2196271587c86c008e1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Payment Form Error", {
      "Error Code": properties.errorCode,
      "Stripe Payment Element Rendered": properties.stripePaymentElementRendered,
      "Error Message": properties.errorMessage,
      "Error Step": properties.errorStep,
      "Error Message From Api": properties.errorMessageFromApi,
      "Setup Intent Status": properties.setupIntentStatus,
      "Setup Intent Id": properties.setupIntentId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Completed Page Scroll: When the user scrolls to the bottom of the page (on both Plan page & Purchase Summary page).
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.pageName - Includes the name of the page (Eg: Playzone game listing page, ). This is not the URL but a easily understandable definition of what page is the user at.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bzUwO7cozC}
   */
  function completedPageScroll(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPageName(properties.pageName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Page Scroll", Object.keys(properties), [
        "pageName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bzUwO7cozC", "db139d9494970b6f29b1e606e68dfe1af797da9e74f318d6ffa514ee6488b3b0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Completed Page Scroll", {
        "Page Name": properties.pageName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bzUwO7cozC", "Completed Page Scroll", messages, [
        {id: "MJKSzmqfHu", name: "Page Name", value: properties.pageName},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Page Scroll': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Page Scroll", {
          "Page Name": properties.pageName,
          "Screen Height": sysScreenHeight,
          }, "bzUwO7cozC", "db139d9494970b6f29b1e606e68dfe1af797da9e74f318d6ffa514ee6488b3b0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Page Scroll", {
      "Page Name": properties.pageName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Child Profile Page Interacted: When child profile page is clicked/tapped
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1rXIJYd5_X}
   */
  function childProfilePageInteracted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Child Profile Page Interacted", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1rXIJYd5_X", "201fc162ddee9e204f31b8a4942322c3a46c016d79b77d4fbcdf1ee89af2df23", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Child Profile Page Interacted", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1rXIJYd5_X", "Child Profile Page Interacted", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Child Profile Page Interacted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Child Profile Page Interacted", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "1rXIJYd5_X", "201fc162ddee9e204f31b8a4942322c3a46c016d79b77d4fbcdf1ee89af2df23");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Child Profile Page Interacted", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Coachmark [B2B]: This event will be fired when the user views the coachmark anywhere on our product.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ExitnhGuRA/trigger/96tpqdAQs
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.coachmarkText - This will capture the text of the coachmark. Example, 'Add a co-teacher to your class & get ready for a seamless class transfer through the next school year.'
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ExitnhGuRA}
   */
  function viewedCoachmarkB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertCoachmarkText(properties.coachmarkText));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Coachmark [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from",
        "section",
        "coachmarkText"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ExitnhGuRA", "9faa0ed2acde39b5a3a43732118a32d572ad38e246b9ed51645840b91f3a8439", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Coachmark [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Section": properties.section,
        "Coachmark Text": properties.coachmarkText,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ExitnhGuRA", "Viewed Coachmark [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "htmKRbaew", name: "Coachmark Text", value: properties.coachmarkText},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Coachmark [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Coachmark [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Section": properties.section,
          "Coachmark Text": properties.coachmarkText,
          "Screen Height": sysScreenHeight,
          }, "ExitnhGuRA", "9faa0ed2acde39b5a3a43732118a32d572ad38e246b9ed51645840b91f3a8439");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Coachmark [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Section": properties.section,
      "Coachmark Text": properties.coachmarkText,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Coachmark [B2B]: This event will be fired when the user interacts with the coachmark anywhere on our product.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GfMIIgbl9/trigger/M151qEtzS
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} properties.coachmarkText - This will capture the text of the coachmark. Example, 'Add a co-teacher to your class & get ready for a seamless class transfer through the next school year.'
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GfMIIgbl9}
   */
  function interactedCoachmarkB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertCoachmarkText(properties.coachmarkText));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Coachmark [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "from",
        "section",
        "coachmarkText",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GfMIIgbl9", "fb31e19f73345dfed3dc333918cb157e6b18690c02187140b908ab3f6d6fbae6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Coachmark [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Section": properties.section,
        "Coachmark Text": properties.coachmarkText,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GfMIIgbl9", "Interacted Coachmark [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "htmKRbaew", name: "Coachmark Text", value: properties.coachmarkText},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Coachmark [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Coachmark [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Section": properties.section,
          "Coachmark Text": properties.coachmarkText,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "GfMIIgbl9", "fb31e19f73345dfed3dc333918cb157e6b18690c02187140b908ab3f6d6fbae6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Coachmark [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Section": properties.section,
      "Coachmark Text": properties.coachmarkText,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Live Classes Freemium Pitch: Triggered when the live classes freemium pitch screen is viewed
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NNdvQ27RyH/trigger/TntFfRs30
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/NNdvQ27RyH}
   */
  function viewedLiveClassesFreemiumPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Classes Freemium Pitch", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "NNdvQ27RyH", "9d1a5f360c775b81f818c547fead3b6fc634de313a11b06b89c5cda7367dee3b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Live Classes Freemium Pitch", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("NNdvQ27RyH", "Viewed Live Classes Freemium Pitch", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Classes Freemium Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Classes Freemium Pitch", {
          "Screen Height": sysScreenHeight,
          }, "NNdvQ27RyH", "9d1a5f360c775b81f818c547fead3b6fc634de313a11b06b89c5cda7367dee3b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Classes Freemium Pitch", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Live Classes Freemium Pitch: Triggered when the live classes freemium pitch is interacted with
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TV3VrmtL-/trigger/e61ts0A51
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TV3VrmtL-}
   */
  function interactedLiveClassesFreemiumPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Classes Freemium Pitch", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TV3VrmtL-", "f52d6e4cf71971aff6eb3ab53d589d4a572410c6a22a5c66a43b945bc6e9632e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Live Classes Freemium Pitch", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TV3VrmtL-", "Interacted Live Classes Freemium Pitch", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Classes Freemium Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Classes Freemium Pitch", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "TV3VrmtL-", "f52d6e4cf71971aff6eb3ab53d589d4a572410c6a22a5c66a43b945bc6e9632e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Classes Freemium Pitch", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Class Preference Screen: Triggered when the user clicks on setup class invites / save your spot on the live classes freemium pitch screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1CGajfxJ76/trigger/uo_EY8foL
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1CGajfxJ76}
   */
  function viewedClassPreferenceScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Class Preference Screen", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1CGajfxJ76", "eae22ea5a7b42975fea1a657a2bb7d544375b9c0ee31d5134657f85f964d6fbe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Class Preference Screen", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1CGajfxJ76", "Viewed Class Preference Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Class Preference Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Class Preference Screen", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "1CGajfxJ76", "eae22ea5a7b42975fea1a657a2bb7d544375b9c0ee31d5134657f85f964d6fbe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Class Preference Screen", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Class Preference Screen: Triggered when a user interacts with the class preference screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6tQBiDq1UJ/trigger/OPv-tVeVT
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6tQBiDq1UJ}
   */
  function interactedClassPreferenceScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Class Preference Screen", Object.keys(properties), [
        "clickedOn",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6tQBiDq1UJ", "9606f6c7b1857a689744a715aff07d4639a7ff35cccd362856c14d9ae71681f8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Class Preference Screen", {
        "Clicked On": properties.clickedOn,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6tQBiDq1UJ", "Interacted Class Preference Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Class Preference Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Class Preference Screen", {
          "Clicked On": properties.clickedOn,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "6tQBiDq1UJ", "9606f6c7b1857a689744a715aff07d4639a7ff35cccd362856c14d9ae71681f8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Class Preference Screen", {
      "Clicked On": properties.clickedOn,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Interest Confirmation Screen: Viewed confirmation screen after the user shares their interest and preference
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/53H04NApfS/trigger/Zd3Nx1liy
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/53H04NApfS}
   */
  function viewedInterestConfirmationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Interest Confirmation Screen", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "53H04NApfS", "1220c15d5e0f311560e872174aad6dd92917a576c3f45849dff7272d8cb59bb6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Interest Confirmation Screen", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("53H04NApfS", "Viewed Interest Confirmation Screen", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Interest Confirmation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Interest Confirmation Screen", {
          "Screen Height": sysScreenHeight,
          }, "53H04NApfS", "1220c15d5e0f311560e872174aad6dd92917a576c3f45849dff7272d8cb59bb6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Interest Confirmation Screen", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Interest Confirmation Screen: Triggered when the user interacts with the interest confirmation screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qRA-_uGxJt/trigger/1sf39RDNg
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qRA-_uGxJt}
   */
  function interactedInterestConfirmationScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Interest Confirmation Screen", Object.keys(properties), [
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qRA-_uGxJt", "ce2d1a1c438e245796b862a8bcac68659e4150332483df2222ba83b5546651c0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Interest Confirmation Screen", {
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qRA-_uGxJt", "Interacted Interest Confirmation Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Interest Confirmation Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Interest Confirmation Screen", {
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "qRA-_uGxJt", "ce2d1a1c438e245796b862a8bcac68659e4150332483df2222ba83b5546651c0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Interest Confirmation Screen", {
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Search Icon: When user clicks/taps on search bar
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nQioCscWdp/trigger/BkLPsq_R3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nQioCscWdp}
   */
  function interactedSearchIcon(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Search Icon", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nQioCscWdp", "0c6cf5981e6d0bfe19359eb1b5e505f0a9a89b32206545008722ef4ad6c7ff9a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Search Icon", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nQioCscWdp", "Interacted Search Icon", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Search Icon': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Search Icon", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "nQioCscWdp", "0c6cf5981e6d0bfe19359eb1b5e505f0a9a89b32206545008722ef4ad6c7ff9a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Search Icon", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Typing Started on Search Bar: When user starts typing in search bar
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GmXo02nCqu/trigger/wzKYlLko3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/GmXo02nCqu}
   */
  function typingStartedOnSearchBar(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Typing Started on Search Bar", Object.keys(properties), [
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GmXo02nCqu", "a3305a28c2e17e254cee9ffc9a1ad6f10e7558b720d175efd4cf1a61504f5c82", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Typing Started on Search Bar", {
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GmXo02nCqu", "Typing Started on Search Bar", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Typing Started on Search Bar': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Typing Started on Search Bar", {
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "GmXo02nCqu", "a3305a28c2e17e254cee9ffc9a1ad6f10e7558b720d175efd4cf1a61504f5c82");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Typing Started on Search Bar", {
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Typing Stopped on Search Bar: When search results are shown to user
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qJLPqWk_no/trigger/Xq63gQNcZ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.numberOfResults - Number of results shown for search results
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qJLPqWk_no}
   */
  function typingStoppedOnSearchBar(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertNumberOfResults(properties.numberOfResults));
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Typing Stopped on Search Bar", Object.keys(properties), [
        "numberOfResults",
        "searchTerm",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qJLPqWk_no", "b763c0023d4c975174c4be305254d9bb63fa7763af973dd2839a7e5cd343ea5b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Typing Stopped on Search Bar", {
        "Number of Results": properties.numberOfResults,
        "Search Term": properties.searchTerm,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qJLPqWk_no", "Typing Stopped on Search Bar", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "UtPMQu4JE", name: "Number of Results", value: properties.numberOfResults},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Typing Stopped on Search Bar': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Typing Stopped on Search Bar", {
          "Number of Results": properties.numberOfResults,
          "Search Term": properties.searchTerm,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "qJLPqWk_no", "b763c0023d4c975174c4be305254d9bb63fa7763af973dd2839a7e5cd343ea5b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Typing Stopped on Search Bar", {
      "Number of Results": properties.numberOfResults,
      "Search Term": properties.searchTerm,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Search Result: When user clicks on search result
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AlQc6-GIyA/trigger/2mFC3AO5J
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.searchTerm - Term searched by the user
   * @param {string} properties.searchResultSelected - Among the search results shown, the one selected by the user
   * @param {string} properties.searchResultType - Type of search result (CG/Milestone/LO)
   * @param {int} properties.searchResultPosition - Position of search result clicked
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/AlQc6-GIyA}
   */
  function interactedSearchResult(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSearchTerm(properties.searchTerm));
      messages = messages.concat(assertSearchResultSelected(properties.searchResultSelected));
      messages = messages.concat(assertSearchResultType(properties.searchResultType));
      messages = messages.concat(assertSearchResultPosition(properties.searchResultPosition));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Search Result", Object.keys(properties), [
        "searchTerm",
        "searchResultSelected",
        "searchResultType",
        "searchResultPosition",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AlQc6-GIyA", "90445535d08f1cdb98517a0d241456d6a3ffea6ecf9797014f22b832a21ac129", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Search Result", {
        "Search Term": properties.searchTerm,
        "Search Result Selected": properties.searchResultSelected,
        "Search Result Type": properties.searchResultType,
        "Search Result Position": properties.searchResultPosition,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AlQc6-GIyA", "Interacted Search Result", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "AeBTQBXi0", name: "Search Result Type", value: properties.searchResultType},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "guJOTwi5T", name: "Search Term", value: properties.searchTerm},
        {id: "of6hlcB4H", name: "Search Result Selected", value: properties.searchResultSelected},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vCfnwTQU8", name: "Search Result Position", value: properties.searchResultPosition},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Search Result': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Search Result", {
          "Search Term": properties.searchTerm,
          "Search Result Selected": properties.searchResultSelected,
          "Search Result Type": properties.searchResultType,
          "Search Result Position": properties.searchResultPosition,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "AlQc6-GIyA", "90445535d08f1cdb98517a0d241456d6a3ffea6ecf9797014f22b832a21ac129");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Search Result", {
      "Search Term": properties.searchTerm,
      "Search Result Selected": properties.searchResultSelected,
      "Search Result Type": properties.searchResultType,
      "Search Result Position": properties.searchResultPosition,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Transfer Page [B2B]: This event will be fired when the user clicks on 'Transfer' button from 'Manage All Classes' screen and lands on the class transfer screen.
The From Page property will include the value of the page it was clicked from -
'Manage All Classes' or 'New SY Class Creation'.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BbH0Re7Gnw/trigger/hd9iT0_2M
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BbH0Re7Gnw}
   */
  function viewedTransferPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Transfer Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BbH0Re7Gnw", "9692e0d266353244cfdf572bde16a9fb7f2cf8fde2b77f8961434a97fad1040c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Transfer Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BbH0Re7Gnw", "Viewed Transfer Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Transfer Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Transfer Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "BbH0Re7Gnw", "9692e0d266353244cfdf572bde16a9fb7f2cf8fde2b77f8961434a97fad1040c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Transfer Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Transfer Page [B2B]: This event will be fired when the user interacts with the Transfer Class Page.

   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jim8tAXzys/trigger/YF_oB_Q_N
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jim8tAXzys}
   */
  function interactedTransferPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Transfer Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jim8tAXzys", "25769dc743d07a9543d5bc23b1dbbc982ec957ec59c40786fdb62b8e4e1454e4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Transfer Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jim8tAXzys", "Interacted Transfer Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Transfer Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Transfer Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "jim8tAXzys", "25769dc743d07a9543d5bc23b1dbbc982ec957ec59c40786fdb62b8e4e1454e4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Transfer Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Feature Feedback Pop-Up [B2B]: This event will be fired whenever the user sees the feedback feature against a widget or page. The value of 'feature_name' will appear in the 'Section' property here.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oydALTKHND/trigger/RnQNcUyfE
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oydALTKHND}
   */
  function viewedFeatureFeedbackPopUpB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Feature Feedback Pop-Up [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oydALTKHND", "a9929d5ca6c2113b1a1c1073b77fd8afbc44f2101d47a0323814a0f18db2fa8c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Feature Feedback Pop-Up [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oydALTKHND", "Viewed Feature Feedback Pop-Up [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Feature Feedback Pop-Up [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Feature Feedback Pop-Up [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "oydALTKHND", "a9929d5ca6c2113b1a1c1073b77fd8afbc44f2101d47a0323814a0f18db2fa8c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Feature Feedback Pop-Up [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Feature Feedback Pop-Up [B2B]: This event will be fired whenever the user interacts with the feedback feature against a widget or page. The value of 'feature_name' will appear in the 'Section' property here.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ah1VLF0L7G/trigger/a_8R5yxl6
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ah1VLF0L7G}
   */
  function interactedFeatureFeedbackPopUpB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Feature Feedback Pop-Up [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ah1VLF0L7G", "9c753230725150e3aaee47b67616531d0c00e31e86fd8b00aa87bd9d91b7bcbe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Feature Feedback Pop-Up [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ah1VLF0L7G", "Interacted Feature Feedback Pop-Up [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Feature Feedback Pop-Up [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Feature Feedback Pop-Up [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Ah1VLF0L7G", "9c753230725150e3aaee47b67616531d0c00e31e86fd8b00aa87bd9d91b7bcbe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Feature Feedback Pop-Up [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Suggest Improvements Popup [B2B]: This event will be fired when the user sees the 'Suggest Improvements' popup
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/uJzutqvacz/trigger/jKxAovOt7
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/uJzutqvacz}
   */
  function viewedSuggestImprovementsPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Suggest Improvements Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "uJzutqvacz", "8853f2fadbaff718006ef6afd150e8560a69fd6c3583dd699e4c8625fa38c1bb", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Suggest Improvements Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("uJzutqvacz", "Viewed Suggest Improvements Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Suggest Improvements Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Suggest Improvements Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "uJzutqvacz", "8853f2fadbaff718006ef6afd150e8560a69fd6c3583dd699e4c8625fa38c1bb");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Suggest Improvements Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Suggest Improvements Popup [B2B]: This event will be fired when the user interacts with the 'Suggest Improvements' popup.
If the user starts to enter content, the value for Clicked on will be 'Enter suggestion'.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XybWmVl5wN/trigger/mCSXf4WvN
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XybWmVl5wN}
   */
  function interactedSuggestImprovementsPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Suggest Improvements Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XybWmVl5wN", "ab27d5718eaa00d868b5ab1bd3f93c148175023a52bdc5c02b51143b67f283da", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Suggest Improvements Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XybWmVl5wN", "Interacted Suggest Improvements Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Suggest Improvements Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Suggest Improvements Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "XybWmVl5wN", "ab27d5718eaa00d868b5ab1bd3f93c148175023a52bdc5c02b51143b67f283da");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Suggest Improvements Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Help Icon [B2B]: This event will be fired when the user interacts with the Help icon on the Teacher Product and selects an item from the dropdown menu.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0w--07Nt3f/trigger/UdWGtTkOp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/0w--07Nt3f}
   */
  function interactedHelpIconB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Help Icon [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "0w--07Nt3f", "fe7b37ff3387bdcaf716196b0bc269bcd3721c49401eecb72b8942b3518306d7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Help Icon [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("0w--07Nt3f", "Interacted Help Icon [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Help Icon [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Help Icon [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "0w--07Nt3f", "fe7b37ff3387bdcaf716196b0bc269bcd3721c49401eecb72b8942b3518306d7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Help Icon [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Clicked on Help Icon [B2B]: This event will be fired when the user clicks on Help icon from the top bar on the teacher product.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kadRgNV_Q}
   */
  function clickedOnHelpIconB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Clicked on Help Icon [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kadRgNV_Q", "adc82d1e294fb073c46d7b7dad26821ebe304cd6fc6bee0a512f89e9eaacea82", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Clicked on Help Icon [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kadRgNV_Q", "Clicked on Help Icon [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Clicked on Help Icon [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Clicked on Help Icon [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "kadRgNV_Q", "adc82d1e294fb073c46d7b7dad26821ebe304cd6fc6bee0a512f89e9eaacea82");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Clicked on Help Icon [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Worksheet Preview: When the user clicks on the worksheet card and the preview window opens
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LmvX08Vsj7/trigger/sS4VqzYQG
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.freeWorksheetsLeftCount - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/LmvX08Vsj7}
   */
  function viewedWorksheetPreview(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Worksheet Preview", Object.keys(properties), [
        "from",
        "freeWorksheetsLeftCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "LmvX08Vsj7", "919ff2fd37e459299f0e223c01065061aead3b26ae8e731b5c5210e5990cc6b0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Worksheet Preview", {
        "From": properties.from,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("LmvX08Vsj7", "Viewed Worksheet Preview", messages, [
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Worksheet Preview': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Worksheet Preview", {
          "From": properties.from,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Screen Height": sysScreenHeight,
          }, "LmvX08Vsj7", "919ff2fd37e459299f0e223c01065061aead3b26ae8e731b5c5210e5990cc6b0");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Worksheet Preview", {
      "From": properties.from,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Worksheet Preview: When the user clicks on the CTA, thumbnail or cross on the worksheet preview window
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ysxppxsc-X/trigger/JinFOmXZm
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.freeWorksheetsLeftCount - Stores the number of free worksheets left for the user to play on a particular day, at that moment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ysxppxsc-X}
   */
  function interactedWorksheetPreview(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertFreeWorksheetsLeftCount(properties.freeWorksheetsLeftCount));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Worksheet Preview", Object.keys(properties), [
        "clickedOn",
        "freeWorksheetsLeftCount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ysxppxsc-X", "5e7e77b81ab48f9f107367720febaff44c3defc16fe2eb05472d50d6c9921def", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Worksheet Preview", {
        "Clicked On": properties.clickedOn,
        "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ysxppxsc-X", "Interacted Worksheet Preview", messages, [
        {id: "H4pP9av1w", name: "Free Worksheets Left Count", value: properties.freeWorksheetsLeftCount},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Worksheet Preview': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Worksheet Preview", {
          "Clicked On": properties.clickedOn,
          "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
          "Screen Height": sysScreenHeight,
          }, "Ysxppxsc-X", "5e7e77b81ab48f9f107367720febaff44c3defc16fe2eb05472d50d6c9921def");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Worksheet Preview", {
      "Clicked On": properties.clickedOn,
      "Free Worksheets Left Count": properties.freeWorksheetsLeftCount,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted FAB [B2B]: This event will be triggered when the user clicks on the items within floating action button popup.
If the user clicks on the Toggle at the top, then 'Math' or 'ELA' will get passes for Clicked on property. If the user clicks on the items in the list, then the subject name will be sent along with it. Example, 'Math Curriculum'
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UKwBfL21rl/trigger/hTgC56k4R
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UKwBfL21rl}
   */
  function interactedFabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted FAB [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UKwBfL21rl", "a9e57e0be6b79807bad60824cb8e1bd6122de57cc16cfe0c5f6a73064ae61e6a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted FAB [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UKwBfL21rl", "Interacted FAB [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted FAB [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted FAB [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "UKwBfL21rl", "a9e57e0be6b79807bad60824cb8e1bd6122de57cc16cfe0c5f6a73064ae61e6a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted FAB [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Scrolled Plan Page: When the user scrolls to each section in the new live classes plan page
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gxL9DVOw6U/trigger/UyX_HevCu
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gxL9DVOw6U}
   */
  function scrolledPlanPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Scrolled Plan Page", Object.keys(properties), [
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gxL9DVOw6U", "91ef7205b6cacd781bd15b1d0d19875bf1050fe5168ca56cc1eeffa9ae9c8fee", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Scrolled Plan Page", {
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gxL9DVOw6U", "Scrolled Plan Page", messages, [
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Scrolled Plan Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled Plan Page", {
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "gxL9DVOw6U", "91ef7205b6cacd781bd15b1d0d19875bf1050fe5168ca56cc1eeffa9ae9c8fee");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Scrolled Plan Page", {
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Promote Popup [B2B]: This event will be fired when the user clicks on 'Promote class' CTA or cross button from the Promote confirmation popup.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/D8i9x4o98/trigger/HSxCi-Cz0
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/D8i9x4o98}
   */
  function interactedPromotePopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Promote Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "D8i9x4o98", "cf3a94dd00410e33f9d8ac0ee8c9f52097191fa620fe94682bee9573ca94df70", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Promote Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("D8i9x4o98", "Interacted Promote Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Promote Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Promote Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "D8i9x4o98", "cf3a94dd00410e33f9d8ac0ee8c9f52097191fa620fe94682bee9573ca94df70");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Promote Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Continue Same Class Popup [B2B]: This event will be fired when the user clicks 'OK' or 'cross' CTA on the Continue Same Class popup.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Hd40HzR46i/trigger/_VApgCbMi
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Hd40HzR46i}
   */
  function interactedContinueSameClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Continue Same Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Hd40HzR46i", "2696af27a97c4c8cb7d5380c4c79b8eb6e334ba9c5c2b67cc3c356f6aa0bcda4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Continue Same Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Hd40HzR46i", "Interacted Continue Same Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Continue Same Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Continue Same Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Hd40HzR46i", "2696af27a97c4c8cb7d5380c4c79b8eb6e334ba9c5c2b67cc3c356f6aa0bcda4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Continue Same Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Student Login Instructions Popup [B2B]: This event will be fired when the user interacts with the Student Login Instructions popup.
The Clicked on value will capture the login mode by prefixing the login mode. Example, 'QR Code Print Instructions'.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/g0Uo5x4dkT/trigger/CK_Kc_9hd
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/g0Uo5x4dkT}
   */
  function interactedStudentLoginInstructionsPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Login Instructions Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "g0Uo5x4dkT", "a960631f43c83c624199b5e896bf2329832ce014c6c54ca1f36b64810c192757", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Student Login Instructions Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("g0Uo5x4dkT", "Interacted Student Login Instructions Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Login Instructions Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Login Instructions Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "g0Uo5x4dkT", "a960631f43c83c624199b5e896bf2329832ce014c6c54ca1f36b64810c192757");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Login Instructions Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Product Purchased: Triggered when the user actually starts a Trial or a direct purchase.

   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TMo5FyU21}
   */
  function productPurchased(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Product Purchased", Object.keys(properties), [
        "wallet",
        "cardType",
        "stripePaymentMethodInfo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TMo5FyU21", "ebf62fc65904bb79d7ca0177c4b097d5e92607ec202d32c76378e1380cd55f2c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Purchased", {
        "Wallet": properties.wallet,
        "Card Type": properties.cardType,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TMo5FyU21", "Product Purchased", messages, [
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Purchased': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Purchased", {
          "Wallet": properties.wallet,
          "Card Type": properties.cardType,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Screen Height": sysScreenHeight,
          }, "TMo5FyU21", "ebf62fc65904bb79d7ca0177c4b097d5e92607ec202d32c76378e1380cd55f2c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Product Purchased", {
      "Wallet": properties.wallet,
      "Card Type": properties.cardType,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Credit Card Submitted: Fires when the user submits any payment method.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/bK068U13_}
   */
  function creditCardSubmitted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Credit Card Submitted", Object.keys(properties), [
        "wallet",
        "cardType",
        "stripePaymentMethodInfo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "bK068U13_", "dab87c1ce8c09ecb24493ab6398993458a690ebe7165045ac8d1fc5505c76958", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Credit Card Submitted", {
        "Wallet": properties.wallet,
        "Card Type": properties.cardType,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("bK068U13_", "Credit Card Submitted", messages, [
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Credit Card Submitted': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Credit Card Submitted", {
          "Wallet": properties.wallet,
          "Card Type": properties.cardType,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Screen Height": sysScreenHeight,
          }, "bK068U13_", "dab87c1ce8c09ecb24493ab6398993458a690ebe7165045ac8d1fc5505c76958");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Credit Card Submitted", {
      "Wallet": properties.wallet,
      "Card Type": properties.cardType,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Product Purchased Frontend: Front end event for when the user starts a trial or makes a purchase.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.wallet] - Stores which wallet has the user used to make the payment for the plan.
Values = (googlePay, applePay)
   * @param {string} [properties.cardType] - Stores the card type of the payment method.
   * @param {string} [properties.stripePaymentMethodInfo] - Stores the type of payment method through which the user is making a payment

Values will include:
- cards
- digital wallets
- bank debits
- bank redirects
- bank transfers
- BNPL
- cash-based vouchers
- real time payment
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sGru8Rdmg}
   */
  function productPurchasedFrontend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalWallet(properties.wallet));
      messages = messages.concat(assertOptionalCardType(properties.cardType));
      messages = messages.concat(assertOptionalStripePaymentMethodInfo(properties.stripePaymentMethodInfo));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Product Purchased Frontend", Object.keys(properties), [
        "wallet",
        "cardType",
        "stripePaymentMethodInfo"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sGru8Rdmg", "aa36fba0671d83030b95c5316b7acc2b6cdc62eb2d7487bda52e9a1ab46a4f5a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Product Purchased Frontend", {
        "Wallet": properties.wallet,
        "Card Type": properties.cardType,
        "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sGru8Rdmg", "Product Purchased Frontend", messages, [
        {id: "3kx20gfYw", name: "Stripe Payment Method Info", value: properties.stripePaymentMethodInfo},
        {id: "G8FSLVPgG", name: "Wallet", value: properties.wallet},
        {id: "WZ4UUsQFg", name: "Card Type", value: properties.cardType},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Product Purchased Frontend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Purchased Frontend", {
          "Wallet": properties.wallet,
          "Card Type": properties.cardType,
          "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
          "Screen Height": sysScreenHeight,
          }, "sGru8Rdmg", "aa36fba0671d83030b95c5316b7acc2b6cdc62eb2d7487bda52e9a1ab46a4f5a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Product Purchased Frontend", {
      "Wallet": properties.wallet,
      "Card Type": properties.cardType,
      "Stripe Payment Method Info": properties.stripePaymentMethodInfo,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed All Recordings Page: Triggered when the user visits the recordings page
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ubCOREr4W2/trigger/BxCOy4ytY
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ubCOREr4W2}
   */
  function viewedAllRecordingsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed All Recordings Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "elaGrade",
        "grade",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ubCOREr4W2", "56fccf3f3c0d1d72cc18f4f33e0e579c4154df52274be4e05af570ff26f87412", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed All Recordings Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ubCOREr4W2", "Viewed All Recordings Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed All Recordings Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed All Recordings Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "ubCOREr4W2", "56fccf3f3c0d1d72cc18f4f33e0e579c4154df52274be4e05af570ff26f87412");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed All Recordings Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted All Recordings Page: Triggered when the user interacts anywhere on the recordings page
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZqRR2kIpIO/trigger/IbwZ0b414
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} [properties.clickedOn] - This will have the info about where the user has clicked on this page
   * @param {string} [properties.gradeSelected] - Grade selected by user in curriculum tab
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} [properties.from] - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ZqRR2kIpIO}
   */
  function interactedAllRecordingsPage(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertOptionalClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalGradeSelected(properties.gradeSelected));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertOptionalFrom(properties.from));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted All Recordings Page", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "gradeSelected",
        "grade",
        "elaGrade",
        "from"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ZqRR2kIpIO", "09299bee43229fce4257bb9e8ff46a6162b704cdd55d073c280f1fa1d537e8e5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted All Recordings Page", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade Selected": properties.gradeSelected,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "From": properties.from,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ZqRR2kIpIO", "Interacted All Recordings Page", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Fcl7PSdr4", name: "Grade Selected", value: properties.gradeSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted All Recordings Page': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted All Recordings Page", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade Selected": properties.gradeSelected,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "From": properties.from,
          "Screen Height": sysScreenHeight,
          }, "ZqRR2kIpIO", "09299bee43229fce4257bb9e8ff46a6162b704cdd55d073c280f1fa1d537e8e5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted All Recordings Page", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade Selected": properties.gradeSelected,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "From": properties.from,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Persona Question Screen: When the user lands on the screen with the persona research questions
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/abU0cA8Fx3/trigger/J82SQvPCP
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} [properties.questionNo] - This will capture the Question Serial no. as it appears in sequence
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/abU0cA8Fx3}
   */
  function viewedPersonaQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertOptionalQuestionNo(properties.questionNo));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Persona Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "questionNo",
        "mode",
        "grade",
        "mathGrade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "abU0cA8Fx3", "7862f2033c1ae62503c494e6b1ef8b6d33facc17421279298f653466533701a2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Persona Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Question No.": properties.questionNo,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("abU0cA8Fx3", "Viewed Persona Question Screen", messages, [
        {id: "1BxvMk6Nz6", name: "Question No.", value: properties.questionNo},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Persona Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Persona Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Question No.": properties.questionNo,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "abU0cA8Fx3", "7862f2033c1ae62503c494e6b1ef8b6d33facc17421279298f653466533701a2");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Persona Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Question No.": properties.questionNo,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Persona Question Screen: When the user clicks on the options, back or any of the 2 CTAs in the screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yvnCL_tKho/trigger/kYvopA8ZZ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.questionNo] - This will capture the Question Serial no. as it appears in sequence
   * @param {Array<string>} [properties.optionsSelected] - Array to save all of the options the user selects
   * @param {string} [properties.errorMessage] - Error message shown to the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yvnCL_tKho}
   */
  function interactedPersonaQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalQuestionNo(properties.questionNo));
      messages = messages.concat(assertOptionalOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertOptionalErrorMessage(properties.errorMessage));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Persona Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "questionNo",
        "optionsSelected",
        "errorMessage",
        "mode",
        "grade",
        "mathGrade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yvnCL_tKho", "6e6541c89d09668fe8d43c9fba76f304c0d70174c54be79c093fbb1b13ab0910", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Persona Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Question No.": properties.questionNo,
        "Options Selected": properties.optionsSelected,
        "Error Message": properties.errorMessage,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Math Grade": properties.mathGrade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yvnCL_tKho", "Interacted Persona Question Screen", messages, [
        {id: "1BxvMk6Nz6", name: "Question No.", value: properties.questionNo},
        {id: "1n3Bq4GKWy", name: "Error Message", value: properties.errorMessage},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Persona Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Persona Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Question No.": properties.questionNo,
          "Options Selected": properties.optionsSelected,
          "Error Message": properties.errorMessage,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Math Grade": properties.mathGrade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "yvnCL_tKho", "6e6541c89d09668fe8d43c9fba76f304c0d70174c54be79c093fbb1b13ab0910");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Persona Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Question No.": properties.questionNo,
      "Options Selected": properties.optionsSelected,
      "Error Message": properties.errorMessage,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Math Grade": properties.mathGrade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Companion: This event gets triggered when the companion state machine isswitches loadedfrom one to another.
   *
   * When to trigger this event:
   * 1. When companion layer has successfully loaded over the dashboard.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oSI8IVoYyf/trigger/6QxU0iaMs
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.stateMachineTid - it is a unique code, passed as string for each state machine
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/oSI8IVoYyf}
   */
  function viewedCompanion(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertStateMachineTid(properties.stateMachineTid));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Companion", Object.keys(properties), [
        "tabCode",
        "stateMachineCode",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "stateMachineTid"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oSI8IVoYyf", "6bae49d194bca76d835a6117375157738c88affbde51c92eeed30e10d6cc3181", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Companion", {
        "Tab Code": properties.tabCode,
        "State Machine Code": properties.stateMachineCode,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "State Machine Tid": properties.stateMachineTid,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oSI8IVoYyf", "Viewed Companion", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "D325IngkY", name: "State Machine Tid", value: properties.stateMachineTid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Companion': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Companion", {
          "Tab Code": properties.tabCode,
          "State Machine Code": properties.stateMachineCode,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "State Machine Tid": properties.stateMachineTid,
          "Screen Height": sysScreenHeight,
          }, "oSI8IVoYyf", "6bae49d194bca76d835a6117375157738c88affbde51c92eeed30e10d6cc3181");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Companion", {
      "Tab Code": properties.tabCode,
      "State Machine Code": properties.stateMachineCode,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "State Machine Tid": properties.stateMachineTid,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Started Companion Animation: Whenever any companion animation is starting
   *
   * When to trigger this event:
   * 1. This is one of the example when companion animation is started at pitstop
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-OWrF7Hhl/trigger/JPk5KFyyh
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.flowName - This property will tell the flow of the companion - is it welcome back, or motivation, etc.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.stateMachineTid - it is a unique code, passed as string for each state machine
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-OWrF7Hhl}
   */
  function startedCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFlowName(properties.flowName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertStateMachineTid(properties.stateMachineTid));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Companion Animation", Object.keys(properties), [
        "flowName",
        "tabCode",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "stateMachineCode",
        "stateMachineTid"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-OWrF7Hhl", "a40c5b302fec76a01b93a3e1690c9f29bd70f839635241d57ccc136024bcf50e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Started Companion Animation", {
        "Flow Name": properties.flowName,
        "Tab Code": properties.tabCode,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "State Machine Code": properties.stateMachineCode,
        "State Machine Tid": properties.stateMachineTid,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-OWrF7Hhl", "Started Companion Animation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "D325IngkY", name: "State Machine Tid", value: properties.stateMachineTid},
        {id: "QvqHzz_24", name: "Flow Name", value: properties.flowName},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Companion Animation", {
          "Flow Name": properties.flowName,
          "Tab Code": properties.tabCode,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "State Machine Code": properties.stateMachineCode,
          "State Machine Tid": properties.stateMachineTid,
          "Screen Height": sysScreenHeight,
          }, "-OWrF7Hhl", "a40c5b302fec76a01b93a3e1690c9f29bd70f839635241d57ccc136024bcf50e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Companion Animation", {
      "Flow Name": properties.flowName,
      "Tab Code": properties.tabCode,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "State Machine Code": properties.stateMachineCode,
      "State Machine Tid": properties.stateMachineTid,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Completed Companion Animation: when companion animation is completed
   *
   * When to trigger this event:
   * 1. This screenshot is post adding stars into level bar.. the animation is already completed.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WuEAuDawCX/trigger/6ULDytqt2
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.flowName - This property will tell the flow of the companion - is it welcome back, or motivation, etc.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} properties.companionState - This property will tell if the companion has taken over full screen or is intervening from the peak view (from side)
   * @param {string} properties.animationUrl - This property will have the URL of the animation played
   * @param {Array<string>} properties.voUrl - This property will have the URL of the VO played
   * @param {string} properties.voText - This property will have the URL of the text of the VO
   * @param {bool} properties.caCompletedSuccessfully - This will be True/False. If animation completes successfully w/o the user interrupting it, the value will be True, otherwise False
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/WuEAuDawCX}
   */
  function completedCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFlowName(properties.flowName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertCompanionState(properties.companionState));
      messages = messages.concat(assertAnimationURL(properties.animationUrl));
      messages = messages.concat(assertVoURL(properties.voUrl));
      messages = messages.concat(assertVoText(properties.voText));
      messages = messages.concat(assertCACompletedSuccessfully(properties.caCompletedSuccessfully));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Completed Companion Animation", Object.keys(properties), [
        "flowName",
        "tabCode",
        "companionState",
        "animationUrl",
        "voUrl",
        "voText",
        "caCompletedSuccessfully"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "WuEAuDawCX", "29d941b5255e6414054085eb814b8e15ab2fb04abc1c88f8dc7e9b1ec6aa27e3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Completed Companion Animation", {
        "Flow Name": properties.flowName,
        "Tab Code": properties.tabCode,
        "Companion State": properties.companionState,
        "Animation URL": properties.animationUrl,
        "Vo URL": properties.voUrl,
        "Vo Text": properties.voText,
        "CA Completed Successfully": properties.caCompletedSuccessfully,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("WuEAuDawCX", "Completed Companion Animation", messages, [
        {id: "KEGhoZGvu", name: "Vo Text", value: properties.voText},
        {id: "MBcj_KFnG", name: "Companion State", value: properties.companionState},
        {id: "QvqHzz_24", name: "Flow Name", value: properties.flowName},
        {id: "_YDbEIGLh", name: "CA Completed Successfully", value: properties.caCompletedSuccessfully},
        {id: "dt9ueOw7v", name: "Animation URL", value: properties.animationUrl},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "yeiCDbEMb", name: "Vo URL", value: properties.voUrl},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Completed Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Completed Companion Animation", {
          "Flow Name": properties.flowName,
          "Tab Code": properties.tabCode,
          "Companion State": properties.companionState,
          "Animation URL": properties.animationUrl,
          "Vo URL": properties.voUrl,
          "Vo Text": properties.voText,
          "CA Completed Successfully": properties.caCompletedSuccessfully,
          "Screen Height": sysScreenHeight,
          }, "WuEAuDawCX", "29d941b5255e6414054085eb814b8e15ab2fb04abc1c88f8dc7e9b1ec6aa27e3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Completed Companion Animation", {
      "Flow Name": properties.flowName,
      "Tab Code": properties.tabCode,
      "Companion State": properties.companionState,
      "Animation URL": properties.animationUrl,
      "Vo URL": properties.voUrl,
      "Vo Text": properties.voText,
      "CA Completed Successfully": properties.caCompletedSuccessfully,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Companion: This event will be fired if child taps/clicks on the companion
   *
   * When to trigger this event:
   * 1. Companion is tapped or clicked upon
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nmR1hU8sWg/trigger/Qtjymy332
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} properties.animationUrl - This property will have the URL of the animation played
   * @param {Array<string>} properties.voUrl - This property will have the URL of the VO played
   * @param {string} properties.voText - This property will have the URL of the text of the VO
   * @param {Array<string>} properties.recommendedRail - This property will be used to store which rails were shown to the user in the HOME tab.

Where possible values are:
Rail Name = Curriculum, Game Zone, Math, Language, Logic & Thinking, Art & Creativity, General Knowledge, Motor Skills, Live Classes, Fluency, Multiplayer
   * @param {string} properties.tapType - This property will tell if the child has tapped once or multiple time on the companion

   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nmR1hU8sWg}
   */
  function interactedCompanion(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertAnimationURL(properties.animationUrl));
      messages = messages.concat(assertVoURL(properties.voUrl));
      messages = messages.concat(assertVoText(properties.voText));
      messages = messages.concat(assertRecommendedRail(properties.recommendedRail));
      messages = messages.concat(assertTapType(properties.tapType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Companion", Object.keys(properties), [
        "tabCode",
        "animationUrl",
        "voUrl",
        "voText",
        "recommendedRail",
        "tapType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nmR1hU8sWg", "217a4cd84d5fc0bf80a5fdc4a1827a14cdd1c217cd484fa83a4cc01e2addf9e5", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Companion", {
        "Tab Code": properties.tabCode,
        "Animation URL": properties.animationUrl,
        "Vo URL": properties.voUrl,
        "Vo Text": properties.voText,
        "Recommended Rail": properties.recommendedRail,
        "Tap Type": properties.tapType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nmR1hU8sWg", "Interacted Companion", messages, [
        {id: "CG846K8Ql", name: "Tap Type", value: properties.tapType},
        {id: "KEGhoZGvu", name: "Vo Text", value: properties.voText},
        {id: "drNgwJn5Xg", name: "Recommended Rail", value: properties.recommendedRail},
        {id: "dt9ueOw7v", name: "Animation URL", value: properties.animationUrl},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "yeiCDbEMb", name: "Vo URL", value: properties.voUrl},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Companion': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Companion", {
          "Tab Code": properties.tabCode,
          "Animation URL": properties.animationUrl,
          "Vo URL": properties.voUrl,
          "Vo Text": properties.voText,
          "Recommended Rail": properties.recommendedRail,
          "Tap Type": properties.tapType,
          "Screen Height": sysScreenHeight,
          }, "nmR1hU8sWg", "217a4cd84d5fc0bf80a5fdc4a1827a14cdd1c217cd484fa83a4cc01e2addf9e5");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Companion", {
      "Tab Code": properties.tabCode,
      "Animation URL": properties.animationUrl,
      "Vo URL": properties.voUrl,
      "Vo Text": properties.voText,
      "Recommended Rail": properties.recommendedRail,
      "Tap Type": properties.tapType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Dashboard Graphql Query Started: This event should trigger when a graphql query is started in flutter dashboard
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/qlZTJ15u1d}
   */
  function dashboardGraphqlQueryStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Dashboard Graphql Query Started", Object.keys(properties), [
        "tabCode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "qlZTJ15u1d", "d72ff13f124e71bd7df24c4cd4f719fbec759a3542cab2cab1250c81836aa5ac", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Dashboard Graphql Query Started", {
        "Tab Code": properties.tabCode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("qlZTJ15u1d", "Dashboard Graphql Query Started", messages, [
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Dashboard Graphql Query Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard Graphql Query Started", {
          "Tab Code": properties.tabCode,
          "Screen Height": sysScreenHeight,
          }, "qlZTJ15u1d", "d72ff13f124e71bd7df24c4cd4f719fbec759a3542cab2cab1250c81836aa5ac");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Dashboard Graphql Query Started", {
      "Tab Code": properties.tabCode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Dashboard Graphql Query Ended: This event should trigger when a graphql query is completed.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} properties.status - To determine if the process failed or succeeded
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yOJB_Qth0}
   */
  function dashboardGraphqlQueryEnded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Dashboard Graphql Query Ended", Object.keys(properties), [
        "tabCode",
        "status"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yOJB_Qth0", "68452485b5ce0df4476663e938a962e16b87164ea2da4a7fdac2d7547ab8c834", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Dashboard Graphql Query Ended", {
        "Tab Code": properties.tabCode,
        "Status": properties.status,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yOJB_Qth0", "Dashboard Graphql Query Ended", messages, [
        {id: "9_Al8_kuam", name: "Status", value: properties.status},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Dashboard Graphql Query Ended': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard Graphql Query Ended", {
          "Tab Code": properties.tabCode,
          "Status": properties.status,
          "Screen Height": sysScreenHeight,
          }, "yOJB_Qth0", "68452485b5ce0df4476663e938a962e16b87164ea2da4a7fdac2d7547ab8c834");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Dashboard Graphql Query Ended", {
      "Tab Code": properties.tabCode,
      "Status": properties.status,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Dashboard Rendered: This event should trigger when a flutter dashboard ui is rendered
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/7TSQLU-m4}
   */
  function dashboardRendered(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Dashboard Rendered", Object.keys(properties), [
        "mathGrade",
        "mode",
        "tabCode",
        "platform",
        "userType",
        "elaGrade",
        "grade",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "7TSQLU-m4", "d9950131fd5a337c716df56f8691b19bd123c7d6445b3085b9d464ae5428abca", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Dashboard Rendered", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Tab Code": properties.tabCode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("7TSQLU-m4", "Dashboard Rendered", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Dashboard Rendered': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Dashboard Rendered", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Tab Code": properties.tabCode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "7TSQLU-m4", "d9950131fd5a337c716df56f8691b19bd123c7d6445b3085b9d464ae5428abca");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Dashboard Rendered", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Tab Code": properties.tabCode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Complete Topic Assignment Popup [B2B]: This event will be fired when the user clicks on 'Mark as complete' from the three dots on the right side of the Curriculum Widget and the 'Mark topic assignment as completed' popup is viewed by the user
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/boq1utIEdA/trigger/m9fEM4ypz
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/boq1utIEdA}
   */
  function viewedCompleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Complete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "boq1utIEdA", "5fedeee910ea6be22fe894016f80a9df29162df93181079c2919597d1ca3c445", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Complete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("boq1utIEdA", "Viewed Complete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Complete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Complete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "boq1utIEdA", "5fedeee910ea6be22fe894016f80a9df29162df93181079c2919597d1ca3c445");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Complete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Complete Topic Assignment Popup [B2B]: This event will be fired when the user interacts with the 'Mark topic assignment as completed' popup.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RG5hu3hbgV/trigger/wPCNeVSZD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/RG5hu3hbgV}
   */
  function interactedCompleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Complete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "RG5hu3hbgV", "111d9f3bca4d3ff739142da084a95f4be281a2079da4793f194436ae640a328a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Complete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("RG5hu3hbgV", "Interacted Complete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Complete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Complete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "RG5hu3hbgV", "111d9f3bca4d3ff739142da084a95f4be281a2079da4793f194436ae640a328a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Complete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Delete Topic Assignment Popup [B2B]: This event will be fired when the user clicks on 'Delete' from the three dots on the right side of the Curriculum Widget and the 'Delete topic assignment' popup is viewed by the user
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HQiUZNrMh/trigger/1f3ciVYuLO
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/HQiUZNrMh}
   */
  function viewedDeleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Delete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "HQiUZNrMh", "0401ba0fbe1986a11c0b4f069f007ae8356d36b62591c8381b70f46a1f651650", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Delete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("HQiUZNrMh", "Viewed Delete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Delete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Delete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "HQiUZNrMh", "0401ba0fbe1986a11c0b4f069f007ae8356d36b62591c8381b70f46a1f651650");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Delete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Delete Topic Assignment Popup [B2B]: This event will be fired when the user interacts with the 'Delete topic assignment' popup.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gAuM0uQD0/trigger/eDeY1ZBOnf
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gAuM0uQD0}
   */
  function interactedDeleteTopicAssignmentPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Delete Topic Assignment Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gAuM0uQD0", "e1fd7ffea3c3341e99714ce87ea161481610f8a5d118f3aad6d2266e897abca8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Delete Topic Assignment Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gAuM0uQD0", "Interacted Delete Topic Assignment Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Delete Topic Assignment Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Delete Topic Assignment Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "gAuM0uQD0", "e1fd7ffea3c3341e99714ce87ea161481610f8a5d118f3aad6d2266e897abca8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Delete Topic Assignment Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Downloaded Worksheet B2C: This event contains the details of the downloaded worksheet from the printable tab on web
   *
   * When to trigger this event:
   * 1. When user clicks on the download button
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/coq92PhrRA/trigger/exUzpF3ni
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.worksheetName - Name of the Worksheet that is downloaded, clicked or tapped.
   * @param {string} properties.worksheetCode - Worksheet code of selected worksheet
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userCountry - Name of the country the user is from
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/coq92PhrRA}
   */
  function downloadedWorksheetB2c(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertWorksheetName(properties.worksheetName));
      messages = messages.concat(assertWorksheetCode(properties.worksheetCode));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserCountry(properties.userCountry));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Downloaded Worksheet B2C", Object.keys(properties), [
        "worksheetName",
        "worksheetCode",
        "signupFlow",
        "platform",
        "userCountry",
        "userType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "coq92PhrRA", "b1d3b8c44f48650e87d3caa692b39ce1a6ef7a763c5efc710c5fc7c198e92213", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Downloaded Worksheet B2C", {
        "Worksheet Name": properties.worksheetName,
        "Worksheet Code": properties.worksheetCode,
        "Signup Flow": properties.signupFlow,
        "Platform": properties.platform,
        "User Country": properties.userCountry,
        "User Type": properties.userType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("coq92PhrRA", "Downloaded Worksheet B2C", messages, [
        {id: "NRFYZYLxy", name: "Worksheet Code", value: properties.worksheetCode},
        {id: "g8uPZdwOmF", name: "Worksheet Name", value: properties.worksheetName},
        {id: "vHdXCmyiec", name: "User Country", value: properties.userCountry},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Downloaded Worksheet B2C': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Downloaded Worksheet B2C", {
          "Worksheet Name": properties.worksheetName,
          "Worksheet Code": properties.worksheetCode,
          "Signup Flow": properties.signupFlow,
          "Platform": properties.platform,
          "User Country": properties.userCountry,
          "User Type": properties.userType,
          "Screen Height": sysScreenHeight,
          }, "coq92PhrRA", "b1d3b8c44f48650e87d3caa692b39ce1a6ef7a763c5efc710c5fc7c198e92213");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Downloaded Worksheet B2C", {
      "Worksheet Name": properties.worksheetName,
      "Worksheet Code": properties.worksheetCode,
      "Signup Flow": properties.signupFlow,
      "Platform": properties.platform,
      "User Country": properties.userCountry,
      "User Type": properties.userType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Assignment Successfully Assigned Page [B2B]: This event is triggered upon click of Download Invite/Copy Invite button after assigning assignments to whole class/selected students
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.assignmentType - This will capture the type of assignment - Manual or Auto
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/E1mCLE5rKH}
   */
  function interactedAssignmentSuccessfullyAssignedPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertAssignmentType(properties.assignmentType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Assignment Successfully Assigned Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "assignmentType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "E1mCLE5rKH", "df2c873e271abc7e42ec3dc08365542bf84edfee5d4e36836bb72230e022ffee", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Assignment Successfully Assigned Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Assignment Type": properties.assignmentType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("E1mCLE5rKH", "Interacted Assignment Successfully Assigned Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "Ueowl7sRb", name: "Assignment Type", value: properties.assignmentType},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Assignment Successfully Assigned Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Assignment Successfully Assigned Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Assignment Type": properties.assignmentType,
          "Screen Height": sysScreenHeight,
          }, "E1mCLE5rKH", "df2c873e271abc7e42ec3dc08365542bf84edfee5d4e36836bb72230e022ffee");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Assignment Successfully Assigned Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Assignment Type": properties.assignmentType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted School Selection Screen [B2B]: This event will be fired in the below cases:
1. Started typing city
2. Stopped typing city
3. Selected city from list
4. Started typing  school
5. Stopped typing school
6. Selected school from list
7. Clicks on 'Find US schools here' or 'Find non-US schools here'

Clicked on will capture the dropdown name - 'City' or 'School'
Value Name will capture the value selected from the dropdown or value of text typed (whichever is relevant). For example, 'I don't see my school' or 'Phoenix'.
Interaction Details will capture the started and stopped events for city and school

The current event - Clicked School Info Added [B2B] will continue to get fired after the user clicks on 'Set your School' CTA.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.interactionDetails] - Stores where is the user interacting with the page
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3CumscrUi6}
   */
  function interactedSchoolSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalInteractionDetails(properties.interactionDetails));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted School Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "interactionDetails",
        "valueName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3CumscrUi6", "da34bcaba0270f6907da90199273750e5d1e27b300844325d6c0e1896adb3170", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted School Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Interaction Details": properties.interactionDetails,
        "Value Name": properties.valueName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3CumscrUi6", "Interacted School Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "ncdYto9gZ", name: "Interaction Details", value: properties.interactionDetails},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted School Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted School Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Interaction Details": properties.interactionDetails,
          "Value Name": properties.valueName,
          "Screen Height": sysScreenHeight,
          }, "3CumscrUi6", "da34bcaba0270f6907da90199273750e5d1e27b300844325d6c0e1896adb3170");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted School Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Interaction Details": properties.interactionDetails,
      "Value Name": properties.valueName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Pricing Info Box: When the user hovers over the info icon on the purchase summary page to view the price breakdown.
   *
   * When to trigger this event:
   * 1. User hovers on the info icon (i)
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kOTuFtT49Q/trigger/bc_hmb-Xr
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kOTuFtT49Q}
   */
  function viewedPricingInfoBox(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Pricing Info Box", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kOTuFtT49Q", "d0a761535bc9b890f35f0e703219185c02efdc14d5746543de8440dc24193750", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Pricing Info Box", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kOTuFtT49Q", "Viewed Pricing Info Box", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Pricing Info Box': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Pricing Info Box", {
          "Screen Height": sysScreenHeight,
          }, "kOTuFtT49Q", "d0a761535bc9b890f35f0e703219185c02efdc14d5746543de8440dc24193750");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Pricing Info Box", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Live Class Tab Available: This event is triggered every time a user lands on the dashboard and the live classes tab is visible
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userCountry - Name of the country the user is from
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/75smLMrncw}
   */
  function liveClassTabAvailable(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserCountry(properties.userCountry));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Live Class Tab Available", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "userCountry"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "75smLMrncw", "6e2d64fc0c295b39c8606d837fed67cb2d9ad03b45a95455bb83abfffed97730", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Live Class Tab Available", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Country": properties.userCountry,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("75smLMrncw", "Live Class Tab Available", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vHdXCmyiec", name: "User Country", value: properties.userCountry},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Live Class Tab Available': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Live Class Tab Available", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Country": properties.userCountry,
          "Screen Height": sysScreenHeight,
          }, "75smLMrncw", "6e2d64fc0c295b39c8606d837fed67cb2d9ad03b45a95455bb83abfffed97730");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Live Class Tab Available", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Country": properties.userCountry,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Ended Companion Animation: This event will be fired as soon as an started flow is closed.
   *
   * When to trigger this event:
   * 1. Whenever the animation is over.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4dONJ9evNU/trigger/gsJAqXp79
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.flowName - This property will tell the flow of the companion - is it welcome back, or motivation, etc.
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {bool} properties.userIntervention - This will give true / false. True will come only when user has done something to stop the animation.
   * @param {bool} properties.caCompletedSuccessfully - This will be True/False. If animation completes successfully w/o the user interrupting it, the value will be True, otherwise False
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.stateMachineCode - Every state machine has its own code, so whenever state machine switches we will be able to debug any issue that may arise
   * @param {string} properties.stateMachineTid - it is a unique code, passed as string for each state machine
   * @param {Array<string>} [properties.voUrl] - This property will have the URL of the VO played
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/4dONJ9evNU}
   */
  function endedCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFlowName(properties.flowName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertUserIntervention(properties.userIntervention));
      messages = messages.concat(assertCACompletedSuccessfully(properties.caCompletedSuccessfully));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertStateMachineCode(properties.stateMachineCode));
      messages = messages.concat(assertStateMachineTid(properties.stateMachineTid));
      messages = messages.concat(assertOptionalVoURL(properties.voUrl));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Ended Companion Animation", Object.keys(properties), [
        "flowName",
        "tabCode",
        "userIntervention",
        "caCompletedSuccessfully",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade",
        "stateMachineCode",
        "stateMachineTid",
        "voUrl"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "4dONJ9evNU", "7d182e3ee9c67be5feaa93453ff43c2b5601e2feb93f14808d87e432681f8a6d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Ended Companion Animation", {
        "Flow Name": properties.flowName,
        "Tab Code": properties.tabCode,
        "User Intervention": properties.userIntervention,
        "CA Completed Successfully": properties.caCompletedSuccessfully,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "State Machine Code": properties.stateMachineCode,
        "State Machine Tid": properties.stateMachineTid,
        "Vo URL": properties.voUrl,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("4dONJ9evNU", "Ended Companion Animation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "D325IngkY", name: "State Machine Tid", value: properties.stateMachineTid},
        {id: "NPXDMFP1_", name: "User Intervention", value: properties.userIntervention},
        {id: "QvqHzz_24", name: "Flow Name", value: properties.flowName},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "T9gjnp76o", name: "State Machine Code", value: properties.stateMachineCode},
        {id: "_YDbEIGLh", name: "CA Completed Successfully", value: properties.caCompletedSuccessfully},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "yeiCDbEMb", name: "Vo URL", value: properties.voUrl},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Ended Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ended Companion Animation", {
          "Flow Name": properties.flowName,
          "Tab Code": properties.tabCode,
          "User Intervention": properties.userIntervention,
          "CA Completed Successfully": properties.caCompletedSuccessfully,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "State Machine Code": properties.stateMachineCode,
          "State Machine Tid": properties.stateMachineTid,
          "Vo URL": properties.voUrl,
          "Screen Height": sysScreenHeight,
          }, "4dONJ9evNU", "7d182e3ee9c67be5feaa93453ff43c2b5601e2feb93f14808d87e432681f8a6d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Ended Companion Animation", {
      "Flow Name": properties.flowName,
      "Tab Code": properties.tabCode,
      "User Intervention": properties.userIntervention,
      "CA Completed Successfully": properties.caCompletedSuccessfully,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "State Machine Code": properties.stateMachineCode,
      "State Machine Tid": properties.stateMachineTid,
      "Vo URL": properties.voUrl,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Companion Recommendation: This event is associated to a specific flow of the companion where it recommends a playable on the basis of user inactivity.
   *
   * When to trigger this event:
   * 1. After sometime of user inactivity, the companion recommends a playable to play. This event will be triggered when recommendations happen.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IbAOUQNf6l/trigger/T7nhGGN9f
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {string} [properties.contentGroup] - Name of content group user clicked/tapped on
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IbAOUQNf6l}
   */
  function viewedCompanionRecommendation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Companion Recommendation", Object.keys(properties), [
        "playableCode",
        "playableName",
        "contentGroup",
        "tabCode",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IbAOUQNf6l", "461f5468d34492a6481de4df177d86f4c6347bd23adcdc50dc82184d7fac0e79", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Companion Recommendation", {
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Content Group": properties.contentGroup,
        "Tab Code": properties.tabCode,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IbAOUQNf6l", "Viewed Companion Recommendation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Companion Recommendation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Companion Recommendation", {
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Content Group": properties.contentGroup,
          "Tab Code": properties.tabCode,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "IbAOUQNf6l", "461f5468d34492a6481de4df177d86f4c6347bd23adcdc50dc82184d7fac0e79");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Companion Recommendation", {
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Content Group": properties.contentGroup,
      "Tab Code": properties.tabCode,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Companion Recommendation: Like companion recommends a playable based on user inactivity, this event is specific to interaction on that screen.
   *
   * When to trigger this event:
   * 1. When user clicks on the recommendation screen - user can click on the playable to start, click on home or the overlay.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTuuHkivgt/trigger/JKQ6FTmVR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} properties.playableName - Name of playable selected
   * @param {string} properties.tabCode - Specifies the tab which has been opened in the event 'Viewed Tiled Dashboard'
   * @param {string} [properties.contentGroup] - Name of content group user clicked/tapped on
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wTuuHkivgt}
   */
  function interactedCompanionRecommendation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertPlayableName(properties.playableName));
      messages = messages.concat(assertTabCode(properties.tabCode));
      messages = messages.concat(assertOptionalContentGroup(properties.contentGroup));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Companion Recommendation", Object.keys(properties), [
        "clickedOn",
        "playableCode",
        "playableName",
        "tabCode",
        "contentGroup",
        "tid",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wTuuHkivgt", "57c5124adb97bc9f38d87e56fdf2ab5b2c04584c24884cf0fa4a076d5cc1233d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Companion Recommendation", {
        "Clicked On": properties.clickedOn,
        "Playable Code": properties.playableCode,
        "Playable Name": properties.playableName,
        "Tab Code": properties.tabCode,
        "Content Group": properties.contentGroup,
        "Tid": properties.tid,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wTuuHkivgt", "Interacted Companion Recommendation", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "Otu1r2JQW", name: "Content Group", value: properties.contentGroup},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "c2W4X05Jy", name: "Playable Name", value: properties.playableName},
        {id: "l9PbANZBu", name: "Tab Code", value: properties.tabCode},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Companion Recommendation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Companion Recommendation", {
          "Clicked On": properties.clickedOn,
          "Playable Code": properties.playableCode,
          "Playable Name": properties.playableName,
          "Tab Code": properties.tabCode,
          "Content Group": properties.contentGroup,
          "Tid": properties.tid,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "wTuuHkivgt", "57c5124adb97bc9f38d87e56fdf2ab5b2c04584c24884cf0fa4a076d5cc1233d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Companion Recommendation", {
      "Clicked On": properties.clickedOn,
      "Playable Code": properties.playableCode,
      "Playable Name": properties.playableName,
      "Tab Code": properties.tabCode,
      "Content Group": properties.contentGroup,
      "Tid": properties.tid,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Started Pitstop Companion Animation: This event is specific to the pitstops where companion comes and collects the stars.
   *
   * When to trigger this event:
   * 1. When user sees the pitstop after completing the playable
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/scKxG4Olr8/trigger/fzDcvCc-D
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.nextPlayableCode] - The next playable that is going to load after current if the user is playing in the autoplay.
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/scKxG4Olr8}
   */
  function startedPitstopCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalNextPlayableCode(properties.nextPlayableCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Started Pitstop Companion Animation", Object.keys(properties), [
        "playableCode",
        "nextPlayableCode",
        "tid"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "scKxG4Olr8", "d33a96c9a6f2ed3ef351b53e042422b4f7e811089a9bedb8e967c6b116ed891e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Started Pitstop Companion Animation", {
        "Playable Code": properties.playableCode,
        "Next Playable Code": properties.nextPlayableCode,
        "Tid": properties.tid,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("scKxG4Olr8", "Started Pitstop Companion Animation", messages, [
        {id: "88sHuVDRp", name: "Next Playable Code", value: properties.nextPlayableCode},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Started Pitstop Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Started Pitstop Companion Animation", {
          "Playable Code": properties.playableCode,
          "Next Playable Code": properties.nextPlayableCode,
          "Tid": properties.tid,
          "Screen Height": sysScreenHeight,
          }, "scKxG4Olr8", "d33a96c9a6f2ed3ef351b53e042422b4f7e811089a9bedb8e967c6b116ed891e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Started Pitstop Companion Animation", {
      "Playable Code": properties.playableCode,
      "Next Playable Code": properties.nextPlayableCode,
      "Tid": properties.tid,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Ended Pitstop Companion Animation: This event is specific to the pitstop when the companion is done with collecting the starts and portal out has happened.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/R1oCIqeQSw/trigger/idCCh4V2l
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.playableCode - Pass the 'Playable Code' of the Playable being started/clicked
   * @param {string} [properties.nextPlayableCode] - The next playable that is going to load after current if the user is playing in the autoplay.
   * @param {string} properties.tid - It's a unique id associated to every new animation getting triggered.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/R1oCIqeQSw}
   */
  function endedPitstopCompanionAnimation(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlayableCode(properties.playableCode));
      messages = messages.concat(assertOptionalNextPlayableCode(properties.nextPlayableCode));
      messages = messages.concat(assertTid(properties.tid));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Ended Pitstop Companion Animation", Object.keys(properties), [
        "playableCode",
        "nextPlayableCode",
        "tid"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "R1oCIqeQSw", "af0b9896f1c0a68bc939579622d3305f36daf6f9c0f47365c1243dba64e65a0e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Ended Pitstop Companion Animation", {
        "Playable Code": properties.playableCode,
        "Next Playable Code": properties.nextPlayableCode,
        "Tid": properties.tid,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("R1oCIqeQSw", "Ended Pitstop Companion Animation", messages, [
        {id: "88sHuVDRp", name: "Next Playable Code", value: properties.nextPlayableCode},
        {id: "QjCwFasvW0", name: "Playable Code", value: properties.playableCode},
        {id: "SYGmTqa9e", name: "Tid", value: properties.tid},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Ended Pitstop Companion Animation': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Ended Pitstop Companion Animation", {
          "Playable Code": properties.playableCode,
          "Next Playable Code": properties.nextPlayableCode,
          "Tid": properties.tid,
          "Screen Height": sysScreenHeight,
          }, "R1oCIqeQSw", "af0b9896f1c0a68bc939579622d3305f36daf6f9c0f47365c1243dba64e65a0e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Ended Pitstop Companion Animation", {
      "Playable Code": properties.playableCode,
      "Next Playable Code": properties.nextPlayableCode,
      "Tid": properties.tid,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Received Rive File: This event will be used for debugging purpose only.
   *
   * When to trigger this event:
   * 1. The event gets triggered when we get events in the pending events API of splashee.
The event will be used for debugging/monitoring purpose.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IAJ5wU1sXk/trigger/7_33H0u0V
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IAJ5wU1sXk}
   */
  function receivedRiveFile(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Received Rive File", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IAJ5wU1sXk", "b6c54341cd1ce3892624c0ee38e0d4f0a21faa189d4fd94eadddd157c0c31e5f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Received Rive File", {
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IAJ5wU1sXk", "Received Rive File", messages, [
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Received Rive File': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Received Rive File", {
          "Screen Height": sysScreenHeight,
          }, "IAJ5wU1sXk", "b6c54341cd1ce3892624c0ee38e0d4f0a21faa189d4fd94eadddd157c0c31e5f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Received Rive File", {
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Companion Events Backend: This event will be fired once the API receives the pending events from backend. It will be used purely for debugging purposes.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.eventName - In the API response, it will show which files/events info received in response.
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/e4DuEUN6yq}
   */
  function companionEventsBackend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertEventName(properties.eventName));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Companion Events Backend", Object.keys(properties), [
        "eventName",
        "platform",
        "elaGrade",
        "mathGrade",
        "mode",
        "userType",
        "signupFlow",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "e4DuEUN6yq", "422d63cd3c9f07dfbff01312d69a1ddd55fae15439a9b9c4f0c2f85c0818baaf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Companion Events Backend", {
        "Event Name": properties.eventName,
        "Platform": properties.platform,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("e4DuEUN6yq", "Companion Events Backend", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "DmZydOAXd", name: "Event Name", value: properties.eventName},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Companion Events Backend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Companion Events Backend", {
          "Event Name": properties.eventName,
          "Platform": properties.platform,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "e4DuEUN6yq", "422d63cd3c9f07dfbff01312d69a1ddd55fae15439a9b9c4f0c2f85c0818baaf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Companion Events Backend", {
      "Event Name": properties.eventName,
      "Platform": properties.platform,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Reached Daily Limit Backend: This event needs to be fired when the user reaches the daily limit irrespective of the experiment segment. This should happen for 2 free cards or freemium of 10 minutes.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.contentType - Type of content viz. Game/Learning Path/Activities/Worksheets
   * @param {string} properties.contentCode - Last content code when limit reached
   * @param {string} properties.contentName - Name of the last playable/activity/worksheet/live class etc, when limit reached
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/M-LJK1cyN}
   */
  function reachedDailyLimitBackend(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertContentCode(properties.contentCode));
      messages = messages.concat(assertContentName(properties.contentName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Reached Daily Limit Backend", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "subject",
        "grade",
        "from",
        "contentType",
        "contentCode",
        "contentName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "M-LJK1cyN", "a4ab803726ece39baaf83624f2c4c6413f7a002d7296da32c691b9297a8bb820", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Reached Daily Limit Backend", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Subject": properties.subject,
        "Grade": properties.grade,
        "From": properties.from,
        "Content Type": properties.contentType,
        "Content Code": properties.contentCode,
        "Content Name": properties.contentName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("M-LJK1cyN", "Reached Daily Limit Backend", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "Nfs9QLl8W7", name: "Content Type", value: properties.contentType},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "gwbjSWtxS", name: "Content Code", value: properties.contentCode},
        {id: "mWOBwcMoZ", name: "Content Name", value: properties.contentName},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Reached Daily Limit Backend': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Reached Daily Limit Backend", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Subject": properties.subject,
          "Grade": properties.grade,
          "From": properties.from,
          "Content Type": properties.contentType,
          "Content Code": properties.contentCode,
          "Content Name": properties.contentName,
          "Screen Height": sysScreenHeight,
          }, "M-LJK1cyN", "a4ab803726ece39baaf83624f2c4c6413f7a002d7296da32c691b9297a8bb820");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Reached Daily Limit Backend", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Subject": properties.subject,
      "Grade": properties.grade,
      "From": properties.from,
      "Content Type": properties.contentType,
      "Content Code": properties.contentCode,
      "Content Name": properties.contentName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Add-on Pitch Screen: Triggered when the user is seeing add-on pitch screen immediately after starting their free trial of splashlearn
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PXFWBQ8pU3/trigger/qL0CUPN4t
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/PXFWBQ8pU3}
   */
  function viewedAddOnPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add-on Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "PXFWBQ8pU3", "ab2ef3adbde2ca0490fcc82067a606aae5ae65f8cc154ca39a3ecab1450d2ecd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Add-on Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("PXFWBQ8pU3", "Viewed Add-on Pitch Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add-on Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add-on Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "PXFWBQ8pU3", "ab2ef3adbde2ca0490fcc82067a606aae5ae65f8cc154ca39a3ecab1450d2ecd");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add-on Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Add-on Pitch Screen: Triggered when the user interacts with our add-on pitch screen. There are 2 CTAs where the user can click
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H2lRb4IRCY/trigger/RokxkpiXn
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/H2lRb4IRCY}
   */
  function interactedAddOnPitchScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add-on Pitch Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "H2lRb4IRCY", "79a959cfe7189a658cf4e966ae82df847a05cfa64e68c718ba4f55b94f6c1b8e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Add-on Pitch Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("H2lRb4IRCY", "Interacted Add-on Pitch Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add-on Pitch Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add-on Pitch Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "H2lRb4IRCY", "79a959cfe7189a658cf4e966ae82df847a05cfa64e68c718ba4f55b94f6c1b8e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add-on Pitch Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Add-on Upgrade Screen: Triggered when the user is interested in live classes and moves to the next screen where they are asked to upgrade the subscription
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dG7ayD4bTy/trigger/FwzYzj3UK
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/dG7ayD4bTy}
   */
  function viewedAddOnUpgradeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add-on Upgrade Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "dG7ayD4bTy", "22c20f234407cf2aeffe47ab9f10c38c46d04178a3375312115800e6df1b3ac3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Add-on Upgrade Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("dG7ayD4bTy", "Viewed Add-on Upgrade Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add-on Upgrade Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add-on Upgrade Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "dG7ayD4bTy", "22c20f234407cf2aeffe47ab9f10c38c46d04178a3375312115800e6df1b3ac3");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add-on Upgrade Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Add-on Upgrade Screen: Triggered when the user interacts anywhere on the add-on upgrade screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jE74LAzM9W/trigger/xt8tEu8yH
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jE74LAzM9W}
   */
  function interactedAddOnUpgradeScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add-on Upgrade Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jE74LAzM9W", "5950938e070ccd8c8bd0ee0d0f7a598c0edcd232dd26a758c9518f3fdc76396d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Add-on Upgrade Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jE74LAzM9W", "Interacted Add-on Upgrade Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add-on Upgrade Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add-on Upgrade Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "jE74LAzM9W", "5950938e070ccd8c8bd0ee0d0f7a598c0edcd232dd26a758c9518f3fdc76396d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add-on Upgrade Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Add-on Purchase Thank You Screen: Triggered after the user decides to upgrade their trial and purchase the add-on. The user arrives at this screen after some animation and hence tracking this event separately will be important
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5pu5eq8KFO/trigger/08J4YyRUq
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5pu5eq8KFO}
   */
  function viewedAddOnPurchaseThankYouScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Add-on Purchase Thank You Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5pu5eq8KFO", "511562608ed025077da361d565f1ff7743e0881cda15f78817586560dac54f8c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Add-on Purchase Thank You Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5pu5eq8KFO", "Viewed Add-on Purchase Thank You Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Add-on Purchase Thank You Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Add-on Purchase Thank You Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "5pu5eq8KFO", "511562608ed025077da361d565f1ff7743e0881cda15f78817586560dac54f8c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Add-on Purchase Thank You Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Add-on Purchase Thank You Screen: Triggered when the user starts interacting on the purchase thank you screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QT1Zp_1x6-/trigger/prOwh0PVx
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/QT1Zp_1x6-}
   */
  function interactedAddOnPurchaseThankYouScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Add-on Purchase Thank You Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QT1Zp_1x6-", "4d9c12218f48421b51b22e940f98c953cba74f48d0f994bac17ded5b70e2078a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Add-on Purchase Thank You Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QT1Zp_1x6-", "Interacted Add-on Purchase Thank You Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Add-on Purchase Thank You Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Add-on Purchase Thank You Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "QT1Zp_1x6-", "4d9c12218f48421b51b22e940f98c953cba74f48d0f994bac17ded5b70e2078a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Add-on Purchase Thank You Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Post Live Class Pitch: Triggered when a free user drops or ends the class
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P8E8Esk3NA/trigger/u6HRYjajN
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P8E8Esk3NA}
   */
  function viewedPostLiveClassPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Post Live Class Pitch", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "P8E8Esk3NA", "a9e24496438ba39ae00d3acea37114b764faa5aa188b141f04172ff2446027fa", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Post Live Class Pitch", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("P8E8Esk3NA", "Viewed Post Live Class Pitch", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Post Live Class Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Post Live Class Pitch", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "P8E8Esk3NA", "a9e24496438ba39ae00d3acea37114b764faa5aa188b141f04172ff2446027fa");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Post Live Class Pitch", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Post Live Class Pitch: Triggered when a user interacts with the post live class pitch
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Q_-GVIESpj/trigger/tbOdM13OS
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Q_-GVIESpj}
   */
  function interactedPostLiveClassPitch(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Post Live Class Pitch", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Q_-GVIESpj", "01e29ea12dd25b79bd666dbab3169e44a2bd75addeda54503bbd34fd1654cb3e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Post Live Class Pitch", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Q_-GVIESpj", "Interacted Post Live Class Pitch", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Post Live Class Pitch': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Post Live Class Pitch", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "Q_-GVIESpj", "01e29ea12dd25b79bd666dbab3169e44a2bd75addeda54503bbd34fd1654cb3e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Post Live Class Pitch", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Reinforcement at Home [B2B]: This event will be triggered when the user lands on the 'Reinforcement at Home' page.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UmMA_mjerT/trigger/XRqrkXgSh
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UmMA_mjerT}
   */
  function viewedReinforcementAtHomeB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Reinforcement at Home [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UmMA_mjerT", "75cb2463d3250c68478d8f913e18fe15bfa7ea175453e4111d2fff1b833c7377", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Reinforcement at Home [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UmMA_mjerT", "Viewed Reinforcement at Home [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Reinforcement at Home [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Reinforcement at Home [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UmMA_mjerT", "75cb2463d3250c68478d8f913e18fe15bfa7ea175453e4111d2fff1b833c7377");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Reinforcement at Home [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Reinforcement at Home [B2B]: This event will be fired when the user interacts with the Reinforcement at Home [B2B]tab.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/De3feF0wy/trigger/I39GKLhSw
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.liveClassSubject] - This will capture the subject of the specific live class shared/clicked by teacher.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/De3feF0wy}
   */
  function interactedReinforcementAtHomeB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertOptionalLiveClassSubject(properties.liveClassSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Reinforcement at Home [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "section",
        "liveClassSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "De3feF0wy", "7c555db2236abf840f4cbca6bb24ee2d248690c05b21ce3041fa26338d6d2c7f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Reinforcement at Home [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Section": properties.section,
        "Live Class Subject": properties.liveClassSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("De3feF0wy", "Interacted Reinforcement at Home [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Ys_LWCV8p", name: "Live Class Subject", value: properties.liveClassSubject},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Reinforcement at Home [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Reinforcement at Home [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Section": properties.section,
          "Live Class Subject": properties.liveClassSubject,
          "Screen Height": sysScreenHeight,
          }, "De3feF0wy", "7c555db2236abf840f4cbca6bb24ee2d248690c05b21ce3041fa26338d6d2c7f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Reinforcement at Home [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Section": properties.section,
      "Live Class Subject": properties.liveClassSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Live Class Page [B2B]: This event will be fired when the user lands on the live class page.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZZs1HRlkF/trigger/e9rmJWrNZ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lZZs1HRlkF}
   */
  function viewedLiveClassPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Class Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lZZs1HRlkF", "aae2ba1e6b5038fb3e4b7d11ae8b31e8164085be0ffe16040f2a52f353171c05", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Live Class Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lZZs1HRlkF", "Viewed Live Class Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Class Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Class Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Screen Height": sysScreenHeight,
          }, "lZZs1HRlkF", "aae2ba1e6b5038fb3e4b7d11ae8b31e8164085be0ffe16040f2a52f353171c05");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Class Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Live Class Page [B2B]: This event will be fired when the user interacts with the live class page.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kJ8DpBgDY/trigger/4teYToc2T
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.section - This will capture the widget name that is being viewed/interacted by the user in that viewport. For example, 'Onboarding Widget', 'Home Access Widget', 'Assignment Widget', 'Assessment Widget', 'Math Fact Widget'
The list will only have 1 value for 'Section' property for Interacted event.
   * @param {string} [properties.liveClassName] - This will capture the title of the live class.
   * @param {string} [properties.liveClassWeek] - This will capture if the live class that was shared was from the current or next week.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} [properties.liveClassSubject] - This will capture the subject of the specific live class shared/clicked by teacher.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kJ8DpBgDY}
   */
  function interactedLiveClassPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertSection(properties.section));
      messages = messages.concat(assertOptionalLiveClassName(properties.liveClassName));
      messages = messages.concat(assertOptionalLiveClassWeek(properties.liveClassWeek));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalLiveClassSubject(properties.liveClassSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Class Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "section",
        "liveClassName",
        "liveClassWeek",
        "clickedOn",
        "liveClassSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kJ8DpBgDY", "11ecdd8478328131a7ca0b6a0064abe7a07ef3ecc9de06251cfb911f064ca4c4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Live Class Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Section": properties.section,
        "Live Class Name": properties.liveClassName,
        "Live Class Week": properties.liveClassWeek,
        "Clicked On": properties.clickedOn,
        "Live Class Subject": properties.liveClassSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kJ8DpBgDY", "Interacted Live Class Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "F__odFSVZ", name: "Live Class Name", value: properties.liveClassName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Ys_LWCV8p", name: "Live Class Subject", value: properties.liveClassSubject},
        {id: "my9qL7M8w6", name: "Section", value: properties.section},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "spiyY6nfy", name: "Live Class Week", value: properties.liveClassWeek},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Class Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Class Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Section": properties.section,
          "Live Class Name": properties.liveClassName,
          "Live Class Week": properties.liveClassWeek,
          "Clicked On": properties.clickedOn,
          "Live Class Subject": properties.liveClassSubject,
          "Screen Height": sysScreenHeight,
          }, "kJ8DpBgDY", "11ecdd8478328131a7ca0b6a0064abe7a07ef3ecc9de06251cfb911f064ca4c4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Class Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Section": properties.section,
      "Live Class Name": properties.liveClassName,
      "Live Class Week": properties.liveClassWeek,
      "Clicked On": properties.clickedOn,
      "Live Class Subject": properties.liveClassSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Max Live Class Limit Reached Popup [B2B]: This event will be fired whenever the user will see the error for max no. of classes shared popup message.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UIfEU7va_0/trigger/JQS4eYyg7
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/UIfEU7va_0}
   */
  function viewedMaxLiveClassLimitReachedPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Max Live Class Limit Reached Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "UIfEU7va_0", "e27a51528fbc09b51fb4ae94b46b8d29029c7692611b0ecff3a5c6826110ff55", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Max Live Class Limit Reached Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("UIfEU7va_0", "Viewed Max Live Class Limit Reached Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Max Live Class Limit Reached Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Max Live Class Limit Reached Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "UIfEU7va_0", "e27a51528fbc09b51fb4ae94b46b8d29029c7692611b0ecff3a5c6826110ff55");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Max Live Class Limit Reached Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Share Live Class Popup [B2B]: This event will be fired when the user clicks on 'Share' next to a live class and the share live class popup appears.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lQCBfZFMdk/trigger/4LdGit9TT
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/lQCBfZFMdk}
   */
  function viewedShareLiveClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Share Live Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "lQCBfZFMdk", "5559498ab6bb4084371bf8a65bcb61666c18c584441df3af763cd8f68cab9253", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Share Live Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("lQCBfZFMdk", "Viewed Share Live Class Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Share Live Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Share Live Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Screen Height": sysScreenHeight,
          }, "lQCBfZFMdk", "5559498ab6bb4084371bf8a65bcb61666c18c584441df3af763cd8f68cab9253");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Share Live Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Share Live Class Popup [B2B]: This event will be fired when the user clicks anywhere on the Share Live Class popup.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6A5k2oC6lq/trigger/6-EUjCD-a
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.studentId] - This will capture the Student analytics IDs in an array.
   * @param {string} [properties.percentClassInvited] - This will capture the (percentage of invited students in that class/total students in that class)
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.liveClassName - This will capture the title of the live class.
   * @param {string} properties.liveClassSubject - This will capture the subject of the specific live class shared/clicked by teacher.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6A5k2oC6lq}
   */
  function interactedShareLiveClassPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalStudentID(properties.studentId));
      messages = messages.concat(assertOptionalPercentClassInvited(properties.percentClassInvited));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertLiveClassName(properties.liveClassName));
      messages = messages.concat(assertLiveClassSubject(properties.liveClassSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Share Live Class Popup [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "studentId",
        "percentClassInvited",
        "fromPage",
        "liveClassName",
        "liveClassSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6A5k2oC6lq", "fac7991f0a2c6d4759684a7627e32d9bdee3d09b818111d90026a70ce847f05f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Share Live Class Popup [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Student ID": properties.studentId,
        "Percent Class Invited": properties.percentClassInvited,
        "From Page": properties.fromPage,
        "Live Class Name": properties.liveClassName,
        "Live Class Subject": properties.liveClassSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6A5k2oC6lq", "Interacted Share Live Class Popup [B2B]", messages, [
        {id: "2Q7hpPm9y", name: "Percent Class Invited", value: properties.percentClassInvited},
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "5IEpaITD9", name: "Student ID", value: properties.studentId},
        {id: "F__odFSVZ", name: "Live Class Name", value: properties.liveClassName},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "Ys_LWCV8p", name: "Live Class Subject", value: properties.liveClassSubject},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Share Live Class Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Share Live Class Popup [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Student ID": properties.studentId,
          "Percent Class Invited": properties.percentClassInvited,
          "From Page": properties.fromPage,
          "Live Class Name": properties.liveClassName,
          "Live Class Subject": properties.liveClassSubject,
          "Screen Height": sysScreenHeight,
          }, "6A5k2oC6lq", "fac7991f0a2c6d4759684a7627e32d9bdee3d09b818111d90026a70ce847f05f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Share Live Class Popup [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Student ID": properties.studentId,
      "Percent Class Invited": properties.percentClassInvited,
      "From Page": properties.fromPage,
      "Live Class Name": properties.liveClassName,
      "Live Class Subject": properties.liveClassSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Live Class Recommendation Popup: Triggered when the user lands on the dashboard after the class has been recommended
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P5_R3TLrNC/trigger/dwSc2a52-
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/P5_R3TLrNC}
   */
  function viewedLiveClassRecommendationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Live Class Recommendation Popup", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "P5_R3TLrNC", "bafab1f43e1e05c3598920a2571fd633064ee73e1c8f5d390558c3bf5994b0bf", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Live Class Recommendation Popup", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("P5_R3TLrNC", "Viewed Live Class Recommendation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Live Class Recommendation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Live Class Recommendation Popup", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "P5_R3TLrNC", "bafab1f43e1e05c3598920a2571fd633064ee73e1c8f5d390558c3bf5994b0bf");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Live Class Recommendation Popup", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Live Class Recommendation Popup: Triggered when the user interacts on the recommendation popup
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cgPOoWglHB/trigger/Xd-DMS86c
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/cgPOoWglHB}
   */
  function interactedLiveClassRecommendationPopup(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Live Class Recommendation Popup", Object.keys(properties), [
        "mathGrade",
        "mode",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "elaGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cgPOoWglHB", "5df7327d2169b82628dd9c2d0af7d0afc82349374b272fd0506344e8aad896fe", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Live Class Recommendation Popup", {
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Ela Grade": properties.elaGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cgPOoWglHB", "Interacted Live Class Recommendation Popup", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Live Class Recommendation Popup': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Live Class Recommendation Popup", {
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Ela Grade": properties.elaGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "cgPOoWglHB", "5df7327d2169b82628dd9c2d0af7d0afc82349374b272fd0506344e8aad896fe");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Live Class Recommendation Popup", {
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Ela Grade": properties.elaGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Loaded Question for Student: Going to render question
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sV2zKaFiHX}
   */
  function loadedQuestionForStudent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Loaded Question for Student", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sV2zKaFiHX", "163033cfd40053ea7fb2cfb5cd7717747913babd0ab28cb9ed87996443624b5b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Loaded Question for Student", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sV2zKaFiHX", "Loaded Question for Student", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Loaded Question for Student': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Loaded Question for Student", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "sV2zKaFiHX", "163033cfd40053ea7fb2cfb5cd7717747913babd0ab28cb9ed87996443624b5b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Loaded Question for Student", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Loaded Question for Tutor: Going to show question
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   * @param {string} properties.questionCode - This will capture unique question code.
   * @param {int} [properties.roundNumber] - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/XqHcpUcDoU}
   */
  function loadedQuestionForTutor(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertQuestionCode(properties.questionCode));
      messages = messages.concat(assertOptionalRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Loaded Question for Tutor", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber",
        "questionCode",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XqHcpUcDoU", "3b3a4fe351078c5f282d81f83a3cbd4f24db96f40d180e2014334bc68f087ea7", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Loaded Question for Tutor", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Question Code": properties.questionCode,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XqHcpUcDoU", "Loaded Question for Tutor", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "bZZvnMF1m", name: "Question Code", value: properties.questionCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Loaded Question for Tutor': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Loaded Question for Tutor", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Question Code": properties.questionCode,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "XqHcpUcDoU", "3b3a4fe351078c5f282d81f83a3cbd4f24db96f40d180e2014334bc68f087ea7");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Loaded Question for Tutor", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Question Code": properties.questionCode,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Tutor Quiz Timer Run Out: Triggered when the tutor interacts with the quiz timer run out screen
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.questionNumber - This will capture Question Serial Number.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nVCL9Xwvl}
   */
  function interactedTutorQuizTimerRunOut(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuestionNumber(properties.questionNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Quiz Timer Run Out", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "questionNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nVCL9Xwvl", "e890764a460c0aa2fbe5e7672703a003e14dfcf842e8112af929bd11a7b561af", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Tutor Quiz Timer Run Out", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Question Number": properties.questionNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nVCL9Xwvl", "Interacted Tutor Quiz Timer Run Out", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_cuCZnBI_", name: "Question Number", value: properties.questionNumber},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Quiz Timer Run Out': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Quiz Timer Run Out", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Question Number": properties.questionNumber,
          "Screen Height": sysScreenHeight,
          }, "nVCL9Xwvl", "e890764a460c0aa2fbe5e7672703a003e14dfcf842e8112af929bd11a7b561af");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Quiz Timer Run Out", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Question Number": properties.questionNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Google Account Selection Screen [B2B]: This event will be triggered when the user views the Google account selection screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zIZY4ziJaX/trigger/AZk-ZJIlK
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/zIZY4ziJaX}
   */
  function viewedGoogleAccountSelectionScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Google Account Selection Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zIZY4ziJaX", "665ab3e01cbc76246c98d081dc421146356e3bc5f666a7e18475bb81e6955f00", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Google Account Selection Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zIZY4ziJaX", "Viewed Google Account Selection Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Google Account Selection Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Google Account Selection Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Screen Height": sysScreenHeight,
          }, "zIZY4ziJaX", "665ab3e01cbc76246c98d081dc421146356e3bc5f666a7e18475bb81e6955f00");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Google Account Selection Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Google/Clever Class Import Screen [B2B]: This event should fire on the page load of google/clever class import screen.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ag3WEgo0bS/trigger/OP2nBPqpB
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ag3WEgo0bS}
   */
  function viewedGooglecleverClassImportScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Google/Clever Class Import Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ag3WEgo0bS", "1071b0c766df10b6e13481c009a6e9431941089e9755bf76a2fe6b15d2aaf171", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Google/Clever Class Import Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ag3WEgo0bS", "Viewed Google/Clever Class Import Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Google/Clever Class Import Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Google/Clever Class Import Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "ag3WEgo0bS", "1071b0c766df10b6e13481c009a6e9431941089e9755bf76a2fe6b15d2aaf171");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Google/Clever Class Import Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Google/Clever Class Import Screen [B2B]: This event gets fired when the user interacts with the google/clever class import screen.
This should not get fired when Import button is clicked because in that case, 'Selected classes for import' event already gets fired. That'll continue.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yMbbHB_hwS/trigger/3wFbp8HU3
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.classType - This Property will capture the type of class - Google Classroom or Clever or Manual
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yMbbHB_hwS}
   */
  function interactedGooglecleverClassImportScreenB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertClassType(properties.classType));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Google/Clever Class Import Screen [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "classType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yMbbHB_hwS", "35e6cb303c637e7dda9bf18067a5b341cdc2a96ab2b60d27af63b001f280b96b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Google/Clever Class Import Screen [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Class Type": properties.classType,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yMbbHB_hwS", "Interacted Google/Clever Class Import Screen [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "dk2bhnFne", name: "Class Type", value: properties.classType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Google/Clever Class Import Screen [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Google/Clever Class Import Screen [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Class Type": properties.classType,
          "Screen Height": sysScreenHeight,
          }, "yMbbHB_hwS", "35e6cb303c637e7dda9bf18067a5b341cdc2a96ab2b60d27af63b001f280b96b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Google/Clever Class Import Screen [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Class Type": properties.classType,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Error Message Displayed [B2B]: This event will get triggered when the user sees any error on the UI This info gets captured in the logs in DB but we need to analyse it within the Mixpanel funnel also.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.valueName - This will capture the value/text of the field that is selected.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/nZzV5gn-V9}
   */
  function errorMessageDisplayedB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertValueName(properties.valueName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Error Message Displayed [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "valueName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "nZzV5gn-V9", "19344520606470054dd18440e7947cdea73a6a2e0d70d809a63d8ba56d96c78c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Error Message Displayed [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Value Name": properties.valueName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("nZzV5gn-V9", "Error Message Displayed [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "l-8JNUE0q", name: "Value Name", value: properties.valueName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Error Message Displayed [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Error Message Displayed [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Value Name": properties.valueName,
          "Screen Height": sysScreenHeight,
          }, "nZzV5gn-V9", "19344520606470054dd18440e7947cdea73a6a2e0d70d809a63d8ba56d96c78c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Error Message Displayed [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Value Name": properties.valueName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Child Name Screen: User views the screen on which they enter the name of their child
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/G_jHclsDsT/trigger/I1HsbhA7M
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/G_jHclsDsT}
   */
  function viewedChildNameScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Child Name Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "G_jHclsDsT", "941e87db985de5e5f46d50bb45bafcfae424a5575f964f00be4a2d53bf093a1d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Child Name Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("G_jHclsDsT", "Viewed Child Name Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Child Name Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Child Name Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "G_jHclsDsT", "941e87db985de5e5f46d50bb45bafcfae424a5575f964f00be4a2d53bf093a1d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Child Name Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Child Name Screen: When the user starts typing the child's name or clicks on the next button
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VWDB4sjpeL/trigger/wwdFhpRMj
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/VWDB4sjpeL}
   */
  function interactedChildNameScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Child Name Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VWDB4sjpeL", "1fa4afde900ce93ba3f5f7362593c5c47a23312f72cf2d05eb9980635f8fa45c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Child Name Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VWDB4sjpeL", "Interacted Child Name Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Child Name Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Child Name Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "VWDB4sjpeL", "1fa4afde900ce93ba3f5f7362593c5c47a23312f72cf2d05eb9980635f8fa45c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Child Name Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Grade Selection Screen: User views the grade selection screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-kkf9y3eAb/trigger/9GIXQQM7H
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-kkf9y3eAb}
   */
  function viewedGradeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Grade Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-kkf9y3eAb", "8e1268852686a5c6020ccf4b08754008d5d2c596a0b4d2521a196462bf60dd49", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Grade Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-kkf9y3eAb", "Viewed Grade Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Grade Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Grade Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "-kkf9y3eAb", "8e1268852686a5c6020ccf4b08754008d5d2c596a0b4d2521a196462bf60dd49");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Grade Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Grade Selection Screen: Selected a grade on the grade selection screen. Takes the values: PreK, K, 1 etc.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gzaaiXgN49/trigger/EV3F--Ty-
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/gzaaiXgN49}
   */
  function interactedGradeSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Grade Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "gzaaiXgN49", "b261aa18ccadedc1525cd7131e7781d075a33a7b4bfb050339a53bcd8974dac1", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Grade Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("gzaaiXgN49", "Interacted Grade Selection Screen", messages, [
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Grade Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Grade Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Screen Height": sysScreenHeight,
          }, "gzaaiXgN49", "b261aa18ccadedc1525cd7131e7781d075a33a7b4bfb050339a53bcd8974dac1");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Grade Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Subject Selection Screen: User views the screen to select which subject to personalise first for the COQs
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kgQNRDN2BS/trigger/VlPHne9rp
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/kgQNRDN2BS}
   */
  function viewedSubjectSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Subject Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "kgQNRDN2BS", "d7370424ca414ad7b20dffcd378f18ce96dfc6ae5556cbe39cca5b6766986d9e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Subject Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("kgQNRDN2BS", "Viewed Subject Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Subject Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Subject Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "kgQNRDN2BS", "d7370424ca414ad7b20dffcd378f18ce96dfc6ae5556cbe39cca5b6766986d9e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Subject Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Subject Selection Screen: User selects either Math or Reading
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YY8BVQNds7/trigger/WWpgIfBy0
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/YY8BVQNds7}
   */
  function interactedSubjectSelectionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Subject Selection Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YY8BVQNds7", "645c3e738b13c9d451757085ded4e908b46ba7cf27ed41be770ab37fd92dd60e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Subject Selection Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YY8BVQNds7", "Interacted Subject Selection Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Subject Selection Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Subject Selection Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "YY8BVQNds7", "645c3e738b13c9d451757085ded4e908b46ba7cf27ed41be770ab37fd92dd60e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Subject Selection Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Onboarding Question Screen: User views any of the child onboarding questions
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5E7urWumBq/trigger/tCX0bFj2G
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.questionIndex - Index means order of the question
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {Array<string>} properties.optionsViewed - Array of all the options the user sees on the screen for a particular question
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5E7urWumBq}
   */
  function viewedOnboardingQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertQuestionIndex(properties.questionIndex));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertOptionsViewed(properties.optionsViewed));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Onboarding Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "questionIndex",
        "subject",
        "optionsViewed",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5E7urWumBq", "c5a16c76f53070db90a0eff6efdc60f2eeb31eefbf49ba0428a5c9cf9535d588", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Onboarding Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Question Index": properties.questionIndex,
        "Subject": properties.subject,
        "Options Viewed": properties.optionsViewed,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5E7urWumBq", "Viewed Onboarding Question Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "jJNP65jPw7", name: "Question Index", value: properties.questionIndex},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xHPp8yOuv", name: "Options Viewed", value: properties.optionsViewed},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Onboarding Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Onboarding Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Question Index": properties.questionIndex,
          "Subject": properties.subject,
          "Options Viewed": properties.optionsViewed,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "5E7urWumBq", "c5a16c76f53070db90a0eff6efdc60f2eeb31eefbf49ba0428a5c9cf9535d588");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Onboarding Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Question Index": properties.questionIndex,
      "Subject": properties.subject,
      "Options Viewed": properties.optionsViewed,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Onboarding Question Screen: User selects the answers, clicks skip or back
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KCuPnCuUW-/trigger/dcSlTKIA8
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.optionsSelected] - Array to save all of the options the user selects
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/KCuPnCuUW-}
   */
  function interactedOnboardingQuestionScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalOptionsSelected(properties.optionsSelected));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Onboarding Question Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "optionsSelected",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KCuPnCuUW-", "162bfb8cc0e5964903e27100bb2c2d0b4010eb8db0ad633f4700083fedde0e4c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Onboarding Question Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Options Selected": properties.optionsSelected,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KCuPnCuUW-", "Interacted Onboarding Question Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "FZg42lPcF", name: "Options Selected", value: properties.optionsSelected},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Onboarding Question Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Onboarding Question Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Options Selected": properties.optionsSelected,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "KCuPnCuUW-", "162bfb8cc0e5964903e27100bb2c2d0b4010eb8db0ad633f4700083fedde0e4c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Onboarding Question Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Options Selected": properties.optionsSelected,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Learning Plan Screen: User views the screen on which we present the learning path for that age/grade
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/noZNYXP5Gu/trigger/89hwb7Zt2
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {int} properties.numberOfLearnCards - Number of topics tagged 'Learn' in the Learning Path loadthrough
   * @param {int} properties.numberOfMasterCards - Number of topics tagged 'Master' in the Learning Path loadthrough
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/noZNYXP5Gu}
   */
  function viewedLearningPlanScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertNumberOfLearnCards(properties.numberOfLearnCards));
      messages = messages.concat(assertNumberOfMasterCards(properties.numberOfMasterCards));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Learning Plan Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "numberOfLearnCards",
        "numberOfMasterCards",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "noZNYXP5Gu", "bc49f94762bf67c49a1ab741dc4dda99a0ca356cb877a6e84a9ef45cc74d5bbc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Learning Plan Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Number of 'Learn' Cards": properties.numberOfLearnCards,
        "Number of 'Master' Cards": properties.numberOfMasterCards,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("noZNYXP5Gu", "Viewed Learning Plan Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "_rbYN5Au4", name: "Number of 'Learn' Cards", value: properties.numberOfLearnCards},
        {id: "fwzqzcIZ4", name: "Number of 'Master' Cards", value: properties.numberOfMasterCards},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Learning Plan Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Learning Plan Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Number of 'Learn' Cards": properties.numberOfLearnCards,
          "Number of 'Master' Cards": properties.numberOfMasterCards,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "noZNYXP5Gu", "bc49f94762bf67c49a1ab741dc4dda99a0ca356cb877a6e84a9ef45cc74d5bbc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Learning Plan Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Number of 'Learn' Cards": properties.numberOfLearnCards,
      "Number of 'Master' Cards": properties.numberOfMasterCards,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Learning Plan Screen: Clicks on either Continue or Personalise Math/Reading
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TO5nxyihsL/trigger/ac1XRjxiZ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TO5nxyihsL}
   */
  function interactedLearningPlanScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Learning Plan Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TO5nxyihsL", "7e0bbc57f6a02683e614e4738273c92c421502af7cc5bb99681ce8f2564d2558", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Learning Plan Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TO5nxyihsL", "Interacted Learning Plan Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Learning Plan Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Learning Plan Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "TO5nxyihsL", "7e0bbc57f6a02683e614e4738273c92c421502af7cc5bb99681ce8f2564d2558");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Learning Plan Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Weekly Goal Screen: User views the screen to set their child's weekly learning goal
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hQcogALMS0/trigger/N8raUKsol
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hQcogALMS0}
   */
  function viewedWeeklyGoalScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Weekly Goal Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "from",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hQcogALMS0", "bfd5e040ffbfaa7020de5f81bc4cbf53726922c6a31680205a750d61ce2914ea", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Weekly Goal Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From": properties.from,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hQcogALMS0", "Viewed Weekly Goal Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Weekly Goal Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Weekly Goal Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From": properties.from,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "hQcogALMS0", "bfd5e040ffbfaa7020de5f81bc4cbf53726922c6a31680205a750d61ce2914ea");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Weekly Goal Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From": properties.from,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Weekly Goal Screen: User sets the day, time goals, and the reminder, or clicks on back or skip
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6qSXwIG7YX/trigger/1upI3gWe4
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {Array<string>} [properties.daysGoal] - Days of the week on which the user wants to practice
   * @param {string} [properties.timeGoal] - Per week practice time set by the user
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} [properties.practiceTime] - The practice time/reminder time for the user
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/6qSXwIG7YX}
   */
  function interactedWeeklyGoalScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertOptionalDaysGoal(properties.daysGoal));
      messages = messages.concat(assertOptionalTimeGoal(properties.timeGoal));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertOptionalPracticeTime(properties.practiceTime));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Weekly Goal Screen", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "daysGoal",
        "timeGoal",
        "from",
        "practiceTime",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6qSXwIG7YX", "f8b4a9a245ca037b30593085343e5b658e4694509b78edc094276a0b6e266fb8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Weekly Goal Screen", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Days Goal": properties.daysGoal,
        "Time Goal": properties.timeGoal,
        "From": properties.from,
        "Practice Time": properties.practiceTime,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6qSXwIG7YX", "Interacted Weekly Goal Screen", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "nAyyn2Mnw", name: "Days Goal", value: properties.daysGoal},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "sGjYFiQA4", name: "Practice Time", value: properties.practiceTime},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ypVRFOT1Z", name: "Time Goal", value: properties.timeGoal},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Weekly Goal Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Weekly Goal Screen", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Days Goal": properties.daysGoal,
          "Time Goal": properties.timeGoal,
          "From": properties.from,
          "Practice Time": properties.practiceTime,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "6qSXwIG7YX", "f8b4a9a245ca037b30593085343e5b658e4694509b78edc094276a0b6e266fb8");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Weekly Goal Screen", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Days Goal": properties.daysGoal,
      "Time Goal": properties.timeGoal,
      "From": properties.from,
      "Practice Time": properties.practiceTime,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Library Loadthrough: Users views the loadthrough which describes what their child will learn (list of subject + topics)
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MvjcgqfHUM/trigger/GdHqdWwr5
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/MvjcgqfHUM}
   */
  function viewedLibraryLoadthrough(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Library Loadthrough", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "elaGrade",
        "mathGrade",
        "grade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MvjcgqfHUM", "e2d3bb8be301699c1cd7f84848ec0c145ffe5445f71a7ae6607e8f20b8f11c37", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Library Loadthrough", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Grade": properties.grade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MvjcgqfHUM", "Viewed Library Loadthrough", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Library Loadthrough': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Library Loadthrough", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Grade": properties.grade,
          "Screen Height": sysScreenHeight,
          }, "MvjcgqfHUM", "e2d3bb8be301699c1cd7f84848ec0c145ffe5445f71a7ae6607e8f20b8f11c37");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Library Loadthrough", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Grade": properties.grade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Exciting Resources Loadthrough: User views the extra resources loadthrough
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IMbern_Xyo/trigger/IF6_xw8as
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/IMbern_Xyo}
   */
  function viewedExcitingResourcesLoadthrough(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Exciting Resources Loadthrough", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "IMbern_Xyo", "f21f6be0b5b85cdc1dd677b7e7285c9ba67195f258b2ead4c4cca9bbe15a655b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Exciting Resources Loadthrough", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("IMbern_Xyo", "Viewed Exciting Resources Loadthrough", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Exciting Resources Loadthrough': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Exciting Resources Loadthrough", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "IMbern_Xyo", "f21f6be0b5b85cdc1dd677b7e7285c9ba67195f258b2ead4c4cca9bbe15a655b");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Exciting Resources Loadthrough", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Local Notification Prompt: User views the local prompt for allowing/denying notifications
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/d5biYuwsXI}
   */
  function viewedLocalNotificationPrompt(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Local Notification Prompt", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "d5biYuwsXI", "5541a6c4d396896f6379f2d44ccb9eb32e024327ebe66cee5c7aebecf513fca4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Local Notification Prompt", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("d5biYuwsXI", "Viewed Local Notification Prompt", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Local Notification Prompt': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Local Notification Prompt", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Screen Height": sysScreenHeight,
          }, "d5biYuwsXI", "5541a6c4d396896f6379f2d44ccb9eb32e024327ebe66cee5c7aebecf513fca4");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Local Notification Prompt", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Local Notification Prompt: User clicks on yes or no on the local prompt for allowing/denying notifications
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/1-R4ITnjG}
   */
  function interactedLocalNotificationPrompt(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Local Notification Prompt", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mode",
        "grade",
        "elaGrade",
        "mathGrade",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1-R4ITnjG", "cf7fe1decc7b5267a3498c435206a593aa2a9ad8f6eb84a86c8e9754166cd195", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Local Notification Prompt", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Math Grade": properties.mathGrade,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1-R4ITnjG", "Interacted Local Notification Prompt", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Local Notification Prompt': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Local Notification Prompt", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Math Grade": properties.mathGrade,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "1-R4ITnjG", "cf7fe1decc7b5267a3498c435206a593aa2a9ad8f6eb84a86c8e9754166cd195");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Local Notification Prompt", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Math Grade": properties.mathGrade,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted My to-Do Popup [B2B]: This event will be fired when the user clicks anywhere within the My to-do popup.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ASZ8RBaEO/trigger/1sN06x-wS
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/-ASZ8RBaEO}
   */
  function interactedMyToDoPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted My to-Do Popup [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-ASZ8RBaEO", "9c0806bb14eac317cc4caa61ef7d0aa17b794d379f17ea26e318dfa4e036ec9f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted My to-Do Popup [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-ASZ8RBaEO", "Interacted My to-Do Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted My to-Do Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted My to-Do Popup [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "-ASZ8RBaEO", "9c0806bb14eac317cc4caa61ef7d0aa17b794d379f17ea26e318dfa4e036ec9f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted My to-Do Popup [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Pending Activity Popup [B2B]: This event will be triggered when the user views the 'Pending Activity Popup'
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/y4wRFq9AfT/trigger/T1N5OMN8l
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.from - From property highlights from where the event has been triggered. If some page or screen is viewed, from where the click was done.
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/y4wRFq9AfT}
   */
  function viewedPendingActivityPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertFrom(properties.from));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Pending Activity Popup [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "from",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "y4wRFq9AfT", "a4083b2c619d02d330eaa5804e91a6d86baf341aa07ce65e0d7724ac5752bd93", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Pending Activity Popup [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "From": properties.from,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("y4wRFq9AfT", "Viewed Pending Activity Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "ENjG288F1l", name: "From", value: properties.from},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Pending Activity Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Pending Activity Popup [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "From": properties.from,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "y4wRFq9AfT", "a4083b2c619d02d330eaa5804e91a6d86baf341aa07ce65e0d7724ac5752bd93");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Pending Activity Popup [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "From": properties.from,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student Level Bar Dropdown [B2B]: This event will be fired when the user views the student level bar dropdown.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TUXCetk7Iw/trigger/7cKkIca7E
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/TUXCetk7Iw}
   */
  function viewedStudentLevelBarDropdownB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Level Bar Dropdown [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TUXCetk7Iw", "8f4294ed60b0c38f4eb874aa97588caf31ff5322fc7a7114c4411081df737b9f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student Level Bar Dropdown [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TUXCetk7Iw", "Viewed Student Level Bar Dropdown [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Level Bar Dropdown [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Level Bar Dropdown [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "TUXCetk7Iw", "8f4294ed60b0c38f4eb874aa97588caf31ff5322fc7a7114c4411081df737b9f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Level Bar Dropdown [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Student Level Bar Dropdown [B2B]: This event will be fired when the user clicks on any item within the student level bar dropdown.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jAGprzgpST/trigger/ZDXBATw1T
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jAGprzgpST}
   */
  function interactedStudentLevelBarDropdownB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Student Level Bar Dropdown [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "clickedOn",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jAGprzgpST", "68eacd816e21e89486490bccb911035dd58308766a7c7daf48f3958d6f414074", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Student Level Bar Dropdown [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Clicked On": properties.clickedOn,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jAGprzgpST", "Interacted Student Level Bar Dropdown [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Student Level Bar Dropdown [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Student Level Bar Dropdown [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Clicked On": properties.clickedOn,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "jAGprzgpST", "68eacd816e21e89486490bccb911035dd58308766a7c7daf48f3958d6f414074");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Student Level Bar Dropdown [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Clicked On": properties.clickedOn,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed MP Game Expired Popup [B2B]: This event will be fired when the game to which user is invited is expired.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pChvfFKWLo/trigger/irHpzO0NR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.gameName - Name of the Game being tapped (Optional)
   * @param {string} properties.gameMode - The mode of the game player is playing
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pChvfFKWLo}
   */
  function viewedMpGameExpiredPopupB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGameName(properties.gameName));
      messages = messages.concat(assertGameMode(properties.gameMode));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed MP Game Expired Popup [B2B]", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "gameName",
        "gameMode",
        "fromPage",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pChvfFKWLo", "1627a3c75fdd5aaad72793bfb044501f9475aaf98679a813a12f7a00c330a82a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed MP Game Expired Popup [B2B]", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Game Name": properties.gameName,
        "Game Mode": properties.gameMode,
        "From Page": properties.fromPage,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pChvfFKWLo", "Viewed MP Game Expired Popup [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "SCiKCU5kRo", name: "Game Mode", value: properties.gameMode},
        {id: "_L1z86KIYb", name: "Game Name", value: properties.gameName},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed MP Game Expired Popup [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed MP Game Expired Popup [B2B]", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Game Name": properties.gameName,
          "Game Mode": properties.gameMode,
          "From Page": properties.fromPage,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "pChvfFKWLo", "1627a3c75fdd5aaad72793bfb044501f9475aaf98679a813a12f7a00c330a82a");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed MP Game Expired Popup [B2B]", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Game Name": properties.gameName,
      "Game Mode": properties.gameMode,
      "From Page": properties.fromPage,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Classroom PTL Link Started: This event will be fired when the PTL linking of parent and teacher will start from the backend.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wfkBJjad3N}
   */
  function classroomPtlLinkStarted(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Classroom PTL Link Started", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wfkBJjad3N", "996d4231dc58944c40a443cd13be25ad92f1118e6f54c51dd968c9d493b1651c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Classroom PTL Link Started", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wfkBJjad3N", "Classroom PTL Link Started", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Classroom PTL Link Started': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom PTL Link Started", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "wfkBJjad3N", "996d4231dc58944c40a443cd13be25ad92f1118e6f54c51dd968c9d493b1651c");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Classroom PTL Link Started", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Classroom PTL Link Ended: This event will be fired when the PTL linking from backend ends (successful and unsuccessful).
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.mathGrade - no description
   * @param {string} properties.mode - Existing event property: Login mode for student: School vs Home
   * @param {string} properties.status - To determine if the process failed or succeeded
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} properties.elaGrade - ELA grade of the user at the time of the event
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/ihT9bkPDpk}
   */
  function classroomPtlLinkEnded(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertMathGrade(properties.mathGrade));
      messages = messages.concat(assertMode(properties.mode));
      messages = messages.concat(assertStatus(properties.status));
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertElaGrade(properties.elaGrade));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Classroom PTL Link Ended", Object.keys(properties), [
        "platform",
        "userType",
        "signupFlow",
        "mathGrade",
        "mode",
        "status",
        "grade",
        "elaGrade"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ihT9bkPDpk", "57d4f044ee08541b62561a01d0b63a6a2bf02d885b9112c672ff7c5a07353712", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Classroom PTL Link Ended", {
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Math Grade": properties.mathGrade,
        "Mode": properties.mode,
        "Status": properties.status,
        "Grade": properties.grade,
        "Ela Grade": properties.elaGrade,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ihT9bkPDpk", "Classroom PTL Link Ended", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "3pg8bY1LfC", name: "Mode", value: properties.mode},
        {id: "9_Al8_kuam", name: "Status", value: properties.status},
        {id: "BaOSrmfa3A", name: "Math Grade", value: properties.mathGrade},
        {id: "qvkkIrTx4s", name: "Ela Grade", value: properties.elaGrade},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Classroom PTL Link Ended': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom PTL Link Ended", {
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Math Grade": properties.mathGrade,
          "Mode": properties.mode,
          "Status": properties.status,
          "Grade": properties.grade,
          "Ela Grade": properties.elaGrade,
          "Screen Height": sysScreenHeight,
          }, "ihT9bkPDpk", "57d4f044ee08541b62561a01d0b63a6a2bf02d885b9112c672ff7c5a07353712");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Classroom PTL Link Ended", {
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Math Grade": properties.mathGrade,
      "Mode": properties.mode,
      "Status": properties.status,
      "Grade": properties.grade,
      "Ela Grade": properties.elaGrade,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Lesson Plans Listing Page [B2B]: This event will be fired when the user lands on the lesson plan listing page.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3borsUujFR/trigger/tT0blN2lr
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.fromPage - The source page where this event was viewed/clicked
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/3borsUujFR}
   */
  function viewedLessonPlansListingPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertFromPage(properties.fromPage));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Lesson Plans Listing Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "fromPage",
        "lessonPlanSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "3borsUujFR", "a598564fd0ff9d61f98f453822e0398a4ba0eccf883dd2f577bbb2a63703f039", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Lesson Plans Listing Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "From Page": properties.fromPage,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("3borsUujFR", "Viewed Lesson Plans Listing Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "nbgkWrkHkN", name: "From Page", value: properties.fromPage},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Lesson Plans Listing Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Lesson Plans Listing Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "From Page": properties.fromPage,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Screen Height": sysScreenHeight,
          }, "3borsUujFR", "a598564fd0ff9d61f98f453822e0398a4ba0eccf883dd2f577bbb2a63703f039");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Lesson Plans Listing Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "From Page": properties.fromPage,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Lesson Plans Listing Page [B2B]: This event will be triggered when the user interacts with the lesson plan.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yWSSyMcVl8/trigger/A3no25JQK
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/yWSSyMcVl8}
   */
  function interactedLessonPlansListingPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Lesson Plans Listing Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "lessonPlanSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "yWSSyMcVl8", "67ada41bbd16f2d5fd33ee4483be46e17abe1e9322f6163a9db175d07eb8e764", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Lesson Plans Listing Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("yWSSyMcVl8", "Interacted Lesson Plans Listing Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Lesson Plans Listing Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Lesson Plans Listing Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Screen Height": sysScreenHeight,
          }, "yWSSyMcVl8", "67ada41bbd16f2d5fd33ee4483be46e17abe1e9322f6163a9db175d07eb8e764");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Lesson Plans Listing Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Lesson Plan Detail Page [B2B]: This event will be fired when the user lands on the detail page of any lesson plan.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SRhLsQ1If_/trigger/T0uEzuIac
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.lessonPlanName - This will capture the name of the lesson plan.
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/SRhLsQ1If_}
   */
  function viewedLessonPlanDetailPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertLessonPlanName(properties.lessonPlanName));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Lesson Plan Detail Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "lessonPlanName",
        "lessonPlanSubject"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "SRhLsQ1If_", "5d21b9b580423244e87ba4263e1600d478eb31da80e5c174cb5112eea6025938", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Lesson Plan Detail Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Lesson Plan Name": properties.lessonPlanName,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("SRhLsQ1If_", "Viewed Lesson Plan Detail Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "aESgK6MlY", name: "Lesson Plan Name", value: properties.lessonPlanName},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Lesson Plan Detail Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Lesson Plan Detail Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Lesson Plan Name": properties.lessonPlanName,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Screen Height": sysScreenHeight,
          }, "SRhLsQ1If_", "5d21b9b580423244e87ba4263e1600d478eb31da80e5c174cb5112eea6025938");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Lesson Plan Detail Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Lesson Plan Name": properties.lessonPlanName,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Lesson Plan Detail Page [B2B]: This event will be fired when the user interacts with the detail page of any lesson plan.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/B7zeQzKVLr/trigger/58YsIiaX-
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {string} properties.lessonPlanSubject - This will capture the subject of the lesson plan listing/landing page. (Values: Math or English)
   * @param {string} properties.lessonPlanName - This will capture the name of the lesson plan.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/B7zeQzKVLr}
   */
  function interactedLessonPlanDetailPageB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertLessonPlanSubject(properties.lessonPlanSubject));
      messages = messages.concat(assertLessonPlanName(properties.lessonPlanName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Lesson Plan Detail Page [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn",
        "lessonPlanSubject",
        "lessonPlanName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "B7zeQzKVLr", "1b460f866654132791fc91f8fa2e5928b56733b536c17e166d607ba3a764ad69", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Lesson Plan Detail Page [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Lesson Plan Subject": properties.lessonPlanSubject,
        "Lesson Plan Name": properties.lessonPlanName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("B7zeQzKVLr", "Interacted Lesson Plan Detail Page [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "aESgK6MlY", name: "Lesson Plan Name", value: properties.lessonPlanName},
        {id: "n3rBqFq3X", name: "Lesson Plan Subject", value: properties.lessonPlanSubject},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Lesson Plan Detail Page [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Lesson Plan Detail Page [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Lesson Plan Subject": properties.lessonPlanSubject,
          "Lesson Plan Name": properties.lessonPlanName,
          "Screen Height": sysScreenHeight,
          }, "B7zeQzKVLr", "1b460f866654132791fc91f8fa2e5928b56733b536c17e166d607ba3a764ad69");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Lesson Plan Detail Page [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Lesson Plan Subject": properties.lessonPlanSubject,
      "Lesson Plan Name": properties.lessonPlanName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student Round Intro Screen: Triggered when a student sees the round intro screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wJHwzzofC3/trigger/cN1ZA63hD
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/wJHwzzofC3}
   */
  function viewedStudentRoundIntroScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Round Intro Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wJHwzzofC3", "4f4907c0169d35e442b06b645a281d650f94f85249912ea2c920ce99536b8e76", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student Round Intro Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wJHwzzofC3", "Viewed Student Round Intro Screen", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Round Intro Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Round Intro Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "wJHwzzofC3", "4f4907c0169d35e442b06b645a281d650f94f85249912ea2c920ce99536b8e76");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Round Intro Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Tutor Round Intro Screen: Triggered when a tutor sees the round intro screen
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fdJS9nElG/trigger/mLvihS00l
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/fdJS9nElG}
   */
  function viewedTutorRoundIntroScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Round Intro Screen", Object.keys(properties), [
        "quizMeetingSlug",
        "quizLiveClassId",
        "quizCode",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "fdJS9nElG", "358516bdd90af9a93ff5fa3ae1d8263b9e596c7939198066669fcbee9e4f1979", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Tutor Round Intro Screen", {
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Quiz Code": properties.quizCode,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("fdJS9nElG", "Viewed Tutor Round Intro Screen", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Round Intro Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Round Intro Screen", {
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Quiz Code": properties.quizCode,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "fdJS9nElG", "358516bdd90af9a93ff5fa3ae1d8263b9e596c7939198066669fcbee9e4f1979");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Round Intro Screen", {
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Quiz Code": properties.quizCode,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Tutor Round Intro Screen: Triggered when a tutor interacts on the round intro screen. Interactions possible are clicks on the Start Round button and the sound button
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pfXUq_Iwq/trigger/HdSuxuoNWY
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/pfXUq_Iwq}
   */
  function interactedTutorRoundIntroScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Round Intro Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "clickedOn",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "pfXUq_Iwq", "1dd59e7dc305c73fb20c5f1d56d0dd900c4977084abad3fb2028ccd7dea11134", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Tutor Round Intro Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Clicked On": properties.clickedOn,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("pfXUq_Iwq", "Interacted Tutor Round Intro Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Round Intro Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Round Intro Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Clicked On": properties.clickedOn,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "pfXUq_Iwq", "1dd59e7dc305c73fb20c5f1d56d0dd900c4977084abad3fb2028ccd7dea11134");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Round Intro Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Clicked On": properties.clickedOn,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Badges Animation in Neo Quiz: Triggered when a student receives a badge and views the animation for it
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/vfqFAi0Fca/trigger/FsmyDbYlP
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/vfqFAi0Fca}
   */
  function viewedBadgesAnimationInNeoQuiz(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Badges Animation in Neo Quiz", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "vfqFAi0Fca", "da39c713aac543f4fb8dd91069baca521e6b2a1632a6bd2f41c2971239f4169f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Badges Animation in Neo Quiz", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("vfqFAi0Fca", "Viewed Badges Animation in Neo Quiz", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Badges Animation in Neo Quiz': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Badges Animation in Neo Quiz", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Screen Height": sysScreenHeight,
          }, "vfqFAi0Fca", "da39c713aac543f4fb8dd91069baca521e6b2a1632a6bd2f41c2971239f4169f");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Badges Animation in Neo Quiz", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Student Round Ended Screen: Triggered when student sees round specific leaderboard
   *
   * When to trigger this event:
   * 1. Triggered When a round completed
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BY4mBr8nrd/trigger/tern2Ysrj
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/BY4mBr8nrd}
   */
  function viewedStudentRoundEndedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Student Round Ended Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BY4mBr8nrd", "442bb3142e102e20b4d794368360e14cf33cdb1ed4f8cdee815d6498661123d6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Student Round Ended Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BY4mBr8nrd", "Viewed Student Round Ended Screen", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Student Round Ended Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Student Round Ended Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "BY4mBr8nrd", "442bb3142e102e20b4d794368360e14cf33cdb1ed4f8cdee815d6498661123d6");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Student Round Ended Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Viewed Tutor Round Ended Screen: Triggered when tutor sees specific round leaderboard
   *
   * When to trigger this event:
   * 1. Triggered when round completed
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sa3WTgOLF/trigger/is9QytZ4-
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/sa3WTgOLF}
   */
  function viewedTutorRoundEndedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Viewed Tutor Round Ended Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sa3WTgOLF", "5e1228e4a9b737e15d9abd115727527e18bc324ae8fd08fa24a4831cd4588bbc", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Viewed Tutor Round Ended Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sa3WTgOLF", "Viewed Tutor Round Ended Screen", messages, [
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Viewed Tutor Round Ended Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Viewed Tutor Round Ended Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "Screen Height": sysScreenHeight,
          }, "sa3WTgOLF", "5e1228e4a9b737e15d9abd115727527e18bc324ae8fd08fa24a4831cd4588bbc");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Viewed Tutor Round Ended Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Tutor Round Ended Screen: Triggered when a tutor interacts on round specific leaderboard screen. Interactions possible are clicks on the Review Questions button and the Next Round or Final Leaderboard.
   *
   * When to trigger this event:
   * 1. Triggered when Review Question or Go To Round CTA clicked
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5O4NMJwuc/trigger/dgxpO9ulc
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.quizCode - This will capture unique code for a quiz.
   * @param {string} properties.quizMeetingSlug - This will capture unique meeting slug for the quiz.
   * @param {string} properties.quizLiveClassId - This will capture unique live class id for quiz.
   * @param {int} properties.roundNumber - Store round info for Mashup Quiz
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/5O4NMJwuc}
   */
  function interactedTutorRoundEndedScreen(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuizCode(properties.quizCode));
      messages = messages.concat(assertQuizMeetingSlug(properties.quizMeetingSlug));
      messages = messages.concat(assertQuizLiveClassId(properties.quizLiveClassId));
      messages = messages.concat(assertRoundNumber(properties.roundNumber));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Tutor Round Ended Screen", Object.keys(properties), [
        "quizCode",
        "quizMeetingSlug",
        "quizLiveClassId",
        "roundNumber",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "5O4NMJwuc", "80c37ccb43561bac37099957230e8a76f0e5b221ad9cd35824078c6c9392284e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Tutor Round Ended Screen", {
        "Quiz Code": properties.quizCode,
        "Quiz Meeting Slug": properties.quizMeetingSlug,
        "Quiz Live Class Id": properties.quizLiveClassId,
        "Round Number": properties.roundNumber,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("5O4NMJwuc", "Interacted Tutor Round Ended Screen", messages, [
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "QwEJtFNQB", name: "Quiz Meeting Slug", value: properties.quizMeetingSlug},
        {id: "_gr4kO5vEN", name: "Quiz Code", value: properties.quizCode},
        {id: "jw_xpal_L1", name: "Round Number", value: properties.roundNumber},
        {id: "kjjqNSO2f", name: "Quiz Live Class Id", value: properties.quizLiveClassId},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Tutor Round Ended Screen': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Tutor Round Ended Screen", {
          "Quiz Code": properties.quizCode,
          "Quiz Meeting Slug": properties.quizMeetingSlug,
          "Quiz Live Class Id": properties.quizLiveClassId,
          "Round Number": properties.roundNumber,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "5O4NMJwuc", "80c37ccb43561bac37099957230e8a76f0e5b221ad9cd35824078c6c9392284e");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Tutor Round Ended Screen", {
      "Quiz Code": properties.quizCode,
      "Quiz Meeting Slug": properties.quizMeetingSlug,
      "Quiz Live Class Id": properties.quizLiveClassId,
      "Round Number": properties.roundNumber,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Disenrolled Class [B2B]: This event gets fired when the user disenrolls their class from Springboard.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/w1xbDmDVzm/trigger/FnhEH8dmR
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.teacherName - This captures the name of the teacher on Splashlearn
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/w1xbDmDVzm}
   */
  function disenrolledClassB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTeacherName(properties.teacherName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Disenrolled Class [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "teacherName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "w1xbDmDVzm", "480c032e3803b622127fe53a1607cfa2226df73c5a32592f00b2a5a944e00f09", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Disenrolled Class [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Teacher Name": properties.teacherName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("w1xbDmDVzm", "Disenrolled Class [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "d4VuJfq-Y", name: "Teacher Name", value: properties.teacherName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Disenrolled Class [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Disenrolled Class [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Teacher Name": properties.teacherName,
          "Screen Height": sysScreenHeight,
          }, "w1xbDmDVzm", "480c032e3803b622127fe53a1607cfa2226df73c5a32592f00b2a5a944e00f09");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Disenrolled Class [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Teacher Name": properties.teacherName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Auto-Enrolled for SpringBoard [B2B]: This event gets fired when the user logs in during the enrolment phase and gets auto-enrolled for Springboard.
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.teacherName - This captures the name of the teacher on Splashlearn
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/hYj9PzZlLI}
   */
  function autoEnrolledForSpringboardB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTeacherName(properties.teacherName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Auto-Enrolled for SpringBoard [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "teacherName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "hYj9PzZlLI", "3ecbbd4fc76e3992ebd6c8a752a850fd7ba5375bd06bb46a2649a88810243450", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Auto-Enrolled for SpringBoard [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Teacher Name": properties.teacherName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("hYj9PzZlLI", "Auto-Enrolled for SpringBoard [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "d4VuJfq-Y", name: "Teacher Name", value: properties.teacherName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Auto-Enrolled for SpringBoard [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Auto-Enrolled for SpringBoard [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Teacher Name": properties.teacherName,
          "Screen Height": sysScreenHeight,
          }, "hYj9PzZlLI", "3ecbbd4fc76e3992ebd6c8a752a850fd7ba5375bd06bb46a2649a88810243450");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Auto-Enrolled for SpringBoard [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Teacher Name": properties.teacherName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Enrolled Class [B2B]: This event gets fired when the user manually enrols the class after disenrolling the class from settings page.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FJvLyr1meL/trigger/mfLVpTrMs
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.teacherName - This captures the name of the teacher on Splashlearn
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/FJvLyr1meL}
   */
  function enrolledClassB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertTeacherName(properties.teacherName));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Enrolled Class [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "teacherName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FJvLyr1meL", "31074c506f2f06b50690d2c4977ea6d6d4654eb070cf528571cb4a53a15c4e52", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Enrolled Class [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Teacher Name": properties.teacherName,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FJvLyr1meL", "Enrolled Class [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "d4VuJfq-Y", name: "Teacher Name", value: properties.teacherName},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Enrolled Class [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Enrolled Class [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Teacher Name": properties.teacherName,
          "Screen Height": sysScreenHeight,
          }, "FJvLyr1meL", "31074c506f2f06b50690d2c4977ea6d6d4654eb070cf528571cb4a53a15c4e52");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Enrolled Class [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Teacher Name": properties.teacherName,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Springboard Tab [B2B]: This event will be fired when the user clicks anywhere within the Springboard tab.
We need to capture the clicks on -
1. Class settings
2. Send parent emails
3. Download printouts
4. Official contest rules
5. Go to dashboard
6. Facebook icon
7. Twitter icon
8. Instagram icon
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ewq8z07r7N/trigger/y7c_q8JN7
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/Ewq8z07r7N}
   */
  function interactedSpringboardTabB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Springboard Tab [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Ewq8z07r7N", "315bcc98d0ec1262d800f6aeb005d2a7fb788b17af1f9d29b9062bc3fd18588d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Springboard Tab [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Ewq8z07r7N", "Interacted Springboard Tab [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Springboard Tab [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Springboard Tab [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "Ewq8z07r7N", "315bcc98d0ec1262d800f6aeb005d2a7fb788b17af1f9d29b9062bc3fd18588d");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Springboard Tab [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  /**
   * Interacted Download Letter [B2B]: This event will be fired when the user clicks on the Download CTA after the PDF for download letter opens up.
   *
   * When to trigger this event:
   * 1.
   * View in Avo: https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jnYk2pvWir/trigger/bKCDhU5xJ
   *
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.grade - Grade Selected by the user during the onboarding OR grade of the currently selected class in teacher dashboard.
   * @param {string} [properties.teacherType] - Type based on subscription plan of the teacher. Legacy property.
   * @param {bool} properties.isGradeDifferent - Is the current grade different from the default grade of the class?
   * @param {string} properties.class_ - Name of the class
   * @param {string} properties.subject - Subject Selected during onboarding

   * @param {string} properties.platform - This property highlights on which platform this pop-up is shown. [Expected Values - web, iPad, iPhone]
   * @param {string} properties.userType - Type of user i.e. parent, teacher,
   * @param {string} properties.signupFlow - This is equal to the sign up flow of the user.
   * @param {string} properties.clickedOn - This will have the info about where the user has clicked on this page
   *
   * @see {@link https://www.avo.app/schemas/6drybyLTwHSLSiD6Yicr/events/jnYk2pvWir}
   */
  function interactedDownloadLetterB2b(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertGrade(properties.grade));
      messages = messages.concat(assertOptionalTeacherType(properties.teacherType));
      messages = messages.concat(assertIsGradeDifferent(properties.isGradeDifferent));
      messages = messages.concat(assertClass(properties.class_));
      messages = messages.concat(assertSubject(properties.subject));
      messages = messages.concat(assertPlatform(properties.platform));
      messages = messages.concat(assertUserType(properties.userType));
      messages = messages.concat(assertSignupFlow(properties.signupFlow));
      messages = messages.concat(assertClickedOn(properties.clickedOn));
      messages = messages.concat(assertScreenHeight(sysScreenHeight));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("Interacted Download Letter [B2B]", Object.keys(properties), [
        "grade",
        "teacherType",
        "isGradeDifferent",
        "class_",
        "subject",
        "platform",
        "userType",
        "signupFlow",
        "clickedOn"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jnYk2pvWir", "993a30f42c8e1dab5b3b5fa408e18f1effaecdc24e3c15a6275c87e7410f7358", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }

      InternalAvoLogger.logEventSent("Interacted Download Letter [B2B]", {
        "Grade": properties.grade,
        "Teacher Type": properties.teacherType,
        "Is Grade Different": properties.isGradeDifferent,
        "Class": properties.class_,
        "Subject": properties.subject,
        "Platform": properties.platform,
        "User Type": properties.userType,
        "Signup Flow": properties.signupFlow,
        "Clicked On": properties.clickedOn,
        "Screen Height": sysScreenHeight,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jnYk2pvWir", "Interacted Download Letter [B2B]", messages, [
        {id: "3LbQtKEdjc", name: "Grade", value: properties.grade},
        {id: "O0dEFLrgl", name: "Clicked On", value: properties.clickedOn},
        {id: "PxWDGuxq95", name: "Class", value: properties.class_},
        {id: "QE2CTvenDi", name: "Subject", value: properties.subject},
        {id: "UsQGEDnYDs", name: "Teacher Type", value: properties.teacherType},
        {id: "qwCZiUS_99", name: "Is Grade Different", value: properties.isGradeDifferent},
        {id: "vjELcWf4BG", name: "Platform", value: properties.platform},
        {id: "xZ9GCD71LN", name: "User Type", value: properties.userType},
        {id: "y8YSspTxeO", name: "Signup Flow", value: properties.signupFlow},
        {id: "ofwq9A74yc", name: "Screen Height", value: sysScreenHeight},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'Interacted Download Letter [B2B]': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }

    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Interacted Download Letter [B2B]", {
          "Grade": properties.grade,
          "Teacher Type": properties.teacherType,
          "Is Grade Different": properties.isGradeDifferent,
          "Class": properties.class_,
          "Subject": properties.subject,
          "Platform": properties.platform,
          "User Type": properties.userType,
          "Signup Flow": properties.signupFlow,
          "Clicked On": properties.clickedOn,
          "Screen Height": sysScreenHeight,
          }, "jnYk2pvWir", "993a30f42c8e1dab5b3b5fa408e18f1effaecdc24e3c15a6275c87e7410f7358");
      }
      // destination CustomDestination
      CustomDestination.logEvent("Interacted Download Letter [B2B]", {
      "Grade": properties.grade,
      "Teacher Type": properties.teacherType,
      "Is Grade Different": properties.isGradeDifferent,
      "Class": properties.class_,
      "Subject": properties.subject,
      "Platform": properties.platform,
      "User Type": properties.userType,
      "Signup Flow": properties.signupFlow,
      "Clicked On": properties.clickedOn,
      "Screen Height": sysScreenHeight,
      });
    } else {
      // do nothing
    }
  }

  exports.DiscountPitch = DiscountPitch;
  exports.Difficulty = Difficulty;
  exports.State = State;
  exports.UserPersonaType = UserPersonaType;
  exports.Source = Source;
  exports.QuestionType = QuestionType;
  exports.Grade = Grade;
  exports.Mode = Mode;
  exports.MFAssignedTo = MFAssignedTo;
  exports.WorksheetFilterAppliedOn = WorksheetFilterAppliedOn;
  exports.EndPoint = EndPoint;
  exports.Status = Status;
  exports.ClickedOnCustomReportPage = ClickedOnCustomReportPage;
  exports.MathGrade = MathGrade;
  exports.GradeSelected = GradeSelected;
  exports.WorksheetGrade = WorksheetGrade;
  exports.ReportType = ReportType;
  exports.ClickedOnTrackCustomPage = ClickedOnTrackCustomPage;
  exports.InteractionType = InteractionType;
  exports.Subject = Subject;
  exports.GameMode = GameMode;
  exports.InteractedWith = InteractedWith;
  exports.ScrolledThrough = ScrolledThrough;
  exports.OpponentType = OpponentType;
  exports.MFMode = MFMode;
  exports.CardType = CardType;
  exports.CustomMFOperatorSelected = CustomMFOperatorSelected;
  exports.MFOperatorSelected = MFOperatorSelected;
  exports.ClickedOnNewMFPractice = ClickedOnNewMFPractice;
  exports.PlayAgainState = PlayAgainState;
  exports.ClassType = ClassType;
  exports.MFCustomSettingsClickedOn = MFCustomSettingsClickedOn;
  exports.ReachedVia = ReachedVia;
  exports.Winner = Winner;
  exports.FromPage = FromPage;
  exports.InteractionDetails = InteractionDetails;
  exports.ValidSavedCardExists = ValidSavedCardExists;
  exports.View = View;
  exports.GooglePayButtonAvailable = GooglePayButtonAvailable;
  exports.ElaGrade = ElaGrade;
  exports.MFPracticeQuestionsCount = MFPracticeQuestionsCount;
  exports.MFTimePerQuestion = MFTimePerQuestion;
  exports.UserType = UserType;
  exports.SignupFlow = SignupFlow;
  exports.ClickedOnStudentSelectionPopup = ClickedOnStudentSelectionPopup;
  exports.setAvoLogger = setAvoLogger;
  exports.viewedTakeTourPopup = viewedTakeTourPopup;
  exports.interactedOnTakeTourPopup = interactedOnTakeTourPopup;
  exports.interactedMpGameTab = interactedMpGameTab;
  exports.viewedMpClassmatesDrawer = viewedMpClassmatesDrawer;
  exports.viewedMpGameTab = viewedMpGameTab;
  exports.interactedMpClassmatesDrawer = interactedMpClassmatesDrawer;
  exports.viewedMpGameInvitesDrawer = viewedMpGameInvitesDrawer;
  exports.interactedMpGameInvitesDrawer = interactedMpGameInvitesDrawer;
  exports.viewedMpInviteNotification = viewedMpInviteNotification;
  exports.interactedMpInviteNotification = interactedMpInviteNotification;
  exports.viewedMpModeSelectionScreen = viewedMpModeSelectionScreen;
  exports.interactedMpModeSelectionScreen = interactedMpModeSelectionScreen;
  exports.viewedMpOptionsSelectionScreen = viewedMpOptionsSelectionScreen;
  exports.interactedMpOptionsSelectionScreen = interactedMpOptionsSelectionScreen;
  exports.viewedMpInviteFriendsScreen = viewedMpInviteFriendsScreen;
  exports.interactedMpInviteFriendsScreen = interactedMpInviteFriendsScreen;
  exports.viewedMpGameLoaderScreen = viewedMpGameLoaderScreen;
  exports.viewedMpGamePlayScreen = viewedMpGamePlayScreen;
  exports.opponentSearchStarted = opponentSearchStarted;
  exports.opponentFound = opponentFound;
  exports.countdownAnimationStarted = countdownAnimationStarted;
  exports.viewedMpQuestionsExhaustedScreen = viewedMpQuestionsExhaustedScreen;
  exports.viewedMpGameLobby = viewedMpGameLobby;
  exports.interactedMpGameLobby = interactedMpGameLobby;
  exports.viewedMpGameRewardsScreen = viewedMpGameRewardsScreen;
  exports.viewedMpRematchPopup = viewedMpRematchPopup;
  exports.interactedMpRematchPopup = interactedMpRematchPopup;
  exports.viewedPost3pmPopUp = viewedPost3pmPopUp;
  exports.interactedPost3pmPopUp = interactedPost3pmPopUp;
  exports.viewedErrorOnPost3pmPopUp = viewedErrorOnPost3pmPopUp;
  exports.viewedSuspectedEmailNudge = viewedSuspectedEmailNudge;
  exports.interactedSuspectedEmailNudge = interactedSuspectedEmailNudge;
  exports.viewedMpGameTabCoachmark = viewedMpGameTabCoachmark;
  exports.viewedMpGameTileCoachmark = viewedMpGameTileCoachmark;
  exports.visitedDashboardTab = visitedDashboardTab;
  exports.viewedMfWalkthroughPopup = viewedMfWalkthroughPopup;
  exports.interactedMfWalkthroughPopup = interactedMfWalkthroughPopup;
  exports.navClickedMfNewPractice = navClickedMfNewPractice;
  exports.viewedMfSettingsPopup = viewedMfSettingsPopup;
  exports.interactedMfSettingsPopup = interactedMfSettingsPopup;
  exports.successfullyAssigned = successfullyAssigned;
  exports.navClickedMfTrackFluency = navClickedMfTrackFluency;
  exports.viewedMfTrackAdaptivePage = viewedMfTrackAdaptivePage;
  exports.viewedMfTrackCustomPage = viewedMfTrackCustomPage;
  exports.interactedMfTrackAdaptivePage = interactedMfTrackAdaptivePage;
  exports.navClickedStudentReport = navClickedStudentReport;
  exports.viewedMfStudentProgressPage = viewedMfStudentProgressPage;
  exports.interactedMfStudentProgressPage = interactedMfStudentProgressPage;
  exports.navClickedClassReport = navClickedClassReport;
  exports.viewedClassCurriculumReportPage = viewedClassCurriculumReportPage;
  exports.viewedMfClassProgressPage = viewedMfClassProgressPage;
  exports.interactedMfClassProgressPage = interactedMfClassProgressPage;
  exports.viewedMfModifyPracticePage = viewedMfModifyPracticePage;
  exports.interactedMfModifyPracticePage = interactedMfModifyPracticePage;
  exports.viewedMytodoPage = viewedMytodoPage;
  exports.mathFactStarted = mathFactStarted;
  exports.completedMathFactAssignment = completedMathFactAssignment;
  exports.viewedDeleteAccountAlert = viewedDeleteAccountAlert;
  exports.interactedDeleteAccountAlert = interactedDeleteAccountAlert;
  exports.startedGame = startedGame;
  exports.viewedGames = viewedGames;
  exports.tappedGame = tappedGame;
  exports.interactedMfNewPracticePage = interactedMfNewPracticePage;
  exports.interactedMfCustomModeSettingsPopup = interactedMfCustomModeSettingsPopup;
  exports.interactedMfStudentSelectionPopup = interactedMfStudentSelectionPopup;
  exports.interactedMfTrackCustomPage = interactedMfTrackCustomPage;
  exports.interactedMfCustomReportPage = interactedMfCustomReportPage;
  exports.weeklyGoalInteracted = weeklyGoalInteracted;
  exports.viewedTiledDashboard = viewedTiledDashboard;
  exports.interactedTiledDashboard = interactedTiledDashboard;
  exports.completedStudentDashboardScroll = completedStudentDashboardScroll;
  exports.completedPageRendering = completedPageRendering;
  exports.downloadedWorksheet = downloadedWorksheet;
  exports.clickedWorksheetTab = clickedWorksheetTab;
  exports.appliedWorksheetFilters = appliedWorksheetFilters;
  exports.clearedWorksheetFilters = clearedWorksheetFilters;
  exports.viewedWorksheetListingPage = viewedWorksheetListingPage;
  exports.interactedWorksheetListingPage = interactedWorksheetListingPage;
  exports.savedWorksheet = savedWorksheet;
  exports.viewedSavedWorksheetPage = viewedSavedWorksheetPage;
  exports.viewedDownloadHistoryWorksheetPage = viewedDownloadHistoryWorksheetPage;
  exports.previewedWorksheet = previewedWorksheet;
  exports.closedMathFacts = closedMathFacts;
  exports.interactedActivityPage = interactedActivityPage;
  exports.emailVerifiedFrontend = emailVerifiedFrontend;
  exports.selectedGame = selectedGame;
  exports.visitedOnboardingWelcome = visitedOnboardingWelcome;
  exports.interactedTeacherOnboarding = interactedTeacherOnboarding;
  exports.ageQuestionScreenViewed = ageQuestionScreenViewed;
  exports.ageQuestionScreenInteracted = ageQuestionScreenInteracted;
  exports.onboardingQuestionScreenViewed = onboardingQuestionScreenViewed;
  exports.onboardingQuestionInteracted = onboardingQuestionInteracted;
  exports.interactedAssignmentSuccessfullyAssignedPage = interactedAssignmentSuccessfullyAssignedPage;
  exports.viewedMfSuccessfullyAssignedPage = viewedMfSuccessfullyAssignedPage;
  exports.interactedMfSuccessfullyAssignedPage = interactedMfSuccessfullyAssignedPage;
  exports.viewedGameZone = viewedGameZone;
  exports.interactedGameZone = interactedGameZone;
  exports.playableClicked = playableClicked;
  exports.playableStarted = playableStarted;
  exports.playableCompleted = playableCompleted;
  exports.viewedSubscribePopup = viewedSubscribePopup;
  exports.interactedSubscribePopup = interactedSubscribePopup;
  exports.viewedWorksheetSearchDropdown = viewedWorksheetSearchDropdown;
  exports.interactedWorksheetSearchDropdown = interactedWorksheetSearchDropdown;
  exports.viewedWorksheetSearchResultsPage = viewedWorksheetSearchResultsPage;
  exports.interactedWorksheetSearchResultsPage = interactedWorksheetSearchResultsPage;
  exports.viewedWorksheetSearchResultsEndPage = viewedWorksheetSearchResultsEndPage;
  exports.interactedThemeToggle = interactedThemeToggle;
  exports.viewedNudge = viewedNudge;
  exports.interactedNudge = interactedNudge;
  exports.interactedStudentProgressPage = interactedStudentProgressPage;
  exports.recommendedItem = recommendedItem;
  exports.interactedPrintReportPopup = interactedPrintReportPopup;
  exports.interactedStudentProgress = interactedStudentProgress;
  exports.playableTapped = playableTapped;
  exports.mathFactsClosed = mathFactsClosed;
  exports.interactedLiveClassesTab = interactedLiveClassesTab;
  exports.interactedLiveClassesSubscriptionPopup = interactedLiveClassesSubscriptionPopup;
  exports.viewedTrialPitchScreen = viewedTrialPitchScreen;
  exports.interactedTrialPitchScreen = interactedTrialPitchScreen;
  exports.interactedLeftNavigationMenu = interactedLeftNavigationMenu;
  exports.interactedSplashcommunityDiscoverabilityPopUp = interactedSplashcommunityDiscoverabilityPopUp;
  exports.viewedSplashcommunityDiscoverabilityPopUp = viewedSplashcommunityDiscoverabilityPopUp;
  exports.interactedNewClassAdditionPage = interactedNewClassAdditionPage;
  exports.freemiumTimerExpired = freemiumTimerExpired;
  exports.freemiumTimerStarted = freemiumTimerStarted;
  exports.reachedDailyLimit = reachedDailyLimit;
  exports.studentAutoLoggedInSuccessfully = studentAutoLoggedInSuccessfully;
  exports.viewedSubscribePopUpOnPtl = viewedSubscribePopUpOnPtl;
  exports.viewedOnboardingStepCompletionAnimation = viewedOnboardingStepCompletionAnimation;
  exports.viewedTeacherDashboard = viewedTeacherDashboard;
  exports.interactedTeacherDashboard = interactedTeacherDashboard;
  exports.autoEnrolledForSpringboard = autoEnrolledForSpringboard;
  exports.viewedSpringboardNewIntro = viewedSpringboardNewIntro;
  exports.interactedSpringboardNewIntro = interactedSpringboardNewIntro;
  exports.viewedSpringboardTab = viewedSpringboardTab;
  exports.interactedSpringboardTab = interactedSpringboardTab;
  exports.interactedClassroomSettingsPage = interactedClassroomSettingsPage;
  exports.viewedUrgencyDiscountPopup = viewedUrgencyDiscountPopup;
  exports.interactedUrgencyDiscountPopup = interactedUrgencyDiscountPopup;
  exports.interactedUnlockContent = interactedUnlockContent;
  exports.visitedCertificateTabSpringboard = visitedCertificateTabSpringboard;
  exports.interactedCertificatesPageSpringboard = interactedCertificatesPageSpringboard;
  exports.viewedCertificate = viewedCertificate;
  exports.downloadedCertificate = downloadedCertificate;
  exports.viewedIntroducingCertificatesPopup = viewedIntroducingCertificatesPopup;
  exports.interactedIntroductoryCertificatesPopup = interactedIntroductoryCertificatesPopup;
  exports.viewedWeeklyHighlightsPopup = viewedWeeklyHighlightsPopup;
  exports.interactedWeeklyHighlightsPopup = interactedWeeklyHighlightsPopup;
  exports.viewedTutorLobby = viewedTutorLobby;
  exports.interactedTutorLobby = interactedTutorLobby;
  exports.classQuizStarted = classQuizStarted;
  exports.classQuizEnded = classQuizEnded;
  exports.viewedTutorInQuizScreen = viewedTutorInQuizScreen;
  exports.interactedTutorInQuizScreen = interactedTutorInQuizScreen;
  exports.nextQuestionWarningViewed = nextQuestionWarningViewed;
  exports.nextQuestionWarningInteracted = nextQuestionWarningInteracted;
  exports.viewedTutorQuizTimerRunOutPopup = viewedTutorQuizTimerRunOutPopup;
  exports.viewedTutorFinalLeaderboard = viewedTutorFinalLeaderboard;
  exports.viewedStudentLobbyScreen = viewedStudentLobbyScreen;
  exports.viewedStudentInQuizScreen = viewedStudentInQuizScreen;
  exports.interactedStudentInQuizScreen = interactedStudentInQuizScreen;
  exports.viewedStudentPitstopScreen = viewedStudentPitstopScreen;
  exports.problemsAnswered = problemsAnswered;
  exports.viewedStudentQuizTimerRunOut = viewedStudentQuizTimerRunOut;
  exports.viewedStudentFinalLeaderboard = viewedStudentFinalLeaderboard;
  exports.interactedSubscribePopUpOnPtl = interactedSubscribePopUpOnPtl;
  exports.problemsAnsweredInNeoWorksheets = problemsAnsweredInNeoWorksheets;
  exports.viewedUpcomingClassTab = viewedUpcomingClassTab;
  exports.interactedUpcomingClassTab = interactedUpcomingClassTab;
  exports.viewedLiveClassesIntroductionPopup = viewedLiveClassesIntroductionPopup;
  exports.interactedLiveClassesIntroductionPopup = interactedLiveClassesIntroductionPopup;
  exports.viewedAddParentEmailsPage = viewedAddParentEmailsPage;
  exports.interactedAddParentEmailsPage = interactedAddParentEmailsPage;
  exports.viewedProgramSelectionScreen = viewedProgramSelectionScreen;
  exports.interactedProgramSelectionScreen = interactedProgramSelectionScreen;
  exports.viewedAgeSelectionScreen = viewedAgeSelectionScreen;
  exports.interactedAgeSelectionScreen = interactedAgeSelectionScreen;
  exports.viewedProgramDetailsScreen = viewedProgramDetailsScreen;
  exports.interactedProgramDetailsScreen = interactedProgramDetailsScreen;
  exports.viewedAddParentsEmailPage = viewedAddParentsEmailPage;
  exports.interactedAddParentsEmailPage = interactedAddParentsEmailPage;
  exports.interactedLockedGame = interactedLockedGame;
  exports.viewedPlayAtHomeScreen = viewedPlayAtHomeScreen;
  exports.interactedPlayAtHomeScreen = interactedPlayAtHomeScreen;
  exports.viewedLockedGames = viewedLockedGames;
  exports.viewedCoqOptInScreen = viewedCoqOptInScreen;
  exports.interactedCoqOptInScreen = interactedCoqOptInScreen;
  exports.classWonSpringboardCertificate = classWonSpringboardCertificate;
  exports.studentWonSpringboardCertificate = studentWonSpringboardCertificate;
  exports.classAlmostWonSpringboardCertificate = classAlmostWonSpringboardCertificate;
  exports.studentAlmostWonSpringboardCertificate = studentAlmostWonSpringboardCertificate;
  exports.viewedCgSummary = viewedCgSummary;
  exports.interactedCgSummary = interactedCgSummary;
  exports.viewedCgMilestones = viewedCgMilestones;
  exports.interactedCgMilestones = interactedCgMilestones;
  exports.scrolledStudentDashboard = scrolledStudentDashboard;
  exports.startedPrintablesSearch = startedPrintablesSearch;
  exports.selectedPrintablesSearch = selectedPrintablesSearch;
  exports.interactedPrintablesFilters = interactedPrintablesFilters;
  exports.viewedShareDiscountBanner = viewedShareDiscountBanner;
  exports.interactedShareDiscountBanner = interactedShareDiscountBanner;
  exports.viewedCertificateTabOnParentDashboard = viewedCertificateTabOnParentDashboard;
  exports.interactedCertificateTabOnParentDashboard = interactedCertificateTabOnParentDashboard;
  exports.viewedSchoolHomeScreen = viewedSchoolHomeScreen;
  exports.interactedSchoolHomeScreen = interactedSchoolHomeScreen;
  exports.viewedSummerLearningOfferPage = viewedSummerLearningOfferPage;
  exports.interactedSummerLearningOfferPage = interactedSummerLearningOfferPage;
  exports.viewedSummerLearningPopUp = viewedSummerLearningPopUp;
  exports.interactedSummerLearningPopUp = interactedSummerLearningPopUp;
  exports.parentalGateFailed = parentalGateFailed;
  exports.parentalGateClosed = parentalGateClosed;
  exports.interactedLoginScreen = interactedLoginScreen;
  exports.viewedClassroomLinkedLoginScreen = viewedClassroomLinkedLoginScreen;
  exports.interactedClassroomLinkedLoginScreen = interactedClassroomLinkedLoginScreen;
  exports.viewedLoginViaOtpByClassroomLinkedParent = viewedLoginViaOtpByClassroomLinkedParent;
  exports.interactedLoginViaOtpByClassroomLinkedParent = interactedLoginViaOtpByClassroomLinkedParent;
  exports.interactedProfileIcon = interactedProfileIcon;
  exports.viewedCoTeacherCoachmark = viewedCoTeacherCoachmark;
  exports.interactedCoTeacherCoachmark = interactedCoTeacherCoachmark;
  exports.viewedManageAllClassesPage = viewedManageAllClassesPage;
  exports.interactedManageAllClassesPage = interactedManageAllClassesPage;
  exports.viewedAddCoTeacherPopup = viewedAddCoTeacherPopup;
  exports.interactedAddCoTeacherPopup = interactedAddCoTeacherPopup;
  exports.viewedCoTeachingPopupByCoTeacher = viewedCoTeachingPopupByCoTeacher;
  exports.interactedCoTeachingPopupByCoTeacher = interactedCoTeachingPopupByCoTeacher;
  exports.viewedWelcomePageByNewlyCreatedCoTeacher = viewedWelcomePageByNewlyCreatedCoTeacher;
  exports.interactedWelcomePageByNewlyCreatedCoTeacher = interactedWelcomePageByNewlyCreatedCoTeacher;
  exports.viewedSummerBundleWidgetOnDashboard = viewedSummerBundleWidgetOnDashboard;
  exports.interactedSummerBundleWidgetOnDashboard = interactedSummerBundleWidgetOnDashboard;
  exports.clickedSupport = clickedSupport;
  exports.visitedAllPlansPage = visitedAllPlansPage;
  exports.interactedAllPlansPage = interactedAllPlansPage;
  exports.visitedPlanPurchaseCombinedPage = visitedPlanPurchaseCombinedPage;
  exports.interactedPlanPurchaseCombinedPage = interactedPlanPurchaseCombinedPage;
  exports.paymentFormError = paymentFormError;
  exports.completedPageScroll = completedPageScroll;
  exports.childProfilePageInteracted = childProfilePageInteracted;
  exports.viewedCoachmarkB2b = viewedCoachmarkB2b;
  exports.interactedCoachmarkB2b = interactedCoachmarkB2b;
  exports.viewedLiveClassesFreemiumPitch = viewedLiveClassesFreemiumPitch;
  exports.interactedLiveClassesFreemiumPitch = interactedLiveClassesFreemiumPitch;
  exports.viewedClassPreferenceScreen = viewedClassPreferenceScreen;
  exports.interactedClassPreferenceScreen = interactedClassPreferenceScreen;
  exports.viewedInterestConfirmationScreen = viewedInterestConfirmationScreen;
  exports.interactedInterestConfirmationScreen = interactedInterestConfirmationScreen;
  exports.interactedSearchIcon = interactedSearchIcon;
  exports.typingStartedOnSearchBar = typingStartedOnSearchBar;
  exports.typingStoppedOnSearchBar = typingStoppedOnSearchBar;
  exports.interactedSearchResult = interactedSearchResult;
  exports.viewedTransferPageB2b = viewedTransferPageB2b;
  exports.interactedTransferPageB2b = interactedTransferPageB2b;
  exports.viewedFeatureFeedbackPopUpB2b = viewedFeatureFeedbackPopUpB2b;
  exports.interactedFeatureFeedbackPopUpB2b = interactedFeatureFeedbackPopUpB2b;
  exports.viewedSuggestImprovementsPopupB2b = viewedSuggestImprovementsPopupB2b;
  exports.interactedSuggestImprovementsPopupB2b = interactedSuggestImprovementsPopupB2b;
  exports.interactedHelpIconB2b = interactedHelpIconB2b;
  exports.clickedOnHelpIconB2b = clickedOnHelpIconB2b;
  exports.viewedWorksheetPreview = viewedWorksheetPreview;
  exports.interactedWorksheetPreview = interactedWorksheetPreview;
  exports.interactedFabB2b = interactedFabB2b;
  exports.scrolledPlanPage = scrolledPlanPage;
  exports.interactedPromotePopupB2b = interactedPromotePopupB2b;
  exports.interactedContinueSameClassPopupB2b = interactedContinueSameClassPopupB2b;
  exports.interactedStudentLoginInstructionsPopupB2b = interactedStudentLoginInstructionsPopupB2b;
  exports.productPurchased = productPurchased;
  exports.creditCardSubmitted = creditCardSubmitted;
  exports.productPurchasedFrontend = productPurchasedFrontend;
  exports.viewedAllRecordingsPage = viewedAllRecordingsPage;
  exports.interactedAllRecordingsPage = interactedAllRecordingsPage;
  exports.viewedPersonaQuestionScreen = viewedPersonaQuestionScreen;
  exports.interactedPersonaQuestionScreen = interactedPersonaQuestionScreen;
  exports.viewedCompanion = viewedCompanion;
  exports.startedCompanionAnimation = startedCompanionAnimation;
  exports.completedCompanionAnimation = completedCompanionAnimation;
  exports.interactedCompanion = interactedCompanion;
  exports.dashboardGraphqlQueryStarted = dashboardGraphqlQueryStarted;
  exports.dashboardGraphqlQueryEnded = dashboardGraphqlQueryEnded;
  exports.dashboardRendered = dashboardRendered;
  exports.viewedCompleteTopicAssignmentPopupB2b = viewedCompleteTopicAssignmentPopupB2b;
  exports.interactedCompleteTopicAssignmentPopupB2b = interactedCompleteTopicAssignmentPopupB2b;
  exports.viewedDeleteTopicAssignmentPopupB2b = viewedDeleteTopicAssignmentPopupB2b;
  exports.interactedDeleteTopicAssignmentPopupB2b = interactedDeleteTopicAssignmentPopupB2b;
  exports.downloadedWorksheetB2c = downloadedWorksheetB2c;
  exports.interactedAssignmentSuccessfullyAssignedPageB2b = interactedAssignmentSuccessfullyAssignedPageB2b;
  exports.interactedSchoolSelectionScreenB2b = interactedSchoolSelectionScreenB2b;
  exports.viewedPricingInfoBox = viewedPricingInfoBox;
  exports.liveClassTabAvailable = liveClassTabAvailable;
  exports.endedCompanionAnimation = endedCompanionAnimation;
  exports.viewedCompanionRecommendation = viewedCompanionRecommendation;
  exports.interactedCompanionRecommendation = interactedCompanionRecommendation;
  exports.startedPitstopCompanionAnimation = startedPitstopCompanionAnimation;
  exports.endedPitstopCompanionAnimation = endedPitstopCompanionAnimation;
  exports.receivedRiveFile = receivedRiveFile;
  exports.companionEventsBackend = companionEventsBackend;
  exports.reachedDailyLimitBackend = reachedDailyLimitBackend;
  exports.viewedAddOnPitchScreen = viewedAddOnPitchScreen;
  exports.interactedAddOnPitchScreen = interactedAddOnPitchScreen;
  exports.viewedAddOnUpgradeScreen = viewedAddOnUpgradeScreen;
  exports.interactedAddOnUpgradeScreen = interactedAddOnUpgradeScreen;
  exports.viewedAddOnPurchaseThankYouScreen = viewedAddOnPurchaseThankYouScreen;
  exports.interactedAddOnPurchaseThankYouScreen = interactedAddOnPurchaseThankYouScreen;
  exports.viewedPostLiveClassPitch = viewedPostLiveClassPitch;
  exports.interactedPostLiveClassPitch = interactedPostLiveClassPitch;
  exports.viewedReinforcementAtHomeB2b = viewedReinforcementAtHomeB2b;
  exports.interactedReinforcementAtHomeB2b = interactedReinforcementAtHomeB2b;
  exports.viewedLiveClassPageB2b = viewedLiveClassPageB2b;
  exports.interactedLiveClassPageB2b = interactedLiveClassPageB2b;
  exports.viewedMaxLiveClassLimitReachedPopupB2b = viewedMaxLiveClassLimitReachedPopupB2b;
  exports.viewedShareLiveClassPopupB2b = viewedShareLiveClassPopupB2b;
  exports.interactedShareLiveClassPopupB2b = interactedShareLiveClassPopupB2b;
  exports.viewedLiveClassRecommendationPopup = viewedLiveClassRecommendationPopup;
  exports.interactedLiveClassRecommendationPopup = interactedLiveClassRecommendationPopup;
  exports.loadedQuestionForStudent = loadedQuestionForStudent;
  exports.loadedQuestionForTutor = loadedQuestionForTutor;
  exports.interactedTutorQuizTimerRunOut = interactedTutorQuizTimerRunOut;
  exports.viewedGoogleAccountSelectionScreenB2b = viewedGoogleAccountSelectionScreenB2b;
  exports.viewedGooglecleverClassImportScreenB2b = viewedGooglecleverClassImportScreenB2b;
  exports.interactedGooglecleverClassImportScreenB2b = interactedGooglecleverClassImportScreenB2b;
  exports.errorMessageDisplayedB2b = errorMessageDisplayedB2b;
  exports.viewedChildNameScreen = viewedChildNameScreen;
  exports.interactedChildNameScreen = interactedChildNameScreen;
  exports.viewedGradeSelectionScreen = viewedGradeSelectionScreen;
  exports.interactedGradeSelectionScreen = interactedGradeSelectionScreen;
  exports.viewedSubjectSelectionScreen = viewedSubjectSelectionScreen;
  exports.interactedSubjectSelectionScreen = interactedSubjectSelectionScreen;
  exports.viewedOnboardingQuestionScreen = viewedOnboardingQuestionScreen;
  exports.interactedOnboardingQuestionScreen = interactedOnboardingQuestionScreen;
  exports.viewedLearningPlanScreen = viewedLearningPlanScreen;
  exports.interactedLearningPlanScreen = interactedLearningPlanScreen;
  exports.viewedWeeklyGoalScreen = viewedWeeklyGoalScreen;
  exports.interactedWeeklyGoalScreen = interactedWeeklyGoalScreen;
  exports.viewedLibraryLoadthrough = viewedLibraryLoadthrough;
  exports.viewedExcitingResourcesLoadthrough = viewedExcitingResourcesLoadthrough;
  exports.viewedLocalNotificationPrompt = viewedLocalNotificationPrompt;
  exports.interactedLocalNotificationPrompt = interactedLocalNotificationPrompt;
  exports.interactedMyToDoPopupB2b = interactedMyToDoPopupB2b;
  exports.viewedPendingActivityPopupB2b = viewedPendingActivityPopupB2b;
  exports.viewedStudentLevelBarDropdownB2b = viewedStudentLevelBarDropdownB2b;
  exports.interactedStudentLevelBarDropdownB2b = interactedStudentLevelBarDropdownB2b;
  exports.viewedMpGameExpiredPopupB2b = viewedMpGameExpiredPopupB2b;
  exports.classroomPtlLinkStarted = classroomPtlLinkStarted;
  exports.classroomPtlLinkEnded = classroomPtlLinkEnded;
  exports.viewedLessonPlansListingPageB2b = viewedLessonPlansListingPageB2b;
  exports.interactedLessonPlansListingPageB2b = interactedLessonPlansListingPageB2b;
  exports.viewedLessonPlanDetailPageB2b = viewedLessonPlanDetailPageB2b;
  exports.interactedLessonPlanDetailPageB2b = interactedLessonPlanDetailPageB2b;
  exports.viewedStudentRoundIntroScreen = viewedStudentRoundIntroScreen;
  exports.viewedTutorRoundIntroScreen = viewedTutorRoundIntroScreen;
  exports.interactedTutorRoundIntroScreen = interactedTutorRoundIntroScreen;
  exports.viewedBadgesAnimationInNeoQuiz = viewedBadgesAnimationInNeoQuiz;
  exports.viewedStudentRoundEndedScreen = viewedStudentRoundEndedScreen;
  exports.viewedTutorRoundEndedScreen = viewedTutorRoundEndedScreen;
  exports.interactedTutorRoundEndedScreen = interactedTutorRoundEndedScreen;
  exports.disenrolledClassB2b = disenrolledClassB2b;
  exports.autoEnrolledForSpringboardB2b = autoEnrolledForSpringboardB2b;
  exports.enrolledClassB2b = enrolledClassB2b;
  exports.interactedSpringboardTabB2b = interactedSpringboardTabB2b;
  exports.interactedDownloadLetterB2b = interactedDownloadLetterB2b;
  exports.setSystemProperties_ = setSystemProperties_;
  exports.setSystemProperties = setSystemProperties;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
  exports.WebDebuggerPosition = WebDebuggerPosition;
  exports.avoInspectorApiKey = avoInspectorApiKey;
}(typeof exports === 'undefined' ? this.Avo = {} : exports));

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["viewedTakeTourPopup","interactedOnTakeTourPopup","interactedMpGameTab","viewedMpClassmatesDrawer","viewedMpGameTab","interactedMpClassmatesDrawer","viewedMpGameInvitesDrawer","interactedMpGameInvitesDrawer","viewedMpInviteNotification","interactedMpInviteNotification","viewedMpModeSelectionScreen","interactedMpModeSelectionScreen","viewedMpOptionsSelectionScreen","interactedMpOptionsSelectionScreen","viewedMpInviteFriendsScreen","interactedMpInviteFriendsScreen","viewedMpGameLoaderScreen","viewedMpGamePlayScreen","opponentSearchStarted","opponentFound","countdownAnimationStarted","viewedMpQuestionsExhaustedScreen","viewedMpGameLobby","interactedMpGameLobby","viewedMpGameRewardsScreen","viewedMpRematchPopup","interactedMpRematchPopup","viewedPost3pmPopUp","interactedPost3pmPopUp","viewedErrorOnPost3pmPopUp","viewedSuspectedEmailNudge","interactedSuspectedEmailNudge","viewedMpGameTabCoachmark","viewedMpGameTileCoachmark","visitedDashboardTab","viewedMfWalkthroughPopup","interactedMfWalkthroughPopup","navClickedMfNewPractice","viewedMfSettingsPopup","interactedMfSettingsPopup","successfullyAssigned","navClickedMfTrackFluency","viewedMfTrackAdaptivePage","viewedMfTrackCustomPage","interactedMfTrackAdaptivePage","navClickedStudentReport","viewedMfStudentProgressPage","interactedMfStudentProgressPage","navClickedClassReport","viewedClassCurriculumReportPage","viewedMfClassProgressPage","interactedMfClassProgressPage","viewedMfModifyPracticePage","interactedMfModifyPracticePage","viewedMytodoPage","mathFactStarted","completedMathFactAssignment","viewedDeleteAccountAlert","interactedDeleteAccountAlert","startedGame","viewedGames","tappedGame","interactedMfNewPracticePage","interactedMfCustomModeSettingsPopup","interactedMfStudentSelectionPopup","interactedMfTrackCustomPage","interactedMfCustomReportPage","weeklyGoalInteracted","viewedTiledDashboard","interactedTiledDashboard","completedStudentDashboardScroll","completedPageRendering","downloadedWorksheet","clickedWorksheetTab","appliedWorksheetFilters","clearedWorksheetFilters","viewedWorksheetListingPage","interactedWorksheetListingPage","savedWorksheet","viewedSavedWorksheetPage","viewedDownloadHistoryWorksheetPage","previewedWorksheet","closedMathFacts","interactedActivityPage","emailVerifiedFrontend","selectedGame","visitedOnboardingWelcome","interactedTeacherOnboarding","ageQuestionScreenViewed","ageQuestionScreenInteracted","onboardingQuestionScreenViewed","onboardingQuestionInteracted","interactedAssignmentSuccessfullyAssignedPage","viewedMfSuccessfullyAssignedPage","interactedMfSuccessfullyAssignedPage","viewedGameZone","interactedGameZone","playableClicked","playableStarted","playableCompleted","viewedSubscribePopup","interactedSubscribePopup","viewedWorksheetSearchDropdown","interactedWorksheetSearchDropdown","viewedWorksheetSearchResultsPage","interactedWorksheetSearchResultsPage","viewedWorksheetSearchResultsEndPage","interactedThemeToggle","viewedNudge","interactedNudge","interactedStudentProgressPage","recommendedItem","interactedPrintReportPopup","interactedStudentProgress","playableTapped","mathFactsClosed","interactedLiveClassesTab","interactedLiveClassesSubscriptionPopup","viewedTrialPitchScreen","interactedTrialPitchScreen","interactedLeftNavigationMenu","interactedSplashcommunityDiscoverabilityPopUp","viewedSplashcommunityDiscoverabilityPopUp","interactedNewClassAdditionPage","freemiumTimerExpired","freemiumTimerStarted","reachedDailyLimit","studentAutoLoggedInSuccessfully","viewedSubscribePopUpOnPtl","viewedOnboardingStepCompletionAnimation","viewedTeacherDashboard","interactedTeacherDashboard","autoEnrolledForSpringboard","viewedSpringboardNewIntro","interactedSpringboardNewIntro","viewedSpringboardTab","interactedSpringboardTab","interactedClassroomSettingsPage","viewedUrgencyDiscountPopup","interactedUrgencyDiscountPopup","interactedUnlockContent","visitedCertificateTabSpringboard","interactedCertificatesPageSpringboard","viewedCertificate","downloadedCertificate","viewedIntroducingCertificatesPopup","interactedIntroductoryCertificatesPopup","viewedWeeklyHighlightsPopup","interactedWeeklyHighlightsPopup","viewedTutorLobby","interactedTutorLobby","classQuizStarted","classQuizEnded","viewedTutorInQuizScreen","interactedTutorInQuizScreen","nextQuestionWarningViewed","nextQuestionWarningInteracted","viewedTutorQuizTimerRunOutPopup","viewedTutorFinalLeaderboard","viewedStudentLobbyScreen","viewedStudentInQuizScreen","interactedStudentInQuizScreen","viewedStudentPitstopScreen","problemsAnswered","viewedStudentQuizTimerRunOut","viewedStudentFinalLeaderboard","interactedSubscribePopUpOnPtl","problemsAnsweredInNeoWorksheets","viewedUpcomingClassTab","interactedUpcomingClassTab","viewedLiveClassesIntroductionPopup","interactedLiveClassesIntroductionPopup","viewedAddParentEmailsPage","interactedAddParentEmailsPage","viewedProgramSelectionScreen","interactedProgramSelectionScreen","viewedAgeSelectionScreen","interactedAgeSelectionScreen","viewedProgramDetailsScreen","interactedProgramDetailsScreen","viewedAddParentsEmailPage","interactedAddParentsEmailPage","interactedLockedGame","viewedPlayAtHomeScreen","interactedPlayAtHomeScreen","viewedLockedGames","viewedCoqOptInScreen","interactedCoqOptInScreen","classWonSpringboardCertificate","studentWonSpringboardCertificate","classAlmostWonSpringboardCertificate","studentAlmostWonSpringboardCertificate","viewedCgSummary","interactedCgSummary","viewedCgMilestones","interactedCgMilestones","scrolledStudentDashboard","startedPrintablesSearch","selectedPrintablesSearch","interactedPrintablesFilters","viewedShareDiscountBanner","interactedShareDiscountBanner","viewedCertificateTabOnParentDashboard","interactedCertificateTabOnParentDashboard","viewedSchoolHomeScreen","interactedSchoolHomeScreen","viewedSummerLearningOfferPage","interactedSummerLearningOfferPage","viewedSummerLearningPopUp","interactedSummerLearningPopUp","parentalGateFailed","parentalGateClosed","interactedLoginScreen","viewedClassroomLinkedLoginScreen","interactedClassroomLinkedLoginScreen","viewedLoginViaOtpByClassroomLinkedParent","interactedLoginViaOtpByClassroomLinkedParent","interactedProfileIcon","viewedCoTeacherCoachmark","interactedCoTeacherCoachmark","viewedManageAllClassesPage","interactedManageAllClassesPage","viewedAddCoTeacherPopup","interactedAddCoTeacherPopup","viewedCoTeachingPopupByCoTeacher","interactedCoTeachingPopupByCoTeacher","viewedWelcomePageByNewlyCreatedCoTeacher","interactedWelcomePageByNewlyCreatedCoTeacher","viewedSummerBundleWidgetOnDashboard","interactedSummerBundleWidgetOnDashboard","clickedSupport","visitedAllPlansPage","interactedAllPlansPage","visitedPlanPurchaseCombinedPage","interactedPlanPurchaseCombinedPage","paymentFormError","completedPageScroll","childProfilePageInteracted","viewedCoachmarkB2b","interactedCoachmarkB2b","viewedLiveClassesFreemiumPitch","interactedLiveClassesFreemiumPitch","viewedClassPreferenceScreen","interactedClassPreferenceScreen","viewedInterestConfirmationScreen","interactedInterestConfirmationScreen","interactedSearchIcon","typingStartedOnSearchBar","typingStoppedOnSearchBar","interactedSearchResult","viewedTransferPageB2b","interactedTransferPageB2b","viewedFeatureFeedbackPopUpB2b","interactedFeatureFeedbackPopUpB2b","viewedSuggestImprovementsPopupB2b","interactedSuggestImprovementsPopupB2b","interactedHelpIconB2b","clickedOnHelpIconB2b","viewedWorksheetPreview","interactedWorksheetPreview","interactedFabB2b","scrolledPlanPage","interactedPromotePopupB2b","interactedContinueSameClassPopupB2b","interactedStudentLoginInstructionsPopupB2b","productPurchased","creditCardSubmitted","productPurchasedFrontend","viewedAllRecordingsPage","interactedAllRecordingsPage","viewedPersonaQuestionScreen","interactedPersonaQuestionScreen","viewedCompanion","startedCompanionAnimation","completedCompanionAnimation","interactedCompanion","dashboardGraphqlQueryStarted","dashboardGraphqlQueryEnded","dashboardRendered","viewedCompleteTopicAssignmentPopupB2b","interactedCompleteTopicAssignmentPopupB2b","viewedDeleteTopicAssignmentPopupB2b","interactedDeleteTopicAssignmentPopupB2b","downloadedWorksheetB2c","interactedAssignmentSuccessfullyAssignedPageB2b","interactedSchoolSelectionScreenB2b","viewedPricingInfoBox","liveClassTabAvailable","endedCompanionAnimation","viewedCompanionRecommendation","interactedCompanionRecommendation","startedPitstopCompanionAnimation","endedPitstopCompanionAnimation","receivedRiveFile","companionEventsBackend","reachedDailyLimitBackend","viewedAddOnPitchScreen","interactedAddOnPitchScreen","viewedAddOnUpgradeScreen","interactedAddOnUpgradeScreen","viewedAddOnPurchaseThankYouScreen","interactedAddOnPurchaseThankYouScreen","viewedPostLiveClassPitch","interactedPostLiveClassPitch","viewedReinforcementAtHomeB2b","interactedReinforcementAtHomeB2b","viewedLiveClassPageB2b","interactedLiveClassPageB2b","viewedMaxLiveClassLimitReachedPopupB2b","viewedShareLiveClassPopupB2b","interactedShareLiveClassPopupB2b","viewedLiveClassRecommendationPopup","interactedLiveClassRecommendationPopup","loadedQuestionForStudent","loadedQuestionForTutor","interactedTutorQuizTimerRunOut","viewedGoogleAccountSelectionScreenB2b","viewedGooglecleverClassImportScreenB2b","interactedGooglecleverClassImportScreenB2b","errorMessageDisplayedB2b","viewedChildNameScreen","interactedChildNameScreen","viewedGradeSelectionScreen","interactedGradeSelectionScreen","viewedSubjectSelectionScreen","interactedSubjectSelectionScreen","viewedOnboardingQuestionScreen","interactedOnboardingQuestionScreen","viewedLearningPlanScreen","interactedLearningPlanScreen","viewedWeeklyGoalScreen","interactedWeeklyGoalScreen","viewedLibraryLoadthrough","viewedExcitingResourcesLoadthrough","viewedLocalNotificationPrompt","interactedLocalNotificationPrompt","interactedMyToDoPopupB2b","viewedPendingActivityPopupB2b","viewedStudentLevelBarDropdownB2b","interactedStudentLevelBarDropdownB2b","viewedMpGameExpiredPopupB2b","classroomPtlLinkStarted","classroomPtlLinkEnded","viewedLessonPlansListingPageB2b","interactedLessonPlansListingPageB2b","viewedLessonPlanDetailPageB2b","interactedLessonPlanDetailPageB2b","viewedStudentRoundIntroScreen","viewedTutorRoundIntroScreen","interactedTutorRoundIntroScreen","viewedBadgesAnimationInNeoQuiz","viewedStudentRoundEndedScreen","viewedTutorRoundEndedScreen","interactedTutorRoundEndedScreen","disenrolledClassB2b","autoEnrolledForSpringboardB2b","enrolledClassB2b","interactedSpringboardTabB2b","interactedDownloadLetterB2b"]
